/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title product.js: Feature level module
	 * @description The module used for the 'product'
	 * feature which encapsulates the product page.
	 * social object is referenced outside of here by product page.
	 * @dependency mathtable.js, navigation.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(54), __webpack_require__(62), __webpack_require__(43), __webpack_require__(98), __webpack_require__(76), __webpack_require__(99), __webpack_require__(68), __webpack_require__(27), __webpack_require__(33), __webpack_require__(100), __webpack_require__(101), __webpack_require__(102), __webpack_require__(92), __webpack_require__(88)], __WEBPACK_AMD_DEFINE_RESULT__ = function (product_helper, mathtable, addtocart, compareProducts, social, addMemberNumber, vendor, scheduledDeliverable, linkMembership, membershipValidation, imageLightbox, modalImageLightbox, modalZoomViewer, adobeAnalyticsEvents, whitelist) {
		function init() {
			COSTCO.util.safe(vendor.initProductPage, 'Product.init').call(vendor);
			COSTCO.util.safe(mathtable.init, 'Product.init')();
			COSTCO.util.safe(addtocart.init, 'Product.init').call(addtocart);
			COSTCO.util.safe(compareProducts.init, 'Product.init').call(compareProducts);
			COSTCO.util.safe(product_helper.init, 'Product.init').call(product_helper);
			COSTCO.util.safe(scheduledDeliverable.init, 'Product.init').call(scheduledDeliverable);
			COSTCO.util.safe(linkMembership.init, 'LinkMembership.init').call(linkMembership);
	
			if ($('.shop-all-brand').length > 0) {
				COSTCO.util.responsivePlacement({ placement: '.shop-all-brand', content: '.visible-xs-block' });
			}
	
			COSTCO.util.responsivePlacement({ placement: '.product-manuals', content: '.visible-xl-block' });
			COSTCO.util.responsivePlacement({ placement: '.product-concierge', content: '.visible-xl-block' });
			COSTCO.util.responsivePlacement({ placement: '.product-right-banners', content: '.visible-xl-block' });
	
			COSTCO.util.safe(product_helper.openWishListSuccess, 'Product.init').call(product_helper);
			COSTCO.util.safe(whitelist.init, 'Product.init').call(whitelist);
			COSTCO.Header.refreshGroceryOrderParams();
			window.reactObj.pickUpQty = $('#pickUpQty').val();
			if ($('#isBOPIWItemForMemberInfo').val() == "true" || $('#isShipToWarehouseItem').val() == "1" || $('#isBOPIMItemForMemberInfo').val() == "true") {
				var bopiwMemberInfo = COSTCO.util.getMemberCookie();
				var memberInfoDetails = { "signedIn": bopiwMemberInfo.signedIn };
				window.wioEventBus.publish("memberInfo", memberInfoDetails);
				window.reactObj.memberInfo = bopiwMemberInfo;
			}
	
			if (COSTCO.util.checkElementById('#liveChatEnabled', 'true')) {
				var mList = document.getElementById('chatInlay'),
				    observer = new MutationObserver(function mCallback(mutations) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var mutation = _step.value;
	
							if (mutation.target.id === 'chatInlay') {
								$('#chatInlay').css("z-index", "21000");
								$('#zoomViewer').css("transform-style", "preserve-3d");
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				});
	
				observer.observe(mList, {
					childList: true,
					attributes: true,
					characterData: true,
					subtree: true,
					attributeOldValue: false,
					characterDataOldValue: true
				});
			}
			COSTCO.Global.notify('ProductModuleLoaded');
		}
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		if (typeof window.COSTCO.Global == 'undefined') document.addEventListener("CostcoGlobalLoaded", init, false);else {
			init();
		}
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 5:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title product_helper.js: utility module
	 * @description This module is fabulous. A utility
	 * module for the product page.
	 * @author kmedz
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var itemIdMap = new Map();
	  var listOfObjects = [];
	  var OOSMap = new Map();
	  var Product = {
	    /**
	     * This variable corresponds with the kind of product we're looking
	     * at. It gets set in mathtable.js.init as part of the product.module.js.init
	     * process.
	     * @type {[string]}
	     */
	    item_type: undefined,
	    chatWindow: undefined,
	
	    /**
	     * This constant represents top value that can be set for quantity for BD
	     */
	    MAX_QUANTITY_BD: 9999,
	
	    /**
	     * This constant represents bottom value that can be set for quantity
	     */
	    MIN_QUANTITY: 1,
	
	    SKIP_EDD: false,
	    isLocCtrlSmallPck: false,
	    isEDDStatusAvailable: true,
	    isEddItem: false,
	
	    /**
	     * The initializing function modules use
	     * to call.
	     * @return {[type]} [description]
	     */
	    init: function init() {
	
	      if (isBDApplication && isBDApplication === 'BC') {
	        var pageNames = "";
	        if (window.currentPageName !== undefined) {
	          pageNames = window.currentPageName;
	        }
	        if ($("#left-side-content") != undefined && pageNames === 'pdp') {
	          $(window).scroll(function () {
	            var windowWidth = parseInt(window.innerWidth);
	            if (window.pageYOffset > parseFloat($("#left-side-content").offset().top - 50)) {
	              if (windowWidth > 768) {
	                $("#left-side-content").css({
	                  "position": "sticky",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                if ($("#product-details").height() > $("#zoomViewer").height()) {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#product-details").height() + 20 + "px",
	                      "background": "#fff"
	                    });
	                  }
	                } else {
	                  if ($(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() < 0) {
	                    $("#left-side-content").css({
	                      "position": "sticky",
	                      "top": $(".bottom-content").offset().top - window.pageYOffset - $("#zoomViewer").height() + 20 + "px",
	                      "background": "#fff"
	
	                    });
	                  }
	                }
	              } else {
	                $("#left-side-content").css({
	                  "position": "static",
	                  "top": "20px",
	                  "background": "#fff"
	                });
	                $(".top-content").css({ "background-color": "#fff" });
	                $(".product-interaction").css({ "background-color": "#fff" });
	                $("#fulfillments").css({ "background-color": "#fff" });
	                $(".buyinstoreonly").css({ "background-color": "#fff" });
	              }
	              if (COSTCO.CMath.iskitsbundle) {
	                $(".style-select").addClass("kits-pdp-margin");
	              }
	
	              $("#product-page").css({ "padding-bottom": "0px" });
	              $("#product-info").css({ "background": "#fff" });
	              $("#merkle-recommendations").css({ "background-color": "#fff" });
	              $("#product-vendor-content > div").css({ "background-color": "#fff" });
	            } else {
	              $("#left-side-content").css({
	                "position": "static",
	                "top": "20px",
	                "background": "transparent"
	              });
	            }
	          });
	        }
	      }
	      $('#product-page').attr("data-onloadTracker", "true");
	      if (isBVv2Enabled === 'false') {
	        this.hide_writereview();
	      }
	      this.maskQuantityInput();
	      this.product_details_view_more();
	      this.enablePlainPackagingMessage();
	      this.pop_overs();
	      this.set_option_price_text();
	      this.injectHiddenSwatchesDiv();
	      this.showViewMore();
	      this.setEDDZipCode();
	      if (COSTCO.util.checkElementById('#liveChatEnabled', 'true')) {
	        this.enableChatFeature();
	      }
	      this.scrollToElementOnPdpWithOffset();
	
	      if ($('#liveEDD').length > 0 && $('#liveEDD').val() === 'true') {
	        COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	        if ($('#backOrdered').val() !== 'true') {
	          COSTCO.Product.eddFormDisplayed = true;
	        }
	        $('#minQtyText').bind("change", function () {
	          if (COSTCO.Product.eddFormDisplayed === false && $.cookie('invCheckPostalCode') != null) {
	            COSTCO.Product.retrieveEDD();
	          }
	        });
	      }
	      $('#minQtyText').bind("click", function () {
	        $('#minQtyText').focus();
	      });
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        this.pdpMakeElementSticky();
	        if (COSTCO.Product.item_type == 'bundle') {
	          this.bundlePageReload();
	          this.bundle_backorder_check();
	        }
	        this.initializeAdaForTabPanel();
	        this.makeTextNonClicableForSR();
	        this.initShippingStatementPopover();
	      }
	
	      document.addEventListener("CostcoSubModulesLoaded", COSTCO.Product.startMutationObserver, false);
	
	      /** INC6205314 - Below code will resize the PDP Review tab content after the BV call back. */
	      window.bvCallback = function (BV) {
	        BV.configure('global', {
	          events: {
	            bvRender: function bvRender(data) {
	              // JavaScript code that executes when the Bazaarvoice application renders.
	              COSTCO.Product.showViewMore();
	            }
	          }
	        });
	      };
	
	      // Binding for Success Notification element Close Icon
	      $('#product-page').on('click', '.success-notification .co-close', function (event) {
	        $('#product-page .success-notification').remove();
	      });
	      this.makeSocialIconsAdaCompliant();
	
	      COSTCO.Product.setShareButtonWidth();
	      COSTCO.Product.startProductActionV2MutationObserver();
	      COSTCO.Product.startVendorActionV2MutationObserver();
	      var ctaEspotAttr = $('.product-cta-espot div').attr('data-bi-placement');
	      if (!((typeof ctaEspotAttr === "undefined" ? "undefined" : _typeof(ctaEspotAttr)) !== ( true ? "undefined" : _typeof(undefined)) && ctaEspotAttr !== false)) {
	        $('.product-cta-espot').addClass("hide");
	      }
	      $('.unit-content').unbind().on('click', function (e) {
	        $('#minQtyText').focus();
	      });
	      var sessionStorageDataModal = sessionStorage.getItem('AddedToCartModalData');
	      if (sessionStorageDataModal && sessionStorageDataModal != null) {
	        this.invokeAddedToCartModalData(sessionStorageDataModal);
	      }
	
	      $('#mattress-statement').hide();
	
	      COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
	
	      $(window).on('load', function () {
	        COSTCO.Product.unsetBreadcrumbPadding();
	
	        $('.lcrelatedvideos-e2').each(function () {
	          this.style.setProperty('margin-left', '0px', 'important');
	        });
	        try {
	          COSTCO.Product.mobileSharePdp();
	        } catch (e) {}
	        //3 level item variants
	        if (!COSTCO.CMath.iskitsbundle) {
	          for (var i = $('.varis[data-product=0]').length - 1; i > 0; i--) {
	            if ($('#swatches-productOption0' + i + ' .selection-box-v2 input:disabled').length > 0) {
	              var firstSelectedVariant = $('#swatches-productOption0' + i + ' .selection-box-v2 input:not(:disabled)')[0];
	
	              $('#productOption0' + i).val($(firstSelectedVariant).val());
	              $('#productOption0' + i).change();
	            }
	          }
	          if ($('#swatches-productOption00 .selection-box-v2 input:disabled').length > 0) {
	            var _firstSelectedVariant = $('#swatches-productOption00 .selection-box-v2 input:not(:disabled)')[0];
	
	            $('#productOption00').val($(_firstSelectedVariant).val());
	            $('#productOption00').change();
	          } else if ($('.varis-v2').length > 0) {
	            var selectedOptionSpanText = $('.selectedOptionValue').text().trim();
	            var selectedOptionDropdownText = $('.varis-v2').find(":selected").text().trim();
	
	            if (selectedOptionSpanText != selectedOptionDropdownText) {
	              $('.varis-v2 option').filter(function () {
	                return $(this).text() == selectedOptionSpanText;
	              }).prop('selected', true);
	
	              var selectedOptionValue = $('.varis-v2').find(":selected").val();
	              $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	              $('#productOption00').change();
	            }
	          }
	        }
	      });
	
	      //SFSTRY0014266 - SOK iFrame analytics change
	      if ($('ul#tablist a#reqConsultTab').length > 0 && typeof digitalDataEvents !== 'undefined') {
	        digitalDataEvents.push({ update: { product: { inventoryStatus: "Request Consultation" } } });
	      }
	    },
	
	    hide_writereview: function hide_writereview() {
	      if (COSTCO.CMath.iskitsbundle) {
	        var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && $(mutation.target).find('.bv-content-list-container').length > 0) {
	              $('.bv-submission-button').removeClass("bv-write-review");
	              $('.bv-submission-button').removeClass("bv-first-to-review");
	              $('.bv-submission-button').html("");
	              $('.bv-action-bar').html("");
	              $('.bv-action-bar').removeClass("bv-action-bar");
	            }
	          });
	        });
	        observerObject.observe(targetObject, { attributes: true, attributeOldValue: true,
	          childList: true,
	          subtree: true,
	          characterData: true
	        });
	      }
	    },
	
	    unsetBreadcrumbPadding: function unsetBreadcrumbPadding() {
	      $('#crumbs_ul > div').css('padding', 'unset');
	    },
	
	    mobileSharePdp: function mobileSharePdp() {
	      try {
	
	        if (typeof Android != 'undefined' && typeof Android.onSharePopup != 'undefined') {
	          $("#pdp-share-android-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-android-native").unbind("click").bind("click", function () {
	            Android.onSharePopup($(document).attr('title'), window.location.href);
	          });
	        } else if (typeof webkit != 'undefined' && typeof webkit.messageHandlers != 'undefined' && typeof webkit.messageHandlers.onSharePopup != 'undefined' && typeof webkit.messageHandlers.onSharePopup.postMessage != 'undefined') {
	
	          $("#pdp-share-ios-native").show();
	          $(".social-share").hide();
	          $("#pdp-share-ios-native").unbind("click").bind("click", function () {
	            webkit.messageHandlers.onSharePopup.postMessage(window.location.href);
	          });
	
	          //iOS behaves strange, it needs timeout to run async
	          setTimeout(function () {
	            if ($("#pdp-share-ios-native").is(":hidden") && $("#pdp-share-android-native").is(":hidden")) {
	              $(".social-share").show();
	            }
	          }, 1000);
	        }
	      } catch (e) {
	        $("#pdp-share-android-native").hide();
	        $("#pdp-share-ios-native").hide();
	        $(".social-share").show();
	      }
	    },
	
	    eddObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    productActionV2ObserverState: '',
	
	    vendorActionV2Observer: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null
	    },
	
	    vendorActionV2ObserverState: '',
	
	    eddMutationObserverState: '',
	
	    eddFormDisplayed: '',
	
	    displayEDDForm: true,
	
	    sortVariantOptions: false,
	
	    sortVariantOptions_V2: false,
	
	    /**
	     * Function used to watch for changes of catEntryId, calling retrieveEDD in case of observing
	    */
	    startEDDMutationObserver: function startEDDMutationObserver() {
	      var targetObject = $('#ProductForm #catEntryId');
	      if (targetObject.length > 0 && this.displayEDDForm === true) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("attributes" === mutation.type) {
	              COSTCO.Product.showEddForm();
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          attributes: true
	        });
	
	        this.eddObserver.observer = observerObject;
	      }
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #ctas content, calling changeContentOfExternalButton in case of observing change in first loop
	    */
	    startVendorActionV2MutationObserver: function startVendorActionV2MutationObserver() {
	      var targetObject = $('#ctas');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type && COSTCO.Product.vendorActionV2ObserverState !== 'STOPPED') {
	              if ($('#ctas ul li a').length) {
	                COSTCO.Product.changeContentOfExternalButton();
	              }
	              COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true,
	          subtree: true
	        });
	        this.vendorActionV2Observer.observer = observerObject;
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Function used to watch for changes of #mr-registry-container content, calling setShareButtonWidth in case of observing
	    */
	    startProductActionV2MutationObserver: function startProductActionV2MutationObserver() {
	      var targetObject = $('#mr-registry-container');
	      if (targetObject.length > 0) {
	        targetObject = targetObject[0];
	        var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	          mutationRecordsList.forEach(function (mutation) {
	            if ("childList" === mutation.type) {
	              COSTCO.Product.setShareButtonWidth();
	              COSTCO.Product.makeGiftRegistryAdaCompliant();
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.item_type == 'bundle') {
	                COSTCO.Product.arrangeBundleButtons();
	              }
	            }
	          });
	        });
	        // Register the target node to observe and specify which DOM changes to watch
	        observerObject.observe(targetObject, {
	          childList: true
	        });
	        this.productActionV2Observer.observer = observerObject;
	      }
	      productActionV2ObserverState = Product.productActionV2Observer.state.STARTED;
	    },
	
	    /**
	     * Mask quantity input field for PDP page
	     */
	    maskQuantityInput: function maskQuantityInput() {
	      $("input[name*='quantity']").unmask().mask(COSTCO.util.isBusinessDelivery() ? '0000' : '000');
	    },
	
	    /**
	     * Function used to change state eddMutationObserverState and disconnect observer in case of showing edd form.
	    */
	    stopEDDMutationObserver: function stopEDDMutationObserver() {
	
	      COSTCO.Product.eddMutationObserverState = Product.eddObserver.state.STOPPED;
	      if (!_typeof(this.eddObserver.observer) === "undefined") {
	        this.eddObserver.observer.disconnect();
	      }
	    },
	
	    /**
	     * Function used to show Live Chat Us feature on the PDP page
	    */
	    enableChatFeature: function enableChatFeature() {
	      if ('BC' === $('#applicationType').val() && $("input[name='productBeanId']").length > 0) {
	        /* Get Catentry Id and partnumber of the Product */
	        var catentryid = $("input[name='productBeanId']").val();
	        var partnumber = $("input[name='productPartnumber']").val();
	        if (!(typeof catentryid === "undefined")) {
	
	          COSTCO.util.ajax({
	            url: '/AjaxGetChatDetails',
	            method: 'GET',
	            dataType: 'json',
	            data: {
	              productId: catentryid,
	              signedIn: COSTCO.util.getMemberCookie().signedIn,
	              hostname: window.location.protocol + "//" + window.location.hostname,
	              partnumber: partnumber
	            },
	            done: function done(data, textStatus, jqXHR, options) {
	              if (data.errorMessageKey) {
	                console.log('Error Occured ' + data.errorMessage);
	              } else if (data.showChatURL) {
	                var windowHeight = window.innerHeight;
	                var feedbackWidth = $('button.chat-button').width() + 10; /* 10px spacing between feedback and chat */
	                var feedbackConverted = feedbackWidth * 100 / windowHeight;
	                var finalHeight = 49 + feedbackConverted; /* 49 top of feedback button */
	                $('button.chat-button').css('top', finalHeight + "%");
	                var chatUrl = new DOMParser().parseFromString(data.chatURL, "text/html");
	                var finalChatUrl = chatUrl.body.textContent;
	                COSTCO.Product.showChatWindow(finalChatUrl);
	              } else {
	                var chatButton = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? 'button.chat-button-v2' : 'button.chat-button';
	                $(chatButton).addClass('hidden');
	              }
	            }, fail: function fail(data) {
	              console.log('Unexpected Error Occured');
	            }
	          });
	        }
	      }
	    },
	    /**
	     * This method is used to render a new Chat Window and load the Chat Us Link
	     */
	    showChatWindow: function showChatWindow(customURL) {
	      var liveChatButton;
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        liveChatButton = 'button.chat-button-v2';
	      } else {
	        liveChatButton = 'button.chat-button';
	      }
	      $(liveChatButton).click(function (event) {
	        /**
	         * If chat window already open then focus existing one
	         * else open new window
	         */
	        if (customURL.length > 0) {
	          if (COSTCO.Product.chatWindow != undefined && !COSTCO.Product.chatWindow.closed) {
	            COSTCO.Product.chatWindow.focus();
	          } else {
	            var chatWindowWidth = 320;
	            var chatWindowHeight = 800;
	            var left = $(window).width() - chatWindowWidth;
	            COSTCO.Product.chatWindow = window.open(customURL, 'chatWindow', 'width=' + chatWindowWidth + ',height=' + chatWindowHeight + ',scrollbars=1,top=0,left=' + left);
	            COSTCO.Product.chatWindow.moveTo(left, 0);
	            COSTCO.Product.chatWindow.focus();
	          }
	        }
	      });
	    },
	
	    /**
	     * Setting width for button share on pdp
	     * @return void
	     */
	    setShareButtonWidth: function setShareButtonWidth() {
	      if ($('#add-to-list').html() == undefined && ($('#mr-registry-container').html() == undefined || $('#mr-registry-container').html().contents == undefined)) {
	        $('#mr-registry-container').remove(); //remove container if it is empty
	        $('#product-social-print-mobile').css('width', '100%');
	      }
	    },
	
	    /**
	     * Changing content of external button
	     * @return void
	     */
	    changeContentOfExternalButton: function changeContentOfExternalButton() {
	      var selector = $('div#ctas').find('a').children('input.primary').length ? $('div#ctas').find('a').children('input.primary') : $('div#ctas').find('a.external').children('span');
	      if (selector.length > 0 && selector.text() !== messages.RWD_VENDOR_CTA_BUTTON_TEXT_ORDER_HERE) {
	        if (selector.is('span')) {
	          selector.text(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        } else {
	          selector.val(messages.RWD_VENDOR_CTA_BUTTON_TEXT);
	        }
	      }
	      COSTCO.Product.vendorActionV2ObserverState = Product.vendorActionV2Observer.state.STOPPED;
	    },
	    /**
	     * Update the EDD zip code based on the current zip code cookie value.
	     */
	    setEDDZipCode: function setEDDZipCode() {
	      $("#eddZipCodeField").val($.cookie('invCheckPostalCode'));
	    },
	
	    /**
	     * change prive from base 64 to a decimal value
	     */
	    processPrice: function processPrice(value) {
	      value = typeof value !== 'undefined' && value != null ? value : "";
	      value = typeof value == "string" ? COSTCO.util.base64test.test(value) ? COSTCO.util.decode(value) : value : value;
	      if ($.type(value) === 'string') {
	        value = value.split(',').join('');
	      }
	      return this.parseCurrency(value);
	    },
	    /**
	     * round a number down to 2 decimal places
	     */
	    parseCurrency: function parseCurrency(num) {
	      if (typeof num == "number") {
	        num = num.toString();
	      }
	      num = parseFloat(Math.round(num.replace(/\s/g, '') * 100) / 100).toFixed(2).toLocaleString();
	      return num;
	    },
	    focusToNavPdpTabHeader1: function focusToNavPdpTabHeader1() {
	      $("#nav-pdp-tab-header-1").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader2: function focusToNavPdpTabHeader2() {
	      $("#nav-pdp-tab-header-2").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader3: function focusToNavPdpTabHeader3() {
	      $("#nav-pdp-tab-header-3").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader4: function focusToNavPdpTabHeader4() {
	      $("#nav-pdp-tab-header-4").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader5: function focusToNavPdpTabHeader5() {
	      $("#nav-pdp-tab-header-5").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader6: function focusToNavPdpTabHeader6() {
	      $("#nav-pdp-tab-header-6").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader7: function focusToNavPdpTabHeader7() {
	      $("#nav-pdp-tab-header-7").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader8: function focusToNavPdpTabHeader8() {
	      $("#nav-pdp-tab-header-8").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader9: function focusToNavPdpTabHeader9() {
	      $("#nav-pdp-tab-header-9").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader10: function focusToNavPdpTabHeader10() {
	      $("#nav-pdp-tab-header-10").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader11: function focusToNavPdpTabHeader11() {
	      $("#nav-pdp-tab-header-11").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader12: function focusToNavPdpTabHeader12() {
	      $("#nav-pdp-tab-header-12").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader13: function focusToNavPdpTabHeader13() {
	      $("#nav-pdp-tab-header-13").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader14: function focusToNavPdpTabHeader14() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.build-bundle-tab').addClass('active in');
	      }, 500);
	      $("#buildabundleTitle").attr("tabindex", -1).focus();
	    },
	    focusToNavPdpTabHeader15: function focusToNavPdpTabHeader15() {
	      $("#selectedKbOffScreenSwatch").attr("tabindex", -1).focus();
	    },
	
	    formatMoney: function formatMoney(number, has_symbol) {
	      var number = number.toString(),
	          dollars = number.split('.')[0],
	          cents = (number.split('.')[1] || '') + '00';
	      dollars = dollars.split('').reverse().join('').replace(/(\d{3}(?!$))/g, '$1,').split('').reverse().join(''), symbol = has_symbol ? '$' : "";
	      var locale = COSTCO.util.getLocale();
	      var appType = $('#applicationType').val();
	
	      if (locale == 'fr-CA' && appType == 'BD') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + ' ' + symbol;
	      } else if (locale == 'fr-CA' && appType == 'BC') {
	        return dollars.split(",").join(" ") + ',' + cents.slice(0, 2) + symbol;
	      }
	
	      return symbol + dollars + '.' + cents.slice(0, 2);
	    },
	    /**
	     * This function iterates through every variant on a product page and sorts
	     * its option, first by sequence, then price (if single variant) else alphabetically.
	     * @return {[type]} [description]
	     */
	    sort_variant_options: function sort_variant_options() {
	      $('.variantContainer').each(function (i, vContainer) {
	        $(vContainer).find('select.varis').each(function (j, select) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          if (!COSTCO.CMath.iskitsbundle) {
	            $options.detach().sort(function (option_a, option_b) {
	
	              var seq_a = parseFloat(this.get_item_sequence(option_a.value, product_num)),
	                  seq_b = parseFloat(this.get_item_sequence(option_b.value, product_num));
	              if (seq_a == seq_b) {
	                // Same sequences, try sorting by price
	                var item_a = this.findItem(products[product_num], this.get_selected_array($(option_a))),
	                    item_b = this.findItem(products[product_num], this.get_selected_array($(option_b)));
	                if (item_a && item_b) {
	                  var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                      price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                  return price_b - price_a;
	                } else {
	                  return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	                }
	              } else {
	                return seq_a > seq_b ? 1 : -1;
	              }
	            }.bind(this));
	            $options.removeAttr("selected");
	            $options.appendTo(select);
	          }
	
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            this.displayVarianceView(select);
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions_V2 = true;
	              var preselectOption = COSTCO.util.getParameterByName('preselectOption');
	              if (typeof preselectOption !== 'undefined' && preselectOption != null) {
	                COSTCO.CMath.bindVariantProducts('', preselectOption);
	              } else {
	                COSTCO.CMath.bindVariantProducts();
	              }
	            }
	          } else {
	            if ($(vContainer).find('select.varis').length == j + 1) {
	              COSTCO.Product.sortVariantOptions = true;
	            }
	            COSTCO.CMath.bindVariantProducts();
	          }
	        }.bind(this));
	      }.bind(this));
	    },
	
	    sort_secondary_variant_options: function sort_secondary_variant_options(selectedVariant) {
	      $('.variantContainer').find('select.varis').each(function (j, select) {
	        if ($(select).attr('id') !== $(selectedVariant).attr('id')) {
	          var $options = $(select).find('option:not([value=unselected])'),
	              product_num = $(select).data('product');
	          var selectedOptionVal = $(select).find('option:selected').val();
	          $options.detach().sort(function (option_a, option_b) {
	            var seq_a = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_a.value, $(selectedVariant).val(), product_num)),
	                seq_b = parseFloat(COSTCO.Product.get_item_sequence_selectVariant(option_b.value, $(selectedVariant).val(), product_num));
	
	            if (isNaN(seq_a)) {
	              seq_a = 0;
	            } else if (isNaN(seq_b)) {
	              seq_b = 0;
	            }
	            if (seq_a == seq_b) {
	              // Same sequences, try sorting by price
	              var item_a = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_a))),
	                  item_b = COSTCO.Product.findItem(products[product_num], COSTCO.Product.get_selected_array($(option_b)));
	              if (item_a && item_b) {
	                var price_a = parseFloat(COSTCO.util.decode(item_a.price).split(',').join('')),
	                    price_b = parseFloat(COSTCO.util.decode(item_b.price).split(',').join(''));
	                return price_b - price_a;
	              } else {
	                return option_a.text.toLowerCase() > option_b.text.toLowerCase() ? 1 : -1;
	              }
	            } else {
	              return seq_a > seq_b ? 1 : -1;
	            }
	          }.bind(this));
	
	          $options.removeAttr("selected");
	          $options.appendTo(select);
	          var rePrintSortedTiles = '<legend id="variantLegend-productOption0' + j + '" class="sr-only">' + $(select).closest('.vari').find('label').text() + '</legend>';
	          $options.each(function (i, option) {
	            var optionValue = $(option).text();
	            if ($(option).val() === selectedOptionVal) {
	              $(option).prop('selected', true);
	            }
	            var templateName;
	            if (COSTCO.CMath.iskitsbundle) {
	              templateName = 'tmpl_KB_product_variants_v2';
	            } else {
	              templateName = 'tmpl_product_variants_v2';
	            }
	            rePrintSortedTiles += COSTCO.util.tmpl(templateName, {
	              inputName: $(select).prop('name'),
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(select).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          });
	          var sortedVariantFieldset = $('#swatches-' + $(select).prop('name')).find('fieldset label.variant-v2').parent();
	          sortedVariantFieldset.html('');
	          sortedVariantFieldset.html(rePrintSortedTiles);
	
	          $('#swatches-' + $(select).prop('name') + ' label.selection-box-v2').on('click keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + $(select).prop('name')).val(radioValue);
	            $('#' + $(select).prop('name')).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        }
	      }.bind(this));
	    },
	
	    /**
	     * Generate variance view for a PDP Redesign page
	     * @param selectVariant variant selection to generate view from
	     * @return void
	     */
	    displayVarianceView: function displayVarianceView(selectVariant) {
	      var _this = this;
	
	      var tileHtml = '';
	      var variantLabelHtml = '';
	      var selectVariantName = $(selectVariant).prop('name');
	      var selectVariantOptions = $(selectVariant).find('option:not([value=unselected])');
	      var variantSelected = $(selectVariant).find('option:selected').hasClass('opt');
	      var isBundle = $('.bundleQty').length > 0;
	      var variantLabelText = $(selectVariant).closest('.vari').find('label').text().trim();
	      var templateName;
	      if (COSTCO.CMath.iskitsbundle) {
	        templateName = 'tmpl_KB_product_variants_v2_label';
	      } else {
	        templateName = 'tmpl_product_variants_v2_label';
	      }
	
	      variantLabelHtml += COSTCO.util.tmpl(templateName, {
	        selectedOptionKey: variantLabelText,
	        optionId: $(selectVariant).attr('id')
	      });
	
	      if ($(selectVariant).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
	        if (COSTCO.CMath.iskitsbundle) {
	          var theSwatchesCloned = $('#theKBSwatches').clone(true);
	          $('#theKBSwatches').remove();
	          var $labelForSwatches = $('label[for="theKBSwatches"]');
	          $labelForSwatches.removeClass('hide');
	          $labelForSwatches.after(theSwatchesCloned);
	          $('#theKBSwatches').removeClass('hide');
	        } else {
	          var _theSwatchesCloned = $('#theSwatches').clone(true);
	          $('#theSwatches').remove();
	          $('#pdpSwatches').remove();
	          var _$labelForSwatches = $('label[for="theSwatches"]');
	          _$labelForSwatches.removeClass('hide');
	          _$labelForSwatches.after(_theSwatchesCloned);
	
	          var $labelForPdpSwatches = $('label[for="pdpSwatches"]');
	          $labelForPdpSwatches.removeClass('hide');
	          $labelForPdpSwatches.after(_theSwatchesCloned);
	        }
	      } else if (numberOfOptionsToDisplayAsTiles && selectVariantOptions.length < numberOfOptionsToDisplayAsTiles && !isBundle) {
	
	        selectVariantOptions.each(function (i, option) {
	          var optionValue = $(option).text();
	          if (COSTCO.CMath.iskitsbundle) {
	            tileHtml += COSTCO.util.tmpl('tmpl_KB_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false',
	              i: i + 1
	            });
	          } else {
	            tileHtml += COSTCO.util.tmpl('tmpl_product_variants_v2', {
	              inputName: selectVariantName,
	              inputValue: $(option).val(),
	              variantName: optionValue,
	              disabled: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? 'disabled' : '',
	              tabindex: $(selectVariant).parent('.style-select').hasClass('disabled') || $(option)[0].hasAttribute('disabled') ? '-1' : '0',
	              checkedValue: $(option).is(':selected') ? 'checked' : '',
	              ariaChecked: $(option).is(':selected') ? 'true' : 'false'
	            });
	          }
	        });
	        var templateName;
	        if (COSTCO.CMath.iskitsbundle) {
	          templateName = 'tmpl_KB_product_variants_v2_row';
	        } else {
	          templateName = 'tmpl_product_variants_v2_row';
	        }
	        $('#product-details').append(COSTCO.util.tmpl(templateName, {
	          swatchesId: selectVariantName,
	          tileDisplay: tileHtml,
	          variantLabel: variantLabelHtml,
	          selectedOptionKey: $(selectVariant).closest('.vari').find('label').text()
	
	        }));
	
	        if (variantSelected) {
	          COSTCO.CMath.update_selected_option_label($(selectVariant).find('option:selected').val());
	        }
	
	        $('#swatches-' + selectVariantName + ' input[type=radio]').change(function () {
	          var radioValue = $(this).val();
	          $('#' + selectVariantName).val(radioValue);
	          $('#isPriceCallInvokedForPickup').val('false');
	          if (selectVariantName === 'productOption00') {
	            COSTCO.Product.sort_secondary_variant_options($(selectVariant));
	          }
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	
	        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	          $('#swatches-' + selectVariantName + ' label.selection-box-v2').on('keypress', function () {
	            $('#isPriceCallInvokedForPickup').val('false');
	            var radioValue = $(this).find('input').val();
	            $('#' + selectVariantName).val(radioValue);
	            $('#' + selectVariantName).trigger('change.vari');
	            $(this).find('input').each(function () {
	              $(this).prop('checked', 'false');
	            });
	            $(this).find('input').prop('checked', 'true');
	          });
	        };
	      } else {
	
	        var styleSelect = $(selectVariant).parent('.style-select');
	        if (!isBundle) {
	          $('#product-details').append(variantLabelHtml);
	        }
	        if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
	          var dropdownSkeleton = '<div class="style-select form-group dropdown-skeleton-' + selectVariantName + '" id="PDP-dropdown-skeleton"> <select class="dropdown-skeleton-load loading" disabled></select></div>';
	          $('#product-details').append(dropdownSkeleton);
	          $('[name=' + selectVariantName + ']').hide();
	        }
	        var styleSelectCloned = styleSelect.clone();
	        var optionsCloned = styleSelectCloned.find('.varis');
	        optionsCloned.removeAttr('id');
	        optionsCloned.addClass('varis-v2');
	        optionsCloned.removeClass('varis');
	        optionsCloned.attr('autocomplete', 'off');
	        optionsCloned.attr('aria-label', variantLabelText);
	
	        $('#product-details').append(styleSelectCloned);
	
	        if (isBundle) {
	          var i;
	          var a;
	
	          (function () {
	            styleSelectCloned.hide();
	            var bundleArr = document.getElementsByClassName('bundle-info-container');
	            var varArr = document.getElementsByClassName('varis-v2');
	            for (i = 0; i < bundleArr.length; i++) {
	              if (varArr[i] != undefined) {
	                varArr[i].id = "cloned" + varArr[i].name;
	                varArr[i].classList.add("cloned");
	                //Append select to the bundle container
	                for (a = 0; a < bundleArr.length; a++) {
	                  if (varArr[i].dataset.product == bundleArr[a].dataset.product && !bundleArr[a].classList.contains("input-field-v2")) {
	                    bundleArr[a].classList.add("input-field-v2");
	                    bundleArr[a].appendChild(varArr[i]);
	                  }
	                }
	              }
	            }
	            var clonedVarArr = document.getElementsByClassName('cloned');
	            var varianceLabel = $(selectVariant).closest('.vari').find('label').text();
	            for (var _i = 0; _i < clonedVarArr.length; _i++) {
	              if ($('label[for="' + clonedVarArr[_i].id + '"]').length === 0) {
	                _this.add_label_to_variance_select(clonedVarArr[_i], varianceLabel);
	                $('#' + clonedVarArr[_i].id).change(function () {
	                  var labels = $("label[for='" + this.id + "']");
	                  var selectedValue = $(this).children("option:selected").val();
	                  var item;
	                  var p = products[$(this).data('product')];
	                  labels.removeClass("label-outline-error");
	                  labels.filter('.error').hide();
	                  $(this).removeClass("error-in-bundle");
	                  for (var i = 0; i < p.length; i++) {
	                    if ($(this).val() == p[i].options || $(this).val() == p[i].catentry) {
	                      item = p[i];
	                    }
	                  }
	                  if (item) {
	                    var catentryid = item.catentry;
	                    var opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
	                    var container = this.parentElement.parentElement;
	                    var bundle = container.parentElement;
	                    var checkbox = $(bundle).find('input:checkbox');
	                    var isBackordered = false;
	                    var varianceBackorderMessage = null;
	                    $(container).find('.price').find('span').text(COSTCO.Product.formatMoney(opPrice, true));
	                    $(bundle).parent().find('#backorder-message').remove();
	                    products.forEach(function (product, index) {
	                      products[index].forEach(function (pro, ind) {
	                        if (selectedValue === pro.options[0]) {
	                          if (pro.inventory === "BACK_ORDER") {
	                            isBackordered = true;
	                            if (typeof pro.backorderMessage !== "undefined" && pro.backorderMessage != null) {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(pro.backorderMessage));
	                              varianceBackorderMessage = pro.backorderMessage;
	                            } else {
	                              $(bundle).parent().append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	                              varianceBackorderMessage = messages.BACKORDER_TEXT_MSG5;
	                            }
	                          }
	                        }
	                      });
	                    });
	                    if ($(checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      COSTCO.Product.changeBundleItemVarianceValue($(this).data('product') + 1, varianceLabel.trim(), $(this).children("option:selected").text(), opPrice, isBackordered, varianceBackorderMessage);
	                    }
	                  } else if (selectedValue == "unselected") {
	                    var _container = this.parentElement.parentElement;
	                    var _bundle = _container.parentElement;
	                    var _checkbox = $(_bundle).find('input:checkbox');
	                    if ($(_checkbox).is(':checked')) {
	                      $('#' + selectVariantName).val(selectedValue);
	                      $('#' + selectVariantName).trigger('change.vari');
	                      $(_container).find('.price').find('span').text('');
	                      $(_checkbox).click();
	                    }
	                  }
	                });
	              }
	              $('#' + clonedVarArr[_i].id).trigger('change');
	            }
	            if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              styleSelectCloned.show();
	            }
	            _this.add_ellipsis_to_variance_select();
	          })();
	        }
	
	        styleSelectCloned.find('.varis-v2').change(function (event) {
	          var selectedOptionValue = $(event.target).find('option:selected').val();
	          $('.varis').find('option[value=' + selectedOptionValue + ']').prop('selected', true);
	          if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
	            //Following code for reload page if user is clicking dropdown
	            COSTCO.CMath.redirectPDP();
	          } else {
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	        });
	      }
	      $(selectVariant).parents('#variants').addClass('visually-hidden');
	    },
	
	    /**
	     * Check if bundle option is backordered
	     */
	    bundle_backorder_check: function bundle_backorder_check() {
	      $('#backorder-message').hide();
	      var containers = $('.variantContainer');
	      var bundleProducts = $('.bundle-product');
	      $(bundleProducts).find('#backorder-message').remove();
	      products.forEach(function (product, index) {
	        if ($(containers[index]).find('select').length) {
	          //Single item with one select box
	          selectedValue = $(containers[index]).find('select > option:selected').val();
	          if (selectedValue === products[index][0].options[0]) {
	            if (products[index][0].inventory === "BACK_ORDER") {
	              if (typeof products[index][0].backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(products[index][0].backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        } else if (parseInt($(containers[index]).find('input').val()) != null) {
	          // Single item with no select box (just quantity input shown)
	          var test = $(containers[index]).find('input').val();
	          if (products[index][0].inventory === "BACK_ORDER") {
	            if (bundleProducts[index] != null) {
	              if (typeof backorderMessage !== "undefined") {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	              } else {
	                $(bundleProducts[index]).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	              }
	            }
	          }
	        }
	      });
	    },
	
	    /**
	     *  Adds ellipsis to variance when text overflows select element size
	     */
	    add_ellipsis_to_variance_select: function add_ellipsis_to_variance_select() {
	      $('.varianceContainer').each(function () {
	        if ($(this).find(".viewport").length === 0) {
	          var newDiv = document.createElement("div");
	          newDiv.className = "viewport";
	          var innerDiv = document.createElement("div");
	          innerDiv.className = "innerViewport";
	          innerDiv.innerHTML = $(this).find('select option:selected').get(0).textContent;
	          newDiv.appendChild(innerDiv);
	          this.insertBefore(newDiv, this.firstChild);
	          $(this).find('select').change(function () {
	            $(this).parent().find('.innerViewport').text($("option:selected", this).text());
	          });
	        }
	      });
	    },
	
	    /**
	     * Adds label and error label to cloned variance select list
	     * @param  varianceArray
	     * @param  varianceLabel
	     */
	    add_label_to_variance_select: function add_label_to_variance_select(varianceArray, varianceLabel) {
	      var $label = $("<label>").text(varianceLabel);
	      var $errorLabel = $("<label>").text(messages.ERR_SELECT_VARIANCE + " " + varianceLabel);
	      var wrapper = document.createElement('div');
	      wrapper.classList.add("varianceContainer");
	      varianceArray.parentNode.insertBefore(wrapper, varianceArray);
	      wrapper.appendChild(varianceArray);
	      $label.attr('for', varianceArray.id);
	      $label.addClass("label-outline ");
	      $errorLabel.attr('for', varianceArray.id);
	      $errorLabel.addClass("error");
	      $errorLabel[0].style.display = "none";
	      varianceArray.parentNode.insertBefore($label[0], varianceArray.nextSibling);
	      varianceArray.parentNode.insertBefore($errorLabel[0], varianceArray.nextSibling);
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence: function get_item_sequence(optionVal, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Gets the item sequence of a product using the option value1 and option value2
	     * of a variant item select
	     * @param  {[type]} optionVal  [description]
	     * @param  {[type]} productNum [description]
	     * @return {[type]}            [description]
	     */
	    get_item_sequence_selectVariant: function get_item_sequence_selectVariant(optionVal1, optionVal2, productNum) {
	      var _sequence = "";
	      for (var i = 0, len = products[productNum].length; i < len; i++) {
	        var item = products[productNum][i];
	        if (COSTCO.util.hasElem(optionVal1, item.options) && COSTCO.util.hasElem(optionVal2, item.options)) {
	          _sequence = item.itemSequence;
	          break;
	        }
	      }
	      return _sequence;
	    },
	
	    /**
	     * Validates EDD zip code format. Returns true if zip code format is valid.
	     */
	    validateZipCode: function validateZipCode(form) {
	
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	      $.validator.addMethod("countrySpecificZipcode", function (value, element) {
	        if (wcs.storeId == '10301') return (/^(\d{5}(-\d{4})?$)$/.test($.trim(value))
	        );
	        if (wcs.storeId == '10302') return (/^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value))
	        );
	      }, messages.ERR_GROCERY_INVALID_ZIP);
	
	      $(form).validate({
	        rules: {
	          eddZipCodeField: { required: true, countrySpecificZipcode: true }
	        },
	        messages: {
	          eddZipCodeField: "<span class=\"sr-only\">" + messages.ERROR + "</span>" + messages.ERR_GROCERY_INVALID_ZIP
	        },
	        errorPlacement: function errorPlacement(error, element) {
	          error.insertAfter(element);
	        },
	        highlight: function highlight(element, errorClass, validClass) {
	          $(element).addClass(errorClass).removeClass(validClass);
	          var enterZipMessageId = $('[id^=enterZipMessage]')[0].id;
	          $(element).attr("aria-describedby", enterZipMessageId);
	        },
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	
	      return $(form).valid();
	    },
	
	    /**
	     * Function to validate delivery zip code
	     * 2 validation will be done
	     * 	 1. Standard form validation postal regex and required
	     *   2. Pass the zipcode to bing to also lookup country and state
	     *   	which we will pass to the command to valid zipcode
	     */
	    validateRefreshEDDZipCode: function validateRefreshEDDZipCode(element) {
	      event.preventDefault();
	      var form = event.currentTarget;
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        if (typeof document.getElementById("isEDDNonNarvarFlow") !== "undefined" && document.getElementById("isEDDNonNarvarFlow") !== null) {
	          document.getElementById("isEDDNonNarvarFlow").value = true;
	        }
	        var deliveryFormZipCode = null;
	        if (wcs.storeId === '10302') {
	          if ($('#eddZipCodeField') !== undefined && $('#eddZipCodeField') !== null) {
	            deliveryFormZipCode = $('#eddZipCodeField').val().toUpperCase();
	          }
	        } else {
	          deliveryFormZipCode = $(form).find("input[name=eddZipCodeField]").val().toUpperCase();
	        }
	
	        window.wioEventBus.publish('changeDeliveryLocation', deliveryFormZipCode);
	      } else {
	        var errorContainer = $('#edd-form-block').find('.edd-error');
	        errorContainer.empty();
	        errorContainer.append(messages.ERR_INVALID_ZIP);
	        errorContainer.show();
	        $('#edd-form-block').removeClass('hide');
	      }
	    },
	
	    /** 
	     * Validates zip code. If valid calls bing and updates cookies for: zip code, state, city.
	     * Then, it invokes get edd service, and update UI with appropriate edd date or error message
	     */
	    refreshEDD: function refreshEDD(event) {
	
	      event.preventDefault();
	      var form = event.currentTarget;
	      var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	
	      // clear errors
	      if ($('#edd-form').find('.edd-error').length > 0) {
	        $('#edd-form').find('.edd-error').empty();
	      }
	
	      if (COSTCO.Product.validateZipCode(form)) {
	        var zipCode = $(form).find("input[name=eddZipCodeField]").val();
	
	        if (typeof zipCode !== 'undefined') {
	          zipCode = zipCode.toUpperCase();
	        }
	
	        serviceToUpdateCookies(zipCode).then(function () {
	          var qty = $('#minQtyText').val();
	          COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	        }).fail(function (data) {
	          // bing failed
	          var errorContainer = $('#edd-form-block').find('.edd-error');
	          errorContainer.empty();
	          errorContainer.append(messages.ERR_INVALID_ZIP);
	          errorContainer.show();
	        });
	      }
	    },
	
	    /**
	     * Shows zip code form whenever change zip is clicked in EDD widget, hides previously
	    * displayed scenario, and resets the states of Add to cart button and OOS overlay
	     */
	    showEddForm: function showEddForm() {
	      COSTCO.Product.hideEddMessagecode();
	      $('#edd-form-block').removeClass('hide');
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#eddZipCodeField').focus();
	      if (COSTCO.Product.eddMutationObserverState === Product.eddObserver.state.STARTED) {
	        COSTCO.Product.stopEDDMutationObserver();
	      }
	      $('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
	      $('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
	
	      COSTCO.Product.eddFormDisplayed = true;
	    },
	
	    retrieveEDD: function retrieveEDD() {
	      var qty = $('#minQtyText').val();
	      COSTCO.Product.callServiceAndRefreshEDD(qty, COSTCO.Product.refreshEDDServiceCallback);
	      var eddStockStatusUpdateDelay = $('#eddStockStatusUpdateDelay').val();
	      //To capture EDD response for local storage stock status we need this async
	      setTimeout(function () {
	        var itemPartNumber = COSTCO.Product.getPartnumber();
	        COSTCO.Product.updateEDDStockstatusforvariant(itemPartNumber);
	      }, eddStockStatusUpdateDelay);
	    },
	
	    callServiceAndRefreshEDD: function callServiceAndRefreshEDD(quantity, callback) {
	
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        //If the product coming soon flag is true, no need to check for EDD
	        return;
	      }
	      if (typeof quantity !== 'undefined' && parseInt(quantity) > 0) {
	        $(" #edd-check-button, #eddZipCodeField").attr("disabled", true);
	        COSTCO.Product.invokeEDDServices(quantity, callback);
	      }
	    },
	    /**
	     *  Method to invoke EDD service
	    **/
	    invokeEDDServices: function invokeEDDServices(quantity, callback) {
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var baseUri = $('#baseUriForEDD').val();
	      var baseInventoryHeader = $('#baseInventoryHeader').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var eddConnectionTime = $('#connectionTimeOutForEDD').val();
	      var smallPackConnectionTime = $('#baseUriConnectionTimeOutForSmallPack').val();
	      var serviceTimeOut = '';
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var country = COSTCO.Product.getCountry();
	      eddInstallationServicesJSON = {};
	      COSTCO.Product.hideEddMessagecode();
	      var zipCode = COSTCO.Product.getZipcode();
	      var costcoService = "restInventory";
	      var eddVendor;
	      var isGroceryProduct = $('#groceryIdentifier').val();
	      var eddUrl = '';
	      var shipcode = $('#defaultShipCode').val();
	      eddUrl = baseUri + '/' + itemPartNumber + "?destinationState=" + $.cookie('invCheckStateCode') + "&destinationPostalCode=" + zipCode + "&destinationCountryCode=" + country + "&quantity=" + quantity + "&orderItemId=" + "0" + "&shippingCodes=" + shipcode + "&action=EDD";
	      serviceTimeOut = eddConnectionTime;
	
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(serviceTimeOut, fetch(eddUrl, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier,
	          "costco.service": costcoService,
	          "costco-x-wcs-clientSystemId": baseInventoryHeader
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (jsonResponse) {
	
	        //identify backordered or presell status from edd response to prevent edd message display in PDP
	        var skipEddMessage = jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell;
	        var itemNumber = jsonResponse.itemNumber;
	
	        if ($("#displaybundle").length) {
	          if (null !== jsonResponse.virtualBundleId && undefined !== jsonResponse.virtualBundleId) {
	            $('#displaybundle').removeClass('hidden');
	            COSTCO.CMath.invokeBundleSetForPDP(jsonResponse.virtualBundleId);
	          } else {
	            $('#displaybundle').addClass('hidden');
	          }
	        }
	
	        SKIP_EDD = skipEddMessage;
	        //Set estimatedDeliveryDate if shipmodeDates has valid values present
	        var estimatedDeliveryDate = null !== jsonResponse.shipmodeDates && undefined !== jsonResponse.shipmodeDates && jsonResponse.shipmodeDates.length > 0 ? jsonResponse.shipmodeDates[0].estimatedDeliveryDate : undefined;
	
	        if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('smallpack')) {
	          if (jsonResponse.itemClassification === 'SMALLPACK' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateSmallPackEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (skipEddMessage) {
	            jsonResponse.messageCode = "EDD_BACKORDERED_PRESELL_ITEM";
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else if (undefined !== isGroceryProduct && isGroceryProduct === 'true') {
	            jsonResponse.messageCode = "EDD_SMALLPACK_GROCERY_UNAVAILABLE";
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else if ($('#vendorName').length > 0 && $('#vendorName').val().toLowerCase().includes('chubltl')) {
	          if (jsonResponse.itemClassification === 'CHUBLTL' && null !== estimatedDeliveryDate && undefined !== estimatedDeliveryDate) {
	            COSTCO.Product.populateChubLTLEDD(estimatedDeliveryDate);
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	              jsonResponse.messageCode = 'MSG_CODE_POSTAL_CODE_RESTRICTED';
	              COSTCO.Product.isEDDStatusAvailable = false;
	            } else {
	              jsonResponse.messageCode = "EDD_SMALLPACK_UNAVAILABLE";
	              COSTCO.Product.isEDDStatusAvailable = true;
	            }
	          }
	          callback(jsonResponse);
	        } else {
	          var msgCode = COSTCO.Product.buildMessageCodeForEDD(jsonResponse);
	          COSTCO.Product.setEDDdisplay(msgCode, jsonResponse);
	          if (jsonResponse !== undefined && jsonResponse.status !== undefined && jsonResponse.status === "SUCCESS") {
	            if (!COSTCO.util.isCAStore()) {
	              COSTCO.Product.prepareAndCallDeliveryServices();
	            }
	          }
	          callback(jsonResponse);
	          COSTCO.Product.executeAlways();
	        }
	      }).catch(function (err) {
	        COSTCO.Product.externalServiceDown();
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    }, populateSmallPackEDD: function populateSmallPackEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      $('.edd-carrier-text').addClass('hidden');
	    }, populateChubLTLEDD: function populateChubLTLEDD(estimatedDeliveryDate) {
	      var date = estimatedDeliveryDate.split('T')[0];
	      var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	      document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	      document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	      document.getElementById('edd-heading-text').innerHTML = messages.DATE_TEXT_SMALL_PACK;
	      document.getElementById('edd-heading-text-suffix').innerHTML = messages.DATE_TEXT_ORDER_NOW_SUFFIX;
	      COSTCO.Product.setZipInErrMsg('edd-date-msg');
	      $('#edd-date-msg').removeClass('hide');
	      document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_CHUB_LTL_GUARANTEE_PRECONDITION;
	      $('.edd-carrier-text').removeClass('hidden');
	    },
	    /**
	          *  Method to get selected partnumber for variant items and normal line items
	        **/
	    getPartnumber: function getPartnumber() {
	      var itemPartnumber = '';
	      var variantItem = COSTCO.Header.itemPartNumberSelcted;
	      var normalItem = $('#resultingItemNumbers').val();
	      if (variantItem !== undefined && variantItem !== '') {
	        itemPartnumber = variantItem;
	      } else {
	        itemPartnumber = normalItem.replace(/[[\]]/g, '');
	      }
	      return itemPartnumber;
	    },
	    /**
	          *  Method to get Zipcode for EDD and installation service call
	        **/
	    getZipcode: function getZipcode() {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var finalZip = '';
	      if (zipCode != null && zipCode != '') {
	        var zipCodeWithoutExtraFour = zipCode.split('-');
	        if (zipCodeWithoutExtraFour.length > 1) {
	          finalZip = zipCodeWithoutExtraFour[0];
	        } else {
	          finalZip = zipCode;
	        }
	      }
	      return finalZip;
	    },
	    /**
	          *  Method to hide message code components
	        **/
	    hideEddMessagecode: function hideEddMessagecode() {
	      $('#edd-date-msg').addClass('hide');
	      $('#edd-postal-code-restricted').addClass('hide');
	      $('#edd-oos-select-option').addClass('hide');
	      $('#edd-outofstock').addClass('hide');
	      $('#edd-unknown-error').addClass('hide');
	      $('#edd-addit-trans-time').addClass('hide');
	      $('#edd-msg-code-available-house').addClass('hide');
	      $('#edd-msg-code-external-service-down').addClass('hide');
	      $('#edd-transit-block').addClass('hide');
	      $(" #edd-check-button, #eddZipCodeField").attr("disabled", false);
	      $('#edd-back-order-msg').addClass('hide');
	      $('#edd-form-block').addClass('hide');
	      $('#edd-msg-code-smallpack').addClass('hide');
	      $('#edd-msg-code-grocery-smallpack').addClass('hide');
	    },
	    /**
	          *  Method to disable zipcode field based on refresh edd param
	        **/
	    executeAlways: function executeAlways() {
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	          *  Method to set EDD value from edd response to JSP page
	        **/
	    setEDDdisplay: function setEDDdisplay(msgCode, jsonResponse) {
	      if (msgCode !== undefined && msgCode !== '') {
	        var status = msgCode.split('+')[0];
	        var messageCode = msgCode.split('+')[1];
	        jsonResponse.status = status;
	        jsonResponse.messageCode = messageCode;
	        if (jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== undefined && jsonResponse.shipmodeDates[0].estimatedDeliveryDate !== null && status === "SUCCESS" && COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          var date = jsonResponse.shipmodeDates[0].estimatedDeliveryDate.split('T')[0];
	          var dateToDisplay = COSTCO.Product.getDateFormattedToDisplay(date);
	          jsonResponse.shipmodeDates[0].estimatedDeliveryDate = dateToDisplay;
	          document.getElementById('estimatedDeliveryDate').innerHTML = dateToDisplay;
	          document.getElementById('edd-postal-code').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-date-msg').removeClass('hide');
	          document.getElementById('edd-disclaimer-text').innerHTML = messages.EDD_AND_CALENDAR_GUARANTEE_PRECONDITION;
	          $('.edd-carrier-text').removeClass('hidden');
	        }
	      }
	    },
	    /**
	          *  Method to disable add to cart button and enable edd form if edd service is down
	          *  NOTE: If item is smallpack, we do not want to disable add to cart button on external service down or timeout
	        **/
	    externalServiceDown: function externalServiceDown() {
	      if ($('#vendorName').length > 0 && ($('#vendorName').val().toLowerCase().includes('smallpack') || $('#vendorName').val().toLowerCase().includes('chubltl'))) {
	        $('#add-to-cart-btn').attr("disabled", false);
	      } else {
	        $('#add-to-cart-btn').attr("disabled", true);
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      }
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#edd-msg-code-external-service-down').removeClass('hide');
	      $('#product-page').attr("data-onloadTracker", "false");
	      COSTCO.Product.pdpMakeElementSticky();
	    },
	    /**
	            *  Method to get country from lang id
	          **/
	    getCountry: function getCountry() {
	      var langId = COSTCO.util.getLangId();
	      var country = 'US';
	      if (langId === '-24' || langId === '-25') {
	        country = 'CA';
	      }
	      return country;
	    },
	    /**
	          * Method to set costco environment for service header
	        **/
	    validateCostcoEnv: function validateCostcoEnv() {
	      var costcoEnv = $('#costcoEnvironmentForEDD').val();
	      var higherEnv = 'QA2';
	      var ecomEnv = 'ECOM';
	      var devEnv = 'DEV';
	      if (costcoEnv === "") {
	        costcoEnv = ecomEnv;
	      } else if (costcoEnv == devEnv) {
	        costcoEnv = higherEnv;
	      }
	      return costcoEnv;
	    },
	    /**
	          * Method to invoke installation API service
	        **/
	    invokeInstallationServices: function invokeInstallationServices(eddServiceResponse, itemPartNumber, zipCode) {
	      var installationServiceUri = $('#baseUriForEDDInstallationServices').val();
	      var clientIdentifier = $('#apigeeClientIdentifierHeader').val();
	      var installationConnetionTime = $('#connectionTimeOutForEDD').val();
	      var costcoEnv = COSTCO.Product.validateCostcoEnv();
	      var installationUri = installationServiceUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&fulfilledBy=" + eddServiceResponse.fulfilledBy + "&orderItemId=" + "0";
	      var timeOutController = COSTCO.util.getTimeoutController();
	      timeOutController(installationConnetionTime, fetch(installationUri, {
	        method: 'GET',
	        headers: {
	          "costco.env": costcoEnv,
	          "client-identifier": clientIdentifier
	        }
	      })).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        eddInstallationServicesJSON = data.services;
	      }).catch(function (err) {
	        if (err.message !== undefined && err.message === 'API_TIMEOUT') {
	          console.log('API TIMEOUT');
	        } else {
	          console.log('API Service Fault');
	        }
	      });
	    },
	    /**
	     * Callback function which updates Add to cart button state and OOS overlay based on service response
	     */
	    refreshEDDServiceCallback: function refreshEDDServiceCallback(response) {
	      if (typeof response !== 'undefined' && !SKIP_EDD) {
	
	        if (COSTCO.util.islocationControlledInventoryFlow()) {
	          //fetch inventory from inventory service response
	          var inventoryStatus = $('.online-price[data-catentry=' + $('#catEntryId').val() + ']').data('inv');
	          // Handling of EDD messages of location controlled items - to avoid multiple message displays
	          // Item failing in CMath.handleContractSpecificRules() will not display EDD messages.
	          if (inventoryStatus === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            $('.edd-container').hide();
	            $('#edd-message-block').hide();
	          }
	          if (inventoryStatus !== COSTCO.util.productConstants.inv_backorderd && inventoryStatus !== COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	              COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	              document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-postal-code-restricted').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	              if (isPDPVariantGreyOutEnabled == 'false') {
	                $('.oos-overlay').removeClass('hide');
	              }
	              $('#edd-oos-select-option').addClass('hide');
	              document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	              $('#edd-outofstock').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	              $('.oos-overlay').addClass('hide');
	              $('#edd-msg-code-external-service-down').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-addit-trans-time').removeClass('hide');
	            } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-available-house').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	              $('.oos-overlay').addClass('hide');
	              document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	            } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	              COSTCO.Product.isLocCtrlSmallPck = true;
	              $('.oos-overlay').addClass('hide');
	              if (COSTCO.CMath.invAvailableAjax) {
	                //condition for depozipin small pck edd msg hide
	                $('#edd-msg-code-smallpack').removeClass('hide');
	                document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	              } else {
	                $('#edd-msg-code-smallpack').addClass('hide');
	              }
	            } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	              $('#edd-unknown-error').removeClass('hide');
	            } else {
	              $('.oos-overlay').addClass('hide');
	            }
	          }
	        } else if (response.messageCode === "MSG_CODE_POSTAL_CODE_RESTRICTED") {
	          $('.edd-container').show();
	          $('#edd-message-block').show();
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          document.getElementById('postal-code-restricted-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-postal-code-restricted').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK" && COSTCO.Product.isVariantAvailable()) {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ITEM_OUT_OF_STOCK") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART_OUTOFSTOCK);
	          if (isPDPVariantGreyOutEnabled == 'false') {
	            $('.oos-overlay').removeClass('hide');
	          }
	          $('#edd-oos-select-option').addClass('hide');
	          document.getElementById('out-of-stock-zip-code').innerHTML = $.cookie('invCheckPostalCode') + '.';
	          $('#edd-outofstock').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_EXTERNAL_SERVICE_DOWN") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-msg-code-external-service-down').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_ADDITIONAL_TRANSIT_TIME") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-transit-time').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-addit-trans-time').removeClass('hide');
	        } else if (response.messageCode === "MSG_CODE_AVAILABLE_INHOUSE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-available-inhouse').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-available-house').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_GROCERY_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          document.getElementById('edd-postal-code-grocery-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	          $('#edd-msg-code-grocery-smallpack').removeClass('hide');
	        } else if (response.messageCode === "EDD_SMALLPACK_UNAVAILABLE") {
	          $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          $('#edd-msg-code-smallpack').removeClass('hide');
	          document.getElementById('edd-postal-code-smallpack').innerHTML = $.cookie('invCheckPostalCode');
	        } else if (response.status === "FAILURE" || response.messageCode === "MSG_CODE_UNKNOWN_ERROR") {
	          COSTCO.Product.disableAddtoCart(messages.ADDTOCART);
	          $('#edd-unknown-error').removeClass('hide');
	        } else {
	          if (!COSTCO.CMath.siteControllOOS) {
	            $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('.oos-overlay').addClass('hide');
	          }
	        }
	      }
	      COSTCO.Product.eddFormDisplayed = false;
	    },
	
	    prepareAndCallDeliveryServices: function prepareAndCallDeliveryServices() {
	
	      var deliveryServicesRequestMap = new Map();
	      var itemPartNumber = COSTCO.Product.getPartnumber();
	      var zipCode = COSTCO.Product.getZipcode();
	      var deliveryServicesUri = $('#baseUriForEDDDeliveryServices').val();
	      installationUri = deliveryServicesUri + '/' + itemPartNumber + "?destinationPostalCode=" + zipCode + "&orderItemId=0";
	      var defaultShipcode = $('#defaultShipCode').val();
	      if (defaultShipcode) {
	        installationUri += "&shipMode=" + defaultShipcode;
	      }
	      deliveryServicesRequestMap.set(0, installationUri);
	      COSTCO.EDD.invokeDeliveryServices(deliveryServicesRequestMap, {});
	    },
	
	    isVariantAvailable: function isVariantAvailable() {
	      return $('#product-page').attr('data-onloadTracker') === "true" && !COSTCO.Product.isSingleAvailableSKU(products) && (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') ? true : false;
	    },
	    enableAddtoCart: function enableAddtoCart() {
	      $('#add-to-cart-btn').attr("disabled", false);
	      $('#add-to-cart-btn').attr("value", messages.ADDTOCART);
	      $('.oos-overlay').addClass('hide');
	      $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	      $('#add-to-list').show();
	      COSTCO.CMath.addBorderToShipItMolecule();
	    },
	    disableAddtoCart: function disableAddtoCart(buttonMessage) {
	      $('#add-to-cart-btn').attr("disabled", true);
	      $('#add-to-cart-btn').attr("value", buttonMessage);
	      $('.oos-overlay').addClass('hide');
	      COSTCO.CMath.addBorderToShipItMolecule();
	
	      if (buttonMessage == messages.ADDTOCART_OUTOFSTOCK) {
	        $('#add-to-list').hide();
	        COSTCO.CMath.addBorderToShipItMolecule('outOfStock');
	      } else {
	        $('#add-to-list').show();
	      }
	    },
	    /**
	          * Method used to replace latest zipcode in message code string
	        **/
	    setZipInErrMsg: function setZipInErrMsg(component) {
	      var zipCode = $.cookie('invCheckPostalCode');
	      var prevZipcode = document.getElementById('prevZipCode').value;
	      var str = document.getElementById(component).innerHTML;
	      if (prevZipcode !== undefined && prevZipcode !== "" && zipCode !== prevZipcode) {
	        document.getElementById(component).innerHTML = str.replace(prevZipcode, zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      } else if (prevZipcode === "") {
	        document.getElementById(component).innerHTML = str.replace("null", zipCode);
	        document.getElementById('prevZipCode').value = zipCode;
	      }
	    },
	    /**
	        * Method return EDD Date in Day,Month date (Thursday, October 1) format
	        **/
	    getDateFormattedToDisplay: function getDateFormattedToDisplay(date) {
	      var splitDate = date.split('-');
	      var year = splitDate[0];
	      var month = splitDate[1] - 1;
	      var day = splitDate[2];
	      var langId = COSTCO.util.getLangId();
	      var daysOfWeek;
	      var monthName;
	      if (langId === '-25') {
	        dateFormat = new Date(year, month, day).toLocaleDateString('fr-CA', { weekday: 'long', month: 'long', day: 'numeric' });
	      } else {
	        dateFormat = new Date(year, month, day).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
	      }
	      return dateFormat;
	    },
	    /**
	        *    Method return true if EDD date is in range after validating xapp entry EDD_MAX_FUTURE_DATE_DIFF
	       **/
	    checkIfEDDInValidRange: function checkIfEDDInValidRange(date) {
	      if (null != date) {
	        date = date.split('T')[0].split('-');
	        var rangeValid = false;
	        var eddMaxFutureDateDiff = parseInt($('#eddMaxFutureDateDiff').val());
	        var year = date[0];
	        var month = date[1] - 1;
	        var day = date[2];
	        var eddDate = new Date(year, month, day);
	        var today = new Date();
	        var diffTime = Math.abs(eddDate - today);
	        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
	        if (diffDays <= eddMaxFutureDateDiff) {
	          rangeValid = true;
	        }
	        return rangeValid;
	      }
	    },
	    /**
	             * Method used to form and return  message code from EDD response
	           **/
	    buildMessageCodeForEDD: function buildMessageCodeForEDD(jsonResponse) {
	      var msgString = '';
	      if (jsonResponse.availability === COSTCO.util.productConstants.edd_backordered || jsonResponse.availability === COSTCO.util.productConstants.edd_presell) {
	        //Backordered or Presell item messages will be displayed by inventory service flow
	        msgString = 'SUCCESS+EDD_BACKORDERED_PRESELL_ITEM';
	        COSTCO.Product.isEDDStatusAvailable = true;
	      } else if (typeof jsonResponse.availableForSale != 'undefined' && jsonResponse.availableForSale) {
	        if (typeof jsonResponse.shipmodeDates[0].estimatedDeliveryDate === 'undefined' || jsonResponse.shipmodeDates[0].estimatedDeliveryDate == null || jsonResponse.shipmodeDates[0].estimatedDeliveryDate != null && jsonResponse.shipmodeDates[0].estimatedDeliveryDate.trim().length === 0) {
	          if (COSTCO.Product.isAdditionalTransitTimeRequired()) {
	            msgString = 'SUCCESS+MSG_CODE_ADDITIONAL_TRANSIT_TIME';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          } else {
	            msgString = 'SUCCESS+MSG_CODE_AVAILABLE_INHOUSE';
	            COSTCO.Product.isEDDStatusAvailable = true;
	          }
	        } else if (COSTCO.Product.checkIfEDDInValidRange(jsonResponse.shipmodeDates[0].estimatedDeliveryDate)) {
	          msgString = 'SUCCESS+';
	          COSTCO.Product.isEDDStatusAvailable = true;
	        } else {
	          msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	          COSTCO.Product.isEDDStatusAvailable = false;
	        }
	      } else if ('ShipRestricted' === jsonResponse.fulfilledBy || COSTCO.util.productConstants.edd_shiprestricted === jsonResponse.availability) {
	        // If fulfilled by comes back with "ship restricted", show a different error message
	        msgString = 'FAILURE+MSG_CODE_POSTAL_CODE_RESTRICTED';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else if (jsonResponse.fulfilledBy != null && 'UNKNOWN' === jsonResponse.fulfilledBy.toUpperCase()) {
	        // if fulfilledBy = 'UNKNOWN' then an exception happened - date will be null
	        msgString = 'FAILURE+MSG_CODE_UNKNOWN_ERROR';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      } else {
	        msgString = 'FAILURE+MSG_CODE_ITEM_OUT_OF_STOCK';
	        COSTCO.Product.isEDDStatusAvailable = false;
	      }
	      return msgString;
	    },
	
	    updateEDDStockstatusforvariant: function updateEDDStockstatusforvariant(itemNumber) {
	      if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && isPDPVariantGreyOutEnabled == 'true') {
	        var uptitemarrayStatus = {};
	        var uptvariantitemArray = {};
	        var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	        var len = optionsSelected.length;
	        var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
	        var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
	        if (COSTCO.CMath.variantJSON.length > 0) {
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber && (!COSTCO.Product.isEDDStatusAvailable || COSTCO.CMath.isErrorlocationControlleditem)) {
	                uptitemarrayStatus["OL"] = '0';
	                uptitemarrayStatus["WH"] = sub_val.WH;
	                uptvariantitemArray[itemNumber] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[i] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	          for (var i in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[i];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == itemNumber) {
	                if (sub_val.OL == '0' && sub_val.WH == '0') {
	                  if (COSTCO.Product.item_type === 'multi_variant') {
	                    if (lowerSwatch) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if (lowerDropDown) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  } else if (COSTCO.Product.item_type === 'single_variant') {
	                    if ($('#swatches-productOption00').length > 0) {
	                      COSTCO.CMath.ajaxStrikeSwatches();
	                    } else if ($('.varis-v2[data-product=0]').length > 0) {
	                      COSTCO.CMath.ajaxGrayOutDropDown();
	                    }
	                  }
	                } else {
	                  //Following code for remove css of previous selected swatches
	
	                  if (lowerSwatch) {
	                    // pills
	                    if (COSTCO.Product.item_type === 'multi_variant') {
	
	                      variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
	                    } else if (COSTCO.Product.item_type === 'single_variant') {
	                      $('.selection-item').removeClass("select-span1-OOS");
	                      variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
	                    }
	                    $('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
	                    $('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
	                    $('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
	                  } else if (lowerDropDown) {
	                    // lower level drop-down
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').removeClass("out-of-stock");
	                    $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').children("span").remove();
	                  }
	                  COSTCO.CMath.update_selected_option_label(optionsSelected[len - 1]);
	                }
	                if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	                  COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	                } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	                  COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	                }
	              }
	            }
	          }
	        }
	      }
	    },
	    /**
	             * Method return true if additional transit time  required for selected state by checking  xapp entry EDD_STATES_THAT_REQUIRE_ADDITIONAL_TRANSIT_TIME
	           **/
	    isAdditionalTransitTimeRequired: function isAdditionalTransitTimeRequired() {
	      var additionalTransitTimeStates = $('#additionalTransitTimeStates').val();
	      var additionTransitTimeRequired = false;
	      var state = $.cookie('invCheckStateCode');
	      if (null !== state) {
	        state = state.toUpperCase();
	        if (additionalTransitTimeStates != null) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = additionalTransitTimeStates.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var stateFromConf = _step.value;
	
	              if (stateFromConf.toUpperCase() === state) {
	                additionTransitTimeRequired = true;
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	      return additionTransitTimeRequired;
	    },
	
	    /**
	     * This function appends price (and backordered text) to every Single Variant product's
	     * We will only show price if the item is not member only pricing if the member is not signed in
	     * select options so that they show something like this Color: "Brown - $194.99".
	     * @return {[void]}
	     */
	    set_option_price_text: function set_option_price_text() {
	      $('.variantContainer').each(function (i, vContainer) {
	        var product_num = $(vContainer).find('[data-product]').data('product');
	        if (this.isSingleVariant([products[product_num]], true)) {
	          $(vContainer).find('select.varis option').each(function (i, option) {
	            if ($(option).val() != 'unselected') {
	              var item = this.findItem(products[product_num], this.get_selected_array($(option))),
	                  back_ordered = item.inventory == 'BACK_ORDER' ? ' - ' + messages.BACKORDER_TEXT : item.inventory == 'OUT_STOCK' ? ' - ' + messages.OUT_OF_STOCK_TEXT : "";
	              var memberOnly = $('#memberItem').val() == "true" ? true : false,
	                  userInfo = COSTCO.util.getMemberCookie(),
	                  signedIn = userInfo.signedIn,
	                  costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	              var variantOptionText = $(option).text() + back_ordered;
	              if (!memberOnly || memberOnly && signedIn && costcoMember) {
	                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                  variantOptionText = variantOptionText;
	                } else {
	                  variantOptionText = variantOptionText + ' - ' + this.formatMoney(this.processPrice(item.price), true);
	                }
	              }
	              $(option).text(variantOptionText);
	              $variant_option_input = $('input[value=' + $(option)[0].value + ']');
	              if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
	                $variant_option_input.siblings('.selection-item')[0].innerHTML = variantOptionText;
	                $variant_option_input.removeAttr('checked');
	                if ($('.variantContainer select.varis').find('option:selected').val() == $(option).val()) {
	                  $('label[for=' + $('.variantContainer select.varis').find('option:selected').parent().attr('id') + ']').find('.selectedOptionValue').html(' ' + variantOptionText);
	                  $variant_option_input.prop('checked', true);
	                }
	              }
	              if (back_ordered.includes(messages.OUT_OF_STOCK_TEXT)) {
	                $(option).attr("disabled", "disabled");
	                $variant_option_input.attr("disabled", "disabled");
	                $variant_option_input.parents('label.variant-v2').addClass('disabled');
	              } else {
	                $variant_option_input.removeAttr('disabled');
	                $variant_option_input.parents('label.variant-v2').removeClass('disabled');
	              }
	            }
	          }.bind(this));
	        }
	      }.bind(this));
	    },
	    /**
	     * The popover for fees associated with a product. These are the "tool-tips" part
	     * of the line items in math table.
	     * @return {[void]}
	     */
	    pop_overs: function pop_overs() {
	      $('.co-info').popover({
	        container: '.math-table'
	      });
	
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        COSTCO.util.socialNetworksPopover('social-share-link');
	      }
	    },
	    /**
	     * If span.view-more-height is set by the business within
	     * a product's long description, this function sets the
	     * product details product-info-description to that designated
	     * max-height and appends a "View More Details" button.
	     * @return {[void]}
	     */
	    product_details_view_more: function product_details_view_more() {
	      $('#product-page .panel-body').each(function (index, el) {
	        var tab_max_height = $(el).find('.view-more-height').length > 0 ? $(el).find('.view-more-height').data('height') : $(el).find('.view-more-height-default').data('height'),
	            $content = $(el).find('.product-info-description');
	        var productType = $('#product-info').data('product');
	        //for BD specific, we want to show the content in its entirety
	        if (tab_max_height && productType !== 'tobacco') {
	          // Append the view more html
	          if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more', {}));
	          } else {
	            $content.after(COSTCO.util.tmpl('tmpl_view_more_v2', {}));
	          }
	          // Set the max-height to the business controlled max-height
	          $content.css({
	            'max-height': tab_max_height
	          });
	        }
	      });
	    },
	    /**
	     * Event listener for button allocated by product_details_view_more
	     * that removes the max-height attribute and then removes itself to
	     * view the entire product details.
	     * @return {[void]}
	     */
	    view_more: function view_more() {
	      if (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $(this).parents('.view-more').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	        $(this).parents('.view-more').remove();
	      } else {
	        $(this).parents('.view-more-v2').siblings('.product-info-description').css({
	          'max-height': 'none'
	        });
	
	        $(this).parents('.view-more-v2').siblings('.product-info-description').removeClass('bv-review-section');
	
	        try {
	          var focusableElements = $(this).parents('.view-more-v2').siblings('.section-title');
	          focusableElements.attr('tabindex', '0');
	          $(focusableElements).focus();
	          if ($(this).parents('.panel-body').attr('id') === "nav-pdp-tab-header-13") {
	            COSTCO.Product.changeVisibilityOfReviewContents("show");
	          }
	          focusableElements.removeAttr('tabindex');
	        } catch (err) {}
	        $(this).parents('.view-more-v2').remove();
	      }
	    },
	    findItem: function findItem(p, o) {
	      if (o.length == 0 && p.length > 0) {
	        return p[0];
	      }
	      for (var i = 0; i < p.length; i++) {
	        if (this.areArraysEqual(o, p[i].options) || o == p[i].catentry) {
	          return p[i];
	        }
	      }
	      return null;
	    },
	    areArraysEqual: function areArraysEqual(array1, array2) {
	      var temp = new Array();
	      if (!array1[0] || !array2[0]) {
	        // If either is not an array
	        return false;
	      }
	      if (array1.length != array2.length) {
	        return false;
	      }
	      for (var i = 0; i < array1.length; i++) {
	        key = _typeof(array1[i]) + "~" + array1[i];
	        if (temp[key]) {
	          temp[key]++;
	        } else {
	          temp[key] = 1;
	        }
	      }
	      for (var i = 0; i < array2.length; i++) {
	        key = _typeof(array2[i]) + "~" + array2[i];
	        if (temp[key]) {
	          if (temp[key] == 0) {
	            return false;
	          } else {
	            temp[key]--;
	          }
	        } else {
	          // Key didn't appear in array1, arrays are not equal.
	          return false;
	        }
	      }
	      return true;
	    },
	    isSingleItem: function isSingleItem(productsArray) {
	      var no_variant_container = $('.variantContainer').length == 0;
	      return productsArray.length === 1 && productsArray[0].length === 1 && no_variant_container ? true : false;
	    },
	    isSingleAvailableSKU: function isSingleAvailableSKU(productsArray) {
	      return productsArray.length === 1 && productsArray[0].length === 1 ? true : false;
	    },
	
	    isBundle: function isBundle(productsArray) {
	      return productsArray.length > 1 || $('.bundleQty').length > 0;
	    },
	    /**
	     * On product page search for collection tab.
	     * 
	     * @return true if collection tab exist, otherwise false
	     */
	    isCollectionPage: function isCollectionPage() {
	      return $('#product-page').find('.collection-tab').length > 0 ? true : false;
	    },
	    isSingleVariant: function isSingleVariant(productsArray, override) {
	      if (productsArray != undefined && productsArray[0] != undefined && productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length === 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isMultiVariant: function isMultiVariant(productsArray, override) {
	      if (productsArray.length === 1 && $('.bundleQty').length === 0 || override) {
	        for (var i = 0, len = productsArray[0].length; i < len; i++) {
	          if (productsArray[0][i].options) if (productsArray[0][i].options.length > 1) return true;
	        }
	      } else {
	        return false;
	      }
	      return false;
	    },
	    isSelectedSingleVariantBackOrdered: function isSelectedSingleVariantBackOrdered(selectedOption, product) {
	      var isBackordered = false,
	          selectedOptionValue = selectedOption.val();
	      product.forEach(function (opt, i) {
	        if (selectedOptionValue === opt.options[0]) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    isSelectedMultiVariantBackOrdered: function isSelectedMultiVariantBackOrdered(selectedOptions, product) {
	      var isBackordered = false;
	      product.forEach(function (opt, i) {
	        var options = opt.options,
	            count = 0;
	        selectedOptions.each(function (chosen, k) {
	          if (COSTCO.util.hasElem(this.value, options)) count++;
	        });
	        if (count === options.length) {
	          if (opt.inventory === "BACK_ORDER") isBackordered = true;
	          return;
	        }
	      });
	      return isBackordered;
	    },
	    areAnySelectedFromBundleBackordered: function areAnySelectedFromBundleBackordered(containers) {
	      var isBackordered = false;
	      products.forEach(function (product, index) {
	        // interogate each product from 'products' array; find out what kind of item it is
	        var selectedValue;
	        if (this.isSingleItem([products[index]])) {
	          if ($(containers[index]).find('select').length) {
	            // Single item with a select box with only one option
	            selectedValue = $(containers[index]).find('select > option:selected').val();
	            if (selectedValue === products[index][0].options[0]) if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          } else if (parseInt($(containers[index]).find('input').val()) > 0) {
	            // Single item with no select box (just quantity input shown)
	            if (products[index][0].inventory === "BACK_ORDER") isBackordered = true;
	            return;
	          }
	        } else if (this.isSingleVariant([products[index]], true)) {
	          if (this.isSelectedSingleVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        } else if (this.isMultiVariant([products[index]], true)) {
	          if (this.isSelectedMultiVariantBackOrdered($(containers[index]).find('select > option:selected'), products[index])) {
	            isBackordered = true;
	            return;
	          }
	        }
	      }.bind(this));
	      return isBackordered;
	    },
	    bindSubmitToBackOrderModal: function bindSubmitToBackOrderModal() {
	      $("#ProductForm input[name='add-to-cart']").unbind('click').click(function () {
	        if (this.item_type == 'single') {
	          // Its a single product aka only "add to cart" button exists
	          typeof products[0][0].inventory !== "undefined" && products[0][0].inventory === 'BACK_ORDER' ? this.backorder_modal(products[0][0]) : $('#ProductForm').submit();
	        } else if (this.item_type == 'single_variant') {
	          // Its a single item with options (ie color or size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedSingleVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'multi_variant') {
	          // Its a single item with multiple options (ie color and size, etc.)
	          var $options = $('#ProductForm select option:selected'),
	              selected_arr = this.get_selected_array($options);
	          this.isSelectedMultiVariantBackOrdered($options, products[0]) ? this.backorder_modal(this.findItem(products[0], selected_arr)) : $('#ProductForm').submit();
	        } else if (this.item_type == 'bundle') {
	          // Its bundle which can contain variants/singleItems - check the option(s) selected and see if they're backordered
	          this.areAnySelectedFromBundleBackordered($('.variantContainer')) ? this.backorder_modal() : $('#ProductForm').submit();
	        } else {
	          // fallback - always try to add to cart.
	          $('#ProductForm').submit();
	        }
	      }.bind(this));
	    },
	    is_sku_resolved: function is_sku_resolved(item_type, quantity_obj) {
	      var resolved = false;
	      if (item_type == 'single_variant' || item_type == 'multi_variant') {
	        // Get values of variant options selected
	        var selected_arr = this.get_selected_array($('.varis option:selected'));
	        // Are any of the select options "unselected"?
	        var any_unselected = COSTCO.util.any(selected_arr, function (value) {
	          return value == 'unselected';
	        });
	        if (!any_unselected) resolved = true;
	      } else if (item_type == 'bundle') {
	        quantity_obj.product_indices.forEach(function (indice) {
	          var product_num = indice;
	          var productArray = products && products[product_num] ? products[product_num] : [];
	          var optionsSelected = this.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
	          var product_selected = this.findItem(productArray, optionsSelected);
	          if (product_selected) {
	            // If at least one product is resolved, we're good.
	            resolved = true;
	            return;
	          }
	        }.bind(this));
	      } else {
	        // We're a single item. We always resolve.
	        resolved = true;
	      }
	      return resolved;
	    },
	    /**
	     * Returns the option:selected ($options) values as an array of strings
	     * aka ['7000000000000053', '7000000000000623']
	     * @param  {[object]} $options - The jQuery selector representing option:selected
	     * @return {[array]} Returns an array of strings
	     */
	    get_selected_array: function get_selected_array($options) {
	      return $.map($options, function (option) {
	        return $(option).val();
	      });
	    },
	    maxQuantity: function maxQuantity() {
	      return COSTCO.util.isBusinessDelivery() ? COSTCO.Product.MAX_QUANTITY_BD : Number($('#cartTotalLimitBC').val());
	    },
	    /**
	     * Returns an object with two properties. The first property, 'valid',
	     * is set to true/false based on whether or not we have (at least one) valid
	     * quantity. The product_indices property correlates with bundles; specifically
	     * their 'data-product=' attributes and is used to validate skus in the next step
	     * of validation.
	     * @param  {[string]} item_type - string representing item type. Corresponds
	     * with phelper.item_type
	     * @param quantityId quantity input element reference
	     * @return {[object]} quantity_obj - The object containing valid quantity p
	     * property (and product_indicies in case of bundles)
	     */
	    is_valid_quantity: function is_valid_quantity(item_type, quantityId) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      var unitOfMeasure = COSTCO.Product.getUnitOfMeasure(quantityId);
	      var err_msgs = {
	        min: "<p class='sr-only'>" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)),
	        max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	        badQtyIncrement: "<p class='sr-only'>" + messages.ERROR + "</p>" + quantityId.data("error-message") + ' ' + COSTCO.Product.getQuantityStep(quantityId, unitOfMeasure)
	      };
	      var quantity_obj = {
	        valid: true,
	        message: err_msgs.min
	      };
	      var product_indices = [];
	      var maxQnty = COSTCO.Product.maxQuantity();
	      var bundleQuantity = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE == true ? 'input[name^=bundle-quantity-]' : 'input[name^=quantity-]';
	      if (item_type == 'bundle') {
	        // At least one quantity must be valid
	        $(bundleQuantity).each(function (i, input) {
	          var quantity_str = $(input).val();
	          var quantity_int = parseInt(quantity_str);
	          if (!COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	            product_indices.push($(input).data('product'));
	            $(input).attr('aria-invalid', 'false');
	          } else {
	            //set aria-invalid to reflect invalid entry
	            $(input).attr('aria-invalid', 'true');
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              quantity_obj.valid = false;
	              if (quantity_int <= 0) {
	                quantity_obj.message = err_msgs.min;
	              }
	              if (quantity_int > maxQnty) {
	                quantity_obj.message = err_msgs.max;
	              }
	            }
	          }
	        });
	        if (product_indices.length == 0) {
	          quantity_obj.valid = false;
	        }
	      } else {
	        var quantity_str = $('input[name=quantity]').val();
	        var quantity_int = parseInt(quantity_str);
	        if (COSTCO.Product.testInput(quantity_str, quantity_int, maxQnty, quantityStep)) {
	          $('input[name=quantity]').attr('aria-invalid', 'true');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            quantity_obj.valid = false;
	            $('input[name=quantity]').addClass('error-qty');
	            if (quantity_int <= 0) {
	              quantity_obj.message = err_msgs.min;
	            } else if (quantity_int > maxQnty) {
	              quantity_obj.message = err_msgs.max;
	            } else if (quantity_int % quantityStep != 0) {
	              quantity_obj.message = err_msgs.badQtyIncrement;
	            }
	          }
	        } else {
	          $('input[name=quantity]').attr('aria-invalid', 'false');
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            $('input[name=quantity]').removeClass('error-qty');
	          }
	        }
	      }
	      quantity_obj.product_indices = product_indices;
	      return quantity_obj;
	    },
	    /**
	     * Returns unit of measure of input quantity value (empty string if there is no unit of measure)
	     * @param quantityId quantity input element reference
	     * @return quantity value unit of measure
	     */
	    getUnitOfMeasure: function getUnitOfMeasure(quantityId) {
	      return quantityId.next('.unit').text();
	    },
	    /**
	     * Returns true if iput value is vlaid or false otherwise
	     * @param quantity_str quantity input value in form of string
	     * @param quantity_int quantity input value in form of integer
	     * @param maxQty maximum quantity input value
	     * @param increment increment/step of quantity input value
	     * @return true if iput value is vlaid or false otherwise
	     */
	    testInput: function testInput(quantity_str, quantity_int, maxQty, increment) {
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str || quantity_int % increment != 0;
	      } else {
	        return isNaN(quantity_int) || quantity_int <= 0 || quantity_int > maxQty || quantity_int.toString() != quantity_str;
	      }
	    },
	
	    backorder_modal: function backorder_modal(product) {
	      // The user must select "add to cart" in the backorder modal to switch this to true
	      var add_obj = {
	        isAdd: false
	      };
	      COSTCO.dialog.showModal({
	        title: messages.RWD_ITEM_BACKORDERED,
	        body: this.backorder_message(product),
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary: messages.ADDTOCART,
	        primary_event: function () {
	          // user selected "add to cart"
	          this.isAdd = true;
	          $('#costcoModal').modal('hide');
	        }.bind(add_obj),
	        afterclose: function () {
	          if (this.isAdd) {
	            // If primary event was selected, add to cart
	            $('#ProductForm').submit();
	          }
	          this.isAdd = false; // reset state
	        }.bind(add_obj)
	      });
	    },
	    backorder_message: function backorder_message(product) {
	      if (isBDApplication && isBDApplication === 'BC') {
	        var message = product.backorderMessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        var locmessage = $('#backorder-message').text();
	        if (product.isLocInvItem || (typeof locmessage === "undefined" ? "undefined" : _typeof(locmessage)) !== undefined && null != locmessage) {
	          message = locmessage + ' ' + messages.BACKORDER_TEXT_ADD;
	        }
	        return message;
	      }
	      var message_key = 'BACKORDER_TEXT_',
	          message_num = product && product.message || '5',
	          date_1 = product && product.date || '',
	          date_2 = product && product.date2 || '';
	
	      if (product) {
	        if (product.allBackorderable == 0) {
	          message_key += 'PART_MSG';
	        } else {
	          message_key += 'MSG';
	        }
	        switch (message_num) {
	          case '1':
	            message_key += message_num;
	            break;
	          case '2':
	            message_key += message_num;
	            break;
	          case '3':
	            date_1 == date_2 ? message_key += 1 : message_key += message_num;
	            break;
	          case '4':
	            date_1 == date_2 ? message_key += 2 : message_key += message_num;
	            break;
	          default:
	            message_key += message_num;
	        }
	      } else {
	        message_key += 'MSG' + message_num;
	      }
	      return messages[message_key].replace('{0}', date_1).replace('{1}', date_2) + ' ' + messages.BACKORDER_TEXT_ADD;
	    },
	    /**
	     * Add to cart modal. Invoked after the "done" promise resolves
	     * when calling AddToCart.ajaxAddToCart.
	     * @param  {[array]} selected_products Array of objects representing
	     * the items that went into the cart
	     * @return {[void]}
	     */
	    added_modal: function added_modal(selected_products, orderItemId, qtyBought, originalQty) {
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          partsandservices = this.getPartsAndServices($('#configuredInfo').val()),
	          partsandservicesType = $('#configuredInfoType').val(),
	          service_html = "",
	          parts_html = "",
	          remark_html = "",
	          parts_and_services_html = "",
	          partandserviceArray = "";
	      if ($('#reactkitsandbundle').val() != 'true') {
	        var $related_products_template = $('#product-page .related-products');
	        $('#product-page .related-products').remove();
	      } else {
	        var selectedVirtualParentPartnumber = $('#productPartnumberVal').val();
	        $related_products_template = $('#product-page #RelatedProducts_' + selectedVirtualParentPartnumber);
	      }
	      var installationFlag = undefined;
	      if (partsandservices != "") {
	        var installationFlag = JSON.parse(partsandservices).installationAvailable;
	      }
	
	      //show if installation is not available
	      if (installationFlag != undefined && !installationFlag) {
	        remark_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_no_installation', {
	          remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
	        });
	      }
	
	      //Parts and service section for Added to cart model box
	      if (partsandservicesType == 7) {
	        if (partsandservices != 'undefined' && partsandservices.length > 0 && partsandservices != "") {
	          partandserviceArray = JSON.parse(partsandservices).services;
	          if (partandserviceArray != 'undefined' && partandserviceArray != "" && partandserviceArray.length > 0) {
	            $.each(partandserviceArray, function (index, value) {
	              if (value.serviceType == 'Service') {
	                service_html += COSTCO.util.tmpl('tmpl_services', {
	                  description: value.description,
	                  selected: value.selected ? "Yes" : "No"
	                });
	              } else if (value.serviceType == 'Part') {
	                if (!value.hidden && value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description
	                  });
	                } else if (!value.hidden && !value.selected && value.availabilityType != 'hidden') {
	                  parts_html += COSTCO.util.tmpl('tmpl_delivery_parts_service_list', {
	                    description: value.description + " : No"
	                  });
	                }
	              }
	            });
	
	            parts_and_services_html = COSTCO.util.tmpl('tmpl_parts_and_services_addedtocart', {
	              services: service_html,
	              parts: parts_html,
	              remarks: remark_html != "" ? remark_html : ""
	            });
	          }
	        }
	      }
	
	      selected_products.forEach(function (product, orderItemId) {
	        // this is for the added to cart review modal
	        var ecofeeIncludedPrice = (document.getElementById("ecoFeeHiddenLayout_" + product.catentry) || {}).value || "0";
	        items_html += COSTCO.util.tmpl(product.isFsaChdItem == 'true' ? 'tmpl_addtocart_item_FsaChd' : 'tmpl_addtocart_item', {
	          img_url: product.img_url ? product.img_url : product.parent_img_url,
	          item_name: product.productName,
	          item_url: product.productUrl,
	          item_number: product.item_number,
	          model_number: product.manufacturerPartNumber,
	          price: ecofeeIncludedPrice != "0" ? ecofeeIncludedPrice : product.final_price,
	          quantity: product.quantity,
	          orderItemId: orderItemId,
	          parts_and_services_html: parts_and_services_html != "" ? parts_and_services_html : "",
	          linkFee: COSTCO.Product.displayLinkFee(product.feeOptions)
	        });
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.RELATED_PRODUCT_ADDED_TO_CART,
	        dialogclasses: 'medium',
	        body: COSTCO.util.tmpl('tmpl_addtocart_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          //COSTCO.Header.refreshMiniBanner();
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	          window.wioEventBus.publish('focusPickUpButton', { focusPickUpButton: true });
	        }
	      });
	      $('input[name="parentOrderItemId"]').val(orderItemId);
	      $('input[name="relatedQty"]').val(originalQty);
	      console.log("Related Quantity Incoming :: " + originalQty + " :: Document source " + $('input[name="relatedQty"]').val());
	      if ($('#related-products-container:not(.hide)').find('div[name="RelatedProductFormDiv"]:not(.hide)').length > 0) {
	        $('.modal-body .related-products').removeClass('hide');
	
	        if (relProductLinkFee !== undefined && relProductLinkFee != null) {
	          Object.entries(relProductLinkFee).forEach(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                key = _ref2[0],
	                value = _ref2[1];
	
	            if ($('#relLinkFee_' + key).length > 0) {
	              $('#relLinkFee_' + key).html(COSTCO.Product.displayLinkFee(value));
	            }
	          });
	        }
	      }
	      $('.co-help.eco-fee').popover();
	    },
	    /**
	     * If a related product is a member only item, show pricing based on member cookie.
	     * @return {[void]}
	     */
	    related_products_member_pricing: function related_products_member_pricing() {
	      var userInfo = COSTCO.util.getMemberCookie(),
	          signedIn = userInfo.signedIn,
	          costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
	          validated = userInfo.validated != 'undefined' ? userInfo.validated : false;
	      active = userInfo.active != 'undefined' ? userInfo.active : false;
	      // This check is added to keep BD flow unaffected by the change in BC flow
	      var showPricingForMember = COSTCO.util.isBusinessDelivery() ? costcoMember : costcoMember && validated && active;
	      if (!signedIn) {
	        $('.sign-in').show();
	        $('.price-details.moi,.productFormContent.moi-atcf,.mem-button.moi').hide();
	      } else {
	        if (showPricingForMember) {
	          $('.sign-in, .mem-button').hide();
	        } else {
	          $('.price-details.moi,.productFormContent.moi-atcf,.sign-in').hide();
	        }
	      }
	    },
	
	    displayLinkFee: function displayLinkFee(feeOptions) {
	      var _this2 = this;
	
	      var linkFeeContenty = '';
	      if (feeOptions !== 'undefined' && feeOptions != null) {
	        var feesConfiguration;
	        var i;
	
	        (function () {
	          var region = $.cookie('C_LOC');
	          feesConfiguration = typeof feesConfigurations !== 'undefined' ? feesConfigurations : null;
	
	          if (feesConfiguration !== 'undefined' && feesConfiguration != null) {
	            var regionalFeeConfig = feesConfiguration[region] || feesConfiguration["ALL"];
	            if (regionalFeeConfig !== undefined && regionalFeeConfig != null) {
	              var _loop = function _loop() {
	                var feeCatConfig = regionalFeeConfig[i];
	                var feeTypeLis = feeCatConfig.feeType.split(',');
	                var categoryWiseFeeOpt = feeOptions.filter(function (fee) {
	                  return fee.region == region && fee.feeCategory == feeCatConfig.feeCategory;
	                });
	                if (categoryWiseFeeOpt !== undefined && categoryWiseFeeOpt != null) {
	                  var hasHybridFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && !feeTypeLis.includes(fee.feeType);
	                  });
	                  var isRegionFee = categoryWiseFeeOpt.some(function (fee) {
	                    return feeTypeLis[0] != 'ALL' && feeTypeLis.includes(fee.feeType);
	                  });
	                  var feeCategory = '',
	                      display = '',
	                      feeDesc = '';
	                  var feeAmount = 0,
	                      sameFeeCategoryCount = 0;
	                  var _iteratorNormalCompletion2 = true;
	                  var _didIteratorError2 = false;
	                  var _iteratorError2 = undefined;
	
	                  try {
	                    for (var _iterator2 = categoryWiseFeeOpt[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                      var feeOption = _step2.value;
	
	                      if (feeOption.feeCategory === feeCatConfig.feeCategory) {
	                        if (feeTypeLis.includes(feeOption.feeType) || feeCatConfig.feeType === "ALL" || hasHybridFee && !isRegionFee) {
	                          sameFeeCategoryCount++;
	                          if (!hasHybridFee || hasHybridFee && !isRegionFee) {
	                            feeAmount += parseFloat(feeOption.price);
	                          }
	                          feeCategory = feeOption.feeCategory;
	                          display = hasHybridFee ? 'STANDARD' : feeCatConfig.display.Browse;
	                          feeDesc = COSTCO.util.sentenceToPascalCase(feeOption.desc.trim());
	                        } else if (hasHybridFee) {
	                          feeAmount += parseFloat(feeOption.price);
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                      }
	                    } finally {
	                      if (_didIteratorError2) {
	                        throw _iteratorError2;
	                      }
	                    }
	                  }
	
	                  if (sameFeeCategoryCount > 0) {
	                    linkFeeContenty += COSTCO.util.tmpl('tmpl_addtocart_linkFee_display', {
	                      "feeCategory": feeCategory,
	                      "display": display,
	                      "fee": feeAmount > 0 ? _this2.formatMoney(_this2.processPrice(feeAmount), true) : '',
	                      "feeDesc": feeDesc,
	                      "ecoFeeToolTipContent": ecoFeeToolTipContent
	                    });
	                  }
	                }
	              };
	
	              for (i = 0; i < regionalFeeConfig.length; i++) {
	                _loop();
	              }
	            }
	          }
	        })();
	      }
	      return linkFeeContenty;
	    },
	
	    /**
	     * Gets an array of item objects that are selected on the page with positive quantity
	     * @return {[array]} an array of item objects
	     */
	    getSelectedBundleAndVariantItems: function getSelectedBundleAndVariantItems() {
	      var selectedItems = [];
	      $('.variantContainer').each(function (index) {
	        var qty = $('input[name=quantity]').val(); //for non-bundle
	        var bundleQty = $(this).find('input[name^=quantity-]').val(); //for bundle
	        if (qty > 0 || bundleQty > 0) {
	          if ($(this).find('.swatchDropdown').length > 0) {
	            //variant
	            var options = [];
	            $(this).find('.varis :selected').each(function () {
	              options.push($(this).val());
	            });
	            selectedItems.push(COSTCO.Product.findItem(products[index], options));
	          } else {
	            //not a variant
	            selectedItems.push(products[index][0]);
	          }
	        }
	      });
	      return selectedItems;
	    },
	    /**
	     * Shows plain packaging option on variant selection and/or bundle quantity change
	     * based on plainPackaging property of selected item(s) on the page. Immediately
	     * shows plain packaging option for a single item page.
	     * @return {[void]}
	     */
	    enablePlainPackagingMessage: function enablePlainPackagingMessage() {
	      //shows or hides plain packaging message based on given option
	      function showHideMessage(ppOption) {
	        //for bundles and variants ppOption will be array.
	        //call the function again based on what's in the array.
	        if ($.isArray(ppOption)) {
	          if ($.inArray("0", ppOption) > -1) {
	            showHideMessage("0");
	          } else if ($.inArray("1", ppOption) > -1) {
	            showHideMessage("1");
	          } else if ($.inArray("3", ppOption) > -1) {
	            showHideMessage("3");
	          } else {
	            showHideMessage(null);
	          }
	          return;
	        }
	        if (ppOption == "1") {
	          //available
	          $("#plain-packaging-available").show();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "0") {
	          //not available
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").show();
	          $("#plain-packaging-mandatory").hide();
	        } else if (ppOption == "3") {
	          //mandatory plain packaging option
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").show();
	        } else {
	          //don't show a message. This will be a value of null for item's plainPackaging property
	          $("#plain-packaging-available").hide();
	          $("#plain-packaging-not-available").hide();
	          $("#plain-packaging-mandatory").hide();
	        }
	      }
	
	      //returns an array of plainPackaging properties of the given items
	      function getPPOptions(items) {
	        var ppOptions = [];
	        $(items).each(function () {
	          ppOptions.push(this.plainPackaging);
	        });
	
	        return ppOptions;
	      }
	
	      if (typeof products == 'undefined') {
	        return;
	      }
	      if (COSTCO.Product.isSingleItem(products)) {
	        showHideMessage(products[0][0].plainPackaging);
	      } else {
	        //bind change event on variant selection and quantity change
	        $('.variantContainer').on('change', '.swatchDropdown:last, input[name^=quantity]', function () {
	          var selectedItems = COSTCO.Product.getSelectedBundleAndVariantItems();
	          showHideMessage(getPPOptions(selectedItems));
	        });
	      }
	    },
	
	    addToWishList: function addToWishList(baseURL) {
	      if ($('#ProductForm').valid()) {
	        var target = baseURL + '&catentryId=' + $('#ProductForm .catentryInput').map(function () {
	          return $(this).val();
	        }).get().join(',');
	        window.location = target;
	      }
	    },
	
	    openWishListSuccess: function openWishListSuccess() {
	      var queryString = COSTCO.util.getQueryStringArray();
	      if (queryString['addToWishlistSuccessMessageKey']) {
	        COSTCO.dialog.createExtDialogBox({
	          title: messages.RWD_WISH_LIST_CONFIRM_TITLE,
	          body: messages.WISHLIST_ITEM_ADD_CONFIRMATION_MESSAGE,
	          primary: messages.RWD_VIEW_WISH_LIST,
	          primary_event: function primary_event() {
	            window.location = '/NonAjaxAccountWishListDisplayView?listId=.';
	          },
	          secondary: messages.CONTINUE_SHOPPING
	        });
	      }
	    },
	    /**
	     * Select options modal for GE. Invoked after the "done" promise resolves
	     * @param data = Parts and Services JSON
	     * @return {[void]}
	     */
	    show_options_modal: function show_options_modal(data) {
	      var locale = COSTCO.util.getLocale();
	      var selected_product = undefined;
	      if (this.isSingleItem(products)) selected_product = this.findItem(products[0], []);else selected_product = this.getSelectedBundleAndVariantItems()[0];
	
	      selected_product.quantity = messages.RWD_QUANTITY + ' ' + $('input[name=quantity]').val();
	      selected_product.item_number = $('span.item-number').text();
	      selected_product.final_price = (locale == 'en-US' || locale == 'en-CA' ? ' $' : '') + $('.your-price .value').text() + (locale == 'fr-CA' ? ' $' : '');
	
	      this.related_products_member_pricing();
	      $('.modal-footer').addClass('hide');
	      var items_html = "",
	          $related_products_template = $('#product-page .related-products');
	      $('#product-page .related-products').remove();
	
	      //call function to create parts and services form
	      var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(data);
	
	      partsservices_html = options_htmls['partsservices_html'];
	      remark_html = options_htmls['remark_html'];
	
	      items_html += COSTCO.util.tmpl('tmpl_selected_delivery_Item', {
	        img_url: selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url,
	        item_name: selected_product.productName,
	        item_url: selected_product.productUrl,
	        item_number: selected_product.item_number,
	        price: selected_product.final_price,
	        quantity: selected_product.quantity,
	        partsservices: partsservices_html,
	        remarksContainer: remark_html,
	        model_number: null
	      });
	
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SCHED_DELIV_SELECT_OPTIONS_HEADING,
	        body: COSTCO.util.tmpl('tmpl_select_options_modal', {
	          items: items_html,
	          related_products: $related_products_template.length > 0 ? $related_products_template[0].outerHTML : ''
	        }),
	        onclose: function onclose() {
	          $('.modal-footer').removeClass('hide');
	          if ($related_products_template.length > 0) {
	            $('#product-page').append($related_products_template[0].outerHTML);
	          }
	        }
	      });
	      $('.modal-body .related-products').removeClass('hide');
	    },
	    /**
	     * this function is to prevent rich media from injecting swatches
	     * onto our page when product has no buyable items or is out of stock.
	     * We don't include theSwatches div in these cases on the jsp so we add
	     * it here.
	     */
	    injectHiddenSwatchesDiv: function injectHiddenSwatchesDiv() {
	      if ($('#theSwatches').length == 0) {
	        $('<div id="theSwatches" class="hide"></div>').appendTo('#zoomViewer');
	      }
	    },
	    /**
	     * Function used to check if any modifications have been appended
	     * to the product details accordion
	     */
	
	    startMutationObserver: function startMutationObserver() {
	      //STRY0141473 - fire showViewMore() anyway if none of the mutations occur
	      COSTCO.Product.showViewMore(observerObject);
	
	      var targetObject = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#product-info')[0] : $('#accordion-product-details')[0];
	      try {
	        if (!$('#CostcoBVContainer').length > 0) {
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type) {
	                COSTCO.Product.showViewMore(observerObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        } else {
	          // Observe Reviews section on PDP
	          var observerObjectReview = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("childList" === mutation.type && ($(mutation.target).find('#bv_review_maincontainer').length > 0 || $(mutation.target).find('.bv-content-list-container').length > 0)) {
	                COSTCO.Product.showViewMore(observerObjectReview);
	
	                if (isBVv2Enabled === 'false') {
	                  // Auto popup BV Write a Review for relogin user
	                  // bveventid is appended to logonform by BV when not logged in user tries WAR
	                  var bveventid = COSTCO.util.getParameterByName('bveventid');
	                  var summaryWAR = $('#WAR');
	                  if (bveventid !== null && summaryWAR.length > 0) {
	                    summaryWAR.trigger('click');
	                  }
	                }
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObjectReview.observe(targetObject, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	
	          //INC3616033 add a seperate mutationObserver for product-info-description
	          var prodInfoObserverObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              if ("attributes" === mutation.type || "childList" === mutation.type) {
	                COSTCO.Product.showViewMore(prodInfoObserverObject);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          prodInfoObserverObject.observe($('.product-info-description')[0], {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	            characterData: true
	          });
	        }
	        //If < IE 10 then display the product details in its entirety
	      } catch (e) {
	        COSTCO.Product.view_more(this);
	        return;
	      }
	    },
	
	    /**
	     * Function used to show the View More Details button
	     * depend on the the height of the product info content.
	     */
	    showViewMore: function showViewMore(observer) {
	      var integrationContentIds = ['#wc-power-page', '#wc-pp', '#SP_ProductImage', '#wc-button', '#easy2-demo', '#ccslogos', '#inline_showcase', '#flix-minisite', '#flix-inpage'];
	      var doesnIntegrationIdExists = false;
	      for (var i = 0; i < integrationContentIds.length; i++) {
	        if ($(integrationContentIds[i]).length > 0) {
	          doesnIntegrationIdExists = true;
	          break;
	        }
	      }
	      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	        $('.product-info-description').each(function (index) {
	          var height = $(this).prop('scrollHeight');
	          var productType = $('#product-info').data('product');
	          var screenSize = screen.width;
	
	          //for BD specific, we do want to show the product info in its entirety for tobacco product
	          if ((height > 600 || index == 0 && doesnIntegrationIdExists) && productType !== 'tobacco') {
	            $(this).next().removeClass("hide");
	            if (observer) {
	              observer.disconnect();
	            }
	          }
	        });
	      } else {
	        var height = $('.product-info-description').prop('scrollHeight');
	        var productType = $('#product-info').data('product');
	        var screenSize = screen.width;
	        //need to take into account the height of the product manual
	        var $productManual = $('.product-info-description').find('.product-manuals');
	        //if item has product manual and it is view on screen larger than 768
	        //product manual should be taken into account because it would be hidden
	        if ($productManual.length && screenSize > 768) {
	          var productManualHeight = $productManual.prop('scrollHeight');
	          //if product manual is hidden in case of large display, do not count its height
	          height = height - productManualHeight;
	        }
	
	        //for BD specific, we do want to show the product info in its entirety for tobacco product
	        if ((height > 600 || doesnIntegrationIdExists) && productType !== 'tobacco') {
	          $('.view-more').removeClass("hide");
	          if (observer) {
	            observer.disconnect();
	          }
	        } else {
	          if (!$('.view-more').hasClass('hide')) {
	            $('.view-more').addClass('hide');
	          }
	        }
	      }
	    },
	    getPartsAndServices: function getPartsAndServices(data) {
	      var configuredInfoArray = [];
	      var showablePartsAndServices = [];
	
	      if (data && data.length > 0) {
	        configuredInfoArray = JSON.parse(data);
	
	        //determine which GE dishwasher parts are not to be displayed
	        if (configuredInfoArray.services.length > 0) {
	          $.each(configuredInfoArray.services, function (index, value) {
	            if (!(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.dependent_service_ids.length > 0) && !(value.groupId == 1 && value.serviceType.toUpperCase() == 'PART' && value.selected == false)) {
	              showablePartsAndServices.push(value);
	            }
	          });
	          if (showablePartsAndServices.length > 0) {
	            configuredInfoArray.services = showablePartsAndServices.slice(0);
	          }
	          data = JSON.stringify(configuredInfoArray);
	        }
	      }
	
	      return data;
	    },
	
	    showReplacementProductModal: function showReplacementProductModal(partNumber) {
	      var $relatedProducts = partNumber ? $('#RelatedProducts_' + partNumber) : $('.related-products');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.TEMP_REPLACED_ITEM_MODAL_TITLE,
	        dialogclasses: 'medium',
	        onshow: function onshow() {
	          if (window.checkoutPage) {
	            $('#costcoModal .close').hide();
	          }
	        },
	        preventClose: window.checkoutPage ? true : false,
	        body: COSTCO.util.tmpl('tmpl_related_products', {
	          related_products: $relatedProducts.html()
	        })
	      });
	    },
	    /**
	     * Triggers click event, binded to social images, by pressing Enter key
	     * @return {[void]}
	     */
	    makeSocialIconsAdaCompliant: function makeSocialIconsAdaCompliant() {
	      $(".social.list-inline.social-icons img").each(function () {
	        $(this).on('keydown', function (event) {
	          if (event.which === 13) {
	            $(this).click();
	          }
	        });
	      });
	    },
	
	    showSuccessMessage: function showSuccessMessage(message) {
	      var messsages_html = '';
	      messsages_html += COSTCO.util.tmpl('tmpl_succes_notification', { message: message });
	      $('#message-area').html(messsages_html);
	    },
	    /**
	     * Changes the quantity displayed in input element on plus/minus click
	     * @param element element user clicked on (plus or minus button)
	     * @return void
	     */
	    changeQuantityValue: function changeQuantityValue(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      if (!qtyValue && qtyValue != 0) {
	        qtyValue = 0;
	      } else {
	        var quantityStep = COSTCO.Product.getQuantityStep($inputElement);
	        var isIncrement = undefined;
	        if ($(element).attr('name') === 'plusQty') {
	          isIncrement = true;
	          var maxQnty = COSTCO.Product.maxQuantity();
	          qtyValue += quantityStep;
	          var residual = qtyValue % quantityStep;
	          qtyValue = qtyValue - residual;
	        } else if ($(element).attr('name') === 'minusQty') {
	          isIncrement = false;
	          var _residual = qtyValue % quantityStep;
	          if (_residual == 0) {
	            qtyValue -= quantityStep;
	          } else {
	            qtyValue -= _residual;
	          }
	        } else if (qtyValue == 0) {
	          isIncrement = false;
	        }
	
	        $inputElement.val(qtyValue);
	
	        COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	        COSTCO.Product.expendErrorOnQtyUnit($inputElement, 'span');
	        COSTCO.Product.discardInvalidQtyValues(qtyValue, $inputElement, isIncrement);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    ChangeQuantityField: function ChangeQuantityField(element) {
	      var $inputElement = $('[name=quantity]');
	      var qtyValue = parseInt($inputElement.val());
	      COSTCO.Product.validateQuantityValue($inputElement, '.product-error', 'span');
	      if (qtyValue == 0) {
	        $inputElement.val(1);
	      }
	      COSTCO.util.announceSRMessage("Quantity " + qtyValue);
	    },
	    /** /reset error class if it is applyed/reseted on quanty value itself
	     * @param quantityId quantity value element reference
	     * @param nextElement element behind input
	     */
	    expendErrorOnQtyUnit: function expendErrorOnQtyUnit(quantityId, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        if (inputError !== quantityId) {
	          var inputParent = quantityId.parent();
	          var hasError = quantityId.hasClass('error');
	          if (hasError) {
	            inputParent.addClass('error');
	          } else {
	            inputParent.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	    * Get quantity step (which is also treated as minimal quantity value as well) plust (optional) unit of measure
	    * @param quantityId quantity value element reference
	    * @param unitOfMeasure unit of measure
	    * @return quantity step (min quantity value)
	    */
	    getQuantityStep: function getQuantityStep(quantityId, unitOfMeasure) {
	      var stepIncrement = quantityId.attr('data-quantity-increment') ? parseInt(quantityId.attr('data-quantity-increment')) : 1;
	      if (typeof unitOfMeasure === "undefined") {
	        return stepIncrement;
	      } else return stepIncrement + " " + unitOfMeasure;
	    },
	    /**
	     * Discard invalid quantity values
	     * @param value current value in quantity input element
	     * @param quantityId quantity input element reference
	     * @param isIncrement undefined value means value is entered not incremented/decremented
	     * @return void
	     */
	    discardInvalidQtyValues: function discardInvalidQtyValues(value, quantityId, isIncrement) {
	      var quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	      if (isIncrement != undefined && value <= 0) {
	        quantityId.val(quantityStep);
	      }
	      var max = COSTCO.Product.maxQuantity();
	      if (value > max) {
	        var remainder = max % quantityStep;
	        quantityId.val(max - remainder);
	      }
	    },
	
	    /**
	     * Test validity of quantity value and applay result.
	     * @param quantityId quantity input element reference
	     * @param errorSelector elements, classes and IDs
	     * @param nextElement if next element is label or span (they contain unit of measure) then error area is bigger then just input field
	     * @return void
	     */
	    validateQuantityValue: function validateQuantityValue(quantityId, errorSelector, nextElement) {
	      if (COSTCO.util.isPDPCartCheckoutEnabled()) {
	        var quantity_obj = COSTCO.Product.is_valid_quantity(COSTCO.Product.item_type, quantityId);
	        var $product_error = $(errorSelector);
	        var inputError = COSTCO.Product.getErrorArea(quantityId, nextElement);
	        // Check if we have a valid quantity
	        if (!quantity_obj.valid) {
	          $product_error.html(quantity_obj.message);
	          inputError.addClass('error');
	          if (quantityId !== inputError) {
	            quantityId.addClass('error');
	          }
	        } else {
	          $product_error.empty();
	          inputError.removeClass('error');
	          if (quantityId !== inputError) {
	            quantityId.removeClass('error');
	          }
	        }
	      }
	    },
	    /**
	     * Find HTML element on which error class should be applyed.
	     * @param quantityId quantity input element reference
	     * @param qtyUnitElement possible next element with quantity unit
	     * @return void
	     */
	    getErrorArea: function getErrorArea(quantityId, qtyUnitElement) {
	      var errObj = quantityId;
	      if (COSTCO.util.isPDPCartCheckoutEnabled() && qtyUnitElement) {
	        var nextElement = quantityId.next();
	        if (nextElement.is(qtyUnitElement)) {
	          errObj = quantityId.parent();
	        }
	      }
	      return errObj;
	    },
	    /**
	        * Shows the sticky element on tablet/desktop view and makes sticky element for mobile view for BC and BD
	        * @return void
	        */
	    pdpMakeElementSticky: function pdpMakeElementSticky() {
	      var userInfo = COSTCO.util.getMemberCookie();
	      var signedIn = userInfo.signedIn;
	      var costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false;
	      var validated = userInfo.validated;
	      var verified = userInfo.verified;
	      var memberActive = userInfo.active;
	      var $qtyInput = $('#qty-input');
	      var isBundle = COSTCO.Product.item_type == 'bundle';
	      var isTwoDayDeliveryZipIn = ($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && COSTCO.Header.hasInvPostalCodeCookie();
	      var $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul'); //notify-me-btn-area
	      var $isAppliance = $('#productCategory').val() === messages.APPLIANCES && ($('#submit-delivery-area').length > 0 || $('#edd-check-button').length > 0);
	      var $addButtonGroup = void 0;
	
	      if ($isAppliance || COSTCO.CMath.iskitsbundle) {
	        if ($('#edd-check-button').is(':visible') && !COSTCO.CMath.iskitsbundle) {
	          $addButtonGroup = $('#check-availability-sticky');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else if ($('#add-to-cart').is(':visible')) {
	          $addButtonGroup = $('#add-to-cart');
	          $('#sticky-price').show();
	          $('#sticky-qty').show();
	        } else if (COSTCO.CMath.iskitsbundle && $('#bundle-button').is(':visible')) {
	          $('#sticky-price').show();
	          $('#sticky-qty').hide();
	          $('#bundle-button-container').append($('#bundle-button'));
	          $addButtonGroup = $('#bundle-button-container');
	        } else if ($('#renew-membership-for-price').is(':visible')) {
	          $addButtonGroup = $('#renew-membership-for-price');
	          $('#sticky-price').hide();
	          $('#sticky-qty').hide();
	        } else {
	          if (!signedIn) {
	            if ($('#mapItem').val() == "true") {
	              $addButtonGroup = $('#sign-in-to-buy');
	            } else {
	              $addButtonGroup = $('#sign-in-to-buy-button-v2');
	            }
	          } else {
	            if (!costcoMember) {
	              $addButtonGroup = $('#link-membership-for-price');
	            }
	          }
	        }
	      } else if ($('input[name="isOOSItem"]').length > 0) {
	        $addButtonGroup = $addButtonContainer.find('input');
	      } else {
	        $addButtonGroup = $addButtonContainer.children().not('#qty-input');
	      }
	      var $detailsBazaarVoice = $('#details-bazaar-voice');
	      var $price = $('#pull-right-price');
	      var $clonedPrice = $price.clone();
	      var $hiddenSticky = $('#hidden-sticky');
	      var $stickyAddBtn = $('#sticky-add-btn');
	      var isHidden = true;
	      var isSticky = false;
	      var topOfBottomContent = void 0;
	      var topOfWindow = void 0;
	      var bottomOfWindow = void 0;
	      $('#pdp-sticky-desktop .tablist').hide();
	
	      var showStickyElementForDesktopAndTablet = function showStickyElementForDesktopAndTablet() {
	        if (topOfWindow < topOfBottomContent && isHidden == false) {
	          if (isBundle) {
	            if ($('#addBundleBtn').attr('disabled')) {
	              $('#sticky-price').empty();
	              $('#bundle-button-container').append($('#bundle-button'));
	            } else {
	              $('#sticky-price').empty();
	              $('#bundle-items-container').append($('#addBundleBtn'));
	            }
	          } else {
	            $addButtonContainer.prepend($addButtonGroup);
	            $addButtonContainer.prepend($qtyInput);
	            $addButtonContainer.prepend($('#sticky-add-btn li'));
	            //2 day delivery not zipped in
	            $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	          }
	          if (isBDApplication && isBDApplication === 'BD') {
	            $('#delivery-zipcode-form .get-zip-code-form').append($('#formProductDetails'));
	            $('#formProductDetails .outline').removeClass('hide');
	            $('#formProductDetails').validate();
	          }
	          $('#sticky-qty #minQtyText').off();
	          $('#bazaar-container').append($detailsBazaarVoice);
	          $('.math-table .your-price').append($price);
	          $('#check-availability-sticky').hide();
	          $hiddenSticky.hide(500);
	          isHidden = true;
	          $('#pdp-sticky-desktop .tablist').hide();
	        } else if (topOfWindow >= topOfBottomContent + 10 && isHidden == true) {
	
	          var selected_product = undefined;
	          if (COSTCO.Product.isSingleItem(products)) selected_product = COSTCO.Product.findItem(products[0], []);else selected_product = COSTCO.Product.getSelectedBundleAndVariantItems()[0];
	
	          var stickyImageUrl = typeof selected_product === 'undefined' ? products[0][0].img_url ? products[0][0].img_url : products[0][0].parent_img_url : selected_product.img_url ? selected_product.img_url : selected_product.parent_img_url;
	          $('#initialProductImageSticky').attr('src', stickyImageUrl);
	
	          $('#sticky-qty').append($qtyInput);
	          if (isBundle) {
	            $stickyAddBtn.append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	          } else {
	            // If item is OOS, set variables again beacause of updated content after Ajax call
	            if ($('input[name="isOOSItem"]').length > 0) {
	              $addButtonContainer = $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	              $addButtonGroup = $isAppliance ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer.children().not('#qty-input');
	            }
	            $('#check-availability-sticky').show();
	            $stickyAddBtn.append($addButtonGroup);
	            $stickyAddBtn.append($('#ctas ul li'));
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $stickyAddBtn.on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop(0);
	              });
	            }
	          }
	          if (isBDApplication && isBDApplication === 'BD' && !$('#bdZipCookie').val().length > 0) {
	            $stickyAddBtn.append($('#formProductDetails'));
	            $('#formProductDetails .outline').addClass('hide');
	            $stickyAddBtn.on('click', function (event) {
	              event.preventDefault();
	              $(window).scrollTop(0);
	              $('#formProductDetails').validate();
	              $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	                required: true,
	                'countryspecificpostalcode': true,
	                messages: {
	                  required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                  countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	                }
	              });
	            });
	          }
	          $('#sticky-qty #minQtyText').on('keypress', function (event) {
	            COSTCO.Product.ChangeQuantityField($('#sticky-qty #minQtyText'));
	            if (event.keyCode === 13) {
	              console.log('test event');
	              $('#add-to-cart-btn').click();
	            }
	          });
	          $('#sticky-bazaar').append($detailsBazaarVoice);
	          if (isBundle) {
	            $clonedPrice = $price.clone();
	            $('#sticky-price').append($clonedPrice);
	            var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	            $isChecked ? $('#sticky-price').show() : $('#sticky-price').hide();
	            $isChecked ? $('.product-numbers').show() : $('.product-numbers').hide();
	          } else if (isTwoDayDeliveryZipIn && !(($('.two-day-delivery').length > 0 || $('.frozen-foods-badge').length > 0) && $price.text().includes("- -.- -")) || $('.two-day-delivery').length === 0 && $('.frozen-foods-badge').length === 0 && $price.is(':visible')) {
	            $('#sticky-price').append($price);
	            $('.product-numbers').hide();
	          } else {
	            $('.product-numbers').show();
	          }
	          $hiddenSticky.show(500);
	          $hiddenSticky.css('display', 'flex');
	          isHidden = false;
	          $('#pdp-sticky-desktop .tablist').show();
	        }
	        $('#sticky').css('width', $('#product_tabs').width());
	      };
	
	      var makeElementStickyForMobile = function makeElementStickyForMobile() {
	        var $isChecked = $('[id^="checkbox-bundle-"]').is(':checked');
	        var $stickyContent = $isChecked ? $('#bundle-items-container') : $('#build-bundle-sticky');
	        var $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('.notify-me-btn-area') : $('#ctas ul');
	        var $isWarningMsg = $("#prod-page-delivery").length > 0 && !$("#prod-page-delivery").hasClass('hide') || $("#edd-form-block").length > 0 && !$("#edd-form-block").hasClass('hide') || $("#edd-message-block .warning").length > $("#edd-message-block .warning.hide").length || $("#deliveryFailMessage").length > 0 && !$("#deliveryFailMessage").hasClass('hide');
	        var $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	        if ($('#ctas').val() !== undefined) {
	          var $buildABundle = $('#build-a-bundle');
	          var bottomOfElement = void 0;
	          if ($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == '') {
	            $('#mobile-bazaar').append($detailsBazaarVoice);
	          }
	          if ($('input[name="isOOSItem"]').length > 0) {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('.notify-me-body').offset().top + $('.notify-me-body').outerHeight();
	          } else {
	            bottomOfElement = isBundle ? $buildABundle.offset().top + $buildABundle.outerHeight() : $('#ctas').offset().top + $('#ctas').outerHeight();
	          }
	          if (topOfWindow < bottomOfElement && isSticky == true) {
	            $('#build-bundle-sticky').attr("hidden", true);
	            $('#check-availability-sticky').attr("hidden", true);
	            $addButtonContainer = isBundle ? $stickyContent : $('input[name="isOOSItem"]').length > 0 ? $('#pdp-sticky-mobile') : $('#pdp-sticky-mobile ul');
	            $appContent = $isWarningMsg ? $('#check-availability-sticky') : $('input[name="isOOSItem"]').length > 0 ? $addButtonContainer.find('input') : $addButtonContainer;
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').removeClass('hide');
	            if (isBundle) {
	              $('#bundle-container').prepend($appContent);
	              $('#bundle-accordion-collapse').removeClass('collapse');
	              $('#bundle-accordion-collapse').css('height', '');
	            } else {
	              if ($('input[name="isOOSItem"]').length > 0) {
	                $('.notify-me-btn-area').prepend($appContent);
	              } else {
	                $('#ctas').prepend($appContent);
	              }
	            }
	            //2 day delivery not zipped in
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#postal-popup-form-inline').append($('#postal-code-submit-btn'));
	            }
	            isSticky = false;
	            $('#chatInlay').removeClass('mobile-inlay-sticker-shown');
	          } else if (topOfWindow >= bottomOfElement && isSticky == false) {
	            $('#build-bundle-sticky').removeAttr('hidden');
	            $('#check-availability-sticky').removeAttr('hidden');
	            $appContent.children('#product-social-print-mobile').length > 0 && $appContent.children('#product-social-print-mobile').addClass('hide');
	            $('#pdp-sticky-mobile').append($appContent);
	            $('#footer-bottom').addClass('sticky-pdp-footer');
	            if (!isTwoDayDeliveryZipIn || $('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) {
	              $('#pdp-sticky-mobile').append($('#postal-code-submit-btn'));
	              $('#pdp-sticky-mobile').on('click', function (event) {
	                event.preventDefault();
	                $(window).scrollTop($('.product-interaction').offset().top - 1.2 * $('.product-interaction').outerHeight());
	              });
	            }
	            var interectionElement = $('#pdp-sticky-mobile ul li:visible').length > 0 ? $('#pdp-sticky-mobile ul li:visible') : $('#pdp-sticky-mobile ul div:visible').not('.error');
	            if ($('#ctas').hasClass('hide') || interectionElement.length === 0 && !isBundle && !$isAppliance && isTwoDayDeliveryZipIn && !($('.two-day-delivery').length > 0 && $price.text().includes("- -.- -")) && !$isWarningMsg) {
	              $('#pdp-sticky-mobile').hide();
	            }
	            if (isBundle) {
	              $('#bundle-accordion-collapse').addClass('collapse');
	            }
	            isSticky = true;
	            $('#chatInlay').addClass('mobile-inlay-sticker-shown');
	          }
	        }
	      };
	
	      var makeElementStickyForMobileBD = function makeElementStickyForMobileBD() {
	        var $stickyElement = $('#pdp-sticky-mobile');
	        var bottomOfElement = $('.product-interaction').offset().top + $('.product-interaction').outerHeight();
	        if (topOfWindow < bottomOfElement) {
	          $('#zipFormatterFlag').after($('#formProductDetails'));
	          $('#formProductDetails .outline').removeClass('hide');
	          $('#formProductDetails').validate();
	        } else if (topOfWindow >= bottomOfElement) {
	          //check out if sticky element should be displayed
	          $stickyElement.append($('#formProductDetails'));
	          $('#footer-bottom').addClass('sticky-pdp-footer');
	          $('#formProductDetails .outline').addClass('hide');
	          $stickyElement.on('click', function (event) {
	            event.preventDefault();
	            $(window).scrollTop(0);
	            //generate validation on input field of zip code
	            $('#formProductDetails').validate();
	            $('#WC_BusinessDeliveryBrowseForm_FormInput_zipCodeFormDeliveryZipCode').rules('add', {
	              required: true,
	              'countryspecificpostalcode': true,
	              messages: {
	                required: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER,
	                countryspecificpostalcode: messages.ERR_INVALID_DELIVERY_ZIP_IN_HEADER
	              }
	            });
	          });
	        }
	      };
	      window.addEventListener('load', function (event) {
	        $(window).scroll(function (event) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and calls the appropriate function
	            if (window.innerWidth > 768) {
	              showStickyElementForDesktopAndTablet();
	            } else if (isBDApplication === 'BD') {
	              if ($('#bdZipCookie').val().length > 0) {
	                makeElementStickyForMobile();
	              } else {
	                makeElementStickyForMobileBD();
	              }
	            } else {
	              window.onbeforeunload = function () {
	                window.scrollTo(0);
	              };
	              makeElementStickyForMobile();
	            }
	          }
	        });
	        var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
	        if ((COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') && !scheduledDeliverable && $('#isBDAppVar').val() != 'BD' && !COSTCO.CMath.pdpPageloadComplete && isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
	          if (COSTCO.CMath.isErrorlocationControlleditem) {
	            if ($('div.buyinstoreonly.MuiBox-root').length > 0) {
	              COSTCO.CMath.isWarehouseEnabled = true;
	            } else {
	              COSTCO.CMath.isWarehouseEnabled = false;
	            }
	          }
	          if (!COSTCO.CMath.iskitsbundle) {
	            COSTCO.Product.findOOSitem(true);
	          }
	        } else {
	          if ($('#isBDAppVar').val() != 'BD' && (isPDPVariantGreyOutEnabled == 'false' || Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) && !COSTCO.CMath.pdpPageloadComplete && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
	            COSTCO.CMath.pdpPageloadComplete = true;
	          }
	        }
	        if (COSTCO.CMath.iskitsbundle) {
	          var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	          COSTCO.CMath.onloadSelectOption = optionsSelected;
	          for (var i = 0; i <= optionsSelected.length; i++) {
	            $('#swatchesID-productOption0' + i + ' span.selection-item').each(function () {
	              var selectedTile = $(this).attr("automation-id");
	              var tileId = selectedTile.split('_')[1];
	            });
	          }
	          COSTCO.CMath.setKbLabel();
	          $('#theSwatches').remove();
	
	          if (COSTCO.Product.item_type === 'single_variant' || COSTCO.Product.item_type === 'multi_variant') {
	            COSTCO.CMath.hideKBSkeletone();
	          }
	        }
	        var currentUrl = window.location.href;
	        var swatchParam = window.location.href.split('?')[1];
	        if (COSTCO.CMath.iskitsbundle && swatchParam == 'isSwatchReload') {
	          COSTCO.Product.focusToNavPdpTabHeader15();
	        }
	        COSTCO.CMath.kbPageloadComplete = true;
	        if (window.innerWidth > 768) {
	          if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	            $('#bazaar-container').append($detailsBazaarVoice);
	          }
	        } else {
	          if ($('#mobile-bazaar').length > 0 && $('#mobile-bazaar').html().trim() == '') {
	            $('#mobile-bazaar').append($detailsBazaarVoice);
	          }
	        }
	      });
	
	      $(window).resize(function () {
	        if (!$("input").is(":focus")) {
	          if ($('#productPage').val() && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	            if (isBundle) {
	              topOfBottomContent = $('#addBundleBtn').attr('disabled') ? $('.bottom-content').offset().top : $('#bundle-container').offset().top + $('#bundle-container').outerHeight(true);
	            } else if ($('#displaybundle').length > 0) {
	              topOfBottomContent = $('.bottom-content').offset().top + $('#displaybundle').outerHeight();
	            } else {
	              topOfBottomContent = $('.bottom-content').offset().top;
	            }
	            topOfWindow = $(window).scrollTop();
	            bottomOfWindow = topOfWindow + $(window).height();
	
	            //checks if page is in MOBILE or TABLET/DESKTOP display view, and modifies sticky element accordingly
	            if (window.innerWidth > 768 && isBDApplication === 'BC') {
	              if ($('#pdp-sticky-mobile ul').length > 0 || $('#bundle-container').hasClass('fixed-footer-bundle')) {
	                $addButtonContainer = isBundle ? $('#bundle-items-container') : $('#pdp-sticky-mobile ul');
	                isBundle ? $('#bundle-container').prepend($addButtonContainer) : $('#ctas').prepend($addButtonContainer);
	                if (isBundle) {
	                  $('#bundle-accordion-collapse').removeClass('collapse');
	                  $('#bundle-accordion-collapse').css('height', '');
	                }
	                isSticky = false;
	                showStickyElementForDesktopAndTablet();
	              }
	              if ($('#bazaar-container').length > 0 && $('#bazaar-container').html().trim() == '') {
	                $('#bazaar-container').append($detailsBazaarVoice);
	              }
	            } else {
	              if (isBundle) {
	                $('#bundle-button-container').append($('#addBundleBtn').attr('disabled') ? $('#bundle-button') : $('#addBundleBtn'));
	              } else {
	                if (!($('input[name="isOOSItem"]').length > 0)) {
	                  $addButtonContainer.prepend($addButtonGroup);
	                  $addButtonContainer.prepend($qtyInput);
	                  $addButtonContainer.prepend($('#sticky-add-btn li'));
	                }
	              }
	              $('.math-table .your-price').append($price);
	              $('#product-body-model-number').after($detailsBazaarVoice);
	              $hiddenSticky.hide();
	              isHidden = true;
	              if (isBDApplication && isBDApplication === 'BD') {
	                makeElementStickyForMobileBD();
	              } else {
	                makeElementStickyForMobile();
	              }
	            }
	          }
	        }
	      });
	
	      $(document).on("click", '.tablist a', function () {
	        var clickedTab = $(this);
	        var clickedTabHref = $(this).attr('href');
	        $('.tablist li').removeClass("active");
	        $('.tablist li a').removeClass("active");
	        $('.tablist li a').attr("aria-current", "false");
	        $('.tablist a[href=' + clickedTabHref + ']').addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').parent().addClass("active");
	        $('.tablist a[href=' + clickedTabHref + ']').attr("aria-current", "true");
	      });
	
	      $(document).on('keydown', '.tablist a', function (e) {
	        if (e.which === 13) {
	          var clickedTabHref = $(this).attr('href');
	          this.click();
	          $('div' + clickedTabHref + ' h3').attr('tabindex', '0');
	          $('div' + clickedTabHref + ' h3').focus().on('focusout', function () {
	            $(this).attr('tabindex', '-1');
	          });
	        }
	      });
	    },
	
	    invokeInventoryBatchAPIcallforSingleitem: function invokeInventoryBatchAPIcallforSingleitem(itemId) {
	      var isBopiw = $('#isBOPIWItemForMemberInfo').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var _data = {
	        "distributionCenters": [""],
	        "selectedWarehouse": selectedWarehouse,
	        "itemNumbers": [itemId]
	      };
	      var clientIdentifier = $('#besBatchCLientIdentifier').val();
	      var batchApiURL = $('#baseUriForInventoryBatch').val();
	      var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	      var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	      if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	        if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	          costcoEnv = "ECOM";
	        }
	      }
	      var costcoService = "restInventory";
	
	      var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	      var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	      var akamaiHeaders = {};
	      akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	      akamaiHeaders["costco.env"] = costcoEnv;
	      akamaiHeaders["client-identifier"] = clientIdentifier;
	      akamaiHeaders["costco.service"] = costcoService;
	
	      if (inventoryBatchAkamaiCacheEnabled === "true") {
	        var batchVariantCacheKey = itemId + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	        akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	      }
	      var batchApiURL;
	      if (inventoryBatchEnabledV2 === "true") {
	        batchApiURL = $('#baseUriForInventoryBatchV2').val();
	      } else {
	        batchApiURL = $('#baseUriForInventoryBatch').val();
	      }
	
	      fetch(batchApiURL, {
	        method: "POST",
	        body: JSON.stringify(_data),
	        headers: akamaiHeaders
	      }).then(function (response) {
	        if (response.status >= 200 && response.status <= 299) {
	          return response.json();
	        } else {
	          throw Error(response.statusText);
	        }
	      }).then(function (jsonResponse) {
	        var programType = jsonResponse[0].programTypes;
	        var inwarehousepgType;
	        if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	          if (programType.inWarehouse[0].length != 0) {
	            inwarehousepgType = programType.inWarehouse[0];
	          }
	        } else {
	          inwarehousepgType = programType.inWarehouse;
	        }
	        if (null != inwarehousepgType && inwarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inwarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	          $('.crumbs').show();
	          $('#product-page').addClass('hide');
	          $('#not_found_error_pdp').removeClass('hide');
	
	          // set city and zip code
	          var storeLocation = COSTCO.LWSearch.getCookie('STORELOCATION');
	          console.log("storeLocation : " + storeLocation);
	          if (storeLocation !== "" || storeLocation != null) {
	            var storeLocation_ = JSON.parse(unescape(storeLocation));
	            var notfound_deliveryWarehouse = storeLocation_.storeLocation.city;
	            $('#notfound_deliveryWarehouse').html(notfound_deliveryWarehouse);
	          }
	          var notfound_deliveryLocation = COSTCO.LWSearch.getCookie('invCheckPostalCode');
	          $('#notfound_deliveryLocation').html(notfound_deliveryLocation);
	
	          $('#pdp-sticky-desktop').hide();
	          $('#pdp-sticky-mobile').hide();
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    },
	
	    pickUpinDistribution: function pickUpinDistribution(cookieDistributionCenters, pickUpCenters) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = pickUpCenters[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var centers = _step3.value;
	
	          if (!cookieDistributionCenters.includes(centers)) cookieDistributionCenters.push(centers);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      return cookieDistributionCenters;
	    },
	    /**
	     * This method is for checkingwarehouse cookie to see whether 3pl location and pickupcenters is present and 
	     * return flag
	     */
	    checkifOutofNetworkLocation: function checkifOutofNetworkLocation() {
	      var cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      var pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      var isOutOfNetworkLocation = false;
	      if (pickUpCenters != undefined && pickUpCenters.length != 0 && cookieDistributionCenters != undefined && cookieDistributionCenters.length != 0 && !cookieDistributionCenters.includes('-3pl')) {
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = pickUpCenters[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var centers = _step4.value;
	
	            if (!cookieDistributionCenters.includes(centers)) {
	              isOutOfNetworkLocation = true;
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	      return isOutOfNetworkLocation;
	    },
	    /**
	        * This method is for call inventory batch API call
	        * @return void
	        */
	    invokeInventoryBatchAPIcall: function invokeInventoryBatchAPIcall(optionsSelected) {
	      var isBopiw = $('#isVariantBopiw').val();
	      var ltlFeatureFlag = $('#isLtlFeatureFlagOn').val();
	      var selectedWarehouse = "";
	      if (isEnableBOPIWUpdatesSync == 'true' && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isBopiwEnabled && !COSTCO.CMath.isWioEnabled && isBopiw == 'true') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && !COSTCO.CMath.isBopiwEnabled && isBopiw == 'false') {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      } else if (COSTCO.CMath.isWioEnabled && COSTCO.CMath.isBopiwEnabled) {
	        selectedWarehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
	      }
	      var distributionCenters = [];
	      var cookieDistributionCenters = [];
	      var cookieGroceryCenters = [];
	      var pickUpCenters = [];
	      var hasLTLPgType = false;
	      cookieDistributionCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('distributionCenters');
	      pickUpCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('pickUpCenters');
	      if (ltlFeatureFlag === "true" && pickUpCenters != undefined && pickUpCenters.length != 0) {
	        for (var i = 0; i < listOfObjects.length; i++) {
	          if (listOfObjects[i].programType.includes('LTLPickUp')) {
	            hasLTLPgType = true;
	            break;
	          }
	        }
	      }
	      if (hasLTLPgType == true) {
	        cookieDistributionCenters = COSTCO.Product.pickUpinDistribution(cookieDistributionCenters, pickUpCenters);
	      }
	      cookieGroceryCenters = COSTCO.LWSearch.fetchWarehouseCookieVal('groceryCenters');
	      distributionCenters = cookieDistributionCenters.concat(cookieGroceryCenters);
	      var JsonResponseSum = 0;
	      itemIdMap.forEach(function (itemIdArray, keys) {
	        var _data = {
	          "distributionCenters": distributionCenters,
	          "selectedWarehouse": selectedWarehouse,
	          "itemNumbers": itemIdArray
	        };
	
	        var costcoEnv = $('#costcoEnvironmentForBatchInv').val(); //COSTCO.Product.validateCostcoEnv();
	        var costcoEnvECOMEnabled = $('#batchApiCostcoEnvECOMEnabled').val();
	        if (typeof costcoEnvECOMEnabled !== "undefined" && costcoEnvECOMEnabled === "true") {
	          if (costcoEnv === "" || costcoEnv === null || costcoEnv === 'null') {
	            costcoEnv = "ECOM";
	          }
	        }
	        var costcoService = "restInventory";
	        var clientIdentifier = $('#besBatchCLientIdentifier').val();
	
	        var inventoryBatchAkamaiCacheEnabled = $('#inventoryBatchAkamaiCacheEnabled').val();
	        var inventoryBatchEnabledV2 = $('#inventoryBatchEnabledV2').val();
	        var akamaiHeaders = {};
	        akamaiHeaders["Content-type"] = "application/json; charset=UTF-8";
	        akamaiHeaders["costco.env"] = costcoEnv;
	        akamaiHeaders["client-identifier"] = clientIdentifier;
	        akamaiHeaders["costco.service"] = costcoService;
	        var itemIdArraysort = itemIdArray.sort(function (a, b) {
	          return a - b;
	        });
	        if (inventoryBatchAkamaiCacheEnabled === "true") {
	          var batchVariantCacheKey = itemIdArraysort + "-" + COSTCO.Product.getZipcode() + "-" + selectedWarehouse;;
	          akamaiHeaders["batch-variant-cache-key"] = batchVariantCacheKey;
	        }
	
	        var batchApiURL;
	        if (inventoryBatchEnabledV2 === "true") {
	          batchApiURL = $('#baseUriForInventoryBatchV2').val();
	        } else {
	          batchApiURL = $('#baseUriForInventoryBatch').val();
	        }
	        fetch(batchApiURL, {
	          method: "POST",
	          body: JSON.stringify(_data),
	          headers: akamaiHeaders
	        }).then(function (response) {
	          if (response.status >= 200 && response.status <= 299) {
	            return response.json();
	          } else {
	            throw Error(response.statusText);
	          }
	        }).then(function (jsonResponse) {
	          if (!window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) {
	            COSTCO.CMath.varItemJSON.push(jsonResponse);
	            window.reactObj.batchApiResponse.apiResponse = COSTCO.CMath.varItemJSON;
	            try {
	              if (COSTCO.CMath.varItemJSON.length > 0) {
	                window.wioEventBus.publish('notifyBatchApiComplete', COSTCO.CMath.varItemJSON);
	              }
	            } catch (e) {
	              console.log(e);
	            }
	          }
	          Object.entries(jsonResponse).forEach(function (entry) {
	            var _entry = _slicedToArray(entry, 2),
	                key = _entry[0],
	                value = _entry[1];
	
	            var itemarrayStatus = {};
	            var variantitemArray = {};
	            var valuesToCheck = ['NOSTOCK'];
	            var programType = value.programTypes;
	            var siteControlledpgType, locationControlledpgType, inwarehousepgType, ltlPickUpPgType;
	
	            if (programType != null && programType.hasOwnProperty("locationControlledInventory") && Array.isArray(programType.locationControlledInventory)) {
	              var locationControlledList = programType && programType.locationControlledInventory || [];
	              var _locationControlledpgType = Array.isArray(locationControlledList) && locationControlledList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.locationControlledInventory != undefined) {
	              locationControlledpgType = programType.locationControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("siteControlledInventory") && Array.isArray(programType.siteControlledInventory)) {
	              var siteControlledList = programType && programType.siteControlledInventory || [];
	              siteControlledpgType = Array.isArray(siteControlledList) && siteControlledList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.siteControlledInventory != undefined) {
	              siteControlledpgType = programType.siteControlledInventory;
	            }
	            if (programType != null && programType.hasOwnProperty("inWarehouse") && Array.isArray(programType.inWarehouse)) {
	              if (programType.inWarehouse[0].length != 0) {
	                inWarehousepgType = programType.inWarehouse[0];
	              }
	            } else {
	              inWarehousepgType = programType.inWarehouse;
	            }
	            if (programType != null && programType.hasOwnProperty("ltlPickUp") && Array.isArray(programType.ltlPickUp)) {
	              ltlPickUpPgType = programType.ltlPickUp[0];
	              var ltlPickUpList = programType && programType.ltlPickUp || [];
	              ltlPickUpPgType = Array.isArray(ltlPickUpList) && ltlPickUpList.every(function (item) {
	                return valuesToCheck.includes(item.availability);
	              });
	            } else if (programType.ltlPickup != undefined) {
	              ltlPickUpPgType = programType.ltlPickUp;
	            }
	
	            if (undefined != siteControlledpgType && (siteControlledpgType || siteControlledpgType.availability == 'NOSTOCK') || undefined != locationControlledpgType && (locationControlledpgType || locationControlledpgType.availability == 'NOSTOCK') || COSTCO.CMath.isErrorlocationControlleditem) {
	
	              itemarrayStatus["OL"] = '0';
	            } else {
	              itemarrayStatus["OL"] = '1';
	            }
	
	            if (null != inWarehousepgType && (inWarehousepgType.availability == 'INSTOCK' || inWarehousepgType.availability == 'LOWSTOCK') && COSTCO.CMath.isWarehouseEnabled || ltlPickUpPgType != undefined && (!ltlPickUpPgType || ltlPickUpPgType.availability == 'INSTOCK')) {
	
	              itemarrayStatus["WH"] = '1';
	            } else if (null != inWarehousepgType && inWarehousepgType.availability == 'NOSTOCK' && COSTCO.CMath.isWarehouseEnabled || null == inWarehousepgType || !COSTCO.CMath.isWarehouseEnabled) {
	              itemarrayStatus["WH"] = '0';
	            }
	            variantitemArray[value.itemNumber] = itemarrayStatus;
	            COSTCO.CMath.variantJSON.push(variantitemArray);
	
	            JsonResponseSum++;
	            if (JsonResponseSum == listOfObjects.length) {
	
	              var len = optionsSelected.length;
	              localStorage.setItem("variantStatus", JSON.stringify(COSTCO.CMath.variantJSON));
	              if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	                COSTCO.Product.strikeOosSwatches(optionsSelected);
	              } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	                COSTCO.Product.grayOutDropDown(optionsSelected);
	              }
	            }
	          });
	        }).catch(function (err) {
	          return console.log(err);
	        });
	      });
	    },
	    /**
	        * This method is for Strike out lower level Swatches
	        * @return void
	        */
	    strikeOosSwatches: function strikeOosSwatches(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	        * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	        *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable = void 0;
	                _variable = $('input[value=' + obj[option] + ']').next().attr("automation-id");
	                if (COSTCO.Product.item_type === 'multi_variant') {
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                    $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                    $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                } else if (COSTCO.Product.item_type === 'single_variant') {
	                  // $('.selection-item').removeClass("select-span1-OOS");
	                  if ($("input[automation-id='variationOptions_" + obj[option] + "']:checked").length) {
	                    $('span[automation-id=' + _variable + ']').addClass("select-span1-OOS");
	                    //folowing  code for appending OOS label in lower level
	                    var $selectedOptionLabel = $('label[for=productOption00]');
	                    var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                    if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                      $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                    $selectedOptionValue.show();
	                  } else {
	                    $('span[automation-id=' + _variable + ']').removeClass("select-span1-OOS");
	                  }
	                  if (!$('span[automation-id=' + _variable + ']').hasClass('span1-outofstock')) {
	                    $('span[automation-id=' + _variable + ']').addClass("span1-outofstock");
	                    if (!$('span[automation-id=' + _variable + ']').children('p').length) {
	                      $('span[automation-id=' + _variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                      $('span[automation-id=' + _variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	      }
	
	      // following code striking upper swatch and dropdown
	
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for OOS Drop down
	        * @return void
	        */
	    grayOutDropDown: function grayOutDropDown(optionsSelected) {
	      var len = optionsSelected.length;
	      var option = "option" + parseInt(len);
	      if (len == 3) {
	        var option0 = "option" + parseInt(len - 2);
	        var level0 = optionsSelected[len - 3];
	        var option1 = "option" + parseInt(len - 1);
	        var level1 = optionsSelected[len - 2];
	      } else if (len == 2) {
	        var option0 = "option" + parseInt(len - 1);
	        var level0 = optionsSelected[len - 2];
	      }
	      for (var i = 0; i < listOfObjects.length; i++) {
	        var option = "option" + parseInt(len);
	        var obj = listOfObjects[i];
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	
	              if (COSTCO.CMath.isWarehouseEnabled) {
	                var uptitemarrayStatus = {};
	                var uptvariantitemArray = {};
	
	                uptitemarrayStatus["OL"] = sub_val.OL;
	                if (listOfObjects[i].isaVariant == 'true') {
	                  uptitemarrayStatus["WH"] = '0';
	                } else {
	                  uptitemarrayStatus["WH"] = sub_val.WH;
	                }
	                uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	              }
	            }
	          }
	        }
	        /*following if condtion for skipping strike out for current selected. 
	           	 * Even selected product is NOSTOCK in batch API call and it is INSTOCK in Ajax call(means INSTOCK in wcs DB) prioprity is given to WCS response
	           	 *  */
	        if (COSTCO.CMath.invokeAjaxCall) {
	          for (var k in COSTCO.CMath.variantJSON) {
	            var val = COSTCO.CMath.variantJSON[k];
	            for (var j in val) {
	              var sub_key = j;
	              var sub_val = val[j];
	              if (sub_key == listOfObjects[i].itemId) {
	
	                if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && (COSTCO.CMath.invAvailableAjax || COSTCO.CMath.isBackOrderFlag) && COSTCO.Product.isEDDStatusAvailable) {
	                  if (len == 3 && level1 == obj[option1]) {
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  } else {
	
	                    var uptitemarrayStatus = {};
	                    var uptvariantitemArray = {};
	                    uptitemarrayStatus["OL"] = '1';
	                    uptitemarrayStatus["WH"] = sub_val.WH;
	                    uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                    COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                    localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                  }
	                } else {
	                  if (optionsSelected[len - 1] == obj[option] && level0 == obj[option0] && ((!COSTCO.CMath.invAvailableAjax || !COSTCO.CMath.isBackOrderFlag) && !COSTCO.Product.isEddItem || !COSTCO.Product.isEDDStatusAvailable || !COSTCO.CMath.invAvailableAjax && COSTCO.Product.isEDDStatusAvailable)) {
	                    if (len == 3 && level1 == obj[option1]) {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    } else {
	                      var uptitemarrayStatus = {};
	                      var uptvariantitemArray = {};
	                      uptitemarrayStatus["OL"] = '0';
	                      uptitemarrayStatus["WH"] = sub_val.WH;
	                      uptvariantitemArray[listOfObjects[i].itemId] = uptitemarrayStatus;
	                      COSTCO.CMath.variantJSON[k] = uptvariantitemArray;
	                      localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
	                    }
	                  }
	                }
	              }
	            }
	          }
	        }
	        for (var k in COSTCO.CMath.variantJSON) {
	          var val = COSTCO.CMath.variantJSON[k];
	          for (var j in val) {
	            var sub_key = j;
	            var sub_val = val[j];
	            if (sub_key == listOfObjects[i].itemId) {
	              if (sub_val.OL == '0' && sub_val.WH == '0') {
	                var _variable2 = void 0;
	                var obj = listOfObjects[i];
	                var len = optionsSelected.length;
	                if (!$('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').hasClass('out-of-stock')) {
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').append('<span class="out-of-stock-text"></span>');
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  $('.varis-v2 option[automation-id=varisOption_' + obj[option] + ']').addClass("out-of-stock");
	                  var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
	                  var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	                  if (optionsSelected[len - 1] == obj[option] && !$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                    var textToReplace = $selectedOptionValue.text();
	                    var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                    $selectedOptionValue.text(newText);
	                    $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	                  }
	                  $selectedOptionValue.show();
	                }
	              }
	            }
	          }
	        }
	      }
	      if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
	        COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
	      } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
	        COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
	      }
	      //For 3 level varaints in order to retain  top level strike when swaping between other top levels
	      COSTCO.CMath.strikealllevelvariants();
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    grayOutUpperLevelDropDown: function grayOutUpperLevelDropDown(optionsSelected) {
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	        var option = "option" + parseInt(optionsSelected.length - 1);
	        if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').hasClass('out-of-stock')) {
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').append('<span class="out-of-stock-text"></span>');
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 2] + ']').addClass("out-of-stock");
	          var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	          var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	          if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	            //$selectedOptionValue.prepend('Out of Stock - ' );
	            var textToReplace = $selectedOptionValue.text();
	            var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	            $selectedOptionValue.text(newText);
	            $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	          }
	          $selectedOptionValue.show();
	        }
	        if (optionsSelected.length == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          //following code for checking mid level is drop down or pills. if  all mid level items are OOS will strike out upper level
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelCount === midLevelOOSCount) {
	            var option = "option" + parseInt(optionsSelected.length - 2);
	            if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').hasClass('out-of-stock')) {
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').append('<span class="out-of-stock-text"></span>');
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[optionsSelected.length - 3] + ']').addClass("out-of-stock");
	              var $selectedOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	              var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	              if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	                //$selectedOptionValue.prepend('Out of Stock - ' );
	                var _textToReplace = $selectedOptionValue.text();
	                var _newText = _textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
	                $selectedOptionValue.text(_newText);
	                $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	              $selectedOptionValue.show();
	            }
	          }
	        }
	      } else {
	        var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 2) + ']');
	        var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	        var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 2] + ']').attr("automation-id");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	        $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        if (optionsSelected.length == 3) {
	          var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(optionsSelected.length - 3) + ']');
	          var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
	
	          var $dropDownOOSOption = $('.varis-v2 option[value=' + optionsSelected[optionsSelected.length - 3] + ']').attr("automation-id");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
	          $('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
	        }
	      }
	    },
	    /**
	        * This method is for strike upper level swatch
	        * @return void
	        */
	    strikeUpperLevelVariant: function strikeUpperLevelVariant(optionsSelected) {
	      var element;
	      var noOfLevel = optionsSelected.length;
	      // below code for appending OOS label in upper level swatch if all
	      // item in lower level is OOS
	      var lowerLevelOOSCount;
	      var lowerLevelCount;
	      var lowerSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
	      var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
	      //following code for checking lower level is drop down or pills. if  all lower level items are OOS will strike out upper level
	      if (lowerDropDown) {
	        lowerLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.opt:not(:disabled)').length;
	        lowerLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
	      } else if (lowerSwatch) {
	        lowerLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.selection-box-v2:visible').length;
	        lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').find('.span1-outofstock').length;
	      }
	      if (lowerLevelOOSCount != "" && lowerLevelCount != "" && lowerLevelCount === lowerLevelOOSCount) {
	
	        if ($('#swatches-productOption0' + parseInt(noOfLevel - 2) + '').length > 0) {
	          // if upper layer is pills
	          element = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	          if ($('input[value=' + optionsSelected[noOfLevel - 2] + ']').attr('checked') === 'checked') {
	            $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	          }
	          if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	            $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	            if (!$('span[automation-id=' + element + ']').children('p').length) {
	              // if upper layer is dropdown
	              $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	              $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	            }
	          }
	        }
	        COSTCO.Product.appendLabelSwatches(noOfLevel - 2);
	        if (noOfLevel == 3) {
	          var midLevelOOSCount;
	          var midLevelCount;
	          var midSwatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0;
	          var midDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0;
	          if (midDropDown) {
	            midLevelCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').length;
	            midLevelOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.out-of-stock:not(:disabled)').length;
	          } else if (midSwatch) {
	            midLevelCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').length;
	            midLevelOOSCount = $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.span1-outofstock').length;
	          }
	          if (midLevelOOSCount != "" && midLevelCount != "" && midLevelOOSCount === midLevelCount) {
	
	            if ($('#swatches-productOption0' + parseInt(noOfLevel - 3) + '').length > 0) {
	              // if upper layer is pills
	              element = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	              if ($('input[value=' + optionsSelected[noOfLevel - 3] + ']').attr('checked') === 'checked') {
	                $('span[automation-id=' + element + ']').addClass("select-span1-OOS");
	              }
	              if (!$('span[automation-id=' + element + ']').hasClass('span1-outofstock')) {
	                $('span[automation-id=' + element + ']').addClass("span1-outofstock");
	              }
	              if (!$('span[automation-id=' + element + ']').children('p').length) {
	                // if upper layer is dropdown
	                $('span[automation-id=' + element + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
	                $('span[automation-id=' + element + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	              }
	            }
	            COSTCO.Product.appendLabelSwatches(noOfLevel - 3);
	          }
	        }
	      } else {
	        var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 2) + ']');
	        var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	        $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	        var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 2] + ']').next().attr("automation-id");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	        $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	        $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        if (noOfLevel == 3) {
	          var $selectedUpperLabel = $('label[for=productOption0' + parseInt(noOfLevel - 3) + ']');
	          var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
	          $selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
	          var $selectedOOSOption = $('input[value=' + optionsSelected[noOfLevel - 3] + ']').next().attr("automation-id");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
	          $('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
	          $('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
	        }
	      }
	    },
	    /**
	        * This method is for getting array of object
	        * object having item id and what are the options associated with the item
	        * @return void
	        */
	    getLowerLevelItemDetails: function getLowerLevelItemDetails(optionsSelected) {
	      //following for loop for getting item and option associated with that item 
	      var selected_first = $('#productOption00').val();
	      var count50 = 0;
	
	      var numberOfChunks = 0;
	      var itemIdchunk = [];
	      for (var i = 0; i < product.length; i++) {
	        for (var j = 0; j < products[i].length; j++) {
	          var singleObj = {}; // this object for holding item id and what are the options belong to that item ID
	          singleObj['itemId'] = products[i][j].partNumber;
	          singleObj['isaVariant'] = products[i][j].isaVariant;
	          singleObj['programType'] = products[i][j].programType;
	          // following for lopp for ordering options in object
	          if (COSTCO.Product.item_type === 'multi_variant') {
	            for (var m = 0; m < optionsSelected.length - 1; m++) {
	              if (products[i][j].options.includes(optionsSelected[m])) {
	                if (m == optionsSelected.length - 2) {
	                  // if upto 2nd last layer all options are macthed then only we are passing that item to batch API
	                  for (var m = 0; m < optionsSelected.length; m++) {
	                    if (products[i][j].options.includes(optionsSelected[m])) {
	                      // folloeing code finding common elements and adding accoding to the index of selected option
	                      var findCommonOption = products[i][j].options.find(function (element) {
	                        return element == optionsSelected[m];
	                      });
	                      singleObj['option' + parseInt(m + 1)] = findCommonOption;
	                    } else {
	                      //finding different option and adding to the bottom of the array
	                      var differentElement = products[i][j].options.filter(function (x) {
	                        return !optionsSelected.includes(x);
	                      });
	                      singleObj['option' + parseInt(optionsSelected.length)] = differentElement[0];
	                    }
	                  }
	
	                  listOfObjects.push(singleObj);
	                  itemIdchunk.push(products[i][j].partNumber);
	                  count50++;
	                }
	              } else {
	                break;
	              }
	            }
	          } else {
	            for (var k = 0; k < products[i][j].options.length; k++) {
	              singleObj['option' + parseInt(k + 1)] = products[i][j].options[k];
	            }
	            listOfObjects.push(singleObj);
	            itemIdchunk.push(products[i][j].partNumber);
	            count50++;
	          }
	
	          /*following code for check item pushed in the array reached the limit(which is configured in appconfigparam) or it loop is completed
	           * in bot scenario pushing all element to the map. this map later used for callling batch API
	          */
	          if (count50 == numberOfBatchApiIds || j == products[i].length - 1 && itemIdchunk.length > 0) {
	            count50 = 0;
	            numberOfChunks++;
	            itemIdMap.set(numberOfChunks, itemIdchunk);
	            itemIdchunk = [];
	          }
	        }
	      }
	    },
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    appendLabelSwatches: function appendLabelSwatches(labelLevel) {
	      var $selectedOptionLabel = $('label[for=productOption0' + parseInt(labelLevel) + ']');
	      var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	      if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
	        $selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
	      }
	      $selectedOptionValue.show();
	    },
	
	    /**
	        * This method is for OOS item using batch API
	        * @return void
	        */
	    findOOSitem: function findOOSitem(invokeBatchAPICall) {
	      itemIdMap = new Map();
	      listOfObjects = [];
	      OOSMap = new Map();
	
	      //folowing code for avoiding 2nd method call
	      var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
	      COSTCO.CMath.selectedswatches = optionsSelected;
	
	      // following code for setting 2nd swatch items for selected first swatch
	
	      COSTCO.Product.getLowerLevelItemDetails(optionsSelected); //for setting array of item id and listOfObjects which has  itemid and option associated with that item 
	      if (invokeBatchAPICall) {
	        COSTCO.Product.invokeInventoryBatchAPIcall(optionsSelected); // following code for call bact API call
	      } else {
	        var len = optionsSelected.length;
	        if ($('#swatches-productOption0' + parseInt(len - 1) + '').length > 0) {
	          COSTCO.Product.strikeOosSwatches(optionsSelected);
	        } else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0) {
	          COSTCO.Product.grayOutDropDown(optionsSelected);
	        }
	      }
	      //following code for remove lower skeleton and append swatches
	      $('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
	      $('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
	      $('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
	      COSTCO.CMath.pdpPageloadComplete = true;
	      COSTCO.CMath.invokebatchCall = false;
	    },
	    /**
	        * Changes the variance value displayed in bundle element
	        * @param id of variance select element user changed
	        * @param  variance label
	        * @param new variance value
	        * @param product price
	        * @param varianceIsBackordered
	        * @param varianceBackorderMessage
	        * @return void
	        */
	    changeBundleItemVarianceValue: function changeBundleItemVarianceValue(varianceId, varianceLabel, varianceValue, variancePrice, varianceIsBackordered, varianceBackorderMessage) {
	      var $varianceValue = $('#bundle-item-value-' + varianceId);
	      $varianceValue.find('span').text(varianceLabel + ': ' + varianceValue);
	      var $variancePrice = $('#bundle-item-price-' + varianceId);
	      $variancePrice.find('span').text(COSTCO.Product.formatMoney(variancePrice, true));
	      var $bundleItem = $('#bundle-item-' + varianceId);
	      $bundleItem.find('#backorder-message').remove();
	      if (varianceIsBackordered && varianceBackorderMessage) {
	        $bundleItem.append($('<div id="backorder-message" class="warning"></div>').text(varianceBackorderMessage));
	      }
	    },
	
	    /**
	        * Changes the quantity displayed in bundle input element on plus/minus click
	        * @param index ID of quantity element user clicked on
	        * @param isIncrement boolean showing if user clicked on plus or minus button
	        * @return void
	        */
	    changeBundleItemQuantityValue: function changeBundleItemQuantityValue(index, isIncrement) {
	      var qtyInput = $('#bundle-quantity-' + index);
	      var qtyValue = parseInt(qtyInput.val());
	      var quantityStep = 1;
	
	      if (isIncrement === true) {
	        var maxQnty = COSTCO.Product.maxQuantity();
	        if (qtyValue + quantityStep <= maxQnty + 1) {
	          qtyValue += quantityStep;
	        }
	      } else if (isIncrement === false) {
	        if (qtyValue - quantityStep >= 0) {
	          qtyValue -= quantityStep;
	        }
	      }
	
	      qtyInput.val(qtyValue);
	
	      COSTCO.Product.validateQuantityValue(qtyInput, '.bundle-item #bundle-error-' + index);
	      COSTCO.Product.discardInvalidQtyValues(qtyValue, qtyInput, isIncrement);
	
	      if (!qtyInput.hasClass("error")) {
	        $('[name=quantity-' + index + ']').val(qtyValue);
	        $('[name=quantity-' + index + ']').trigger('change');
	      }
	    },
	
	    /**
	     * Adds item to the bundle and shows it in the bundle section
	     * @param bundleItemObj product that is added to bundle
	     * @return void
	     */
	    addBundleItem: function addBundleItem(bundleItemObj) {
	      $('#bundle-div-empty').hide();
	      if (bundleItemObj.varianceLabel && bundleItemObj.varianceValue) {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item_variance', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_label: bundleItemObj.varianceLabel,
	          item_value: bundleItemObj.varianceValue,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof bundleItemObj.beckorderedMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(bundleItemObj.beckorderedMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      } else {
	        $('#bundle-div').append(COSTCO.util.tmpl('tmpl_bundle_item', {
	          item_desc: bundleItemObj.desc,
	          item_url: bundleItemObj.url,
	          item_price: bundleItemObj.price,
	          item_id: bundleItemObj.itemId,
	          item_data_product: parseInt(bundleItemObj.itemId) - 1
	        }));
	        if (bundleItemObj.backordered) {
	          if (typeof backorderMessage !== "undefined") {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(backorderMessage));
	          } else {
	            $('#bundle-item-' + bundleItemObj.itemId).append($('<div id="backorder-message" class="warning"></div>').text(messages.BACKORDER_TEXT_MSG5));
	          }
	        }
	      }
	      var $qtyInput = $('#bundle-quantity-' + bundleItemObj.itemId);
	      COSTCO.Product.changeBundleItemQuantityValue(bundleItemObj.itemId);
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 1) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	      } else {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	      }
	      $('#bundle-container').append($('#bundle-items-container'));
	      $('#bundle-items-container').show();
	      var topOfWindow = $(window).scrollTop();
	      var $buildABundle = $('#build-a-bundle');
	      var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	      if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	        $('#pdp-sticky-mobile').append($('#bundle-items-container'));
	        $('#build-bundle-sticky').detach();
	      }
	      $('#addBundleBtn').removeAttr('disabled');
	    },
	
	    /**
	     * Removes the item from the bundle section
	     * @param bundleItemNumber ID number of bundle item that is being removed
	     * @return void
	     */
	    removeBundleItem: function removeBundleItem(bundleItemNumber) {
	      $('#ProductForm #quantity-' + bundleItemNumber).val('0');
	      $('#ProductForm #quantity-' + bundleItemNumber).trigger('change');
	      if ($('#checkbox-bundle-' + bundleItemNumber).is(':checked')) {
	        $('#checkbox-bundle-' + bundleItemNumber).prop('checked', false);
	        $('#checkbox-bundle-' + bundleItemNumber).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	      }
	      $('#bundle-item-' + bundleItemNumber).remove();
	      var numberOfItems = $('.bundle-item').length;
	      if (numberOfItems == 0) {
	        $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE_ITEMS);
	        $('#accordion-item-number').text('');
	        $('#bundle-div-empty').show();
	        var topOfWindow = $(window).scrollTop();
	        var $buildABundle = $('#build-a-bundle');
	        var bottomOfElement = $buildABundle.offset().top + $buildABundle.outerHeight();
	        if (topOfWindow >= bottomOfElement && $(window).width() < 769) {
	          $('#bundle-container').append($('#bundle-items-container'));
	          $('#pdp-sticky-mobile').append($('#build-bundle-sticky'));
	        }
	        $('#addBundleBtn').attr('disabled', true);
	      } else {
	        if (numberOfItems == 1) {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.ITEM + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.ITEM + ')');
	        } else {
	          $('#bundle-caption').text(messages.PDP_REDESIGN_V2_BUNDLE + ' (' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	          $('#accordion-item-number').text('(' + numberOfItems + ' ' + messages.NO_OF_ITEMS + ')');
	        }
	      }
	    },
	
	    /**
	     * Calls addBundleItem/removeBundleItem when the bundle checkbox is clicked
	     * @param element checkbox element that is being clicked
	     * @param bundleItemNumber ID number of bundle item
	     * @return void
	     */
	    bundleCheckboxClick: function bundleCheckboxClick(element, bundleItemNumber) {
	      if ($(element).is(':checked')) {
	        var clonedVarArr = document.getElementsByClassName('cloned');
	        var select = $("select[data-product=" + (bundleItemNumber - 1) + "]");
	        //Check if item is backordered
	        var isBackordered = false;
	        if ($(element).closest('.bundle-product').find('#backorder-message').length > 0) {
	          isBackordered = true;
	        }
	        if (clonedVarArr.length > 0 && select.length > 0) {
	          var selectedOption = $("select[data-product=" + (bundleItemNumber - 1) + "] option:selected");
	          var selectVariantName = $(select).prop('name');
	          var labels = '';
	          //check if bundle item has variance to select
	          labels = $("label[for='" + select[1].id + "']");
	          //check value of the cloned select 
	          if (selectedOption[1].value == "unselected") {
	            $(element).prop("checked", false);
	            select.addClass("error-in-bundle");
	            labels.addClass("label-outline-error");
	            labels.show();
	            return;
	          } else {
	            $('#' + selectVariantName).val(selectedOption[1].value);
	            $('#' + selectVariantName).trigger('change.vari');
	          }
	          var $bundleItemLink = $(element).closest('.vari').find('.desc');
	          var bundleItemObj = {
	            desc: $bundleItemLink.text(),
	            url: $bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            varianceLabel: labels[1].textContent.trim(),
	            varianceValue: selectedOption[1].text,
	            backordered: isBackordered,
	            beckorderedMessage: $(element).closest('.bundle-product').find('#backorder-message').text()
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(bundleItemObj);
	        } else {
	          var _$bundleItemLink = $(element).closest('.vari').find('.desc');
	          var _bundleItemObj = {
	            desc: _$bundleItemLink.text(),
	            url: _$bundleItemLink.attr('href'),
	            price: $(element).closest('.vari').find('.price span').text(),
	            itemId: bundleItemNumber,
	            backordered: isBackordered
	          };
	          $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADDED_TO_BUNDLE);
	          COSTCO.Product.addBundleItem(_bundleItemObj);
	        }
	      } else {
	        $(element).closest('a').find('span').text(messages.PDP_REDESIGN_V2_ADD_TO_BUNDLE);
	        COSTCO.Product.removeBundleItem(bundleItemNumber);
	      }
	    },
	
	    /**
	     * Scroll to section from product info sticky element. 
	     * Sets offset approximately for the width of sticky element.   
	     */
	    scrollToElementOnPdpWithOffset: function scrollToElementOnPdpWithOffset() {
	      $('a.scrollLink').click(function (event) {
	        event.preventDefault();
	        var stickyOffset = $('#hidden-sticky').is(':hidden') ? 190 : 140;
	        $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top - stickyOffset }, 500);
	      });
	    },
	
	    /**
	     * Changes bundle accordion header text when accordion is expanded/collapsed
	     * @return void
	     */
	    bundleAccordionClick: function bundleAccordionClick() {
	      if ($('#bundle-accordion-collapse').hasClass('in')) {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_VIEW_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate270');
	        $('#bundle-accordion-header a i').addClass('rotate90');
	      } else {
	        $('#accordion-header-text').text(messages.PDP_REDESIGN_V2_HIDE_ORDER_SUMMARY);
	        $('#bundle-accordion-header a i').removeClass('rotate90');
	        $('#bundle-accordion-header a i').addClass('rotate270');
	      }
	    },
	    /**
	     * Scrolls the page to tablist and shows the buld a bundle tab
	     * @return void
	     */
	    focusBuildABundle: function focusBuildABundle() {
	      $('html, body').scrollToElem($('.bottom-content'), 500);
	      $('#build-bundle-tab').focus();
	      setTimeout(function () {
	        $('#tablist li').removeClass('active');
	        $('.tab-content div').removeClass('active in');
	        $('#tab-header-bundle').addClass('active');
	        $('.bundle-tab').addClass('active in');
	      }, 500);
	    },
	    /**
	     * Scrolls the page to the top and focuses on the Zip Code field
	     * @return void
	     */
	    focusZipCodeField: function focusZipCodeField() {
	      var x = $('#edd-message-block').length > 0 ? $("#edd-message-block").offset() : $('#delivery-zip').offset();
	      $('html, body').animate({ scrollTop: x.top - 200 }, 'slow');
	      if ($('#edd-message-block').length > 0) {
	        $('#edd-message-block').focus();
	      } else {
	        $('#delivery-zip').focus();
	      }
	    },
	
	    /**
	     * Makes Add to Registry button reachable by keyboard,
	     * and enables click on the button via keyboard 
	     */
	    makeGiftRegistryAdaCompliant: function makeGiftRegistryAdaCompliant() {
	      var addToRegistryDivContent = $('.mr-registry-container a');
	      addToRegistryDivContent.attr('tabindex', '0');
	      addToRegistryDivContent.attr('role', 'button');
	
	      addToRegistryDivContent.on('keypress click', function (event) {
	        if (event.which === 13 || event.which === 1) {
	          addToRegistryDivContent.click();
	          return false;
	        }
	      });
	    },
	    /**
	     * ADA compliance
	     * Initializes aria-current value for tab panel
	     * @return void
	     */
	    initializeAdaForTabPanel: function initializeAdaForTabPanel() {
	      $('.tablist li.active a').attr('aria-current', "true");
	    },
	    /**
	     * Sets all bundle checkboxes to unchecked on load
	     * @return void
	     */
	    bundlePageReload: function bundlePageReload() {
	      $('[id^="checkbox-bundle-"]').prop('checked', false);
	      $('[id^="clonedproductOption"]').prop("selectedIndex", 0);
	    },
	
	    arrangeBundleButtons: function arrangeBundleButtons() {
	      if (!$('#mr-registry-container').is(':empty')) {
	        $('#bundle-button').addClass('not-alone');
	      }
	    },
	
	    /** envent for determing if quantity-selector-v2 buttons shoud be enabled/disabled. This event is triggering when user changes quantity box
	     * 
	     */
	    initializeQuantityBtns: function initializeQuantityBtns() {
	      $('#minQtyText').unbind('keyup').bind('keyup', function () {
	        COSTCO.Product.changeQuantityButtonsBehaviour();
	      });
	    },
	
	    /** function for disabling '+' and '-' buttons for quantity-selector-v2
	     * @param disblebuttonSelector - selector for buttton which needs to be disabled.
	     * @return void
	     * 
	     */
	    disableButton: function disableButton(disblebuttonSelector) {
	      disblebuttonSelector.get(0).setAttribute('disabled', true);
	      disblebuttonSelector.addClass("disabled");
	    },
	
	    /** function for enabling '+' and '-' buttons for quantity-selector-v2
	     * @param enablebuttonSelector - selector for buttton which needs to be enabled.
	     * @return void
	     * 
	     */
	    enableButton: function enableButton(enablebuttonSelector) {
	      enablebuttonSelector.removeAttr("disabled");
	      enablebuttonSelector.removeClass("disabled");
	    },
	    /**
	     * this function has logic for determing should '+' or '-' buttons be enabled or disabled
	     * @return void
	     */
	    changeQuantityButtonsBehaviour: function changeQuantityButtonsBehaviour() {
	      var quantityStep = $('#minQtyText').attr('data-quantity-increment') ? parseInt($('#minQtyText').attr('data-quantity-increment')) : 1;
	      var currentQut = $('[name=quantity]').val();
	      if (currentQut > 999 - quantityStep) {
	        COSTCO.Product.disableButton($("#plusQty"));
	      } else if (currentQut <= quantityStep) {
	        COSTCO.Product.disableButton($("#minusQty"));
	      } else {
	        COSTCO.Product.enableButton($("#minusQty"));
	        COSTCO.Product.enableButton($("#plusQty"));
	      }
	    },
	    makeTextNonClicableForSR: function makeTextNonClicableForSR() {
	      $('#product-details').off('click');
	      $('#product-details').find('*').off('click');
	    },
	
	    initShippingStatementPopover: function initShippingStatementPopover() {
	      $('.popup-help').attr('aria-haspopup', 'true');
	      $('.popup-help').attr('aria-expanded', 'false');
	      var sr_message = messages.RWD_HELP;
	      $('.popup-help i').append("<span class='sr-only'>" + sr_message + "</span>");
	      $('.popup-help').popover({
	        trigger: 'click'
	      }).on('keypress', function (e) {
	        if (e.which === 13 || e.which === 32 || e.which === 1) {
	          // mozilla condition
	          if ($('.popover').length === 1) {
	            return;
	          } else {
	            $(this).click();
	          }
	        }
	      }).on('shown.bs.popover', function () {
	        COSTCO.util.announceSRMessage('expanded');
	        $('.popover').on('focusout ', function (e) {
	          $('.popup-help').popover('hide').on('keydown', function (e) {
	            if (event.shiftKey && event.keyCode === 9) {
	              $('.popup-help').popover('hide');
	            }
	          });
	        });
	        $('body').on('click', function (e) {
	          var $popupContainer = $('.shipping-statement .popup-help');
	          if (!$popupContainer.is(e.target) && $popupContainer.has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
	            $popupContainer.popover('hide');
	          }
	        });
	      });
	    },
	    /**
	      * this function has logic to show/hide review contents
	      * param action
	      * @return void
	      */
	    changeVisibilityOfReviewContents: function changeVisibilityOfReviewContents(action) {
	      var $bvReviewContents = $('.bv-content-item.bv-content-top-review.bv-content-review');
	      $bvReviewContents.each(function (index) {
	        if (index != 0 && action === "hide") {
	          $(this).attr("style", "display: none !important");
	        } else if (action === "show") {
	          $(this).attr("style", "display: flex !important");
	        }
	      });
	    },
	    invokeAddedToCartModalData: function invokeAddedToCartModalData(sessionStorageDataModal) {
	      var addedToCartModalData = $.parseJSON(sessionStorageDataModal);
	      COSTCO.AddToCart.product_form_done(addedToCartModalData);
	      sessionStorage.removeItem("AddedToCartModalData");
	    },
	    /**
	    * Show/Hide the EDD details and message based on whether Product is coming soon.
	    * @param product isComingSoon and feature flag are true shows the coming soon message else shows EDD details.
	    */
	    toggleDeliveryMoleculeOnComingSoon: function toggleDeliveryMoleculeOnComingSoon() {
	      if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) {
	        $('#comingsoon-alert-id').removeClass('hide');
	        $('#product-form-and-action').addClass('hide');
	        $('#product-estimated-date').addClass('hide');
	        $('#sticky-content').addClass('hide');
	      } else {
	        $('#comingsoon-alert-id').addClass('hide');
	        $('#product-form-and-action').removeClass('hide');
	        if (!COSTCO.CMath.iskitsbundle) {
	          $('#product-estimated-date').removeClass('hide');
	        }
	        $('#sticky-content').removeClass('hide');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.Product = Product;
	  return Product;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 16:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title costcodialog.js: Sub-module for Global pages
	 * @description This module is used to creating Modal
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var dialog = {
	    dialogSettings: null,
	    triggerEvent: null,
	    /**
	     * Create a BS style modal that is customizable
	     * @param  {Object} settings Object with following properties:
	     * - title : string appears in the header portion of the modal
	     * - body : HTML/string that represents the body of the modal
	     * - primary : primary action button name.
	     * - secondary : secondary action button name.z
	     * - primary_event : OPTIONAL custom event to attach to primary button
	     * - url : OPTIONAL url for external link. Used if a primary_event is not provided.
	     * @return {void}
	     */
	    createExtDialogBox: function createExtDialogBox(settings) {
	      // show onetimepopup?
	      if (settings.oneTimePopup && this.isPresentInLocalStorage(settings.url)) {
	        window.open(settings.url);
	        return;
	      }
	      dialog.showAndHideModal(settings);
	    },
	
	    modalObserver: {
	      state: {
	        STARTED: 'STARTED',
	        STOPPED: 'STOPPED'
	      },
	      observer: null,
	      modalObserverState: '',
	      elementCausedModal: undefined,
	      elementCausedSecondModalId: undefined,
	      showingSecondModal: undefined
	    },
	
	    /**
	     * Function used to watch for changes of costco modal
	    */
	    returnFocusOnCallerElement: function returnFocusOnCallerElement(activeElement) {
	      if (dialog.modalObserver.modalObserverState != dialog.modalObserver.state.STARTED) {
	        dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STARTED;
	        if (activeElement !== undefined) {
	          dialog.modalObserver.elementCausedModal = activeElement;
	        }
	        var targetObject = COSTCO.dialog.getModal();
	        if (targetObject.length > 0) {
	          targetObject = targetObject[0];
	          var observerObject = new MutationObserver(function mutationObjectCallback(mutationRecordsList) {
	            mutationRecordsList.forEach(function (mutation) {
	              var eventOnClick = false;
	              if (event !== undefined) {
	                eventOnClick = event.target.onclick ? true : false;
	              }
	              //On modal close
	              if (mutation.target.className === "modal fade" && !dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                $(dialog.modalObserver.elementCausedModal).focus();
	                dialog.modalObserver.elementCausedModal = undefined;
	                COSTCO.dialog.stopModalObserver();
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedSecondModalId && !eventOnClick) {
	                dialog.modalObserver.showingSecondModal = undefined;
	              } else if (mutation.target.className === "modal fade" && dialog.modalObserver.elementCausedModal && eventOnClick) {
	                COSTCO.dialog.addParentElementForModalObserver(event.target);
	              }
	            });
	          });
	          // Register the target node to observe and specify which DOM changes to watch
	          observerObject.observe(targetObject, {
	            attributes: true,
	            attributeFilter: ["class"]
	          });
	          if (observerObject) {
	            this.modalObserver.observer = observerObject;
	          }
	        }
	      }
	    },
	
	    addParentElementForModalObserver: function addParentElementForModalObserver(activeElement) {
	      dialog.modalObserver.elementCausedSecondModalId = activeElement.id;
	      dialog.modalObserver.showingSecondModal = true;
	    },
	
	    removeParentElementForModalObserver: function removeParentElementForModalObserver(activeElement) {
	      if ($('#' + dialog.modalObserver.elementCausedSecondModalId).get(0)) {
	        $('#' + dialog.modalObserver.elementCausedSecondModalId).get(0).focus();
	        $(document).keyup(function (e) {
	          if (e.key === "Escape") {
	            $(dialog.modalObserver.elementCausedModal).focus();
	            dialog.modalObserver.elementCausedModal = undefined;
	            COSTCO.dialog.stopModalObserver();
	          }
	        });
	      }
	
	      dialog.modalObserver.elementCausedSecondModalId = undefined;
	    },
	
	    stopModalObserver: function stopModalObserver() {
	
	      dialog.modalObserver.modalObserverState = dialog.modalObserver.state.STOPPED;
	
	      this.modalObserver.observer.disconnect();
	    },
	
	    /**
	     * Get the Modal for instances where you need to bind certain events
	     * @return {jQuery.Object} The costcoModal jquery object
	     */
	    getModal: function getModal() {
	      return $('#costcoModal');
	    },
	    /**
	     * [description]
	     * @return {[type]} [description]
	     */
	    isVisible: function isVisible() {
	      if ($('#costcoModal').css('display') == 'none') {
	        return false;
	      } else {
	        return $('#costcoModal').is(':visible');
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showAndHideModal: function showAndHideModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      if (COSTCO.dialog.isVisible()) {
	        $('#costcoModal').on('hidden.bs.modal', function () {
	          // Load up a new modal...
	          COSTCO.dialog.showModal(settings);
	        });
	        $('#costcoModal').modal('hide');
	      } else {
	        this.showModal(settings);
	      }
	    },
	    /**
	     * [description]
	     * @param  {[type]} settings [description]
	     * @return {void}          [description]
	     */
	    showModal: function showModal(settings) {
	      dialog.captureDataBeforeShowingModal(settings);
	      //modification for ReturnDialogMOdal.jsp
	      if (settings.url) {
	        $('#select-page').addClass('hidden');
	        $('#add-edit-page').removeClass('hidden');
	      }
	      if (settings.hideCloseButton) {
	        $('.close').addClass('hidden');
	      }
	      //end modification for ReturnDialogMOdal.jsp
	      if (settings.dialogclasses) {
	        $('.modal-dialog').addClass(settings.dialogclasses);
	      }
	      if (settings.hideHeader) {
	        $('.modal-header').hide();
	      } else {
	        $('.modal-header').show();
	        $('#costcoModalTitle').text(settings.title);
	        var modaltitle = settings.title;
	        if (modaltitle == 'Edit Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Shipping Address | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Shipping Address | Save Address");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Edit Shipping Address | Cancel");
	        }
	        if (modaltitle == 'Add New Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Add New Address Modal | X Close");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Add New Address Modal | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Add New Address | Cancel");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Add New Address Modal | Cancel");
	        }
	        if (modaltitle == 'Select Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Select Address Modal | X Close");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").attr("data-bi-tc", "ui:Select Address Modal | Cancel");
	        }
	        if (modaltitle == 'Change Pick Up Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".costcoModalBtn1.btn.btn-tertiary.btn-block").removeAttr("data-bi-tc");
	        }
	        if (modaltitle == 'Edit Delivery Address' || modaltitle == 'Edit Billing Address') {
	          $(".modal-header").find(":button").removeAttr("data-bi-tc");
	          $(".modal-header").find(":button").attr("data-bi-tc", "ui:Edit Address | Close Button");
	          $("#costcoModalBtn2").removeAttr("data-bi-tc");
	          $("#costcoModalBtn2").attr("data-bi-tc", "ui:Edit Address | Save Address");
	          $("#costcoModalBtn1").removeAttr("data-bi-tc");
	          $("#costcoModalBtn1").attr("data-bi-tc", "ui:Edit Address | Cancel");
	        }
	        if (settings.close) {
	          $('.close').unbind().on('click', function () {
	            settings.close();
	          });
	        }
	      }
	      // if there is a modal Label specified in the setting used it
	      // otherwise we will use the modal title
	      if (settings.modalLabel) {
	        $('#costcoModal').attr('aria-label', settings.modalLabel);
	        $('#costcoModal').removeAttr('aria-labelledby');
	      } else {
	        if (!settings.hideHeader && settings.title) {
	          $('#costcoModal').attr('aria-labelledby', 'costcoModalTitle');
	          $('#costcoModal').removeAttr('aria-label');
	        }
	      }
	
	      $('#costcoModalText').html(settings.body);
	      if (settings.replaceFooter) {
	        $('#costcoModal .modal-footer').html(settings.replaceFooter);
	      }
	      if (settings.showVerifyMeModal || settings.primary && (settings.primary_event || settings.url)) {
	        $('#costcoModalBtn2').text(settings.primary).show();
	        $('#costcoModalBtn2').removeAttr('automation-id');
	        $('#costcoModalBtn2').attr('automation-id', settings.primary.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() + "_button");
	        if (settings.primary_button_style !== undefined && settings.primary_button_style.includes('rounded')) {
	          $('#costcoModalBtn2').addClass('primary-button-v2');
	        }
	        //since primary button is visible, make the secondary button half the row again
	        if (settings.secondary != undefined || settings.setHalfButtons) {
	          $('.costcoModalBtn1').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('#costcoModalBtn2').parent('.col-md-12').removeClass('col-md-12').addClass('col-md-6');
	          $('.costcoModalBtn1').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	          $('#costcoModalBtn2').parent('.col-lg-12').removeClass('col-lg-12').addClass('col-lg-6');
	        } else {
	          $('#costcoModalBtn2').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	          $('#costcoModalBtn2').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	        }
	        if (settings.showVerifyMeModal) {
	          $('#costcoModalBtn2').html(settings.showVerifyMeModalText);
	          $('#costcoModalBtn2').addClass('verify-me-button');
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('#costcoModalBtn2').removeClass('btn-primary');
	          $('#costcoModalBtn2').addClass('no-padding');
	        } else {
	          $('#costcoModalBtn2').removeClass('verify-me-button');
	        }
	      } else {
	        $('#costcoModalBtn2').hide();
	        //since primary event button is hidden, make the secondary button span the whole row
	        $('.costcoModalBtn1').parent('.col-md-6').removeClass('col-md-6').addClass('col-md-12');
	        $('.costcoModalBtn1').parent('.col-lg-6').removeClass('col-lg-6').addClass('col-lg-12');
	      }
	      if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('rounded')) {
	        $('.costcoModalBtn1').addClass('secondary-button-v2');
	      } else if (settings.secondary_button_style !== undefined && settings.secondary_button_style.includes('tertiary')) {
	        $('.costcoModalBtn1').addClass('tertiary-alternative-button-v2');
	        $('.costcoModalBtn1').removeClass('btn-tertiary secondary-button-v2');
	      }
	
	      if (settings.hideFooter) {
	        $('.modal-footer').hide();
	      } else {
	        $('.modal-footer').show();
	      }
	      if (settings.primaryDisabled) {
	        $('#costcoModalBtn2').addClass('btn-disabled');
	      } else {
	        $('#costcoModalBtn2').removeClass('btn-disabled');
	      }
	      if (settings.secondary) {
	        $('.costcoModalBtn1').text(settings.secondary).show();
	      } else {
	        $('.costcoModalBtn1').hide();
	      }
	      if (settings.close) {
	        $('.close').unbind().on('click', function () {
	          //modification for ReturnDialogMOdal.jsp
	          if (settings.url == undefined) {
	            $('#select-page').removeClass('hidden');
	            $('#add-edit-page').addClass('hidden');
	          }
	          //end modification for ReturnDialogMOdal.jsp
	
	          settings.close();
	        });
	      }
	
	      if (settings.footerText) {
	        $('#costcoModalFooterText').html(settings.footerText);
	        $('#costcoModalFooterText').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText').addClass('hide');
	      }
	      // Hides the default modal footer and shows the alternate modal footer
	      if (settings.footerText2) {
	        $('#costcoModalFooterText2').html(settings.footerText2);
	        $('#costcoModalFooterText2').removeClass('hide');
	      } else {
	        $('#costcoModalFooterText2').addClass('hide');
	      }
	
	      $('#commercial-indicator, #residental-indicator').unbind().on('keydown keypress', function (event) {
	        if (event.which === 32) {
	          $(this).click();
	        } else if (event.which === 38 || event.which === 40) {
	          //cursors up and down
	          var $controlIndicators = $(this).closest('.control-group').find('.control__indicator');
	          var total = $controlIndicators.length;
	          var index = $controlIndicators.index(this);
	          if (event.which == 38) {
	            //cursor up
	            index = index == 0 ? total - 1 : index - 1;
	          } else if (event.which == 40) {
	            //cursor down
	            index = (index + 1) % total;
	          }
	          $controlIndicators[index].click();
	        }
	      });
	
	      $('#commercial-indicator, #residental-indicator').unbind('click').on('click', function (event) {
	        if ($(event.target).hasClass('control__indicator')) {
	          var passiveElement = $(event.target).attr('id') === "commercial-indicator" ? $('#residental-indicator') : $('#commercial-indicator');
	          COSTCO.dialog.setRadioButtonsAttributes($(event.target), passiveElement);
	        }
	        $(event.target).find('input').click();
	      });
	
	      $('#costcoModalBtn2').unbind().on('click', function () {
	        if (COSTCO.timeoutModal && COSTCO.timeoutModal.state === COSTCO.timeoutModal.TIMEDOUT) {
	          var url = "ReLogonFormView?URL=" + window.location.pathname;
	          document.location.href = url;
	        }
	        if (settings.primary_event) {
	          if (settings.primary == 'View List' || settings.primary == 'Voir la liste') {
	            COSTCO.Global.updateSelectedMenuItem('Lists.label');
	          }
	          settings.primary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	          if (settings.url) {
	            window.open(settings.url);
	
	            // check for onetimepopup and add to local storage
	            if (settings.oneTimePopup) {
	              COSTCO.util.setInStorage(settings.url, {
	                'url': settings.url
	              });
	            }
	          }
	        }
	      });
	      $('.costcoModalBtn1').unbind().on('click', function () {
	        //modification for ReturnDialogMOdal.jsp
	        if (settings.url == undefined) {
	          $('#select-page').removeClass('hidden');
	          $('#add-edit-page').addClass('hidden');
	        }
	        //end modification for ReturnDialogMOdal.jsp
	
	        if (settings.secondary_event) {
	          settings.secondary_event();
	        } else {
	          $('#costcoModal').modal('hide');
	        }
	      });
	      if (settings.popover) {
	        $('#costcoModal').find('[data-toggle="popover"]').popover();
	      }
	      this.bindEvents(settings);
	      $('#costcoModal').modal({
	        backdrop: settings.preventClose ? 'static' : true,
	        keyboard: settings.preventClose ? false : true,
	        show: true
	      });
	      //Handle page load by opening in new tab
	      $('#costcoModal').show();
	      $('#costcoModal').css('display', 'block');
	    },
	
	    sameAddressValidation: function sameAddressValidation(formSelector, fieldSelector) {
	      var addressEnteredForCheck = $('#addressEnteredForCheck').val();
	      $(fieldSelector).val(addressEnteredForCheck);
	      $(fieldSelector).focus();
	      var forms = $(fieldSelector).parents('FORM');
	      var addressEnteredForCheck2 = $('#addressEnteredForCheck2');
	      if (forms.length && addressEnteredForCheck2.length) {
	        var form = $(forms[0]);
	        var address2 = addressEnteredForCheck2.val();
	        var city = $('#addressEnteredForCheckCity').val();
	        var state = $('#addressEnteredForCheckState').val();
	        var postalCode = $('#addressEnteredForCheckPostalCode').val();
	        var formFields = form.find('INPUT[type="text"]');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/address2/.test(field.name)) {
	            field.value = address2;
	          } else if (/city/.test(field.name)) {
	            field.value = city;
	          } else if (/.*(zip|postal).*/.test(field.name)) {
	            field.value = postalCode;
	          }
	        }
	        formFields = form.find('SELECT');
	        for (var i = 0; i < formFields.length; i++) {
	          var field = formFields[i];
	          if (/.*(province|state).*/.test(field.name)) {
	            field.value = state;
	          }
	        }
	      }
	      $.validator.addMethod("sameAddressValidationRule", function (inputValue) {
	        return addressEnteredForCheck === inputValue ? false : true;
	      }, messages.ERR_SHIP_ADDR_SAME_AS_WHS_ADDR_FIELD_VALIDATION);
	
	      $(formSelector).validate().resetForm();
	      $(formSelector).validate();
	      $(fieldSelector).rules('add', 'sameAddressValidationRule');
	      $(fieldSelector).valid();
	    },
	
	    /**
	     * Updates the modal title, body, buttons, bindings etc without closing the modal
	     * @param  {Object} settings @see COSTCO.dialog.createExtDialogBox()
	     */
	    updateModal: function updateModal(settings) {
	      dialog.showModal(settings);
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    close: function close() {
	      $('#costcoModal').modal('hide');
	      dialog.returnFocusOnPreviousElement();
	    },
	    /**
	     * [description]
	     * @return {void} [description]
	     */
	    closeAndUnbind: function closeAndUnbind() {
	      $('#costcoModal').unbind('shown.bs.modal');
	      $('#costcoModal').unbind('hidden.bs.modal');
	      $('#costcoModal').unbind('hide.bs.modal');
	      this.close();
	    },
	    /**
	     * Binds the "hidden/shown" events (ie modal is closed/opened) with some
	     * clear/show actions. Additionally you can pass a function as part
	     * of your settings object to execute custom thangs.
	     * @param  {Object} settings  The settings object that contains
	     *                            the event handlers used for various
	     *                            modal actions.
	     * @return {void}
	     */
	    bindEvents: function bindEvents(settings) {
	      $('#costcoModal').unbind('shown.bs.modal').on('shown.bs.modal', function (e) {
	        // This event is fired when the modal has been made visible to the user
	        // (will wait for CSS transitions to complete). If caused by a click,
	        // the clicked element is available as the relatedTarget property of
	        // the event.
	        if (settings.onshown) settings.onshown(e);
	        if (dialog.modalObserver.elementCausedSecondModalId && !e.target.onclick && !dialog.modalObserver.showingSecondModal) {
	          COSTCO.dialog.removeParentElementForModalObserver();
	        };
	        COSTCO.util.trapFocusInsideModal();
	      });
	      $('#costcoModal').unbind('hidden.bs.modal').on('hidden.bs.modal', function (e) {
	        if (typeof settings.dialogclasses != 'undefined') {
	          $('.modal-dialog').removeClass(settings.dialogclasses);
	        }
	        // clear and show. Execute fn if it exists
	        if (settings.onclose) settings.onclose(e);
	        $('#costcoModalTitle').empty().show();
	        if ($('#react-video-holder').length && $('#videoViewer-popup').length) $('#react-video-holder').append($('#videoViewer-popup'));
	        $('#costcoModalText').empty().show();
	        $('.costcoModalBtn1').empty().show();
	        $('#costcoModalBtn2').empty().show();
	
	        if (settings.afterclose) settings.afterclose(e);
	      });
	      $('#costcoModal').unbind('show.bs.modal').on('show.bs.modal', function (e) {
	        if (settings.onshow) settings.onshow(e);
	      });
	      $('#costcoModal').unbind('hide.bs.modal').on('hide.bs.modal', function (e) {
	        // This event is fired when the modal is going to close.
	        if (settings.onhide) settings.onhide(e);
	      });
	    },
	    /**
	     * [description]
	     * @param  {[type]} hostname [description]
	     * @return {boolean}
	     */
	    isPresentInLocalStorage: function isPresentInLocalStorage(hostname) {
	      if (JSON.stringify(COSTCO.util.getFromStorage(hostname)).indexOf(hostname) > 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    /**
	     * Holds previous options object used to instantiate a modal with.
	     * This is the modal stack used by modalStack function.
	     * @type {Array}
	     */
	    modalStackPreviousOptions: [],
	    /**
	     * Create a sequential stack of modals by calling this function
	     * successively.
	     *  ex.
	     *    1. COSTCO.dialog.modalStack({title:'hi', body:'robert'})
	     *      -> Invoke a hi-robert modal, pushes options to stack.
	     *    2. COSTCO.dialog.modalStack({title:'hi', body:'kurt'})
	     *      -> Closes the hi-robert modal and invokes/pushes the hi-kurt
	     *         modal to stack.
	     *    3. (Escape key, Exit Arrow, or blur)
	     *      -> Pops the currently invoked modal from the stack and
	     *         closes it. Invokes the previous modal from the stack
	     *         until the stack b gone or we call this function again.
	     * @param  {Object} options The settings object for the modal.
	     * @return {void}
	     */
	    modalStack: function modalStack(options) {
	      var stack = this.modalStackPreviousOptions;
	      options.index = stack.length + 1;
	      stack.push(options);
	      options.afterclose = function () {
	        var stack = dialog.modalStackPreviousOptions;
	        if (stack.length === this.index && stack.length !== 1) {
	          // we need to go backward
	          dialog.showAndHideModal(stack[this.index - 2]);
	          COSTCO.dialog.modalStackPreviousOptions.pop();
	        } else if (stack.length > this.index) {
	          dialog.showAndHideModal(stack[this.index]);
	        } else {
	          COSTCO.dialog.clearStack();
	        }
	      }.bind(options);
	      if (stack.length === 1) {
	        this.showAndHideModal(options);
	      } else {
	        this.close();
	      }
	    },
	
	    /**
	     * set radio buttons attributes
	     */
	    setRadioButtonsAttributes: function setRadioButtonsAttributes(activeElement, passiveElement) {
	      activeElement.addClass('active').attr('aria-checked', true).find('div').removeClass('hide');
	      passiveElement.removeClass('active').attr('aria-checked', false).find('input').removeAttr('checked');
	      passiveElement.find('div').addClass('hide');
	    },
	
	    /**
	     * Clears the modal stack.
	     * @return {void} [description]
	     */
	    clearStack: function clearStack() {
	      this.modalStackPreviousOptions = [];
	    },
	    /*
	     * Listener for opening/closing modals 
	     * to help with returning focus to original 
	     * element or input 
	     */
	    initializeReturnFocusListener: function initializeReturnFocusListener() {
	      $(document).on('hidden.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnPreviousElement();
	      });
	      $(document).on('shown.bs.modal', '#costcoModal', function (e) {
	        dialog.returnFocusOnInput();
	      });
	    },
	    /*
	     * This function utilizes the triggerEvent variable
	     * to return focus on elements 
	     */
	    returnFocusOnPreviousElement: function returnFocusOnPreviousElement() {
	      var previousElement = null;
	      if (dialog.triggerEvent != null) {
	        previousElement = dialog.triggerEvent.srcElement;
	      } else if (dialog.triggerEvent == null && COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	      } else {
	        previousElement = $('body');
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function's use case is to return 
	     * focus to the element within a modal
	     */
	    returnFocusOnInput: function returnFocusOnInput() {
	      var previousElement = null;
	      if (COSTCO.timeoutModal != null && COSTCO.timeoutModal.lastActiveElement != null && dialog.dialogSettings.title !== messages.TIMEOUT_MODAL_HEADER) {
	        previousElement = COSTCO.timeoutModal.lastActiveElement;
	        COSTCO.timeoutModal.lastActiveElement = null;
	      }
	      $(previousElement).focus();
	    },
	
	    /*
	     * This function captures 
	     */
	    triggerEventUtil: function triggerEventUtil() {
	      if (window.event !== undefined) {
	        if (dialog.getSettings() != null && dialog.getSettings().title === messages.BD_QUESTIONNAIRE_TITLE) {
	          return;
	        } else if (dialog.getSettings() != null && dialog.getSettings().title === messages.TIMEOUT_MODAL_HEADER) {
	          return;
	        } else {
	          dialog.triggerEvent = window.event;
	        }
	      }
	    },
	    /*
	     * returns the current dialog's settings
	     */
	    getSettings: function getSettings() {
	      return dialog.dialogSettings;
	    },
	    /*
	     * Captures data upon opening a modal
	     * to grab the event and copy settings
	     */
	    captureDataBeforeShowingModal: function captureDataBeforeShowingModal(settings) {
	      dialog.triggerEventUtil();
	      dialog.dialogSettings = settings;
	    }
	
	  }; // end costcoDialog object
	  // Expose costcoDialog to the global scope.
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	  window.COSTCO.dialog = dialog;
	  return dialog;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	* @title checkout_helper.js: Feature level module
	* @description Utility module associated with checkout
	*/
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var Checkout = {
			/**
	  * Default implementation of the done promise used by ajax_update_state.
	  * The data structure this function uses is defined in JSONLayout.jsp.
	  * Update the state of each html segment. This assumes that the
	  * property key maps to the id of the html segment to replace. Also,
	  * if there any errors defined on the response_obj.error,
	  * display them.
	  * @param  {String} data       The JSON returned as a string. Contains
	  *                             the encoded html that must be decoded
	  *                             and then is injected into the DOM.
	  * @param  {String} textStatus [description]
	  * @param  {String} jqXHR      [description]
	  * @param  {Object} options    The options object originally passed to
	  *                             ajax_update_state
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_done
	  */
			ajax_update_default_done: function ajax_update_default_done(data, textStatus, jqXHR, options) {
				try {
					var response_obj = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : JSON.parse(data);
					var defaultOptions = {
						ajax_replace_content: COSTCO.Checkout.ajax_replace_content,
						ajax_handle_errors: COSTCO.Checkout.ajax_handle_errors,
						ajax_update_post_done: function ajax_update_post_done() {},
						error_container: '',
						scrollToError: true
					};
					$('body').trigger('costco.ajax.content.update.start', response_obj);
					var mergedOptions = $.extend(true, {}, defaultOptions, options);
					// Inject New Html
					mergedOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
					// Post Html Injection
					mergedOptions.ajax_update_post_done(response_obj, mergedOptions, defaultOptions);
					// Handle any Errors and perform cleanup
					mergedOptions.ajax_handle_errors(response_obj, mergedOptions, defaultOptions);
					$('body').trigger('costco.ajax.content.update.end', response_obj);
				} catch (e) {
					console.error(e);
				}
				console.log('ajax_update_default_done');
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_replace_content
	  */
			ajax_replace_content: function ajax_replace_content(response_obj, mergedOptions, defaultOptions) {
				Object.keys(response_obj.payload.html).forEach(function (key) {
					var encoded_html = response_obj.payload.html[key];
					if (mergedOptions.replaceKey) {
						if (mergedOptions.replaceKey.original == key) {
							key = mergedOptions.replaceKey.replace;
						}
					}
					$('#' + key).html(COSTCO.util.get_decoded_html(encoded_html));
					console.log('ajax_replace_content' + key);
				});
			},
	
			/**
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_handle_errors
	  */
			ajax_handle_errors: function ajax_handle_errors(response_obj, mergedOptions, defaultOptions) {
				if ($('#isBDAppVar').val() == 'BD') {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(.error-qty-increment, #cc_cvc, #cc_cvc_err_msg)').empty();
					} else {
						$('.error:not(.error-qty-increment)').empty(); // clear any errors that may be on the page
					}
				} else {
					if (COSTCO.CreditCard.isCybersourceEnabled()) {
						$('.error:not(select, #cc_cvc, #cc_cvc_err_msg)').empty();
						$('.error:not(select)').removeClass('critical-notification');
					} else {
						$('.error:not(select)').empty().removeClass('critical-notification'); // clear any errors that may be on the page
					}
	
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				var error_container = mergedOptions.error_container;
				if (Checkout.isReviewPage() || Checkout.isPaymentPage()) {
					if (typeof TokenGateway !== 'undefined') {
						TokenGateway.refreshGateway();
					}
					if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
						error_container = '#errquantity_application_';
						$('#errquantity_application_').addClass('critical-notification');
						$('#errquantity_application_').removeClass('error');
						$("#CheckoutPaymentForm input[name=doBillingPaymentCmd]").val('true');
	
						if ($('#errquantity_application_').html().trim() == '') {
							$('#errquantity_application_').html(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
						}
					} else {
						if (typeof COSTCO.CreditCard !== 'undefined') {
							COSTCO.CreditCard.init();
						}
						if (typeof COSTCO.wallet !== 'undefined') {
							//wallet module is not used in USBD - all other allow
							if (wcs.storeId != '11301') {
								COSTCO.wallet.init();
							}
						}
						if (typeof COSTCO.CC !== 'undefined') {
							COSTCO.CC.init();
						}
					}
				}
				var input_container = mergedOptions.input_container;
				var application = response_obj.error.application || [];
				var exception = response_obj.error.exception || [];
				var error_html = '';
				if (exception.length > 0) {
					if (wcs.langId !== -25) {
						error_html += '<p>Sorry, we are experiencing technical issues. Please try again later.</p>';
					} else {
						error_html += '<p>Désolé, nous éprouvons des difficultés techniques. Veuillez réessayer plus tard.</p>';
					}
				}
				application.forEach(function (error_message) {
					error_html += '<p>' + error_message.replace(/''/g, '\'') + '</p>';
				});
				// if there is a redirect, store the error in sessionStorage and redirect user,
				// otherwise error will show in error container
				if (response_obj.error.redirect) {
					if (typeof sessionStorage != 'undefined') {
						sessionStorage.setItem('errorMessage', error_html); // store error_html in sessionStorage to show on redirected page
					}
					document.location.href = '/' + response_obj.error.redirect;
					return;
				}
				if (typeof error_container === 'string') {
					error_container = $(error_container);
				}
				if (input_container) {
					if (application.length + exception.length > 0) {
						$(input_container).addClass('error');
						$(input_container).attr('aria-invalid', 'true');
					} else {
						$(input_container).removeClass('error');
						$(input_container).attr('aria-invalid', 'false');
					}
				}
				if (error_container == '' || error_container.length == 0) {
					$('body').trigger('costco.ajax.content.update.sucess', response_obj);
					return;
				}
				error_container.children().remove();
				if (response_obj.metadata.quantityUpdatedForCashCardPaymentErr && error_html.length > 0) {
					$(error_container).html('');
					COSTCO.Checkout.showPaymentEditOption($('input[name=payMethodId]').val());
				}
				if (error_html.trim() != '') {
					error_container.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
					error_container.append(error_html);
					error_container.addClass('critical-notification');
					if (mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
						error_container.removeClass('critical-notification');
					}
	
					// add quantity limit error at the item level for BD
					if ($('#isBDAppVar').val() == 'BD') {
						$('.order-item').each(function () {
							if ($(this).find('.itemPartNumberPurchased').html() == response_obj.error.itemNumber) {
								$(this).find('.critical-notification').append(error_html).removeClass('hide');
							}
						});
					}
	
					COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
				}
				// Add/remove class critical-notification for page-top error in Cart page
				if (error_container.attr('id') == 'errquantity_' && checkoutPage && checkoutPage == 'cart') {
					if (error_container.html().trim() != '') {
						error_container.addClass('critical-notification');
					} else {
						error_container.removeClass('critical-notification');
					}
				}
				if ($('#errquantity_application_').length > 0 && $('#errquantity_application_').html().trim() != '') {
					if (!COSTCO.OrderSummary.isAllPaidByCashCard()) {
						COSTCO.Checkout.showPaymentEditSection($('input[name=payMethodId]').val());
					} else {
						$('#errquantity_application_').html('');
						$('#errquantity_application_').removeClass('critical-notification');
						$('#errquantity_application_').addClass('error');
					}
					COSTCO.CC.init();
				} else if ($('#errquantity_application_').length > 0) {
					$('#errquantity_application_').removeClass('critical-notification');
					$('#errquantity_application_').addClass('error');
					//This will do the real work - I have no idea what the above code does.
					//This will place error messages in-line
				} else if ($('#isBDAppVar').val() == 'BD') {
					COSTCO.OrderItems.placeGlobalCartErrorsInLine(response_obj);
					if ($("#contractErrContainer").length > 0) {
						error_container.addClass('hide');
						if (!$("#contractErrContainer").is(':visible')) $("#contractErrContainer").removeClass('hide');
					} else {
						error_container.removeClass('hide');
					}
				}
				if (mergedOptions.scrollToError && COSTCO.util.has_errors(response_obj)) {
					$('body').trigger('costco.ajax.content.update.error', response_obj);
					$('body, html').animate({
						scrollTop: $(error_container).offset().top - 30
					}, 800);
				}
			},
	
			/**
	  * A generic function to make ajax requests. The only difference being
	  * that this function sets a default done promise that injects html
	  * into the DOM with the response data. Pass done, fail, and always
	  * functions to the options object to be called in each respective promise.
	  * @param  {Object} options Object containing options to pass to $.ajax
	  *                          and functions to call within $.ajax promises.
	  * @return {void}
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_state
	  */
			ajax_update_state: function ajax_update_state(options, page) {
				// Prevent code breaking if checkoutPage is undefined.
				//let checkoutPage = typeof window.checkoutPage == 'undefined' ? false : window.checkoutPage;
				$('.order-ajax').addClass('ajax-busy');
				var checkoutPageName = typeof checkoutPage === 'undefined' ? false : checkoutPage;
				if (options.page || checkoutPageName) {
					options.url = COSTCO.util.makeUrl(options.url, {
						'checkoutPage': options.page || checkoutPageName
					});
				}
				if (!options.done) {
					options.done = COSTCO.Checkout.ajax_update_default_done;
				}
				if (!options.always) {
					options.always = COSTCO.Checkout.ajax_update_default_always(options.inputContainer);
				}
				COSTCO.util.ajax(options);
			},
	
			/**
	  * Extracting default function out so we can perfom this and something else
	  *
	  * @DEPRECATED - Replaced with: AjaxModular.ajax_update_default_always
	  */
			ajax_update_default_always: function ajax_update_default_always(inputContainer) {
				$('.order-ajax').removeClass('ajax-busy');
				COSTCO.Checkout.validator = undefined;
				// ALM 54928 Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				// Create a function to focus back to the original input after
				// the ajax call is done
				// This will only be done only if there input is defined in the option payload
				// ALM 54928: Possible patch fix for issue that exists in prod, NOT PERMANENT!
				if ($('#isBDAppVar').val() == 'BD') {
					if (!$('.order-error').find('p').text().length) {
						$('.order-error').removeClass('critical-notification');
					}
				}
				if (inputContainer) {
					var focusInput = $(inputContainer);
					if (focusInput.length > 0) {
						// If we have the id then lets use it
						if (focusInput[0].id) {
							console.log(focusInput[0].id);
							$('#' + focusInput[0].id).focus();
						} else {
							console.log('Working for it');
							// Ok no id so now we have to do work
							if (focusInput[0].nodeName == 'INPUT') {
								if (focusInput.attr('type') == 'radio' && focusInput.attr('name')) {
									$('input:checked[name="' + focusInput.attr('name') + '"]').focus();
								}
							}
						}
					}
				}
			},
	
			/**
	  * Displays the error message stored in sessionStorage from the previous page
	  * where error was sent to client, but a redirect needed to happen
	  */
			display_error_after_redirect: function display_error_after_redirect() {
				if (typeof sessionStorage != 'undefined' && sessionStorage.getItem('errorMessage')) {
					var $container = $('#progress-meter-row').children().last();
					$container.addClass('error');
					$container.append(sessionStorage.getItem('errorMessage'));
					sessionStorage.removeItem('errorMessage');
				}
			},
	
			/**
	  * Util to give an interactive character count down
	  * @param  {ojbect} label    pass the jquery obj where you want the
	  *                           countdown to reflect
	  * @param  {object} textarea pass a 'text' input
	  *                           (input[type='text'],textarea) to count
	  * @return {void}
	  */
			character_count: function character_count(label, textarea) {
				if ($(label).length > 0 && $(textarea).length > 0) {
					var updateLabelCount = function updateLabelCount(textarea, label) {
						var count = $(textarea).val().length;
						$(label).text(max - count);
					};
	
					var max = parseInt($(textarea).attr('maxlength'));
					$(label).text(max - $(textarea).val().length);
					$(textarea).unbind('keyup').on('keyup', function () {
						updateLabelCount(this, label);
					});
					$(textarea).unbind('change').on('change', function () {
						updateLabelCount(this, label);
					});
				}
			},
	
			getAuthToken: function getAuthToken() {
				return $('[name=authToken]').first().val();
			},
	
			show_busy_indicator: function show_busy_indicator() {
				$('.order-ajax').addClass('ajax-busy');
			},
	
			remove_busy_indicator: function remove_busy_indicator() {
				$('.order-ajax').removeClass('ajax-busy');
			},
	
			/**
	  * If PAD is the only choice in div.delivery-option-radios, PAD is required.
	  * Else it ain't.
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean} Is PAD required as a shipping method for this item.
	  */
			is_pad_required: function is_pad_required(delivery_radios) {
				var $radio_containers = $(delivery_radios).children();
				return $radio_containers.length === 1 && $radio_containers.first().hasClass('pad');
			},
	
			/**
	  * Is a PAD delivery option radio selected?
	  * @param  {object}  delivery_radios The jQuery object that maps to
	  *                                   div.delivery-option-radios
	  * @return {Boolean}                 Is the PAD radio selected?
	  */
			is_pad_selected: function is_pad_selected(delivery_radios) {
				var isSelected = false;
				var $pad_input = $(delivery_radios).find('.pad input[type=radio]');
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
					var $padWithoutNextDay = $(delivery_radios).find('.individualShipBlock, .individualPharmacyShipModes');
					if ($(delivery_radios).find(".grocery-header-text").length === 0 && $(delivery_radios).find(".frozen-header-text").length === 0) {
						if ($padWithoutNextDay.length === 0) {
							$(delivery_radios).find(".selection-box-v2.pad").attr("checked");
							isSelected = true;
						} else {
							isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
						}
					}
				} else {
					isSelected = $pad_input.length > 0 && $pad_input.prop('checked');
				}
				return isSelected;
			},
	
			/**
	  * Clean inputs with quantity value unit
	  */
			clear_form: function clear_form() {
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					var inputs = $('input[name^=quantity]');
					if (inputs) {
						inputs.each(function () {
							var parent = $(this).parent('div');
							parent.removeClass('error');
						});
					}
				}
			},
			/**
	  * Generic validator instance
	  * @type $.validator
	  */
			validator: undefined,
	
			/**
	  * This function is used for dynamic form validation. Its meant to be
	  * wrapped in a decorator and configured appropriately. (See how
	  * orderitems.js uses it). Everything keys off of options_obj.rule. If
	  * a rule is supplied, we're matching that rule with a single dynamic input.
	  * Otherwise, we want to validate multiple, dynamic inputs. We pass a
	  * options_obj.validate_inputs function(See orderitem.js example) that
	  * applies the rules we want. Finally, if we're valid, execute the supplied
	  * callback
	  * @param  {object} options_obj The object with the following properties:
	  *                              {
	  	*                                form: <The form we're validating>,
	  	*                                input: <optional: input to validate>,
	  	*                                validate_inputs: <The fn to add N number
	  	*                                  of rules>,
	  	*                                rule: <optional: the object that represents
	  	*                                  the rule to validate with provided input>,
	  	*                                rules_config_obj: <All of the rules to
	  	*                                  potentially pass to $.fn.validator>,
	  	*                                callback: <The function to pass on
	  	*                                  successful validation>
	  	*                              }
	  * @return {void}
	  */
			_dynamic_validate: function _dynamic_validate(options_obj) {
				var self = COSTCO.Checkout;
				var $form = options_obj.form;
				var $input = options_obj.input;
				var validate_inputs = options_obj.validate_inputs;
				var rule = options_obj.rule;
				var rules_config_obj = options_obj.rules_config_obj;
				var callback = options_obj.callback;
				//callbackParams is used in case callback function has parameters
				var callbackParams = options_obj.callbackParams;
				var options = {
					focusInvalid: false,
					errorElement: 'span'
				};
				var errorPlacement = options_obj.errorPlacement;
				if (self.validator && rule != 'quantity') {
					$form.destroyValidator(self.validator);
					COSTCO.Checkout.clear_form();
				}
				// If we're not validating a single input, we want to call the invalid
				// handler so when we throw an error we scroll to where that error is.
				if (!rule) {
					options.invalidHandler = COSTCO.util.invalid_handler;
				}
				self.validator = $form.validate(options);
				if (rule) {
					// We want a specific rule bound on the input.
					// If we're being called as an inline event handler on an input, we good, otherwise
					// use the data-id attribute of the calling DOM element to get the input.
					var $input = $input.prop('tagName') === 'INPUT' || $input.prop('tagName') === 'SELECT' ? $input : $('#' + $input.data('id'));
					$input.rules('add', rules_config_obj[rule]);
					if (!(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)) {
						if ($('#isBDAppVar').val() == 'BD' && rule == 'quantity') {
							self.validator.settings.errorClass = self.validator.settings.errorClass + ' error-qty-increment';
						}
					}
				} else {
					// Case where we have mulitple dynamic inputs to validate
					if (validate_inputs) validate_inputs(rules_config_obj);
				}
				if (errorPlacement) {
					self.validator.settings.errorPlacement = errorPlacement;
				}
				// $.validator.form triggers form validation programmatically
				// If we're a valid form, execute the callback.
				if (self.validator.form()) {
					if (callback) {
						if (callbackParams !== undefined && callbackParams.length > 0) {
							callback(callbackParams);
						} else {
							callback();
						}
					}
				}
			},
	
			editMyAccount: function editMyAccount(view) {
				var path = "/AccountInformationView?langId=" + wcs.langId + "&storeId=" + wcs.storeId + "&catalogId=" + wcs.catalogId + "&crmSpecificView=" + view;
				window.location.href = path;
			},
	
			/**
	  * This is the inline event handler for membership application item.
	  * It needs to redirect back to the application page.
	  * @param  {[type]} partNumber  [description]
	  * @param  {[type]} orderItemId [description]
	  * @param  {[type]} orderId     [description]
	  * @return {void}
	  */
			editApplication: function editApplication(partNumber, orderItemId, orderId) {
				var path = '';
				try {
					$.cookie('APPLICATION_TRACKING_COOKIE', null, {
						path: '/'
					});
				} catch (e) {}
				if ($('#isBDAppVar').val() === 'BD' && $.cookie('cartCountCookie') > 1) {
					path = '/MembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				} else {
					path = '/QuickMembershipApplicationView?productPartNumber=' + partNumber + '&fromPage=' + currentPage;
				}
				$.cookie('APPLICATION_TRACKING_COOKIE', orderItemId);
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					path += '&orderId=' + orderId;
				}
				window.location.href = path;
			},
	
			/**
	  * Opens 'Remove Memebrship/Renewal Warning Modal' dialog modal.
	  * @return {void}
	  */
			openRemoveWarningModal: function openRemoveWarningModal(isRenew, orderItemId) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item(orderItemId);
					}
				});
			},
	
			openRemoveWarningModal_v2: function openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart) {
				COSTCO.dialog.createExtDialogBox({
					title: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Label : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Label,
					body: isRenew ? memberOnlyFeatureEnabled ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Body_Text : memberOnlyFeatureEnabled ? messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_POST_LOCKDOWN_Body_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Body_Text,
					primary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Keep_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Keep_Membership_Button_Text,
					secondary: isRenew ? messages.CART_REMOVE_RENEWAL_WARNING_MODAL_Remove_Renewal_Button_Text : messages.CART_REMOVE_MEMBERSHIP_WARNING_MODAL_Remove_Membership_Button_Text,
					dialogclasses: 'leave-page-modal',
					primary_event: function primary_event() {
						COSTCO.dialog.close();
					},
					secondary_event: function secondary_event() {
						COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
					}
				});
			},
	
			deletePaymentInstructionsForOrder: function deletePaymentInstructionsForOrder() {
				return new Promise(function (resolve, reject) {
					if (Checkout.isCheckoutPage()) {
						// if we're on the checkout page
						var currentOrderId = $('INPUT[name="orderId"]').val();
						COSTCO.util.ajax({
							url: '/AjaxDeletePaymentInstructionsForOrder',
							method: 'POST',
							dataType: 'json',
							data: {
								orderId: currentOrderId
							},
							success: function success(result) {
								// if no xcreditcard id, clear everything in the form. Else, clear the piId and populate the xCreditCardId in the form
								if (result.xcreditCardId.length === 0) {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('#account').length > 0) {
										$('#account').val('');
									}
									if ($('#cc_expiry_date').length > 0) {
										$('#cc_expiry_date').val('');
									}
									if ($('#cc_nameoncard').length > 0) {
										$('#cc_nameoncard').val('');
									}
								} else {
									if ($('#piIdCashCard').length > 0) {
										$('#piIdCashCard').val('');
									}
									if ($('[name="xCreditCardId"]').length > 0) {
										$('[name="xCreditCardId"]').val(result.xcreditCardId);
									}
								}
	
								console.log('Deleted payment instructions for order ' + currentOrderId);
								resolve();
							},
							fail: function fail(error) {
								console.error('Error deleting payment instructions for order ' + currentOrderId);
								resolve();
							}
						});
					} else {
						// if we're not on the checkout page, do nothing
						resolve();
					}
				});
			},
	
			showPaymentEditOption: function showPaymentEditOption(payType, skipCreateToken) {
				if (payType == 'ACH' && hasCashCard) {
					COSTCO.CC.removeCashCard($('#remove-cash-card-link'));
				}
				if (/^(Check|LineOfCredit)$/i.test(payType)) {
					Checkout.showPaymentEditSection(payType);
				} else {
					Checkout.deletePaymentInstructionsForOrder().then(function () {
						COSTCO.Checkout.moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay();
						if (undefined == skipCreateToken) {
							createTokenSessionId().then(function () {
								Checkout.showPaymentEditSection(payType);
							});
						}
					});
				}
			},
	
			showPaymentEditSection: function showPaymentEditSection(payType) {
				$('#payment-method-radio-buttons').removeClass('hide');
				$('#cod-ach-acr-payment').removeClass('hide');
				$('#cc-payment-block-title').removeClass('hide');
				$('#cc-payment-block').removeClass('hide');
				$('#credit-card-address-block').removeClass('hide');
				$('#cc-payment-address-block').removeClass('hide');
				$('#credit-card-block').removeClass('hide');
				$('#wallet-block').removeClass('hide');
				$('#credit-card-info-container').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				$('#single-page-checkout #cc-payment-block').attr('do-not-show', 'false');
				$('.payment-method-change').addClass('hide');
				$('#applepay-payment-block').addClass('hide');
				$('#applepay-block-form').removeClass('display');
				$('#applepay-info-container').addClass('hide');
				$('#placeOrderTerms').removeClass('hide');
				$('#placeOrderTermsApplePay').addClass('hide');
				$('#placeOrderTermsMob').removeClass('hide');
				$('#placeOrderTermsApplePayMob').addClass('hide');
				$('#place-order-button-regular').removeAttr('do-not-show');
				$('#place-order-button-applepay').attr('do-not-show', 'true');
				$('#place-order-button-regular').removeClass('hide');
				$('#place-order-button-applepay').addClass('hide');
				if (COSTCO.Checkout.displayAllPayments()) {
					$('#credit-card-block-review').addClass('hide');
					$('input[id=usedPayMethod]').val('');
				}
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
					$('#wallet-payment-address-form').addClass('hide');
					$('#payment-address-form').removeClass('hide');
					$('#payment-address-form .address-change-link-B').removeClass('hide');
					$('input[id=appliedPayMethod]').val('');
					$('input[id=isApplePaySheetSubmitted]').val('');
					$('input[id=unifiedPaymentType]').val('');
				}
				if ($('#isBDAppVar').val() == 'BD') {
	
					if (COSTCO.util.isNdEnabled()) {
						$('#ach-block').removeClass('hide');
					} else if (!COSTCO.util.isExternalCarrierShipmode()) {
						$('#check-del-block').removeClass('hide');
						$('#ach-block').removeClass('hide');
						$('#acc-receiv-block').removeClass('hide');
					}
	
					var paymentType = $('#ordPayInsVal').length > 0 ? $('#ordPayInsVal').val() : payType;
					if (paymentType == 'Check') {
						COSTCO.wallet.showCheckOnDeliverySection();
					} else if (paymentType == 'ACH') {
						COSTCO.wallet.showACHSection();
					} else if (paymentType == 'LineOfCredit') {
						COSTCO.wallet.showAcctReceivableSection();
					} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
						$('#wallet-info-div').addClass('hide');
						$('#wallet-change-link').addClass('hide');
						if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
							COSTCO.wallet.showMasterpassSection();
						} else {
							COSTCO.wallet.disableUseExistingWallet();
							COSTCO.wallet.showVisaSection();
						}
					} else {
						COSTCO.wallet.showCCSection();
						Checkout.reValidateCVV();
					}
				} else if ($('#wallet-info-div').length && !$('#wallet-info-div').hasClass('hide')) {
					$('#wallet-info-div').addClass('hide');
					$('#wallet-change-link').addClass('hide');
					if (wcs.locale == 'en_CA' || wcs.locale == 'fr_CA') {
						COSTCO.wallet.showMasterpassSection();
					} else {
						COSTCO.wallet.disableUseExistingWallet();
						COSTCO.wallet.showVisaSection();
					}
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('wallet');
				} else {
					COSTCO.wallet.showCCSection();
					Checkout.reValidateCVV();
					COSTCO.QuickRenewAddressHelper.configureAddressesSectionBasedOnPaymentType('credit card');
				}
				$('#auto-renew-div').appendTo($('#save_CC').parent().parent());
				$('#auto-renew-div').removeClass('mt-16');
				$('#auto-renew-div').addClass('mt-5');
				$('#auto-renew-div').addClass('mb-16');
				$('#autorenew-invalid-saved-card-div').addClass('hide');
				return false;
			},
	
			hidePaymentEditSection: function hidePaymentEditSection() {
				$('#payment-method-radio-buttons').addClass('hide');
				$('#cod-ach-acr-payment').addClass('hide');
				$('#cc-payment-block').addClass('hide');
				$('#credit-card-block').addClass('hide');
				$('#credit-card-address-block').addClass('hide');
				$('#cc-payment-address-block').addClass('hide');
				$('#wallet-block').addClass('hide');
				if ($('#isBDAppVar').val() == 'BD') {
					$('#check-del-block').addClass('hide');
					$('#ach-block').addClass('hide');
					$('#acc-receiv-block').addClass('hide');
				}
			},
	
			clickToPayWasTriggered: function clickToPayWasTriggered() {
				var value = sessionStorage.getItem('CLICK_TO_PAY_TRIGGERED');
				return value ? true : false;
			},
	
			removeClickToPayTriggered: function removeClickToPayTriggered() {
				sessionStorage.removeItem('CLICK_TO_PAY_TRIGGERED');
			},
	
			setClickToPayTriggered: function setClickToPayTriggered() {
				sessionStorage.setItem('CLICK_TO_PAY_TRIGGERED', true);
			},
	
			moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay: function moveCheckoutStepBackAfterCreditCardChangeFollowingClickToPay() {
				if (COSTCO.Checkout.clickToPayWasTriggered()) {
					var btn = $('#orderSummaryCheckoutButton');
					if (btn.length) {
						var currentStepNumber = parseInt(btn.attr('current-step-number')),
						    finalStepNumber = CHECKOUTSTEPS.length;
						// if we're on the last checkout step
						if (currentStepNumber > 1 && currentStepNumber == finalStepNumber) {
							var previousStepIndex = currentStepNumber - 2,
							    previousStepNumber = currentStepNumber - 1;
							btn.val(CHECKOUTSTEPS[previousStepIndex].text).attr('onclick', 'COSTCO.OrderSummary.checkoutSteps.submitCheckoutStep(' + previousStepNumber + ')');
						}
					}
				}
				COSTCO.Checkout.removeClickToPayTriggered();
			},
	
			updateCheckoutForm: function updateCheckoutForm() {
				var val = this.checked ? 'on' : 'off';
				$('#isSavedPaymentAutoRenew').prop('value', val);
			},
	
			isCheckoutPage: function isCheckoutPage() {
				return $('#CheckoutPaymentForm').length ? true : false;
			},
	
			isCartPage: function isCartPage() {
				return $('#cart').length > 0;
			},
	
			isReviewPage: function isReviewPage() {
				var isReviewPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutReviewView')) {
					isReviewPage = true;
				}
				return isReviewPage;
			},
	
			isPaymentPage: function isPaymentPage() {
				var isPaymentPage = false;
				var currentPage = window.location.pathname.substr(1);
				if (currentPage.includes('CheckoutPaymentView')) {
					isPaymentPage = true;
				}
				return isPaymentPage;
			},
	
			reValidateCVV: function reValidateCVV() {
				if ($('#cc_expiry_date').val() != '') {
					COSTCO.CreditCard.validate.creditCardForm();
					$("label[for='cc_cvc_validator']").text(messages.CVV_REENTER);
				} else {
					$('#save_CC').prop('checked', false);
				}
			},
			toggleCartAccordion: function toggleCartAccordion(orderItemId) {
				if ($('#cart-accordion-header-1-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).hide();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-1-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-' + orderItemId).show();
					$('#arrow-' + orderItemId).remove();
					$('#cart-accordion-header-1-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-" + orderItemId + "'></i>");
				}
			},
	
			membershipAutoRenewOptionOptedIn: function membershipAutoRenewOptionOptedIn() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('true');
				$('#wallet-block').addClass('hide');
				$('#creditcard-block-form').removeClass('display');
				if ($('#credit-card-info-container').length == 0) {
					$('#wallet-info-div').addClass('hide');
					$('#credit-card-block').removeClass('hide');
				}
				document.getElementById('credit-card-block').scrollIntoView({ behavior: 'smooth', block: 'center' });
			},
	
			membershipAutoRenewOptionOptedOut: function membershipAutoRenewOptionOptedOut() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				if ($("input[name='radio-auto-renew']:checked").val() !== undefined && !$('#membership-renew-error-container').hasClass('hide')) {
					$('#membership-renew-selection-error').addClass('hide');
				}
				$('input[name="isPurchaseMembershipAutoRenew"]').val('false');
				if (!$('#wallet-info-div').length > 0) {
					$('#wallet-block').removeClass('hide');
				}
				$('#CheckoutPaymentForm').validate().resetForm();
				$('#account').removeClass('error-credit-card');
				$('#cc_cvc').removeClass('error-credit-card');
				$('#account_validator_err_msg').html('');
				$('#cc_cvc_err_msg').html('');
				$('#cc_membership_renew_error').removeClass('critical-notification');
				$('#cc_membership_renew_error').addClass('alert-notification');
			},
	
			pageRefreshForToken: function pageRefreshForToken() {
				window.digitalDataEvents = window.digitalDataEvents || [];
				digitalDataEvents.push({ nav: "Checkout Flow | refresh your page" });
			},
	
			toggleCartAccordionMobile: function toggleCartAccordionMobile(orderItemId) {
				if ($('#cart-accordion-header-2-' + orderItemId).hasClass('collapsed')) {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.HIDE_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).hide();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-left rotate90' id='arrow-m-" + orderItemId + "'></i>");
				} else {
					$('#cart-accordion-header-2-' + orderItemId).text(messages.SHOW_ADDITIONAL_TIRE_FEE_DETAILS);
					$('#cart-accordion-right-div-2-' + orderItemId).show();
					$('#arrow-m-' + orderItemId).remove();
					$('#cart-accordion-header-2-' + orderItemId).after("&nbsp;<i class='co-arrow-right rotate90' id='arrow-m-" + orderItemId + "'></i>");
				}
			},
	
			/**
	  * Helper function to recompile & reload all checkout sections. Performed by ajax-modular
	  * call to '/order-prepare' without additional request parameters.
	  * @return {object} Deferred
	  */
			ajaxRefreshAllCheckoutSections: function ajaxRefreshAllCheckoutSections() {
				var deferred = $.Deferred();
				COSTCO.CreditCard.initComplete = false;
				COSTCO.AjaxModular.ajax_update_state({
					url: '/order-prepare',
					always: function always(data, textStatus, jqXHR, options) {
						deferred.resolve();
					}
				});
				return deferred.promise();
			},
	
			addScreenReaderAnnouncement: function addScreenReaderAnnouncement(adaMessage) {
				var adaMessageDiv = $('#screen-reader-announcement');
				if (adaMessageDiv.length > 0) {
					setTimeout(function () {
						adaMessageDiv.html(adaMessage);
					}, 1000);
				}
			},
			displayAllPayments: function displayAllPayments() {
				return costcoStoreFeatures.DISPLAY_ALL_PAYMENTS;
			},
			usedPayment: function usedPayment() {
				return $('input[id=usedPayMethod]').length > 0 ? $('input[id=usedPayMethod]').val() : "";
			},
			resetCheckoutPaymentFields: function resetCheckoutPaymentFields(payType) {
				$('#account').val("");
				$('#cc_cvc').val("");
				$('#cc_expiry_date').val("");
				$('#cc_nameoncard').val("");
				TokenGateway.focusField = "card.number";
				$('#cc_cvc_err_msg').addClass('hide');
				$.cookie('tkSession', 'false', { path: '/' });
				createTokenSessionId().then(function () {
					Checkout.showPaymentEditSection(payType);
				});
			}
		};
	
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.Checkout = Checkout;
		return Checkout;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 27:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title link-membership.js: Sub-module for Product Details page
	 * @description This sub-module is used to handle membership validation.
	 * @dependency checkout_helper.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (checkoutHelper) {
	  var LinkMembership = {
	
	    /**
	     * Constants.
	     */
	    constants: {
	      PRIMARY_VALIDATION_FORM_ID: '#membership-primary-validation-form',
	      PRIMARY_VALIDATION_FORM_NAME: 'membershipPrimaryValidationForm',
	      SECONDARY_VALIDATION_FORM_ID: '#membership-secondary-validation-form',
	      ERROR_PLACEHOLDER_ID: '#error-placeholder',
	      AJAX_LOADER_ID: '#link-membership-loader',
	      SECONDARY_VALIDATION_VIEW: '/MembershipSecondaryValidationView',
	      CANCELED_MEMBERSHIP_VIEW: '/CanceledMembershipView'
	    },
	
	    /**
	     * Object that holds useful membership data.
	     */
	    memberData: {
	      number: ''
	    },
	
	    /**
	     * Initialization function.
	     */
	    init: function init() {
	      // 'Link Membership' button visibility is toggled in CMath.init() which executes prior to this call.
	      if ($('#link-membership, #link-membership-v2, .link-membership-btn, .link-membership-pet-meds').is(':visible')) {
	        $('#link-membership, #link-membership-v2, .link-membership-btn, #link-membership-for-price').unbind('click').click(function () {
	          COSTCO.LinkMembership.openLinkMembershipModal();
	        });
	
	        COSTCO.LinkMembership.populateMemberData();
	        COSTCO.LinkMembership.addValidationRules();
	      }
	      if ($('#ProductForm [name=purchase-membership]').is(':visible')) {
	        $('#ProductForm [name=purchase-membership]').unbind('click').click(function () {
	          COSTCO.LinkMembership.purchaseMembershipButtonClick();
	        });
	      }
	
	      console.log('Link Membership sub-module initialized.');
	    },
	
	    /**
	     * Populates this.memberData using the membershipNumber derived from
	     * wcMember persistent cookie.
	     */
	    populateMemberData: function populateMemberData() {
	      this.memberData.number = COSTCO.util.getMemberCookie().membershipNumber;
	    },
	
	    /**
	     * Mask employee start date
	     */
	    maskStartDateInput: function maskStartDateInput() {
	      $('#employeeStartDate').mask('00/00', {
	        placeholder: 'MM/YY'
	      });
	    },
	
	    /**
	     * Opens 'Link Membership for Price' dialog modal.
	     */
	
	    openLinkMembershipModal: function openLinkMembershipModal(title) {
	
	      var modalTitle = typeof title === 'undefined' ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Title : title;
	
	      var bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
	      var modalSettings = {
	        dialogclasses: 'link-membership-modal',
	
	        title: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : modalTitle,
	        body: COSTCO.util.tmpl('tmpl_membership_validation_pdp', {
	          infoText: bypassEnabled ? messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText_ALT : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceStep1Modal_Body_InfoText,
	          membershipNumber: COSTCO.LinkMembership.memberData.number
	        }),
	
	        primary: bypassEnabled ? messages.RWD_ADD_MEMBERSHIP_NUMBER : messages.MEMBERSHIP_VALIDATION_LinkMembershipForPriceModal_Continue_ButtonText,
	        secondary: messages.JS_DIALOG_CANCEL,
	        primary_event: this.performPrimaryValidation,
	        preventClose: false,
	        onshown: function onshown() {
	          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
	          COSTCO.util.maskMembershipInput();
	          $('.co-help').popover();
	        },
	        onclose: function onclose() {}
	      };
	
	      COSTCO.dialog.showModal(modalSettings);
	    },
	    /**
	     * Executes logic on Purchase Membership button click on PDP page.
	     */
	    purchaseMembershipButtonClick: function purchaseMembershipButtonClick() {
	      if ($.cookie('cartCountCookie') > 0) {
	        window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	      } else {
	        window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	      }
	    },
	    /**
	     * Validation rules for the inputs associated with creating an account.
	     */
	    addValidationRules: function addValidationRules() {
	      $.validator.addMethod('costcoMembership', function (value, element) {
	        return (/^\d{12,16}$/.test(value)
	        );
	      }, messages.ERR_INVALID_MEMBERSHIP_NO);
	    },
	
	    /**
	     * Validates the primary validation form.
	     * @param {Object} $primaryValidationForm - Form to be validated.
	     */
	    validatePrimaryValidationForm: function validatePrimaryValidationForm($primaryValidationForm) {
	      $primaryValidationForm.validate({
	
	        ignoreTitle: true,
	
	        rules: {
	          membershipId: {
	            required: true,
	            costcoMembership: true
	          },
	          lastName: {
	            // Last name is not required, i.e. for internal membership
	            // required: true,
	          }
	        },
	
	        messages: {
	          membershipId: {
	            required: messages.JS_VALID_REQUIRED,
	            costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	          },
	          lastName: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        },
	        highlight: COSTCO.util.highlightWithErrorLabel,
	        unhighlight: COSTCO.util.unhighlightWithErrorLabel
	      });
	    },
	
	    /**
	     * Performs primary validation of entered data via calling Ajax Modular command.
	     */
	    performPrimaryValidation: function performPrimaryValidation() {
	      var $primaryValidationForm = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID);
	
	      COSTCO.LinkMembership.validatePrimaryValidationForm($primaryValidationForm);
	
	      if ($primaryValidationForm.valid()) {
	        COSTCO.LinkMembership.clearErrors();
	        COSTCO.LinkMembership.ajaxLoader.on();
	        checkoutHelper.ajax_update_state({
	          method: 'POST',
	          url: '/AjaxMembershipPrimaryValidationCmd',
	          data: $primaryValidationForm.serialize(),
	          dataType: 'json',
	          done: function done(data, textStatus, jqXHR, options) {
	            // COSTCO.LinkMembership.clearErrors();
	            COSTCO.LinkMembership.ajaxLoader.off();
	            if (data.payload.data.status == 'success') {
	              COSTCO.LinkMembership.memberData.number = $(COSTCO.LinkMembership.constants.PRIMARY_VALIDATION_FORM_ID + ' :input[name=membershipId]').val().trim();
	              if (data.payload.data.validationCompleted) {
	                COSTCO.dialog.close();
	                location.reload();
	              } else {
	                checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR, options);
	                COSTCO.LinkMembership.maskStartDateInput();
	                $('#costcoModalBtn2').html(messages.LINK_MEMBERSHIP_BUTTON);
	                $('#costcoModalBtn2').unbind('click').bind('click', COSTCO.LinkMembership.performSecondaryValidation);
	                if ($('#error-placeholder').data('status') == 'undetermined') {
	                  $('#costcoModalBtn2').unbind('click');
	                  $('#costcoModalBtn2').prop('disabled', true);
	                }
	              }
	            } else if (data.error.application.length > 0) {
	              var errorCode = data.payload.data.errorCode;
	              // Expired Membership
	              if (errorCode == 'E53') {
	                window.location.href = LinkMembership.constants.SECONDARY_VALIDATION_VIEW;
	                // Canceled Membership
	              } else if (errorCode == 'E54') {
	                var canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
	                var membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
	                var membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
	                var isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
	                $form = $('form[name=' + LinkMembership.constants.PRIMARY_VALIDATION_FORM_NAME + ']');
	                $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
	                $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
	                $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
	                $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
	                $form.append('<input type="hidden" name="isReturningUser" value="true">');
	                $form.attr('action', LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW);
	                $form.submit();
	              } else {
	                // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
	                if (errorCode == 'E07') {
	                  data.error.application = [];
	                  data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
	                }
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, data.error.application, false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	                COSTCO.LinkMembership.markErrorFields(errorCode);
	              }
	            } else {
	              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	              console.error('Unexpected error occurred.');
	            }
	          },
	          always: function always() {
	            COSTCO.LinkMembership.ajaxLoader.off();
	            $('.order-ajax').removeClass('ajax-busy');
	          }
	        });
	      }
	    },
	
	    /**
	     * Performs secondary validation of entered data via calling Ajax Modular command.
	     */
	    performSecondaryValidation: function performSecondaryValidation() {
	      var $secondaryValidationForm = $(COSTCO.LinkMembership.constants.SECONDARY_VALIDATION_FORM_ID);
	      var action = $secondaryValidationForm.find('input[name=action]').val();
	      // If we're validating the employee primary first and last name, we set
	      // the users answer to a combination of these with a pipe.
	      if (action == 'employee_first_last_name') {
	        var firstName = $secondaryValidationForm.find('[name="usersFirstNameAnswer"]').val();
	        var lastName = $secondaryValidationForm.find('[name="usersLastNameAnswer"]').val();
	        $('#usersAnswer').val(firstName + '|' + lastName);
	      }
	
	      COSTCO.LinkMembership.ajaxLoader.on();
	
	      checkoutHelper.ajax_update_state({
	        method: 'POST',
	        url: '/AjaxMembershipSecondaryValidationCmd',
	        data: $secondaryValidationForm.serialize(),
	        dataType: 'json',
	        done: function done(data, textStatus, jqXHR, options) {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          COSTCO.LinkMembership.clearErrors();
	          if (data.status == 'success') {
	            COSTCO.dialog.close();
	            location.reload();
	          } else if (data.message) {
	            // TODO: Is there a better way to handle '&lt;' and '&gt;' from response?
	            data.message = data.message.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.message], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	          } else {
	            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false, COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	            console.error('Unexpected error occurred.');
	          }
	        },
	        always: function always() {
	          COSTCO.LinkMembership.ajaxLoader.off();
	          $('.order-ajax').removeClass('ajax-busy');
	        }
	      });
	    },
	
	    /**
	     * Marks input fields with class 'validation-error' depending on error code.
	     * @param {string} errorCode
	     */
	    markErrorFields: function markErrorFields(errorCode) {
	      if (['E01', 'E02', 'E03', 'E04', 'E07', 'E51'].indexOf(errorCode) > -1) {
	        $('input[name=membershipId]').addClass('validation-error');
	      }
	
	      if (['E01', 'E02', 'E03', 'E52'].indexOf(errorCode) > -1) {
	        $('input[name=lastName]').addClass('validation-error');
	      }
	
	      if (errorCode == 'unknown') {
	        console.error('Uknnown error code.');
	      }
	
	      $('input.validation-error:first').focus();
	    },
	
	    /**
	     * Clears error notification box and removes validation-error class from input fields.
	     */
	    clearErrors: function clearErrors() {
	      COSTCO.util.notification.clearNotification(COSTCO.LinkMembership.constants.ERROR_PLACEHOLDER_ID);
	      $('input.validation-error').removeClass('validation-error');
	    },
	
	    /**
	     * Turn AJAX loader on/off and disable/enable clicking appropriately.
	     */
	    ajaxLoader: {
	      on: function on() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).show();
	        $('body').css('pointer-events', 'none');
	      },
	      off: function off() {
	        $(COSTCO.LinkMembership.constants.AJAX_LOADER_ID).hide();
	        $('body').css('pointer-events', 'auto');
	      }
	    }
	  };
	
	  if (typeof window.COSTCO === 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.LinkMembership = LinkMembership;
	
	  return LinkMembership;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 33:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title membership-validation.js: Sub-module of Register User (Create Account) page
	 * @description This module provides membership validation functionality.
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var MembershipValidation = {
	
	    /**
	     * Initializes the submodule data
	     * @return void
	     */
	    init: function init() {
	      this.maskInputs();
	      this.bindEvents();
	      COSTCO.util.maskMembershipInput();
	
	      $('#AddMembershipForm').keypress(function (e) {
	        if (e.which == 13) {
	          MembershipValidation.addMembershipForm.submitForm();
	        }
	      });
	    },
	
	    /**
	     * Binds event handlers
	     * @return void
	     */
	    bindEvents: function bindEvents() {
	      $('#buy-membership-button').unbind('click').bind('click', function () {
	        if ($.cookie('cartCountCookie') > 0) {
	          window.open('/join-costco.html?COSTID=Header_Membership_TOP', '_self');
	        } else {
	          window.open('/join-costco-quick.html?COSTID=Header_Membership_TOP', '_self');
	        }
	      });
	    },
	
	    /**
	     * Calls renew membership main logic
	     * @param  {String}  membershipType membership type
	     * @param  {Boolean} isExecutive    true | false
	     * @param  {Boolean} isUpgrade      true | false
	     * @param  {String} fromPage       source page to decide on redirection
	     * @return void
	     */
	    renewMembership: function renewMembership(memberType, isExecutive, isUpgrade, fromPage) {
	
	      var goldDiv = document.getElementById('membership-config-gold');
	      var uccGoldEnabled = goldDiv ? goldDiv.getAttribute('data-ucc-renew-upgrade-gold-enabled') : "false";
	      var busDiv = document.getElementById('membership-config-bus');
	      var uccBusinessEnabled = busDiv ? busDiv.getAttribute('data-ucc-renew-upgrade-business-enabled') : "false";
	
	      var uccGold = "true";
	      var uccBusiness = "true";
	
	      var addRenewMemberhsipToCartUrl = '';
	      // Check if MembershipRenewUpgradeStatic object exists (provided externally from JSP)
	      if ((typeof MembershipRenewUpgradeStatic === 'undefined' ? 'undefined' : _typeof(MembershipRenewUpgradeStatic)) == 'object') {
	        if (memberType.toUpperCase() == 'Z010') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.goldExecRenewAddToCart : MembershipRenewUpgradeStatic.goldBasicRenewAddToCart;
	          uccGold = uccGoldEnabled;
	        } else if (memberType.toUpperCase() == 'Z020') {
	          addRenewMemberhsipToCartUrl = isExecutive || isUpgrade ? MembershipRenewUpgradeStatic.bizExecRenewAddToCart : MembershipRenewUpgradeStatic.bizBasicRenewAddToCart;
	          uccBusiness = uccBusinessEnabled;
	        } else {
	          console.error('Unsupported membership type');
	        }
	        if (fromPage && fromPage !== '') {
	          addRenewMemberhsipToCartUrl = addRenewMemberhsipToCartUrl + '&sourcePage=' + fromPage;
	        }
	
	        if (typeof dmcRenwalFlow != "undefined" ? dmcRenwalFlow : false) {
	          addRenewMemberhsipToCartUrl += '&dmcRenewalFlow=true&deviceId=' + deviceId;
	        }
	
	        if (uccGold === "true" && uccBusiness === "true") {
	
	          // Try to get cardNumber from membershipData first, then fall back to memberData
	          if (membershipData != null && membershipData !== 'undefined') {
	            var cardNumber = membershipData.caller.cardNumber.value;
	            var queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            var params = new URLSearchParams(queryString);
	            var itemNumber = params.get('itemNumber');
	
	            localStorage.setItem('cartMember', JSON.stringify({ id: cardNumber }));
	
	            window.location.href = '/cart/membership/terms?itemNumber=' + encodeURIComponent(itemNumber);
	          } else if (typeof memberData !== 'undefined' && memberData != null && memberData.caller && memberData.caller.cardNumber) {
	            var _cardNumber = memberData.caller.cardNumber.value;
	            var _queryString = addRenewMemberhsipToCartUrl.split('?')[1];
	            var _params = new URLSearchParams(_queryString);
	            var _itemNumber = _params.get('itemNumber');
	
	            localStorage.setItem('cartMember', JSON.stringify({ id: _cardNumber }));
	
	            window.location.href = '/cart/membership/terms?itemNumber=' + encodeURIComponent(_itemNumber);
	          }
	        } else {
	          this.addToCartAndRedirect(addRenewMemberhsipToCartUrl, isUpgrade);
	        }
	      } else {
	        console.error('MembershipRenewUpgradeStatic object does not exist.');
	      }
	    },
	
	    /**
	     * Calls AjaxManageShoppingCart and redirects to appropriate page
	     * @param  {String} addToCartUrl URL to call
	     * @return void
	     */
	    addToCartAndRedirect: function addToCartAndRedirect(addToCartUrl, isUpgrade) {
	      var isCartEmpty = this.isCartEmpty();
	      var requestFromPostLockdownPage = $('#membership-card-info-post-lockdown').length > 0;
	
	      if (addToCartUrl) {
	        addToCartUrl += '&unverifiedRenew=true';
	
	        if (requestFromPostLockdownPage) {
	          COSTCO.Checkout.ajax_update_state({
	            method: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            ajax_update_post_done: function ajax_update_post_done(data, textStatus, jqXHR, options) {
	              COSTCO.util.notification.clearNotification('#notification-message');
	              if (data.error.application.length > 0) {
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], false, '#notification-message');
	                COSTCO.RenewMembership.revertRadioSelection(isUpgrade);
	              }
	            }
	          });
	        } else {
	          COSTCO.util.ajax({
	            type: 'POST',
	            url: addToCartUrl,
	            dataType: 'json',
	            done: function done(data) {
	              var errorObject = !$.isEmptyObject(data.orderErrMsgObj) ? data.orderErrMsgObj : !$.isEmptyObject(data.errorMessage) ? data.errorMessage : '';
	
	              if (errorObject) {
	                COSTCO.util.notification.clearNotification('#error-message-placeholder');
	                COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [errorObject], false, '#error-message-placeholder', 'span');
	                $('.order-ajax').removeClass('ajax-busy');
	              } else {
	                if ($('#isBDAppVar').val() === 'BD') {
	                  if (isCartEmpty) {
	                    document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  } else {
	                    document.location.href = '/CheckoutCartView?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                  }
	                } else {
	                  document.location.href = '/QuickMembershipCheckoutCmd?langId=' + wcs.langId + '&storeId=' + wcs.storeId + '&catalogId=' + wcs.catalogId;
	                }
	              }
	            },
	            timeout: wcs.ajaxTimeout,
	            fail: function fail(x, t, m) {
	              $('.order-ajax').removeClass('ajax-busy');
	              if (t === 'timeout') {
	                console.error('Error AJAX timeout.');
	              } else {
	                console.error('Unexpected AJAX error.');
	              }
	            }
	          });
	        }
	      } else {
	        console.error('Membership not added to cart.');
	      }
	    },
	    /**
	     * [secondaryValidationForm object for secondary validation form handling]
	     * @type {Object}
	     */
	    secondaryValidationForm: {
	
	      getForm: function getForm() {
	        return $('#SecondaryValidationForm');
	      },
	
	      inputRules: function inputRules() {
	        var rules = {};
	
	        rules.usersAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersFirstNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.usersLastNameAnswer = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.postalCode = {
	          required: true,
	          messages: {
	            required: messages.JS_VALID_REQUIRED
	          }
	        };
	
	        rules.employeeDate = {
	          required: true,
	          checkDate: true,
	          checkIsDateInFuture: true,
	          messages: {
	            checkDate: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_VALID_DATE,
	            required: messages.JS_VALID_REQUIRED,
	            checkIsDateInFuture: messages._ERR_MEMBERSHIP_SECONDARY_VALIDATION_JS_PAST_DATE
	          }
	        };
	
	        return rules;
	      },
	      /**
	       * validates Secondary Validation Form
	       * @return {Boolean} if form is valid or not
	       */
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.secondaryValidationForm.getForm();
	        $form.validate({
	          errorPlacement: function errorPlacement(error, element) {
	            if (element.is(':radio')) {
	              error.appendTo(element.parents('.control-group'));
	            } else {
	              error.insertAfter(element);
	            }
	          }
	        });
	        $.validator.addMethod('checkDate', function (value, element) {
	          return this.optional(element) || /^(1[0-2]|0[1-9]|\d)\/(\d{2})$/.test(value);
	        });
	        $.validator.addMethod("checkIsDateInFuture", function (value, element) {
	          var isDateInFuture = false;
	          var enteredMonth = parseInt(value.split('/')[0]);
	          var enteredYear = parseInt(value.split('/')[1]);
	          var now = new Date();
	          var currentMonth = parseInt((now.getMonth() + 1).toString());
	          var currentYear = parseInt(now.getFullYear().toString().substr(-2));
	          if (enteredYear == currentYear && enteredMonth > currentMonth) {
	            isDateInFuture = true;
	          }
	          return isDateInFuture ? false : true;
	        });
	
	        var actionForm = $('#action')[0].value;
	        if (actionForm === 'primary_member_postal_code' || actionForm === 'business_postal_code') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().postalCode);
	        } else if (actionForm === 'employee_start_date') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().employeeDate);
	        } else if (actionForm === 'employee_first_last_name') {
	          $form.find('[name="usersFirstNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersFirstNameAnswer);
	          $form.find('[name="usersLastNameAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersLastNameAnswer);
	
	          $('#usersAnswer')[0].value = $form.find('[name="usersFirstNameAnswer"]').val() + '|' + $form.find('[name="usersLastNameAnswer"]').val();
	        } else if (actionForm === 'employee_last_name') {
	          $form.find('[name="usersAnswer"]').rules('add', MembershipValidation.secondaryValidationForm.inputRules().usersAnswer);
	        }
	        return $form.valid();
	      },
	      /**
	       * Submits Secondary Validation Form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        if (MembershipValidation.secondaryValidationForm.validateForm()) {
	          MembershipValidation.secondaryValidationForm.getForm().submit();
	        }
	      }
	    },
	    /**
	     * [addMembershipForm Object for Add membership Form handling]
	     * @type {Object}
	     */
	    addMembershipForm: {
	      getForm: function getForm() {
	        return $('#AddMembershipForm');
	      },
	      validateForm: function validateForm() {
	        var $form = MembershipValidation.addMembershipForm.getForm();
	
	        $.validator.addMethod('costcoMembership', function (value, element) {
	          return (/^\d{12,16}$/.test(value)
	          );
	        }, messages.ERR_INVALID_MEMBERSHIP_NO);
	
	        $form.validate({
	          rules: {
	            membershipId: {
	              required: true,
	              costcoMembership: true
	            },
	            lastName: {
	              required: true
	            }
	          },
	          messages: {
	            membershipId: {
	              required: messages.JS_VALID_REQUIRED,
	              costcoMembership: messages.ERR_INVALID_MEMBERSHIP_NO
	            },
	            lastName: {
	              required: messages.JS_VALID_REQUIRED
	            }
	          }
	        });
	        return $form.valid();
	      },
	      /**
	       * Submits Add Membership form
	       * @return void
	       */
	      submitForm: function submitForm() {
	        sessionStorage.removeItem("changeValidationFlag");
	        if (MembershipValidation.addMembershipForm.validateForm()) {
	          // verifyme validation
	          if (typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true && wcs.storeId !== 'undefined' && wcs.storeId === '10302' && $("#membershipNumber").parent()[0] !== 'undefined' && $("#membershipNumber").parent()[0] !== undefined && (/^$/.test($('#membershipNumber').val()) || !/^\d{12,12}$/.test($('#membershipNumber').val()))) {
	            // verify me flow enabled and CA and membership number is invalid	    	    
	            $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
	            $("#membershipNumber")[0].classList.add("highlightError");
	            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML = messages.ERR_INVALID_MEMBERSHIP_NO;
	            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
	          } else {
	            MembershipValidation.addMembershipForm.getForm().submit();
	          }
	        } else if (memberOnlyFeatureEnabled !== undefined && memberOnlyFeatureEnabled === true) {
	          $('#membershipId label.error').insertAfter($('#membershipId label.error').next());
	        }
	      }
	    },
	
	    /**
	     * Mask input fields
	     */
	    maskInputs: function maskInputs() {
	      var $form = MembershipValidation.secondaryValidationForm.getForm();
	      if ($form.length > 0) {
	        $($form).find('#employeeStartDate').mask('00/00', {
	          placeholder: 'MM/YY'
	        });
	
	        // Set initial mask input.
	        if (COSTCO.CAddressForm.isUS()) {
	          $($form).find('#postalCode').unmask().mask('00000-0000');
	        } else {
	          $($form).find('#postalCode').unmask().mask('S0S 0S0');
	        }
	
	        // Enable both CA postal-code mask and US ZIP-code mask depending on first character,
	        // as US members must be able to link membership on CA site and vice versa.
	        // CA postal-code starts with a letter, US ZIP-code starts with a digit.
	        $($form).find('#postalCode').keypress(function (event) {
	          if ($($form).find('#postalCode').val().length == 0) {
	            if (/[a-zA-Z]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('S0S 0S0');
	            } else if (/[0-9]/.test(event.key)) {
	              $($form).find('#postalCode').unmask().mask('00000-0000');
	            } else {
	              $($form).find('#postalCode').val('');
	              return false;
	            }
	          }
	        });
	      }
	    },
	
	    /**
	     * Checks if cart is empty.
	     * @return {Boolean}
	     *
	     */
	    isCartEmpty: function isCartEmpty() {
	      var cartEmpty = true;
	      var cartCookie = $.cookie('cartCountCookie');
	      if (cartCookie != null && cartCookie != 'undefined') {
	        if (cartCookie > 0) {
	          cartEmpty = false;
	        }
	      }
	      return cartEmpty;
	    },
	
	    /**
	     * Opens 'Upgrade Membership' dialog modal.
	     * @return {void}
	     */
	    openUpgradeMembershipModal: function openUpgradeMembershipModal(membershipType) {
	
	      var fromPage = $('#fromPage').val();
	      if (fromPage === undefined) {
	        fromPage = '';
	      }
	
	      var modalSettings = {
	        dialogclasses: '',
	        title: messages.MEMBERSHIP_VALIDATION_UpgradeMembershipModal_Title,
	        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
	        primary: messages.MEMBERSHIP_VALIDATION_Expired_Upgrade_Button_Text,
	        secondary: messages.MEMBERSHIP_VALIDATION_Expired_Renew_Only_Button_Text,
	        primary_event: function primary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, true, fromPage);
	          COSTCO.dialog.close();
	        },
	        secondary_event: function secondary_event() {
	          COSTCO.MembershipValidation.renewMembership(membershipType, false, false, fromPage);
	          COSTCO.dialog.close();
	        },
	        onclose: function onclose() {
	          if (typeof isDmcPage !== 'undefined' && isDmcPage) {
	            window.location = '/DMCCheck?action=renewal&renewCanceled=true';
	          }
	        },
	        onshown: function onshown() {}
	      };
	      COSTCO.dialog.showModal(modalSettings);
	    },
	
	    /**
	     * Shows last name / zip code form to validate user for editing membership info
	     * If user entered valid last name & zip code - save info as flag
	     */
	    showValidationPrescreen: function showValidationPrescreen() {
	      var settings = {};
	      if ($("#maxAttemptMemberAccountReached").val() === "false") {
	        settings = {
	          title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	          body: COSTCO.util.tmpl("tmpl_membership_validate_prescreen", {}),
	          primary: messages.MEMBERVERIFICATION_MEMBERSHIP__Continue_ButtonText,
	          secondary: messages.MEMBERVERIFICATION_MEMBERSHIP__Cancel_ButtonText,
	          dialogclasses: "modal-dialog-membership verify-membership-dialog",
	          primary_button_style: "rounded",
	          secondary_button_style: "rounded",
	          primary_event: function primary_event() {
	            if (COSTCO.MemberVerification.validateZipCodeForm($("#MemberValidationForm"))) {
	              var url = COSTCO.util.makeUrl('/AjaxAccountAutoRenewMembershipValidationCmd', {
	                lastName: $('#questionLastName').val(),
	                zipCode: $('#questionZip').val()
	              });
	
	              COSTCO.MemberVerification.submitRequest(url).then(function (data) {
	                $('#questionLastName').val('');
	                $('#questionZip').val('');
	                $('#labelQuestionLastName').removeClass('active');
	                $('#labelQuestionZip').removeClass('active');
	                if (data.memberAccountRecordCheckMaxAttempsReached == 'true') {
	                  var newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	                  COSTCO.dialog.updateModal(newSettings);
	                  $("#maxAttemptMemberAccountReached").val("true");
	                } else if (data.memberAccountRecordMatch == 'true') {
	                  var _newSettings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_success");
	                  COSTCO.dialog.updateModal(_newSettings);
	                  sessionStorage.setItem("changeValidationFlag", true);
	                } else {
	                  $("#MemberValidationForm .notification").removeClass("hidden");
	                }
	              });
	            }
	          },
	          secondary_event: function secondary_event() {
	            COSTCO.dialog.close();
	          },
	          close: function close() {
	            COSTCO.dialog.close();
	          },
	          afterclose: function afterclose() {
	            $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	            $('#costcoModalBtn2').removeClass('primary-button-v2');
	            $('.costcoModalBtn1').removeClass('secondary-button-v2');
	          },
	          onshown: function onshown() {
	            COSTCO.util.maskMembershipInput();
	          }
	        };
	      } else {
	        settings = MembershipValidation.updateValidationModal("tmpl_membership_validate_prescreen_locked");
	      }
	      COSTCO.dialog.createExtDialogBox(settings);
	    },
	
	    /**
	     * Show different info on modal after member account check
	     * @param tmplName - template name to be loaded in modal body.
	     * @param tmplParam - parameters to be loaded for template. Default is empty.
	     */
	    updateValidationModal: function updateValidationModal(tmplName) {
	      var tmplParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return {
	        title: messages.ACCOUNT_RENEW_MEMBERSHIP_Membership_Information_Text,
	        body: COSTCO.util.tmpl(tmplName, tmplParam),
	        primary: messages.CLOSE,
	        primary_button_style: "rounded",
	        setHalfButtons: true,
	        primary_event: function primary_event() {
	          COSTCO.dialog.close();
	        },
	        afterclose: function afterclose() {
	          $("#costcoModal").find(".modal-dialog").removeClass("modal-dialog-membership");
	          $('#costcoModalBtn2').removeClass('primary-button-v2');
	          $('.costcoModalBtn1').removeClass('secondary-button-v2');
	        }
	      };
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = {};
	  }
	
	  window.COSTCO.MembershipValidation = MembershipValidation;
	
	  return MembershipValidation;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 43:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * @title compareProducts.js: Sub-module for Global pages
	 * @description This module handles the states of the compare Products selection box
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		"use strict";
	
		var compareProducts = {
	
			error: false,
	
			getCompare: function getCompare() {
				var compareString = localStorage.getItem("compare");
	
				if (compareString == null || typeof compareString == "undefined") {
					return [];
				}
	
				var compareArray = JSON.parse(compareString);
	
				// read the array and sanitize the values for compareImage
				for (var i = 0; i < compareArray.length; i++) {
					compareArray[i].compareImage = encodeURI(compareArray[i].compareImage);
					if (compareArray[i].alt != "" && compareArray[i].alt != undefined) {
						compareArray[i].alt = compareArray[i].alt.replace(/\\"/g, " inch").replace(/\\'/g, "'") + ' image';
					}
				}
	
				return compareArray;
			},
	
			clearAll: function clearAll() {
				this.clearCheckboxes();
				this.setCompare([]);
				this.draw();
				COSTCO.util.announceSRMessage(messages.ALL_ITEMS_REMOVED);
			},
	
			clearCheckboxes: function clearCheckboxes() {
				var compareArray = this.getCompare();
				for (var i = 0; i < compareArray.length; i++) {
					this.uncheckCheckbox(compareArray[i].partNumber);
				}
			},
	
			setCompare: function setCompare(json) {
	
				var jsonString = JSON.stringify(json);
				localStorage.setItem("compare", jsonString);
			},
	
			hideCompare: function hideCompare() {
				this.hideError();
				$('#compare-box-products').addClass('closed');
				$('#compare-box-products [tabindex=0]').attr('tabindex', '-1');
				if (localStorage) {
					localStorage.setItem('compareMin', 'false');
				}
			},
	
			minimizeCompare: function minimizeCompare() {
				this.hideError();
				$('#compare-box-products').addClass('minimized');
				$('#minimize-text').html(cpStatic.showText);
				$('#compare-minimize .co-chevron-right').removeClass('rotate90').addClass('rotate270');
				$('#compare-box-products [tabindex = 0]').attr('tabindex', '-1');
				$('#compare-minimize').attr('tabindex', '0');
				if (localStorage) {
					localStorage.setItem('compareMin', 'true');
				}
			},
	
			showCompare: function showCompare() {
				this.unhide();
				$('#compare-box-products,#compare-box-container,#compare-box-products').removeClass('minimized').removeClass('closed');
				$('#minimize-text').html(cpStatic.hideText);
				$('#compare-minimize .co-chevron-right').removeClass('rotate270').addClass('rotate90');
				$('#compare-box-products [tabindex=-1]').attr('tabindex', '0');
				if (localStorage) {
					localStorage.setItem('compareMin', 'false');
				}
			},
	
			unhide: function unhide() {
				$('#compare-box-container').removeClass('hide');
				$('#compare-box-products [tabindex=-1]').attr('tabindex', '0');
			},
	
			isPageComparable: function isPageComparable() {
				return $('#compare-box-container').length > 0 && $('.compare-container').length > 0;
			},
			addAttributes: function addAttributes() {
				$('#compare-box-products').attr('role', 'region');
				$('#compare-box-products').attr('aria-label', 'Compare Products');
				$('#compare-box-products').attr('id', 'compare-box-products');
			},
	
			init: function init() {
	
				if (!this.isPageComparable()) {
					console.log('Not a comparable page');
					return;
				} else {
					var compArray = this.getCompare();
					if (compArray != undefined && compArray.length != 0) {
						this.unhide();
					}
				}
	
				console.log('Initializing Compare Products');
				this.initMinmize();
				this.initCheckboxes();
				this.addAttributes();
				this.draw();
			},
	
			isMinimized: function isMinimized() {
				var minState = localStorage.getItem('compareMin');
	
				if (typeof minState == "undefined" || minState == null) {
					return false;
				}
	
				if (minState == "true") {
					return true;
				}
				return false;
			},
	
			initMinmize: function initMinmize() {
				if (this.isMinimized()) {
					this.minimizeCompare();
				}
			},
	
			initCheckboxes: function initCheckboxes() {
	
				$('input[name="compare-product"]').prop('checked', false);
	
				var compareArray = this.getCompare();
				for (var i = 0; i < compareArray.length; i++) {
					this.checkCheckbox(compareArray[i].partNumber);
				}
			},
	
			checkCheckbox: function checkCheckbox(partNumber) {
				$('#compare_' + partNumber).prop('checked', true);
			},
	
			uncheckCheckbox: function uncheckCheckbox(partNumber) {
				if ($('#compare_' + partNumber).length > 0) {
					$('#compare_' + partNumber).prop('checked', false);
				} else if ($('#compare_sponsored_' + partNumber).length > 0) {
					$('#compare_sponsored_' + partNumber).prop('checked', false);
				} else {
					console.log('Error unchecking checkbox there is no item with this part number. ' + partNumber);
				}
			},
	
			isItemCompared: function isItemCompared(partNumber) {
	
				var compareJson = this.getCompare();
				for (var i = 0; i < compareJson.length; i++) {
					if (partNumber == compareJson[i].partNumber) {
						return true;
					}
				}
	
				return false;
			},
	
			pushItem: function pushItem(partNumber, image, description, isFsaChd) {
	
				var compareObj = { partNumber: partNumber, compareImage: image, alt: description, isFsaOrChd: isFsaChd };
	
				if (localStorage) {
					localStorage.setItem('compareMin', 'false');
				}
	
				var compareArray = this.getCompare();
				if (compareArray.length == 4) {
					COSTCO.compareProducts.error = true;
					this.uncheckCheckbox(partNumber);
				} else {
					compareArray.push(compareObj);
					this.setCompare(compareArray);
				}
			},
	
			removeItem: function removeItem(partNumber) {
	
				this.hideError();
	
				var compareJson = this.getCompare();
				var index = -1;
				for (var i = 0; i < compareJson.length; i++) {
					if (partNumber == compareJson[i].partNumber) {
						index = i;
					}
				}
	
				if (index > -1) {
					this.uncheckCheckbox(compareJson[index].partNumber);
					compareJson.splice(index, 1);
					this.setCompare(compareJson);
				}
			},
	
			toggleItem: function toggleItem(partNumber, image, object, isFsaChd) {
				var description = $(object).attr("data-description");
				if (description != undefined && description != "undefined" && description != null) {
					description = description.replace(/(['"&:;])/g, "\\$1");
				}
				if (this.isItemCompared(partNumber)) {
					this.removeItem(partNumber);
				} else {
					this.pushItem(partNumber, image, description, isFsaChd);
				}
				this.draw();
				COSTCO.util.announceSRMessage(messages.ITEM_REMOVED);
			},
	
			toggleMinimize: function toggleMinimize() {
	
				if ($('#compare-box-products').hasClass('minimized')) {
					this.showCompare();
					$('#compare-minimize').attr('aria-expanded', 'true');
					$('#compare-box-row, .compare-buttons-container').attr('aria-hidden', 'false');
				} else {
					this.minimizeCompare();
					$('#compare-minimize').attr('aria-expanded', 'false');
					$('#compare-box-row, .compare-buttons-container').attr('aria-hidden', 'true');
				}
			},
	
			toggleMinimizeKey: function toggleMinimizeKey(e) {
				//if event is enter key
				if (e.which === 13) {
					COSTCO.compareProducts.toggleMinimize();
				}
			},
			hideError: function hideError() {
				COSTCO.compareProducts.error = false;
				$('#compare-box-products,#compare-error-row').removeClass('error-state');
				$('#compare-error-row').html('');
			},
	
			showError: function showError() {
				$('#compare-box-products,#compare-error-row').addClass('error-state');
				$('#compare-error-row').html(cpStatic.itemAddErrorText);
			},
	
			draw: function draw() {
	
				var compareJson = this.getCompare();
				if (compareJson == null || compareJson.length == 0) {
					this.hideCompare();
				} else if (this.isMinimized()) {
					this.minimizeCompare();
				} else {
					this.showCompare();
				}
	
				if (COSTCO.compareProducts.error) {
					this.showError();
				} else {
					this.hideError();
				}
	
				var compareArray = this.getCompare();
				var totalSpots = 4; // 1 based indices around these parts
				var totalItems = compareArray.length;
				var html = '';
				var automation = '';
	
				for (var i = 0; i < totalItems; i++) {
					if (typeof compareArray[i].compareImage == "undefined") {
						compareArray[i].compareImage = cpStatic.errorDomain + "images/unavailable_350.png";
					} else if (!COSTCO.util.isBusinessDelivery() && compareArray[i].compareImage.indexOf('847') < 0 && compareArray[i].compareImage.indexOf('894') < 0) {
						compareArray[i].compareImage = cpStatic.errorDomain + "images/unavailable_350.png";
					}
					if (compareArray[i].isFsaOrChd == 'true') {
						html += COSTCO.util.tmpl('tmpl_comparable_product_fsachd', compareArray[i]);
					} else {
						html += COSTCO.util.tmpl('tmpl_comparable_product', compareArray[i]);
					}
				}
	
				for (var i = 0; i < totalSpots - totalItems; i++) {
					html += COSTCO.util.tmpl('tmpl_empty_product', { 'automationId': automation + i });
				}
	
				this.fill(html);
			},
	
			fill: function fill(html) {
				$('#compare-box-row').html(html);
			},
	
			compare: function compare() {
	
				var COMPARE_URL = "/CompareProductsDisplay",
				    PART_NUMBER_PARAM = "?partNumbers=";
	
				var compareArray = this.getCompare();
				var partNumbers = $(compareArray).map(function () {
					return this.partNumber;
				}).get().join(',');
				var url = COMPARE_URL + PART_NUMBER_PARAM + partNumbers;
	
				window.location = url;
			}
	
		}; //end compareProducts object
	
		function getScrubbedUrl(urltoscrub) {
			if (urltoscrub != null && urltoscrub.indexOf('.product.') != -1) {
				var sarray = urltoscrub.split('.product.');
				if (sarray == null) {
					return "";
				} else {
					return '.product.' + sarray[1];
				}
			} else {
				return urltoscrub;
			}
		}
	
		// Expose compareProducts to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.compareProducts = compareProducts;
	
		return compareProducts;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 54:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title mathtable.js: Sub-module
	 * @description Associated with MathTableAndProductOptions.jsp
	 * This JS file calculates prices of products, shows/hides the 
	 * math table on the Product Details Page
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (phelper) {
		var retryCount = 0;
		var retryLimit = 3;
		var isRegionalPdtAvlble = false;
		var initSwatch = false;
		var isRegionalPdt = false;
		var backordered = false;
		var bundlePriceMap = new Map();
		var blockContractAjax = false;
		var previousContractAjaxItem = '';
		var selectedObj = null;
		var selectedVar = null;
		var initalizeAjaxCall = false;
		var hideBreakdownvariants = false;
		var isCostcoMembers = false;
		var isUserSignedIn = false;
		var CMath = {
			isBackOrderFlag: false,
			invAvailableAjax: false,
			invokebatchCall: false,
			pdpPageloadComplete: false,
			kbPageloadComplete: false,
			siteControllOOS: false,
			isWarehouseEnabled: false,
			isWioEnabled: false,
			isBopiwEnabled: false,
			isErrorlocationControlleditem: false,
			invokeAjaxCall: false,
			selectedswatches: [],
			onloadSelectOption: [],
			variantJSON: [],
			varItemJSON: [],
			iskitsbundle: false,
			/* Math Table Controller */
			// Initializes the controller. Checks what kind of product the user landed on executes accordingly.
			init: function init() {
				if (isPDPVariantGreyOutEnabled == 'true') {
					localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
				}
				var bundleItem = $('#bundleItem').val();
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				var isWarehouseOnlyAttr = $('#isWarehouseOnlyAttr').val() == "true" ? true : false;
				var pricingtextdisplay = $('#pricingtextdisplay').val() == 'true' ? true : false;
	
				if (isWarehouseOnlyAttr && pricingtextdisplay && $('#applicationType').val() == 'BC') {
					$('#warehouseonly_pricing_info').removeClass('hide');
				}
	
				COSTCO.CMath.iskitsbundle = $('#iskitsbundle').val() == "true" ? true : false;
				if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true' && !(typeof product != 'undefined' && Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
					$('head').append('<style type="text/css">.loading {animation: pulse 1.5s ease-in-out 0.5s 50;}@keyframes pulse {0% {opacity: 1;}50% {opacity: 0.4;}100% {opacity: 1;}}</style>');
				}
				if ($('#isBDAppVar').val() != 'BD' && bundleItem && product.length == 0) {
					$('.crumbs').show();
					$('#product-page').addClass('hide');
					$('#not_found_error_pdp').removeClass('hide');
				}
				if (phelper.isSingleItem(products)) {
					$('.starting-price').hide();
					var catentry = $('.online-price').data('catentry');
					var quickView = $('#quick_view').val() == "true" ? true : false;
					phelper.item_type = 'single';
					if ($('#isBDAppVar').val() != 'BD' && !quickView) {
						window.reactObj.fulfillments.buyInStoreOnly.wcsVariant = false;
						window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = false;
					}
					if (catentry) {
	
						if ($('#isBDAppVar').val() == 'BD' || quickView) {
							CMath.pricingInfo(catentry);
							CMath.showBreakdown(!hideBreakdownvariants);
							CMath.showBackorderMessage();
						}
					} else {
						$('.your-price').addClass('hide');
					}
					var catID = products[0][0].catentry;
					COSTCO.Product.active_catentry = catID;
					COSTCO.CMath.invokeBuildABundle(catID);
					var defaultItemNumber = COSTCO.Product.getPartnumber();
					window.eventBus.subscribe('reactReady', function (data) {
						window.eventBus.publish('bfImageViewerPartnumber', defaultItemNumber);
					});
				} else if (phelper.isSingleVariant(products)) {
					phelper.item_type = 'single_variant';
	
					if (COSTCO.CMath.iskitsbundle) {
						COSTCO.CMath.buildTooltip();
						CMath.selectCurrentSelectedItem();
					}
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
					var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
					if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) {
						$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
					}
				} else if (phelper.isMultiVariant(products)) {
					phelper.item_type = 'multi_variant';
	
					if (COSTCO.CMath.iskitsbundle) {
						COSTCO.CMath.buildTooltip();
						CMath.selectCurrentSelectedItem();
					}
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
					if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
						var _optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
						for (var i = 0; i <= _optionsSelected.length - 2; i++) {
							$('#PDPSwatchSkeletone-productOption0' + parseInt(i) + '').hide();
							$('#swatchesID-productOption0' + parseInt(i) + '').show();
							$('.dropdown-skeleton-productOption0' + parseInt(i) + '').hide();
							$('[name=productOption0' + parseInt(i) + ']').show();
						}
						if (Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag || scheduledDeliverable) {
							$('#PDPSwatchSkeletone-productOption0' + parseInt(_optionsSelected.length - 1) + '').hide();
							$('#swatchesID-productOption0' + parseInt(_optionsSelected.length - 1) + '').show();
							$('.dropdown-skeleton-productOption0' + parseInt(_optionsSelected.length - 1) + '').hide();
							$('[name=productOption0' + parseInt(_optionsSelected.length - 1) + ']').show();
						}
					}
				} else if (COSTCO.CMath.iskitsbundle) {
	
					phelper.item_type = 'single_variant';
					COSTCO.Product.sort_variant_options();
					CMath.bindVariantProducts();
				} else if (phelper.isBundle(products)) {
					phelper.item_type = 'bundle';
					if ($('#isBDAppVar').val() != 'BD') {
						for (var i = 0; i < product.length; i++) {
							var productId = product[i].catentry;
							var count = 0,
							    size = product.length;
							count = i;
							for (var j = 0; j < products[i].length; j++) {
								var itemId = products[i][j].catentry;
								//CMath.showBundleSpecificData(productId,itemId,count,size);
								CMath.callAjaxBundleInventory(productId, itemId, count, size);
							}
						}
					}
					CMath.addToCartSwitch(false);
					CMath.bindQuantitiesForBundle();
					CMath.bindVariantProducts('bundle');
	
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						CMath.updateItemNumberDisplay();
					}
				}
				CMath.regionSelector();
				CMath.mathTableDisplayRules();
				CMath.showRightToRepair();
				if ($('#isBDAppVar').val() == 'BD') {
					CMath.showPriceVariants();
				}
				var userInfo = COSTCO.util.getMemberCookie(),
				    signedIn = userInfo.signedIn,
				    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
				    isCostcoMembers = costcoMember,
				    memberOnly = $('#memberItem').val() == "true" ? true : false;
	
				if (COSTCO.CMath.iskitsbundle && !isUserSignedIn && memberOnly) {
					$('#bundle-button-container').addClass('hide');
				}
				if (COSTCO.CMath.iskitsbundle && isUserSignedIn && isCostcoMembers) {
					$('#bundle-button-container').removeClass('hide');
				}
				if (COSTCO.CMath.iskitsbundle && !isUserSignedIn && !memberOnly && mapItem) {
					$('#bundle-button-container').addClass('hide');
				}
	
				//Grocery US change - Depot Catalog Online - Call Ajax for contract specific details 
				if (CMath.isContractSpecificAjaxRequired()) {
					if (!COSTCO.CMath.iskitsbundle) {
						CMath.handleContractSpecificRules();
					}
				}
				if ($('#delivery-zip').val() != undefined) {
					$('#delivery-zip').val($.cookie('invCheckPostalCode'));
				}
	
				// Single Product EDD setup
				if (Array.isArray(products) && products.length > 0) {
	
					var defaultShipcode = "";
	
					if ($('#defaultShipcode').length != 0) {
						defaultShipcode = $('#defaultShipCode').val();
					}
	
					$('#showLiveEDD').val(products[0][0].eddVendorName);
					$('#vendorName').val(products[0][0].eddVendorName);
	
					if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
						$('#showLiveEDD').val("");
						$('#vendorName').val("");
					}
				}
				if (!COSTCO.CMath.iskitsbundle) {
					CMath.handleEDDForms();
				}
				if (phelper.isSingleItem(products) && $('#vendorName').length > 0) {
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						var zipcode = $.cookie('invCheckPostalCode');
						var updateZipCodeStateCookies = function updateZipCodeStateCookies(data, textstatus, XMLHttpRequest) {
	
							var locationData = COSTCO.Header.extractLocationData(data);
							var invalidZip = locationData.InvalidZip;
							var province = locationData.Province;
							var country = locationData.Country;
	
							if (!invalidZip) {
								COSTCO.Header.setDeliveryCookies(zipcode, province, country);
	
								if ((typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									COSTCO.Product.showEddForm();
								} else if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									COSTCO.Product.displayEDDForm = false;
									COSTCO.Product.retrieveEDD();
								} else if ($('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
									COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
									COSTCO.Header.showEDDWidget();
								} else if (typeof product !== 'undefined' && typeof product[0] !== 'undefined' && product[0].isScheduledDeliverable === "true") {
									var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
									COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
										sku: $('#deliveryVendorSku').val(),
										url: url,
										productSku: $('#productPartnumberVal').val(),
										zipCode: $.cookie('invCheckPostalCode')
									});
								}
							}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						} else {
							COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						}
					} else {
						if ((typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
							COSTCO.Product.showEddForm();
						} else if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
							COSTCO.Product.displayEDDForm = false;
							COSTCO.Product.retrieveEDD();
						} else if ($('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
							COSTCO.Header.itemPartNumberSelcted = products[0][0].partNumber;
							COSTCO.Header.showEDDWidget();
						} else if (typeof product !== 'undefined' && typeof product[0] !== 'undefined' && product[0].isScheduledDeliverable === "true") {
							var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
							COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
								sku: $('#deliveryVendorSku').val(),
								url: url,
								productSku: $('#productPartnumberVal').val(),
								zipCode: $.cookie('invCheckPostalCode')
							});
						}
					}
					// onclick of pills bfImageViewerPartnumber will be published
					window.eventBus.publish('bfImageViewerPartnumber', COSTCO.Header.itemPartNumberSelcted);
					window.reactObj.defaultItemNumber = COSTCO.Header.itemPartNumberSelcted;
				}
	
				try {
					COSTCO.util.checkAndDisableSignInButton();
				} catch (ignore) {}
			},
	
			swatchTileSelected: false,
			swatchInitialTileSelected: false,
			allVariantsSelected: false,
			swatchActiveColor: '',
			changeVariantTriggered: false,
			preSelectedAttributesPassed: false,
			preSelectedAttributesChanged: false,
	
			// A sequence of functions that shows the online price, fees/discounts, calculates and shows (if not bundle) "Your Price"
			pricingInfo: function pricingInfo(catentryid, priceOnline) {
				CMath.showOnlinePrice(catentryid);
				CMath.processEcoFee(catentryid, priceOnline);
				//Commented out the below lines as part of Canada Compliance changes
				//CMath.showFeesAndDiscounts(catentryid);
				//CMath.calculateYourPrice(catentryid);
				CMath.showTaxableFoodAttribute(catentryid);
			},
			//Implemented as part of Canada Compliance changes
			showDiscountsBreakdown: function showDiscountsBreakdown(catentryid) {
				var $disc = $('.disc[data-catentry=' + catentryid + ']');
				var $discValue = $disc.find('.disc-value');
	
				CMath.hideElements($('.disc'), $('.disc .disc-value'));
				CMath.showLocalizedValues($disc, $discValue, $disc.data('disc'));
	
				var discText = $discValue.text().trim();
				var isDiscEmpty = discText === '' || discText === '--';
				var hasHideClass = $disc.hasClass('hide');
	
				if (isDiscEmpty) {
					$disc.toggleClass('active hide');
				} else if (!isDiscEmpty && hasHideClass) {
					$disc.toggleClass('hide active');
				}
			},
			//Implemented as part of Canada Compliance changes
			showFeeBreakdown: function showFeeBreakdown(catentryId, feeArray) {
				CMath.hideElements($('.fees'), $('.fees .fee-value'));
	
				var loc = $.cookie('C_LOC');
				if (!loc || loc.length <= 2 || !Array.isArray(feeArray)) return;
				document.querySelectorAll('.fees.' + loc + '[data-catentry="' + catentryId + '"]').forEach(function (feeElement) {
					var feeType = feeElement.getAttribute('data-feeType');
					if (feeArray.includes(feeType)) {
						var $feeElement = $(feeElement);
						CMath.showLocalizedValues($feeElement, $feeElement.find('.fee-value'), $feeElement.data('feeamt'));
					}
				});
			},
			//Implemented as part of Canada Compliance changes
			processEcoFee: function processEcoFee(catentryId, priceOnline) {
				var currentRegion = COSTCO.util.getRegion();
				var ecoFeesConfigurations = typeof feesConfigurations !== 'undefined' ? feesConfigurations : null;
				var discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
				discount = discount ? parseFloat(COSTCO.util.decode(discount).replace(/,/g, '')) : 0;
	
				if (discount) {
					$('.disc[data-catentry=' + catentryId + ']').toggleClass('active hide');
					CMath.showBreakdown(true, catentryId);
					CMath.showDiscountsBreakdown(catentryId);
				} else {
					CMath.hideElements($('.disc'), $('.disc .disc-value'));
				}
				if (priceOnline) {
					$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(phelper.processPrice(priceOnline)));
					$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', COSTCO.util.encode(String(priceOnline)));
				}
	
				var opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryId + ']').data('opvalue')) || 0;
				opPrice = parseFloat(opPrice.toString().replace(/,/g, '')) || 0;
	
				var regionECOConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "EcoFee");
				var regionDepositConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "Deposit");
				var regionOtherConfig = CMath.getRegionFeeConfig(ecoFeesConfigurations, currentRegion, "OtherFee");
				var categoryConfigMap = {
					EcoFee: regionECOConfig,
					Deposit: regionDepositConfig,
					OtherFee: regionOtherConfig
				};
				var feeIdMap = {
					EcoFee: [],
					Deposit: [],
					OtherFee: []
				};
				var loc = $.cookie('C_LOC');
				if (!loc || loc.length <= 2) {
					CMath.showFeeBreakdown(catentryId, null);
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					return;
				}
				var feeElements = $('.fees.' + loc + '[data-catentry=' + catentryId + ']');
				document.getElementById("linkfee-container").innerHTML = "";
				var regionfees = []; // feeIds eligible for the provience
				feeElements.each(function () {
					var feeType = this.getAttribute('data-feeType');
					var feeCategory = this.getAttribute('data-feeCategory');
					if (feeCategory && feeType && feeType.trim() !== "") {
						var config = categoryConfigMap[feeCategory];
						if (config) {
							feeIdMap[feeCategory].push(feeType);
						}
					}
				});
				if (!feeElements || feeElements.length === 0) {
					CMath.showFeeBreakdown(catentryId, null);
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					return;
				}
				if (!regionECOConfig) {
					console.warn("Region configuration not found");
					CMath.showFeeBreakdown(catentryId, null);
					if (regionECOConfig || regionDepositConfig || regionOtherConfig) {
						CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, null, opPrice);
					}
					CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					if ($('#isBDAppVar').val() == 'BD' && COSTCO.util.isUSBDStore()) {
						CMath.showFeesAndDiscounts(catentryId);
						if ($('#breakdown').hasClass('hide') && $('.active.online-price .op-value').text() != "--") {
							$('#breakdown').toggleClass('hide active');
						}
						CMath.calculateYourPrice(catentryId);
					}
					return;
				}
				if (regionECOConfig.feeType !== "ALL") {
					regionfees = regionECOConfig.feeType.split(',');
				}
	
				var displayLogic = {
					INTERNALIZED: function INTERNALIZED() {
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var combinedPrice = (opPrice + ecofeetotal).toFixed(2);
						if (ecofeetotal > 0) {
							var clonedContent = document.getElementById('priceBreakdown').cloneNode(true);
							clonedContent.removeAttribute('id');
							clonedContent.className = 'ecofee-details';
							var parentDiv = null;
							if (discount > 0) {
								parentDiv = document.querySelector('.online-price[data-catentry="' + catentryId + '"]');
							} else {
								parentDiv = document.querySelector('.your-price');
							}
							parentDiv.parentNode.insertBefore(clonedContent, parentDiv.nextSibling);
							var locale = COSTCO.util.getLocale();
							if (locale == 'fr-CA' && discount > 0) {
								document.querySelector('.ecofee-details').style.paddingLeft = '150px';
							}
							document.getElementById('priceBreakdown').innerHTML = "";
						}
						CMath.showFeeBreakdown(catentryId, null);
						CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
						if (combinedPrice) {
							$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(combinedPrice));
							$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', combinedPrice);
						}
					},
					HIDDEN: function HIDDEN() {
						CMath.showFeeBreakdown(catentryId, null);
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var combinedPrice = (opPrice + ecofeetotal).toFixed(2);
						CMath.calculateYouPriceV2(catentryId, false, combinedPrice, discount);
						if (ecofeetotal) {
							$('.online-price[data-catentry=' + catentryId + '] .op-value').text(phelper.formatMoney(combinedPrice));
							$('.online-price[data-catentry=' + catentryId + ']').data('opvalue', combinedPrice);
						}
					},
					MATHTABLE: function MATHTABLE() {
						CMath.showBreakdown(true, catentryId);
						CMath.showFeeBreakdown(catentryId, feeIdMap["EcoFee"]);
	
						var ecofeetotal = CMath.ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, categoryConfigMap, opPrice);
						var totalSplit = opPrice + ecofeetotal;
						CMath.calculateYouPriceV2(catentryId, false, totalSplit, discount);
					},
					STANDARD: function STANDARD() {
						CMath.showFeeBreakdown(catentryId, null);
						CMath.ecoFeeBreakdownDisplay(feeIdMap, null, catentryId, categoryConfigMap, opPrice);
						CMath.calculateYouPriceV2(catentryId, false, opPrice, discount);
					}
				};
	
				(displayLogic[regionECOConfig.display.PDP] || displayLogic.STANDARD)();
	
				$('.co-help.eco-fee').popover();
			},
	
			ecoFeeBreakdownDisplay: function ecoFeeBreakdownDisplay(feeIdMap, regionfees, catentryId, displayConfig, opValue) {
				if (!displayConfig || (!feeIdMap["EcoFee"] || feeIdMap["EcoFee"].length === 0) && (!feeIdMap["Deposit"] || feeIdMap["Deposit"].length === 0) && (!feeIdMap["OtherFee"] || feeIdMap["OtherFee"].length === 0)) {
					return 0;
				}
				var ecoFeeTotal = 0;
				var ecoFeeTotalHidden = 0;
				var noEcoFeeInRegion = Array.isArray(regionfees) && regionfees.length > 0 && Array.isArray(feeIdMap.EcoFee) && feeIdMap.EcoFee.length > 0 && feeIdMap.EcoFee.some(function (id) {
					return !regionfees.includes(id);
				});
				document.getElementById("linkfee-container").innerHTML = "";
				var container = document.getElementById("linkfee-container");
				var location = $.cookie('C_LOC');
				var elements = document.querySelectorAll('.fee-parent .fees.' + location + '[data-catentry="' + catentryId + '"]');
				var tooltip = null;
				var ecoFeeHiddenTextAdded = false;
				var ecoFeeDisplay = null;
				elements.forEach(function (feeElement) {
					var feeType = feeElement.getAttribute('data-feeType');
					if (!feeType) return;
					var feeCategory = null;
					for (var category in feeIdMap) {
						if (feeIdMap[category].includes(feeType)) {
							feeCategory = category;
							break;
						}
					}
					var decodedAmount = parseFloat(atob(feeElement.getAttribute('data-feeamt')));
					var labelElement = feeElement.querySelector(".fee-label");
					var label = labelElement ? COSTCO.util.sentenceToPascalCase(labelElement.innerText.trim()) : "";
					var ecoFeeElement = feeElement.querySelector(".co-help.eco-fee");
					var linkFeeElement = feeElement.querySelector(".eco-fee");
					var tooltipClone = ecoFeeElement ? ecoFeeElement.cloneNode(true) : linkFeeElement ? linkFeeElement.cloneNode(true) : "";
					var isRegionFee = regionfees != null && regionfees.length > 0 ? regionfees.includes(feeType) : true;
					var isEcoFee = feeCategory == 'EcoFee' && isRegionFee;
					var config = displayConfig[feeCategory];
					var pdpDisplay = config && config.display ? config.display.PDP : null;
					if (isEcoFee && (pdpDisplay === 'INTERNALIZED' || pdpDisplay === 'MATHTABLE')) {
						ecoFeeTotal += decodedAmount;
						tooltip = tooltipClone;
						ecoFeeDisplay = pdpDisplay;
					} else if (isEcoFee && pdpDisplay === 'HIDDEN' && isRegionFee) {
						if (!noEcoFeeInRegion) {
							ecoFeeTotalHidden += decodedAmount;
							if (!ecoFeeHiddenTextAdded) {
								ecoFeeHiddenTextAdded = true;
								container.appendChild(CMath.createFeeRow(label, messages.ECO_FEE_INCLUDED, tooltipClone));
							}
						}
						ecoFeeTotal += decodedAmount;
					} else {
						var ecofeeamount = phelper.formatMoney(phelper.processPrice(decodedAmount.toFixed(2)), true);
						container.appendChild(CMath.createFeeRow(label, '+' + ecofeeamount, tooltipClone));
					}
				});
	
				if (ecoFeeTotal > 0 && ecoFeeDisplay === 'INTERNALIZED') {
					var breakdownDiv = document.getElementById('priceBreakdown');
					var itemprice = phelper.formatMoney(phelper.processPrice(opValue.toFixed(2)), true);
					var totalEcofeeAmount = phelper.formatMoney(phelper.processPrice(ecoFeeTotal.toFixed(2)), true);
					breakdownDiv.innerHTML = '(' + itemprice + ' + ' + totalEcofeeAmount + ' ' + messages.PDETAIL_ECOFEE_TEXT + '<span class="eco-fee-tool"></span>)';
					if (tooltip) breakdownDiv.querySelector(".eco-fee-tool").appendChild(tooltip);
				}
				if (ecoFeeTotalHidden > 0) {
					var _discount = $('.disc[data-catentry=' + catentryId + ']').data('disc');
					_discount = _discount ? parseFloat(COSTCO.util.decode(_discount).replace(/,/g, '')) : 0;
					if (_discount > 0) {
						opValue -= _discount;
					}
					var combinedPrice = (opValue + ecoFeeTotalHidden).toFixed(2);
					var addedprice = phelper.formatMoney(phelper.processPrice(combinedPrice), true);
					document.getElementById("ecoFeeHiddenLayout_" + catentryId).value = addedprice;
				}
	
				return ecoFeeTotal;
			},
			createFeeRow: function createFeeRow(label, valueHtml, tooltipElement) {
				var div = document.createElement("div");
				div.className = "fee-row linkfee_";
				div.innerHTML = '\n\t            <div class="fee-name linkfee_">' + label + '</div>\n\t            <div class="fee-info-icon linkfee_"></div>\n\t            <div class="fee-value pull-right">' + valueHtml + '</div>\n\t        ';
				if (tooltipElement) div.querySelector(".fee-info-icon").appendChild(tooltipElement);
				return div;
			},
			getRegionFeeConfig: function getRegionFeeConfig(feeDisplayConfig, currentRegion, feeCategory) {
				if (!feeDisplayConfig) return null;
				var regionFees = feeDisplayConfig[currentRegion] || feeDisplayConfig["ALL"] || [];
				return regionFees.find(function (fee) {
					return fee.feeCategory === feeCategory;
				}) || null;
			},
			// A utility function that first hides the "Online Price" for each product on the page and then shows the particular "Online Price" (div) associated with the passed catentryId 
			showOnlinePrice: function showOnlinePrice(catentryid) {
				CMath.hideElements($('.online-price'), $('.online-price .op-value'));
				CMath.useRegionFeeIncludedOpValue($('.online-price[data-catentry=' + catentryid + ']'), catentryid);
			},
			// A utility function that first hides the "Fees / Discounts" for each product on the page and then shows the particular "Fees / Discounts" (divs) associated with the passed catentryId
			showFeesAndDiscounts: function showFeesAndDiscounts(catentryid) {
				CMath.hideElements($('.disc'), $('.disc .disc-value'));CMath.hideElements($('.fees'), $('.fees .fee-value'));
				CMath.showLocalizedValues($('.disc[data-catentry=' + catentryid + ']'), $('.disc[data-catentry=' + catentryid + '] .disc-value'), $('.disc[data-catentry=' + catentryid + ']').data('disc'));
				if ($('.disc[data-catentry=' + catentryid + '] .disc-value').text() == '' || $('.disc[data-catentry=' + catentryid + '] .disc-value').text() == '--') {
					$('.disc[data-catentry=' + catentryid + ']').toggleClass('active hide');
				} else if (($('.disc[data-catentry=' + catentryid + '] .disc-value').text() != '' || $('.disc[data-catentry=' + catentryid + '] .disc-value').text() != '--') && $('.disc[data-catentry=' + catentryid + ']').hasClass('hide')) {
					$('.disc[data-catentry=' + catentryid + ']').toggleClass('hide active');
				}
				if ($.cookie('C_LOC') != null) {
					if ($.cookie('C_LOC').length > 2) {
						if ($('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').length > 0) {
							// fees exist for this region
							$('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').each(function () {
								var isFeeCombined = false;
								if (typeof feesCombineWithPrice !== 'undefined') {
									for (var i = 0; i < feesCombineWithPrice.length; i++) {
										var config = feesCombineWithPrice[i];
										if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
											isFeeCombined = true;
											break;
										}
									}
								}
								if (isFeeCombined == false) {
									CMath.showLocalizedValues($(this), $(this).find('.fee-value'), $(this).data('feeamt'));
								}
							});
						}
					}
				}
			},
			//Method to display the taxable food item label in the PDP page
			showTaxableFoodAttribute: function showTaxableFoodAttribute() {
				if (typeof taxableCatalogsAttributes !== 'undefined' && taxableCatalogsAttributes != null) {
					for (var i = 0; i < taxableCatalogsAttributes.length; i++) {
						var taxableAttr = taxableCatalogsAttributes[i];
						var regionCode = $.cookie('C_LOC');
						if (regionCode !== 'undefined' && regionCode != null && taxableAttr.value === regionCode.slice(-2)) {
							$("#taxable-item").removeClass('hide');
							break;
						} else {
							$("#taxable-item").addClass('hide');
						}
					}
				}
			},
			// Display Right to Repair content based on the region
			showRightToRepair: function showRightToRepair() {
				if (typeof righToRepairConfig !== 'undefined' && righToRepairConfig != null) {
					var rtrRegions = righToRepairConfig.split(",");
					for (var i = 0; i < rtrRegions.length; i++) {
						var rtrRegion = rtrRegions[i];
						var regionCode = $.cookie('C_LOC');
						if (regionCode !== 'undefined' && regionCode != null && rtrRegion === regionCode.slice(-2)) {
							$("#right-to-repair").removeClass('hide');
							break;
						} else {
							$("#right-to-repair").addClass('hide');
						}
					}
				}
			},
	
			// Main workhorse. Calculates the "Your Price" after adding any fees and then subtracting any discount associated with the catentryid. Always returns a double
			calculateYouPriceV2: function calculateYouPriceV2(catentryid, isBundle, finalprices, discount) {
				CMath.showLocalizedValues($('.online-price[data-catentry=' + catentryid + ']'), $('.online-price[data-catentry=' + catentryid + '] .op-value'), $('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
				var finalPrice = finalprices - discount;
				if (!isBundle) {
					if ($('#isBDAppVar').val() == 'BD') {
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
							$('#price-per-unit-container').addClass('hide');
						} else {
							$('#price-per-unit-container').show();
							$('#price-per-unit-container').removeClass('hide');
						}
					} else {
						if (finalPrice != 0.00) {
							$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						}
					}
					if ($('#isBDAppVar').val() != 'BD') {
						$('#price-per-unit-container').show();
					}
				}
				return finalPrice;
			},
	
			calculateYourPrice: function calculateYourPrice(catentryid, isBundle) {
				var opPrice;
				if (catentryid) {
					opPrice = COSTCO.util.decode($('.online-price[data-catentry=' + catentryid + ']').data('opvalue'));
				}
				if ($.type(opPrice) === 'string') {
					opPrice = opPrice.split(',').join('');
				}
				var opValue = parseFloat(opPrice) || 0.00;
				var discount = $('.disc[data-catentry=' + catentryid + ']').data('disc') ? COSTCO.util.decode($('.disc[data-catentry=' + catentryid + ']').data('disc')) : 0.00;
				discount = $.type(discount) === 'string' ? parseFloat(discount.split(',').join('')) : discount;
				var fees = function () {
					var totalFees = 0.00;
					if ($.cookie('C_LOC') != null) {
						if ($.cookie('C_LOC').length > 2) {
							$('.fees.' + $.cookie('C_LOC') + '[data-catentry=' + catentryid + ']').each(function () {
								var isFeeCombined = false;
								if (typeof feesCombineWithPrice !== 'undefined') {
									for (var i = 0; i < feesCombineWithPrice.length; i++) {
										var config = feesCombineWithPrice[i];
										if (config.region == $.cookie('C_LOC') && config.feeId == $(this).data('feeid')) {
											isFeeCombined = true;
											opValue += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
											break;
										}
									}
								}
								if (!isFeeCombined) {
									totalFees += parseFloat(COSTCO.util.decode($(this).data('feeamt')));
								}
							});
						}
					}
					return totalFees;
				}();
	
				$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(opValue)));
				$('.online-price[data-catentry=' + catentryid + ']').attr('data-opvalue', COSTCO.util.encode(opValue + ''));
	
				var finalPrice = opValue + fees - discount;
				if (!isBundle) {
					if ($('#isBDAppVar').val() == 'BD') {
						$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
							$('#price-per-unit-container').addClass('hide');
						} else {
							$('#price-per-unit-container').show();
							$('#price-per-unit-container').removeClass('hide');
						}
					} else {
						if (finalPrice != 0.00) {
							$('.your-price .value').text(phelper.formatMoney(phelper.processPrice(finalPrice)));
						}
					}
					if ($('#isBDAppVar').val() != 'BD') {
						$('#price-per-unit-container').show();
					}
				}
				return finalPrice;
			},
			// Generic utility function for hiding the passed element. Additionally, this function encodes the hidden values to base64
			hideElements: function hideElements(element, valueHolder) {
				$(element).each(function () {
					if (!$(this).hasClass('hide')) {
						$(this).addClass('hide');
					}
					if ($(this).hasClass('active')) {
						$(this).removeClass('active');
					}
				});
				$(valueHolder).each(function () {
					if (!COSTCO.util.base64test.test($(this).text())) {
						$(this).text(COSTCO.util.encode($(this).text()));
					}
				});
			},
			// Hides price per unit container
			hidePricerPerUnit: function hidePricerPerUnit() {
				if (products[0].length > 1) {
					$('#price-per-unit-container').hide();
				}
			},
			// Generic utility function for showing the localized values of valueHolder.
			showLocalizedValues: function showLocalizedValues(parent, valueHolder, value) {
				$(parent).toggleClass('hide');$(parent).toggleClass('active');
				if ($('#isBDAppVar').val() == 'BD') {
					$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
				} else {
					if (phelper.processPrice(value) != 0.00) {
						$(valueHolder).text(phelper.formatMoney(phelper.processPrice(value)));
					} else {
						$(valueHolder).text('--');
					}
				}
			},
			// Show the math table breakdown (true/false). True is show, false is hide.
			showBreakdown: function showBreakdown(flag, catentryId) {
				if (flag) {
					var sameVals = $('.active.online-price .op-value').text() == $('.your-price .value').text();
					if ($('#breakdown').hasClass('hide') && !sameVals && $('.active.online-price .op-value').text() != "--") {
						$('#breakdown').toggleClass('hide active');
					} else if ($('#breakdown').hasClass('active') && sameVals) {
						$('#breakdown').toggleClass('active hide');
					}
				} else {
					if ($('#breakdown').hasClass('active')) {
						$('#breakdown').toggleClass('active hide');
						if ($('#isBDAppVar').val() != 'BD') {
							$('.your-price .value').text('--');
							CMath.hidePricerPerUnit();
						}
					}
				}
			},
			/**
	   * Uses feesCombineWithPrice config set from xappconfig to determine if
	   * eco-fee should be hidden and included in the online-price
	   */
			useRegionFeeIncludedOpValue: function useRegionFeeIncludedOpValue(parent, catentryid) {
				function getRegionPrice(regionPrices, region) {
					for (var i = 0; i < regionPrices.length; i++) {
						if (regionPrices[i].region == region) {
							return regionPrices[i].price;
						}
					}
					return null;
				}
				function getFeeId(feeOptions, region) {
					for (var i = 0; i < feeOptions.length; i++) {
						if (feeOptions[i].region == region) {
							return feeOptions[i].feeId;
						}
					}
					return null;
				}
	
				function getFeeIds(feeOptions, region) {
					var feeIds = [];
					for (var i = 0; i < feeOptions.length; i++) {
						if (feeOptions[i].region == region) {
							feeIds.push(feeOptions[i].feeId);
						}
					}
					return feeIds;
				}
				var region = COSTCO.util.getRegion();
				if (region && region != '""' && $('.fees.' + region).length > 0 && typeof feesCombineWithPrice != 'undefined') {
					var productData = phelper.findItem(products[0], catentryid) || [];
					var feeIds = getFeeIds(productData.feeOptions, region);
					var isAllFeesCombined = false;
					if (feeIds && feeIds.length > 0) {
						feeIds.forEach(function (feeId) {
							var isFeeCombined = false;
							for (var i = 0; i < feesCombineWithPrice.length; i++) {
								var config = feesCombineWithPrice[i];
								if (config.region == region && config.feeId == feeId) {
									isFeeCombined = true;
									break;
								}
							}
							isAllFeesCombined = isAllFeesCombined && isFeeCombined;
						});
						if (isAllFeesCombined == true) {
							hideBreakdownvariants = true;
						}
					}
				}
			},
			/* Product Options (variants) controller */
			bindQuantitiesForBundle: function bindQuantitiesForBundle() {
				var $qtys = $('input[name^=quantity-]'),
				    has_math_table = $('.math-table').length > 0;
				$qtys.unbind('change.bundleQty').on('change.bundleQty', function () {
					var total = 0.00,
					    allQtyVals = $.map($qtys, function (e) {
						var qtyVal = parseInt($(e).val());return isNaN(qtyVal) ? 0 : qtyVal;
					});
					if (has_math_table) {
						$qtys.each(function (i) {
							var qtyVal = parseInt($(this).val()),
							    quantity = isNaN(qtyVal) || qtyVal < 0 ? 0 : qtyVal,
							    //if product is not a number or negative treat as 0
							catentryid = CMath.getCatEntryId($(this).data('product'));
							typeof catentryid !== 'undefined' ? total += CMath.calculateYourPrice(catentryid, true) * quantity : allQtyVals[i] = 0;
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
								var itemTotal = CMath.calculateYourPrice(catentryid, true) * quantity;
								var itemProcesPrice = phelper.processPrice(itemTotal);
								var itemFormatMoney = COSTCO.util.formatMoney(itemProcesPrice, true);
								$('#bundle-' + this.id).closest('.bundle-item').find('.bundle-item-total').text(itemFormatMoney);
							}
						});
					}
					//treat quantity value that is negative as 0
					if (COSTCO.util.all(allQtyVals, function (x) {
						return x == 0 || x < 0;
					})) {
						CMath.addToCartSwitch(false);
						$('.your-price .value').text('--');
						CMath.hidePricerPerUnit();
					} else {
						CMath.addToCartSwitch(true);
						if (has_math_table) {
							$('.your-price .value').text(COSTCO.util.formatMoney(phelper.processPrice(total)), true);
						}
					}
				});
			},
			/**
	      * Updates item number section for Bundle without variance.
	      * @return void
	      */
			updateItemNumberDisplay: function updateItemNumberDisplay() {
				$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][0].partNumber);
				$('#product-body-item-number').removeClass('hide');
			},
			// Each variant select associated with a product gets a change event that controls if to calculate a price (i.e. if there are any unselected values as part of a multi-variant product). Handles bundles
			bindVariantProducts: function bindVariantProducts(type, inOption) {
	
				if (typeof inOption !== 'undefined') {
					$('.varis').find('option[value=' + inOption + ']').prop('selected', true);
				}
				$('.varis').each(function (variIndex) {
					if (variIndex + 1 == $('.varis').length && (!costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE)) {
						console.log("Binding the Variants Selected ");
						COSTCO.CMath.allVariantsSelected = true;
					}
					$(this).parent().find('select[data-product=' + $(this).data('product') + ']').unbind('change.vari').on('change.vari', function () {
						var num = $(this).data('product');
						var variantProductIndex = $(this).index('.varis[data-product=' + num + ']');
						var optionsSelected = phelper.get_selected_array($('.varis[data-product=' + num + ']').find('option:selected'));
						if (isPDPVariantGreyOutEnabled == 'true') {
							//Analytics for variants
							for (var i = 0; i < optionsSelected.length; i++) {
	
								var $selectedOption = $('.varis option[value=' + optionsSelected[i] + ']');
								var productOptionId = $selectedOption.parent().attr('id');
								var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
								var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
								var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
								var selectedlabelText = $selectedOptionKey.text().split(':')[0].trim();
								window.digitalDataEvents = window.digitalDataEvents || [];
								var swatch = $('#swatches-productOption0' + parseInt(optionsSelected.length - 1) + '').length > 0;
								var dropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 1) + ']').length > 0;
								if (swatch) {
									var swatchvalue = $('span[automation-id=selectionItem_' + optionsSelected[i] + ']').text().trim();
									digitalDataEvents.push({ uimsg: "Product Detail | " + selectedlabelText + " | " + swatchvalue + "" });
								} else if (dropDown) {
									var dropdownvalue = $('.varis-v2 option[automation-id=varisOption_' + optionsSelected[i] + ']').text().trim();
									if (!dropdownvalue.includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
										digitalDataEvents.push({ uimsg: "Product Detail | " + selectedlabelText + " | " + dropdownvalue + "" });
									}
								}
							}
						}
						if (optionsSelected.length == 3 && !COSTCO.CMath.iskitsbundle) {
							// inorder to handle multivariant 3 level on page load this iteration is required for enabling lower level
							for (var i = 0; i < optionsSelected.length - 1; i++) {
								CMath.next_variant_attributes(i, num, optionsSelected[i]);
							}
						} else {
							if (!COSTCO.CMath.iskitsbundle || COSTCO.CMath.iskitsbundle && !dropDown) {
								CMath.next_variant_attributes(variantProductIndex, num, $(this).find('option:selected').val());
							}
						}
	
						optionsSelected = phelper.get_selected_array($('.varis[data-product=' + num + ']').find('option:selected'));
						var any_unselected = optionsSelected.indexOf("unselected") > -1;
						var any_selected = COSTCO.util.any(optionsSelected, function (x) {
							return x != "unselected";
						});
						var selectedCatentryid = CMath.getCatEntryId(num, optionsSelected);
						var selectedProgramType = CMath.getItemProgramType(num, optionsSelected);
						var isShipToWarehouseItem = CMath.isShipToWarehouseItem(num, optionsSelected);
						var applType = $('#applicationType').val();
						CMath.disableSelectsAfterUnselected($('.varis[data-product=' + num + ']').parent(), optionsSelected, type);
						if (applType == 'BC') {
							var varaintParameters = { "productId": selectedCatentryid, "programType": selectedProgramType, "storeId": wcs.storeId };
							if (selectedCatentryid != undefined && selectedProgramType != undefined) {
								if ((typeof selectedObj === 'undefined' ? 'undefined' : _typeof(selectedObj)) === undefined || JSON.stringify(selectedObj) !== JSON.stringify(varaintParameters)) {
									selectedObj = varaintParameters;
									window.reactObj.global.shipToWarehouse = isShipToWarehouseItem;
									window.reactObj.fulfillments.buyInStoreOnly.productId = selectedCatentryid;
									window.reactObj.fulfillments.buyInStoreOnly.programType = selectedProgramType;
									if (phelper.item_type == 'single_variant' || phelper.item_type == 'multi_variant') {
										window.reactObj.fulfillments.buyInStoreOnly.wcsVariant = true;
										window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = false;
										var readInvFromBatchApiXapp = $('#readInvFromBatchApiEnabled').val();
										if (readInvFromBatchApiXapp === 'true') {
											window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi = true;
										}
									}
									try {
										if (_typeof(window.reactObj.fulfillments.buyInStoreOnly) != undefined) {
											if (_typeof(window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) != undefined && window.reactObj.fulfillments.buyInStoreOnly.readInvFromBatchApi) {
												window.wioEventBus.publish('notifyVaraintsChange', varaintParameters);
											} else {
												var itemStockStatusExist = false;
												var selectedPartNum = '';
												$.each(products, function (index, jsonObject) {
													$.each(jsonObject, function (key, value) {
														if (value['catentry'] === selectedCatentryid) {
															selectedPartNum = value['partNumber'];
														}
													});
												});
												$.each(COSTCO.CMath.varItemJSON, function (index, jsonObject) {
													$.each(jsonObject, function (key, value) {
														$.each(value, function (objKey, objValue) {
															if (objKey === 'itemNumber' && objValue === selectedPartNum) {
																itemStockStatusExist = true; // verify if selected item stock exists
															}
														});
													});
												});
												if (itemStockStatusExist) {
													window.wioEventBus.publish('notifyVaraintsChange', varaintParameters);
												}
											}
										}
									} catch (e) {
										console.log(e);
									}
								}
							}
						}
	
						var preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
						if (typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && CMath.preSelectedAttributesChanged == false) {
							var preselectAttrArr = preselectAttrsStr.split('||');
							CMath.preSelectedAttributesPassed = true;
							if (preselectAttrArr.length == 1) {
								preselectAttrKeyVal = preselectAttrArr[0];
								var replaceSelected = '';
								var replaceNextVariant = '';
								var preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
								optionsSelected.forEach(function (selectedOption, selectedIndex) {
									options[0].forEach(function (optionsArr) {
										if (optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]) {
											if (optionsArr['v'].hasOwnProperty(selectedOption) == true) {
												Object.keys(optionsArr['v']).forEach(function (attrVal) {
													if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption) {
														console.log(preselectAttrKeyValArr[1] + " value is preselected ");
													} else if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]) {
														replaceSelected = attrVal;
														console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
													}
												});
												if (replaceSelected !== '') {
													optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected);
													$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
	
													var nextSelectedIndex = selectedIndex == 0 ? 1 : 0;
													products[0].forEach(function (product, index) {
														if (product.options.includes(replaceSelected) == true) {
	
															if (product.options.includes(optionsSelected[nextSelectedIndex]) == true) {
																console.log("The Variant Exists .. ");
																replaceNextVariant = optionsSelected[nextSelectedIndex];
															} else {
																if (replaceNextVariant == '') {
																	replaceNextVariant = product.options[0] == replaceSelected ? product.options[1] : product.options[0];
																}
															}
														}
													});
													if (typeof replaceNextVariant != 'undefined' && replaceNextVariant != '') {
														optionsSelected.splice(nextSelectedIndex, 1, replaceNextVariant);
														$('.varis').find('option[value=' + replaceNextVariant + ']').prop('selected', true);
													}
													CMath.next_variant_attributes(variantProductIndex, num, replaceSelected);
													replaceSelected = '';
													replaceNextVariant = '';
												}
											}
										}
									});
								});
							} else {
								preselectAttrArr.forEach(function (preselectAttrKeyVal, index) {
									var replaceSelected = '';
									var preselectAttrKeyValArr = preselectAttrKeyVal.split(':');
									optionsSelected.forEach(function (selectedOption, selectedIndex) {
										options[0].forEach(function (optionsArr) {
											if (optionsArr['n'].toLowerCase() == preselectAttrKeyValArr[0]) {
												if (optionsArr['v'].hasOwnProperty(selectedOption) == true) {
													Object.keys(optionsArr['v']).forEach(function (attrVal) {
														if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1] && attrVal.toLowerCase() == selectedOption) {
															console.log(preselectAttrKeyValArr[1] + " value is preselected ");
														} else if (optionsArr['v'][attrVal].toLowerCase() == preselectAttrKeyValArr[1]) {
															replaceSelected = attrVal;
															console.log(preselectAttrKeyValArr[1] + " new value is preselected " + attrVal);
														}
													});
													if (replaceSelected !== '') {
														optionsSelected.splice(optionsSelected.indexOf(selectedOption), 1, replaceSelected);
														$('.varis').find('option[value=' + replaceSelected + ']').prop('selected', true);
														replaceSelected = '';
													}
												}
											}
										});
									});
								});
							}
							CMath.preSelectedAttributesChanged = true;
							$('body').trigger("costco.variant.changed");
						}
	
						if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && !$(optionsSelected).parents('.vari').is('.swatchDropdown[data-swatch-mode=2]')) {
	
							optionsSelected.forEach(function (value) {
								CMath.update_selected_option_label(value);
							});
							CMath.disableSelectsAfterUnselected($('.varis-v2[data-product=' + num + ']').parent(), optionsSelected, type);
							try {
	
								for (var i = $('.varis[data-product=0]').length - 1; i > 0; i--) {
									$("#productOption0" + i + " option[style*='display: none']").each(function () {
										$("#swatches-productOption0" + i + " input[value*='" + $(this).val() + "']").parent().hide();
										$(this).attr('disabled', 'disabled').hide();
									});
	
									$("#productOption0" + i + " option[style*='display: block'], #productOption0" + i + " option[style*='display: inline']").each(function () {
										if ($("#swatches-productOption0" + i + " input:checked:enabled").length < 1) {
											$("#swatches-productOption0" + i + " input[value*='" + $(this).val() + "']").click();
											$(this).removeAttr('disabled').show();
											return false;
										}
									});
								}
							} catch (e) {
								console.log(e);
							}
						}
	
						if (type === 'bundle') {
							// If we're a bundle and at least one variant is selected and its associated qty
							// is 0, set it to one to help user.
							if (any_selected) {
								var $input = $(this).parents('.variantContainer').find('.bundleQty input'),
								    input_val = $input.val();
								if (!isNaN(parseInt(input_val)) && parseInt(input_val) == 0) {
									$input.val(1);
								}
							}
							$('input[name^=quantity-]').trigger('change.bundleQty');
						}
						if (type !== 'bundle' && any_unselected) {
							CMath.showLowestPriceVariant();
							//if the catentryid is undefined it means there is no option selected
							//in that case show default variant backorder message 
							if (typeof catentryid === "undefined") {
								$('#backorder-message').text(variantBackorderMessageDefault);
								$('#backorder-message').show();
							}
						} else {
							$('.starting-price').hide();
						}
	
						var catentryid = CMath.getCatEntryId(num, optionsSelected);
						if (product[0].isScheduledDeliverable === "true" && catentryid) {
							//invoke if item is scheduledDeliverable and a variant has been selected
							window.COSTCO.ScheduledDeliverable.setDeliverableInputsFromSelectedProduct();
						}
						var variantIndex = 0;
						var deliveryVendorSku = '';
						COSTCO.Product.active_catentry = catentryid;
						//populate the catalogEntryID property in the add to cart form with the 
						//catentry ID for the resolved item.
						if (typeof catentryid !== "undefined") {
							COSTCO.CMath.allVariantsSelected = true;
							if (type === 'bundle') {
								$('input[name=catalogEntryId_' + (num + 1) + ']').val(catentryid);
							} else {
								//exclude the contract specific flow as price will be populated by ajax in that flow
								$('input[name=catEntryId]').val(catentryid);
								if ($('#isBDAppVar').val() == 'BD') {
									CMath.pricingInfo(catentryid);
									$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(phelper.findItem(products[num], optionsSelected).pricePerUnit)));
									if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
										$('#price-per-unit-container').addClass('hide');
									} else {
										$('#price-per-unit-container').show();
										$('#price-per-unit-container').removeClass('hide');
									}
									CMath.showBreakdown(true);
								}
								//Exclude LocationControlled Inv items
								if (!COSTCO.util.islocationControlledInventoryFlow() && $('#isBDAppVar').val() == 'BD') {
									//show backorder message only on variants that are backorder and hide for the rest
									var variantInventory = phelper.findItem(products[num], optionsSelected).inventory;
									var vaiantType = phelper.findItem(products[num], optionsSelected).type;
									if (variantInventory && variantInventory === COSTCO.util.productConstants.inv_backorderd || vaiantType > 2) {
										$('#backorder-message').text(phelper.findItem(products[num], optionsSelected).backorderMessage);
										$('#backorder-message').show();
										$('.edd-container').hide();
									} else {
										$('#backorder-message').hide();
										$('.edd-container').show();
									}
								}
	
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].catentry === catentryid) {
										variantIndex = i;
										break;
									}
								}
							}
						} else {
							//Only 1 attribute is selected from multi-variant
							COSTCO.CMath.allVariantsSelected = false;
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options[0] === optionsSelected[0] || products[0][i].options[1] === optionsSelected[0]) {
									variantIndex = i;
									break;
								}
							}
						}
						for (var i = 0; i < products[0].length; i++) {
							if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
								deliveryVendorSku = deliveryVendorSku + products[0][i].manufacturerPartNumber + ",";
							}
						}
						if (deliveryVendorSku.length > 0) {
							deliveryVendorSku = deliveryVendorSku.slice(0, deliveryVendorSku.length - 1);
						}
	
						if (any_selected) {
							if ($(window).width() < 769) {
								$('.item-model-number').removeClass('col-xs-12');
								//STR0167115 - ALM26087
								//and STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
										$('#model-no').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
									} else {
										$('#model-no').html(products[0][variantIndex].vendorModelNumber);
									}
								}
							} else {
	
								//STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].partNumber !== undefined && products[0][variantIndex].partNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
										$('#product-body-item-number').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
									} else {
										$('#product-body-item-number').html(products[0][variantIndex].partNumber);
									}
								}
								$('#product-body-item-number').removeClass('hide');
								if (COSTCO.CMath.iskitsbundle) {
									if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].productName !== undefined && products[0][variantIndex].productName !== "") {
										$('[automation-id="productName"]').text(products[0][variantIndex].productName);
									}
								}
								//STR0167115 - ALM26087
								//and STRY0167115...
								if (products[0] !== undefined && products[0][variantIndex] !== undefined && products[0][variantIndex].vendorModelNumber !== undefined && products[0][variantIndex].vendorModelNumber !== "") {
									if (messages !== undefined && messages.PDETAIL_MODEL !== undefined) {
										$('#product-body-model-number').html(messages.PDETAIL_MODEL + products[0][variantIndex].vendorModelNumber);
									} else {
										$('#product-body-model-number').html(products[0][variantIndex].vendorModelNumber);
									}
								}
							}
	
							$('#showLiveEDD').val(products[0][variantIndex].eddVendorName);
							$('#vendorName').val(products[0][variantIndex].eddVendorName);
	
							var defaultShipcode = "";
	
							if ($('#defaultShipcode').length != 0) {
								defaultShipcode = $('#defaultShipCode').val();
							}
	
							if (!COSTCO.util.isEDDEnabled() || !CMath.isValidShipMode(defaultShipcode)) {
								$('#showLiveEDD').val("");
								$('#vendorName').val("");
							}
							if ((isRegionalPdtAvlble || !COSTCO.util.issiteControlledInventoryFlow()) && initalizeAjaxCall || $('#isBDAppVar').val() == 'BD' || (phelper.item_type == 'single_variant' || phelper.item_type == 'multi_variant') && !initalizeAjaxCall && !COSTCO.CMath.iskitsbundle) {
								CMath.handleEDDForms();
							}
	
							if (messages !== undefined && messages.PDETAIL_NUMBER !== undefined) {
								$('#item-no').html(messages.PDETAIL_NUMBER + products[0][variantIndex].partNumber);
							} else {
								$('#item-no').html(products[0][variantIndex].partNumber);
							}
	
							COSTCO.Header.itemPartNumberSelcted = products[0][variantIndex].partNumber;
	
							// update sku/itemNumber for analytics
	
							window.digitalDataEvents = window.digitalDataEvents || [];
							if (typeof window.digitalData !== "undefined" && typeof window.digitalData.product !== "undefined" && typeof window.digitalData.product[0] !== "undefined") {
								window.digitalData.product[0].sku = products[0][variantIndex].partNumber;
								window.digitalData.product[0].itemNumber = products[0][variantIndex].partNumber;
							}
						}
						if (product[0].isScheduledDeliverable === "true") {
							//invoke if item is scheduledDeliverable and a variant has been selected
	
							$('#deliveryVendorSku').val(products[0][variantIndex].manufacturerPartNumber);
							$('#deliveryVendorSkuArr').val(deliveryVendorSku);
	
							//attach event to select options button
							window.COSTCO.ScheduledDeliverable.attachEventSelectOptions({
								sku: $('#deliveryVendorSku').val(),
								categoryCode: $('#categoryCode').val(),
								zipCode: $('#delivery-zip').val()
	
							});
							var swatchMode = $('.swatchDropdown').data('swatch-mode');
	
							if ($('#catEntryId').val() == COSTCO.Product.active_catentry && previousContractAjaxItem != COSTCO.Header.itemPartNumberSelcted && (swatchMode == 2 && (brandfolderEnabled || COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected) || (swatchMode == 1 || swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || (swatchMode == 1 || swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2)) {
								previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
								if (products[0][variantIndex].zipcodeAvailabilityMessage === '0' || typeof products[0][variantIndex].zipcodeAvailabilityMessage === "undefined") {
									window.COSTCO.ScheduledDeliverable.resetDeliverableForm();
									var url = "AjaxDeliveryReservationCalendarCmd?storeId=" + wcs.storeId + "&deliveryVendorSku=" + $('#deliveryVendorSku').val() + "&zipCode=" + $.cookie('invCheckPostalCode') + "&productSku=" + $('#productPartnumberVal').val();
									COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
										sku: $('#deliveryVendorSku').val(),
										url: url,
										productSku: $('#productPartnumberVal').val(),
										zipCode: $.cookie('invCheckPostalCode')
									});
								} else if (typeof products[0][variantIndex].zipcodeAvailabilityResponseCode !== "undefined" && products[0][variantIndex].zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
									if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
										$('#deliveryFailMessage').removeClass("hide");
										$('#prod-page-delivery').removeClass('hide');
										$('#zip-group').addClass('hide');
										if (products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											$('#deliveryFailMessage').addClass("warning").removeClass("critical-notification");
											$('[name=select-options]').prop("disabled", false);
										} else {
											$('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
											$('[name=select-options]').prop("disabled", true);
										}
										$('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
										$('#deliveryDateMessage').removeClass('success').addClass('hide');
										$('#deliveryLocationText').addClass('hide');
										$('#deliveryInfoText').addClass("hide");
									} else {
										$('#deliveryFailMessage').removeClass("hide");
										$('#prod-page-delivery').addClass('hide');
										$('#zip-group').addClass('hide');
										$('#geDeliveryFailMessageSpan').text(products[0][variantIndex].zipcodeAvailabilityMessage);
										$('#deliveryDateMessage').removeClass('success').addClass('hide');
										$('#deliveryLocationText').addClass('hide');
										$('#deliveryInfoText').addClass("hide");
										if (products[0][variantIndex].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											$('[name=select-options]').prop("disabled", false);
										} else {
											$('[name=select-options]').prop("disabled", true);
										}
									}
								} else {
									if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
										var deliveryDate = products[0][variantIndex].zipcodeAvailabilityMessage;
										var date = deliveryDate ? new Date(deliveryDate).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : "";
										$('#deliveryDateMessageTxt').text(date);
									} else {
										$('#deliveryDateMessageTxt').text(products[0][variantIndex].zipcodeAvailabilityMessage);
									}
									$('#zip-group').removeClass('hide');
									$('#deliveryFailMessage').addClass("hide");
									$('#prod-page-delivery').addClass('hide');
									$('#deliveryDateMessage').removeClass('hide').addClass('success');
									$('#deliveryLocationText').removeClass('hide');
									$('#deliveryInfoText').removeClass("hide");
								}
							}
						}
						if ($(this).parents('.vari').is('.swatchDropdown[data-swatch-mode=1]')) {
							var swatchable = $(this).find('option:selected[data-swatch]');
							if (swatchable.length > 0) {
								CMath.triggerSwatchDropDownSelection($(swatchable).data('swatch'));
							}
						}
	
						if (any_selected && (typeof catentryid !== "undefined" || !catentryid) && COSTCO.CMath.allVariantsSelected) {
							$('body').trigger("costco.variant.changed");
							var _swatchMode = $('.swatchDropdown').data('swatch-mode');
							if ($('#catEntryId').val() == COSTCO.Product.active_catentry && (_swatchMode == 2 && (brandfolderEnabled || COSTCO.CMath.swatchTileSelected && COSTCO.CMath.swatchInitialTileSelected) || (_swatchMode == 1 || _swatchMode == 0) && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions || (_swatchMode == 1 || _swatchMode == 0) && costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && COSTCO.Product.sortVariantOptions_V2)) {
								if ($.cookie('invCheckPostalCode') != null && $('#liveEDD') && $('#liveEDD').val() === "true" && !$('#vendorName').val().toLowerCase().includes('narvar') && $('#edd-form-block').length > 0) {
									if ((typeof selectedVar === 'undefined' ? 'undefined' : _typeof(selectedVar)) === undefined || selectedVar != $('#catEntryId').val()) {
										selectedVar = $('#catEntryId').val();
										COSTCO.Product.displayEDDForm = false;
										COSTCO.Product.retrieveEDD();
										COSTCO.Product.isEddItem = true;
									}
								} else if ($('#productPage').val() && $('#liveEDD') && $('#liveEDD').val() === "true" && $('#vendorName').val().toLowerCase().includes('narvar') && $('.edd-container').length > 0) {
									COSTCO.CMath.callEDDFunctions();
								}
							}
						}
	
						if ((!(any_selected && (typeof catentryid !== "undefined" || !catentryid)) || typeof $.cookie('invCheckPostalCode') === 'undefined' || $.cookie('invCheckPostalCode') == null) && $('#edd-form-block').length > 0 && !$('#vendorName').val().toLowerCase().includes('narvar')) {
							COSTCO.Product.showEddForm();
						}
						//block ajax calls which are repeated and in case of variation only trigger ajax after its first call from init 
						if ($('.swatchDropdown').data('swatch-mode') == 2 && (!COSTCO.CMath.swatchTileSelected || COSTCO.CMath.swatchTileSelected && previousContractAjaxItem === '')) {
							brandfolderEnabled ? blockContractAjax = false : blockContractAjax = true;
						} else {
							blockContractAjax = false;
						}
						var userInfo = COSTCO.util.getMemberCookie(),
						    signedIn = userInfo.signedIn,
						    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
						    memberOnly = $('#memberItem').val() == "true" ? true : false;
						var itemPartNumber = COSTCO.Product.getPartnumber();
	
						varaintParameters = { "productId": selectedCatentryid, "programType": selectedProgramType, "partNumber": itemPartNumber, "storeId": wcs.storeId };
						if (isShipToWarehouseItem) {
							window.wioEventBus.publish('notifyVaraintsChangeForSTW', varaintParameters);
						}
	
						var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
						//Invoke contract specific ajax on each selection		
						if (!COSTCO.CMath.iskitsbundle) {
							if (CMath.changeVariantTriggered && CMath.isContractSpecificAjaxRequired() && selectedCatentryid != undefined) {
								retryCount = 0;
								if (!memberOnly || signedIn && memberOnly) {
									CMath.handleContractSpecificRules();
								} else {
									if (isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
										COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
										COSTCO.CMath.handlePillsForGuest();
										COSTCO.CMath.invokeAjaxCall = false;
									}
								}
							} else {
								if (isPDPVariantGreyOutEnabled == 'true' && !(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag) && !scheduledDeliverable) {
									COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
									COSTCO.CMath.handlePillsForGuest();
									COSTCO.CMath.invokeAjaxCall = false;
								}
							}
						}
						var itemPartNumber = COSTCO.Product.getPartnumber();
						window.reactObj.fulfillments.buyInStoreOnly.partNumber = itemPartNumber;
						window.eventBus.publish('bfImageViewerPartnumber', itemPartNumber);
						window.eventBus.publish('pdpSwatchUpdate', itemPartNumber);
						window.eventBus.subscribe('reactReady', function () {
							window.eventBus.publish('bfImageViewerPartnumber', itemPartNumber);
						});
						window.eventBus.subscribe('swatchReady', function () {
							window.eventBus.publish('pdpSwatchUpdate', itemPartNumber);
						});
						window.reactObj.defaultItemNumber = itemPartNumber;
						if (COSTCO.CMath.iskitsbundle) {
							COSTCO.CMath.invokeBuildABundle(catentryid);
						}
					});
	
					if (!CMath.changeVariantTriggered) {
						$(this).trigger('change.vari');
						CMath.changeVariantTriggered = true;
					}
				});
			},
			//FOr GuestUser, To handle pills selection based on oos response
			handlePillsForGuest: function handlePillsForGuest() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
					$(this).removeClass("select-span1-OOS");
				});
				var variable;
				var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
				if (lowerSwatch) {
					// pills
					if (COSTCO.Product.item_type === 'multi_variant') {
	
						variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
					} else if (COSTCO.Product.item_type === 'single_variant') {
						// $('.selection-item').removeClass("select-span1-OOS");
						variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
					}
					if ($('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
						$('span[automation-id=' + variable + ']').addClass("select-span1-OOS");
					}
				}
				CMath.update_selected_option_label(optionsSelected[len - 1]);
			},
			callEDDFunctions: function callEDDFunctions() {
				if (COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted) {
					if (COSTCO.Header.hasInvPostalCodeCookie() && COSTCO.Header.isInvStateCookieMissing()) {
						var zipcode = $.cookie('invCheckPostalCode');
						var updateZipCodeStateCookies = function updateZipCodeStateCookies(data, textstatus, XMLHttpRequest) {
	
							var locationData = COSTCO.Header.extractLocationData(data);
							var invalidZip = locationData.InvalidZip;
							var province = locationData.Province;
							var country = locationData.Country;
	
							if (!invalidZip) {
								COSTCO.Header.setDeliveryCookies(zipcode, province, country);
								if (COSTCO.Header.narvarDCFetchedSku == '' || COSTCO.Header.narvarDCFetchedSku != COSTCO.Header.itemPartNumberSelcted) {
									COSTCO.Header.startEDDMutationObserver();
									COSTCO.Header.showEDDWidget();
								}
							}
						};
						if ($('#isGeocodeService').val() != "true") {
							COSTCO.util.callBing(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						} else {
							COSTCO.util.callGeocodeAPI(zipcode, updateZipCodeStateCookies, updateZipCodeStateCookies);
						}
					} else {
						COSTCO.Header.startEDDMutationObserver();
						COSTCO.Header.showEDDWidget();
					}
				}
			},
	
			// A utility function that disables successive selects of variant products if their previous is unselected. Supports n multivariants
			disableSelectsAfterUnselected: function disableSelectsAfterUnselected(styleSelects, optionsArray, type) {
	
				$(styleSelects).removeClass('disabled');
				$(styleSelects).find('select').removeAttr('disabled');
				var unselectedPos = optionsArray.indexOf("unselected");
				if (type !== 'bundle') {
					if (unselectedPos > -1) {
						CMath.addToCartSwitch(false);
					} else {
						CMath.addToCartSwitch(true);
					}
				}
				for (var i = unselectedPos == -1 ? optionsArray.length - 1 : unselectedPos, len = optionsArray.length; i < len; i++) {
					$($(styleSelects)[i + 1]).addClass('disabled');
					$($(styleSelects)[i + 1]).find('select').attr("disabled", "disabled");
					$($(styleSelects)[i + 1]).find('option[value=unselected]').prop('selected', true);
				}
			},
	
			/**
	   * Utility function that determines what combination of variants is valid
	   * @param  {[type]}
	   * @param  {[type]}
	   * @param  {[type]}
	   * @return {[type]}
	   */
			next_variant_attributes: function next_variant_attributes(current_index, product_num, prev_variant_value) {
				var $next_variant = $($('.varis[data-product=' + product_num + ']')[current_index + 1]);
				var optionsSelected = phelper.get_selected_array($('.varis[data-product=' + product_num + ']').find('option:selected'));
				var upperVariant = optionsSelected.length > 2 ? optionsSelected[0] : '';
				if ($next_variant.length > 0) {
	
					var $next_variant_options = $next_variant.find('option:not(.defaultOpt)');
	
					var _$variant_option_input = void 0;
					var $variant_option_label = void 0;
					var $variant_option_dropbox = void 0;
	
					$('.varis-v2').attr('disabled', 'disabled');
					$next_variant_options.attr('disabled', 'disabled').hide().each(function (index, opt) {
	
						if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	
							if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
	
								_$variant_option_input = $('input[value=' + opt.value + ']');
								$variant_option_label = _$variant_option_input.closest('label');
								_$variant_option_input.attr('disabled', 'disabled');
								_$variant_option_input.prop('checked', false);
							} else {
	
								$variant_option_dropbox = $('.varis-v2').find('option[value=' + opt.value + ']');
								$variant_option_dropbox.attr('disabled', 'disabled').hide();
							}
						}
	
						products[product_num].forEach(function (product_obj) {
							var upperlevelCheck = upperVariant != '' ? COSTCO.util.hasElem(upperVariant, product_obj.options) : true;
							if (COSTCO.util.hasElem(prev_variant_value, product_obj.options) && COSTCO.util.hasElem(opt.value, product_obj.options) && upperlevelCheck) {
	
								$(opt).removeAttr('disabled').attr("style", "display: block;");
								$(opt)[0].disabled = false;
	
								if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	
									if (numberOfOptionsToDisplayAsTiles && $next_variant_options.length < numberOfOptionsToDisplayAsTiles) {
	
										$variant_option_label.removeClass('disabled');
										$variant_option_label.show();
										$variant_option_label.css('display', '');
										_$variant_option_input.removeAttr('disabled');
										if (_$variant_option_input.siblings()[0]) {
											CMath.update_variant_option(_$variant_option_input.siblings(), product_obj, $next_variant_options.length);
										}
									} else {
	
										$variant_option_dropbox.removeAttr('disabled').show();
										if ($variant_option_dropbox[0]) {
											CMath.update_variant_option($variant_option_dropbox[0], product_obj, $next_variant_options.length);
										}
									}
								}
							}
							if (typeof prev_variant_value === "undefined" || prev_variant_value == null || product_obj.options.includes(prev_variant_value)) {
								CMath.update_variant_option(opt, product_obj, $next_variant_options.length);
							}
						});
					});
					$next_variant.find('option[value=unselected]').prop('selected', true);
					if ($next_variant.find('option:enabled').length > 0 && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						$($next_variant.find('option:enabled')[0]).prop('selected', true);
					}
					if ($variant_option_dropbox) {
						var dropdownIndex = current_index + 1;
						newoptval = $($('.varis-v2[name=productOption0' + dropdownIndex + ']').find('option:enabled')[0]).val();
						$($('.varis-v2[name=productOption0' + dropdownIndex + ']').find('option:enabled')[0]).prop('selected', true);
						$($($next_variant.find('option[value=' + newoptval + ']'))[0]).prop('selected', true);
					}
				} else if (typeof prev_variant_value === "undefined" || prev_variant_value == null) {
					var $variant_options = $('.varis[data-product=' + product_num + ']').find('option:not(.defaultOpt)');
					$variant_options.each(function (index, opt) {
						products[product_num].forEach(function (product_obj) {
							CMath.update_variant_option(opt, product_obj, $variant_options.length);
						});
					});
				}
			},
	
			/**
	   * Function that updates variant option label for selected options
	   */
			update_selected_option_label: function update_selected_option_label(value) {
	
				if (value != 'unselected') {
	
					var $selectedOption = $('.varis option[value=' + value + ']');
					var productOptionId = $selectedOption.parent().attr('id');
					var $selectedOptionLabel = $('label[for=' + productOptionId + ']');
					var $selectedOptionKey = $selectedOptionLabel.find('.selectedOptionKey');
					var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
	
					$selectedOptionKey.html($selectedOptionKey.text()[$selectedOptionKey.text().length - 1] == ':' ? $selectedOptionKey.text() : $selectedOptionKey.text() + ':');
					$selectedOptionValue.html(' ' + $selectedOption.text());
					if ($('#isBDAppVar').val() != 'BD' && isPDPVariantGreyOutEnabled == 'true') {
						if ($('span[automation-id=selectionItem_' + value + ']').hasClass("select-span1-OOS")) {
							if (!$selectedOptionValue.text().includes(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
								$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
							}
						} else if ($('.varis-v2 option[automation-id=varisOption_' + value + ']').hasClass("out-of-stock")) {
							if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
								var textToReplace = $selectedOptionValue.text();
								var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
								$selectedOptionValue.text(newText);
								$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
							}
						}
					}
					$selectedOptionValue.show();
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
						$variant_option_input = $('input[value=' + value + ']');
						$variant_option_input.prop('checked', true);
					}
				} else {
	
					var $defaultOptions = $('option[value=' + value + ']');
					$defaultOptions.each(function (index, element) {
	
						if ($(element).prop('selected')) {
	
							var productOptionId = $(element).parent().attr('id');
							var $defaultOptiontLabel = $('label[for=' + productOptionId + ']');
							var $defaultOptionKey = $defaultOptiontLabel.find('.selectedOptionKey');
							$defaultOptionKey.html($defaultOptionKey.text()[$defaultOptionKey.text().length - 1] == ':' ? $defaultOptionKey.text().substring(0, $defaultOptionKey.text().length - 1) : $defaultOptionKey.text());
							$defaultOptiontLabel.find('.selectedOptionValue').hide();
						}
					});
				}
			},
	
			/**
	   * Function that disables/enables variant option and updates option text
	   */
			update_variant_option: function update_variant_option(opt, product_obj, nextVariantLength) {
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					$(opt).siblings().each(function (index, option) {
						if (typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(option).removeAttr('disabled');
						}
					});
					$(opt).closest('label').removeClass('disabled');
				}
				//Update backorder / not available text for multivariant products
				if (typeof opt.value !== "undefined" && product_obj.options.includes(opt.value)) {
					if (product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	
						if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.BACKORDER_TEXT;
						}
					} else if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - ' + messages.BACKORDER_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.OUT_OF_STOCK_TEXT;
						}
						if (product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
								$(opt).siblings().attr('disabled', 'disabled');
								$(opt).closest('span').addClass('disabled');
							}
							$(opt).attr('disabled', 'disabled');
						}
					} else {
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT) || $(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
								var sliceStr = ' - ' + messages.BACKORDER_TEXT;
								$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
							}
							if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
								var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
								$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
							}
							$(opt)[0].disabled = false;
						}
					}
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
						if (typeof opt.value !== "undefined") {
							$variant_option_input = $('input[value=' + opt.value + ']');
							if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
								$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
							}
							$variant_option_span = $variant_option_input.closest('span');
							if ($variant_option_span.length > 0) {
								if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
									$variant_option_span.addClass('disabledSwatch');
								} else {
									$variant_option_span.removeClass('disabledSwatch');
								}
							}
						}
					}
				}
			},
	
			// A utility function to retrieve that catentry of a product by passing the product number and an array of the options selected associated with that product number.
			getCatEntryId: function getCatEntryId(productNum, optionsSelected) {
				var catentryid;
				if (phelper.item_type == 'single') {
					return products[0][0].catentry;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.catentry ? product_selected.catentry : undefined;
				}
			},
			getItemProgramType: function getItemProgramType(productNum, optionsSelected) {
				var programType;
				if (phelper.item_type == 'single') {
					return products[0][0].programType;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.programType ? product_selected.programType : undefined;
				}
			},
	
			isShipToWarehouseItem: function isShipToWarehouseItem(productNum, optionsSelected) {
				var shipToWarehouse;
				if (phelper.item_type == 'single') {
					return products[0][0].shipToWarehouse;
				} else {
					var productArray = products ? products[productNum] : [];
					var optionsSelected = optionsSelected || phelper.get_selected_array($('.varis[data-product=' + productNum + ']').find('option:selected'));
					var product_selected = phelper.findItem(productArray, optionsSelected);
					return product_selected && product_selected.shipToWarehouse ? product_selected.shipToWarehouse : false;
				}
			},
	
			// A function that enables/disables the add-to-cart button; true = enable, false = disable.
			addToCartSwitch: function addToCartSwitch(test) {
				if (test) {
					//add-to-car button
					$('#add-to-cart input[name=add-to-cart]').removeAttr('disabled');
					$(".add-to-list-button").show();
					//add-to-wishlist button
					//ALM22204 Show the Add to List option once the variant is selected
					$("#add-to-wishlist").show();
					$("#addListbtn").show();
					$("#add-to-wishlist").removeClass("add-to-wishlist-desactive");
					$("#addListbtn").removeClass("add-to-wishlist-desactive");
					if ($('#add-to-cart input[name=add-to-cart]').val() == 'Out of Stock') {
						$('#add-to-cart input[name=add-to-cart]').attr('disabled', 'disabled');
					}
				} else {
					//Add to Cart Button need not be disabled if the Contract Ajax had been invoked
					if (!isRegionalPdt) {
						//add-to-car button
						$('#add-to-cart input[name=add-to-cart]').attr('disabled', 'disabled');
					}
					$("#add-to-list").hide();
					//Ensure 'Add to Registry' div spans the whole row on mobile when 'Add to List' button is hidden
					$("#mr-registry-container").removeClass("col-xs-6").addClass("col-xs-12");
	
					//add-to-wishlist button
					//ALM22204 Hide the Add to List option until the variant is selected
					$("#add-to-wishlist").hide();
					$("#addListbtn").hide();
					$("#add-to-wishlist").addClass("add-to-wishlist-desactive");
					$("#addListbtn").addClass("add-to-wishlist-desactive");
				}
			},
			// Change event on region selector to associate fees with their respective region.
			regionSelector: function regionSelector() {
				$('#regionDropdown').unbind('change.regionFees').on('change.regionFees', function (e) {
					CMath.pricingInfo($('.active.online-price').data('catentry'));
					CMath.showBreakdown(true);
				});
			},
			//Grocery US change - Depot Catalog Online - Retrieve the contract specific details of an item
			handleContractSpecificRules: function handleContractSpecificRules() {
				retryCount++;
				if ((COSTCO.util.islocationControlledInventoryFlow() || COSTCO.util.issiteControlledInventoryFlow() && phelper.item_type != 'bundle') && retryCount <= retryLimit) {
					CMath.hideElementsBeforeAjax();
					previousContractAjaxItem = COSTCO.Header.itemPartNumberSelcted;
					var productId = $("input[name='productBeanId']").val();
					if (productId == undefined) {
						productId = product[0].catentry;
					}
					if (productId) {
						//Invoke ajax call
						//CMath.showContractSpecificData(productId);
						CMath.callAjaxInventory(productId);
					}
				}
			},
			//Grocery US change - Depot Catalog Online - Invoke ajax call
			/**
	   * Invokes the AjaxGetContractPriceCmd controller command to fetch default contract and contract based
	   * price  and handle it's response, setting the jsp view accordingly.
	   */
			showContractSpecificData: function showContractSpecificData(data) {
				var productOnlinePrice = parseFloat(0.00).toFixed(2);
				var catentryid = $('#catEntryId').val();
				var pricePerUnit = "";
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var signedIn = false;
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				//Call AJAX to get the contract prices of the given item
				COSTCO.util.ajax({
					url: '/AjaxGetContractPrice',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(data.itemId),
						catalogId: wcs.catalogId,
						productId: data.productId[0],
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
	
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						CMath.showBreakdown(false);
						if (data.errorMessageKey) {
							//setUp2DayErrorPage with zip code overlay
							if (data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID') {
								CMath.handleContractPriceAjaxFailure(data);
							} else {
								CMath.setUp2DayErrorPage();
								if (!signedIn) {
									$('.view-zip-signin').removeClass('hide');
								}
								$('.grocery-zip-form').removeClass('hide');
								$('.your-price .value').text('- -.- -');
								$('.unitcurrency').text('$-.- -');
								$('.math-table').show();
								$('#price-per-unit-container').show();
								//Paint the error message on the zip code overlay
								if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
									$('.alert-notification').empty();
									$('.critical-notification').empty();
									var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
									if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
										error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
									}
									CMath.addBorderToShipItMolecule('default');
									$('.alert-notification').append(error);
									$('.alert-notification').removeClass('hide');
									$('.critical-notification').addClass('hide');
								}
							}
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
	
							COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
						} else {
							productOnlinePrice = data.finalOnlinePrice;
							pricePerUnit = data.pricePerUnit;
							discount = data.discount;
							catentryid = data.itemId;
							//if there exists value for price
							if (typeof productOnlinePrice !== 'undefined' && !isNaN(productOnlinePrice)) {
								//if there exists value for discount, show discount node
								if (typeof discount !== 'undefined' && !isNaN(discount) && discount != 0.0) {
									$('.disc[data-catentry=' + catentryid + ']').toggleClass('hide active');
									$('.disc[data-catentry=' + catentryid + '] .disc-value').text(phelper.formatMoney(phelper.processPrice(discount)));
									$('.disc[data-catentry=' + catentryid + ']').data('disc', COSTCO.util.encode(discount + ''));
									CMath.showBreakdown(true);
								} else {
									//remove the discount node if there is no discount
									if ($('.disc').length > 0) {
										$('.disc[data-catentry=' + catentryid + ']').toggleClass('active hide');
									}
								}
								//Paint the contract price on PDP and encode the final item price to PDP page
								$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
								$('.online-price[data-catentry=' + catentryid + ']').data('opvalue', COSTCO.util.encode(productOnlinePrice + ''));
								if (!$('.online-price').length && !$('.your-price').length) {
									if ($('.marketing-container .merchandisingText').text() == '') {
										$('.marketing-container .merchandisingText').text("Starting at $" + phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
									}
								}
								if (pricePerUnit.length > 0) {
									//populate the price per unit based on contract price
									$('.unitcurrency').text('$' + phelper.formatMoney(phelper.processPrice(pricePerUnit)));
								}
	
								if ($('.unitcurrency').text() == null || $('.unitcurrency').text() == '$-.- -' || $('.unitcurrency').text().trim() == '' || COSTCO.util.getLocale() == 'fr-CA') {
									$('#price-per-unit-container').addClass('hide');
								} else {
									$('#price-per-unit-container').show();
									$('#price-per-unit-container').removeClass('hide');
								}
								//Handle other render events - 
								//Rules to hide/show UI elements , based on bussines requirement -
								//This will only be executed after Successfull price update.
	
								CMath.pricingInfo($('.online-price[data-catentry=' + catentryid + ']').data('catentry'), productOnlinePrice);
							}
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
			callAjaxInventory: function callAjaxInventory(productId) {
	
				var catentryid = $('#catEntryId').val();
				if (catentryid == undefined) {
					catentryid = products[0][0].catentry;
				}
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var whParam = COSTCO.LWSearch.getRegionalLocations();
				var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
				var signedIn = false;
				backordered = false;
				COSTCO.CMath.isBackOrderFlag = false;
				initalizeAjaxCall = true;
				var backorderMessage = '';
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				COSTCO.CMath.invAvailableAjax = false;
				COSTCO.CMath.isWarehouseEnabled = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				COSTCO.util.ajax({
					url: '/AjaxGetInventoryDetail',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(catentryid),
						catalogId: wcs.catalogId,
						productId: productId,
						WH: whParam,
						warehouse: warehouse,
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
						//Display out of stock overlay over product image
						if (data.errorMessageKey) {
							CMath.setUp2DayErrorPage();
							if (!signedIn) {
								$('.view-zip-signin').removeClass('hide');
							}
							$('.grocery-zip-form').removeClass('hide');
							//Read variable from jsp to see whether price call happened already
							var isPriceCallInvokedForPickup = $('#isPriceCallInvokedForPickup').val();
							if (isPriceCallInvokedForPickup == 'false') {
								$('.your-price .value').text('- -.- -');
							}
							$('.unitcurrency').text('$-.- -');
							$('.math-table').show();
							$('#price-per-unit-container').show();
							if ($('#price-per-unit-container').hasClass('hide') && isPriceCallInvokedForPickup == 'false') {
								$('#price-per-unit-container').removeClass('hide');
							}
							//Paint the error message on the zip code overlay
							if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
								$('.alert-notification').empty();
								$('.critical-notification').empty();
								var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
								if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
									error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
								}
								CMath.addBorderToShipItMolecule('default');
								$('.alert-notification').append(error);
								$('.alert-notification').removeClass('hide');
								$('.critical-notification').addClass('hide');
							}
	
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
							if (isPDPVariantGreyOutEnabled == 'true' && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
								var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
								var len = optionsSelected.length;
								var itemPartNumber = COSTCO.Product.getPartnumber();
								var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
								var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
								$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
									$(this).removeClass("select-span1-OOS");
								});
								var status = '0';
								COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
								COSTCO.CMath.isErrorlocationControlleditem = true;
								//Following code for invoke batch API if we are switching upper level swatch/dropdown 
								if ($('div.buyinstoreonly.MuiBox-root').length > 0) {
									COSTCO.CMath.isWarehouseEnabled = true;
								} else {
									COSTCO.CMath.isWarehouseEnabled = false;
								}
								COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
							}
							//Check for coming soon flag
							COSTCO.Product.toggleDeliveryMoleculeOnComingSoon();
						} else {
							var _optionsSelected2 = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
							var len = _optionsSelected2.length;
							var lowerSwatch = $('#swatches-productOption0' + parseInt(len - 1) + '').length > 0;
							var lowerDropDown = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').length > 0;
							var itemPartNumber = COSTCO.Product.getPartnumber();
							COSTCO.CMath.isErrorlocationControlleditem = false;
							isRegionalPdtAvlble = data.invAvailable;
							COSTCO.CMath.invAvailableAjax = data.invAvailable;
							COSTCO.CMath.isWarehouseEnabled = data.isWarehouseEnabled;
							dispOnZeroInv = data.dispOnZeroInvtry;
							backordered = data.isBackOrdered;
							COSTCO.CMath.isBackOrderFlag = data.isBackOrdered;
							backorderMessage = data.backOrderMessage;
							COSTCO.CMath.invokeAjaxCall = true;
							COSTCO.CMath.isWioEnabled = data.isWioEnabled;
							COSTCO.CMath.isBopiwEnabled = data.isBopiwEnabled;
	
							//If the product coming soon and feature flags are false, do this
							if (!(Array.isArray(product) && product.length && product[0].isComingSoon && comingSoonFeatureFlag)) {
								if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
										$(this).removeClass("select-span1-OOS");
									});
									//Following code for invoke batch API if we are switching upper level swatch/dropdown 
									COSTCO.CMath.invokeBatchCallForUpperLevel(itemPartNumber);
								}
								if (isPDPVariantGreyOutEnabled == 'false') {
									if (!isRegionalPdtAvlble && dispOnZeroInv && !backordered) {
										var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
										$('#productImageOverlay').prepend(oosImgTag);
										$('.primary-clause').hide();
									} else {
										if (!$('#vendorName').val()) {
											$('.primary-clause').show();
										}
									}
								}
								if (!isRegionalPdtAvlble && !backordered && isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									var status = '0';
									COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
	
									//$('.primary-clause').show();
								} else {
									if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
										var status = '1';
										COSTCO.CMath.updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown);
	
										//Following code for remove css of previous selected swatches
										if (lowerSwatch) {
											// pills
											if (COSTCO.Product.item_type === 'multi_variant') {
												var len = _optionsSelected2.length;
												variable = $('input[value=' + _optionsSelected2[len - 1] + ']').next().attr("automation-id");
											} else if (COSTCO.Product.item_type === 'single_variant') {
												$('.selection-item').removeClass("select-span1-OOS");
												variable = $('input[value=' + _optionsSelected2[0] + ']').next().attr("automation-id");
											}
											$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
										} else if (lowerDropDown) {
											// lower level drop-down
											$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[len - 1] + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[len - 1] + ']').children("span").remove();
											COSTCO.CMath.update_selected_option_label(_optionsSelected2[len - 1]);
										}
										if ($('#swatches-productOption0' + parseInt(_optionsSelected2.length - 2) + '').length > 0) {
											COSTCO.Product.strikeUpperLevelVariant(_optionsSelected2);
										} else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 2) + ']').length > 0) {
											COSTCO.Product.grayOutUpperLevelDropDown(_optionsSelected2);
										}
									}
								}
								var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
								//For LocationControlledInventory Items 
								if (backordered && backorderMessage !== '') {
									$('#backorder-message').text(backorderMessage);
									$('#backorder-message').append('<span id="backordered"></span>');
									$('#backorder-message').show();
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.inv_backorderd);
									if (isRegionalPdt) {
										$('.primary-clause').hide(); //Added this for Depozipin hide this message in delivery molecule
									}
								} else {
									$('#backorder-message').hide();
									$('.edd-container').show();
									$('.online-price[data-catentry=' + catentryid + ']').data('inv', 'IN_STOCK');
									if (isRegionalPdtAvlble && !isEDDItem) {
										$('.primary-clause').show();
									}
								}
								//if inventory not available and display on zero inventory flag off show product not found view
	
								if (!isRegionalPdtAvlble && !dispOnZeroInv && phelper.item_type == 'single' && !isEDDItem) {
									COSTCO.Product.invokeInventoryBatchAPIcallforSingleitem(itemPartNumber);
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								//depozip in small pack edd msg hide
								if (!isRegionalPdtAvlble && isRegionalPdt && COSTCO.Product.isLocCtrlSmallPck) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
								}
								//Added this for Depozipin hide this message in delivery molecule
								if (!isRegionalPdtAvlble && isRegionalPdt && !isEDDItem) {
									$('.primary-clause').hide();
								}
								if (!isRegionalPdtAvlble && !isRegionalPdt) {
									$('.edd-container').hide();
									$('#edd-message-block').hide();
									$('.primary-clause').hide();
									COSTCO.CMath.siteControllOOS = true;
								} else {
									if (isEDDItem && !backordered) {
										$('.edd-container').show();
										$('#edd-message-block').show();
										if (!$('#vendorName').val()) {
											$('.primary-clause').show();
										}
									}
								}
								if (isPDPVariantGreyOutEnabled == 'true' && !scheduledDeliverable) {
									if (lowerSwatch) {
										var lowerLevelCount = $('#swatchesID-productOption0' + parseInt(_optionsSelected2.length - 1) + '').find('.selection-box-v2:visible').length;
										var lowerLevelOOSCount = $('#swatchesID-productOption0' + parseInt(_optionsSelected2.length - 1) + '').find('.span1-outofstock').length;
										if (lowerLevelCount === lowerLevelOOSCount) {
											COSTCO.Product.strikeUpperLevelVariant(_optionsSelected2);
										} else {
											var $selectedUpperLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 2) + ']');
											var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
											$selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
											var $selectedOOSOption = $('input[value=' + _optionsSelected2[_optionsSelected2.length - 2] + ']').next().attr("automation-id");
											$('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
											if (_optionsSelected2.length == 3) {
												var $selectedUpperLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 3) + ']');
												var $newValueWithoutOOS = $selectedUpperLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
												$selectedUpperLabel.find('.selectedOptionValue').text($newValueWithoutOOS);
	
												var $selectedOOSOption = $('input[value=' + _optionsSelected2[_optionsSelected2.length - 3] + ']').next().attr("automation-id");
												$('span[automation-id=' + $selectedOOSOption + ']').removeClass("span1-outofstock");
												$('span[automation-id=' + $selectedOOSOption + ']').removeClass("select-span1-OOS");
												$('span[automation-id=' + $selectedOOSOption + ']').children("p").remove();
											}
										}
									} else if (lowerDropDown) {
										var lowerLevelDropDownCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 1) + ']').find('option.opt:not(:disabled)').length;
										var lowerLevelDropDownOOSCount = $('.varis-v2[automation-id=varisSwatch_0' + parseInt(_optionsSelected2.length - 1) + ']').find('option.out-of-stock:not(:disabled)').length;
										if (lowerLevelDropDownCount === lowerLevelDropDownOOSCount) {
	
											if (!$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').hasClass('out-of-stock')) {
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').append('<span class="out-of-stock-text"></span>');
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
												$('.varis-v2 option[automation-id=varisOption_' + _optionsSelected2[_optionsSelected2.length - 2] + ']').addClass("out-of-stock");
												var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 2) + ']');
												var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
												if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
													//$selectedOptionValue.prepend('Out of Stock - ' );
													var textToReplace = $selectedOptionValue.text();
													var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
													$selectedOptionValue.text(newText);
													$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
												}
												$selectedOptionValue.show();
											}
										} else {
											var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 2) + ']');
											var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
											$dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
											var $dropDownOOSOption = $('.varis-v2 option[value=' + _optionsSelected2[_optionsSelected2.length - 2] + ']').attr("automation-id");
											$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
											if (_optionsSelected2.length == 3) {
												var $dropDownOptionLabel = $('label[for=productOption0' + parseInt(_optionsSelected2.length - 3) + ']');
												var $dropDownValueWithoutOOS = $dropDownOptionLabel.find('.selectedOptionValue').text().split(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)[0];
												$dropDownOptionLabel.find('.selectedOptionValue').text($dropDownValueWithoutOOS);
												var $dropDownOOSOption = $('.varis-v2 option[value=' + _optionsSelected2[_optionsSelected2.length - 3] + ']').attr("automation-id");
												$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').removeClass("out-of-stock");
												$('.varis-v2 option[automation-id=' + $dropDownOOSOption + ']').children(".out-of-stock-text").remove();
											}
										}
									}
									//For 3 level varaints in order to retain  top level strike when swaping between other top levels
									COSTCO.CMath.strikealllevelvariants();
								}
							}
							CMath.mathTableDisplayRules();
							CMath.showContractSpecificData(data);
						}
					}, fail: function fail(data) {
						//CMath.handleContractPriceAjaxFailure(data);
						console.log('ajax fail - will retry - count=' + retryCount);
						CMath.handleContractSpecificRules();
					}
				});
			},
			updateAjaxStockStatus: function updateAjaxStockStatus(status, itemPartNumber, lowerSwatch, lowerDropDown) {
				if (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant') {
					var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
					var len = optionsSelected.length;
					var uptitemarrayStatus = {};
					var uptvariantitemArray = {};
					if (COSTCO.CMath.variantJSON.length > 0) {
						for (var i in COSTCO.CMath.variantJSON) {
							var val = COSTCO.CMath.variantJSON[i];
							for (var j in val) {
								var sub_key = j;
								var sub_val = val[j];
								if (sub_key == itemPartNumber) {
									uptitemarrayStatus["OL"] = status;
									uptitemarrayStatus["WH"] = sub_val.WH;
									uptvariantitemArray[itemPartNumber] = uptitemarrayStatus;
									COSTCO.CMath.variantJSON[i] = uptvariantitemArray;
									localStorage.setItem('variantStatus', JSON.stringify(COSTCO.CMath.variantJSON));
								}
							}
						}
						for (var i in COSTCO.CMath.variantJSON) {
							var val = COSTCO.CMath.variantJSON[i];
							for (var j in val) {
								var sub_key = j;
								var sub_val = val[j];
								if (sub_key == itemPartNumber) {
									if (status == '0' && sub_val.WH == '0') {
										if (COSTCO.Product.item_type === 'multi_variant') {
											if (lowerSwatch) {
												COSTCO.CMath.ajaxStrikeSwatches();
											} else if (lowerDropDown) {
												COSTCO.CMath.ajaxGrayOutDropDown();
											}
										} else if (COSTCO.Product.item_type === 'single_variant') {
											if ($('#swatches-productOption00').length > 0) {
												COSTCO.CMath.ajaxStrikeSwatches();
											} else if ($('.varis-v2[data-product=0]').length > 0) {
												COSTCO.CMath.ajaxGrayOutDropDown();
											}
										}
									} else {
										//Following code for remove css of previous selected swatches
	
										if (lowerSwatch) {
											// pills
											if (COSTCO.Product.item_type === 'multi_variant') {
	
												variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
											} else if (COSTCO.Product.item_type === 'single_variant') {
												$('.selection-item').removeClass("select-span1-OOS");
												variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
											}
											$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
											$('span[automation-id=' + variable + ']').removeClass("span1-outofstock");
											$('span[automation-id=' + variable + ']').children("p").remove(); // for removing P tag
										} else if (lowerDropDown) {
											// lower level drop-down
											$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').removeClass("out-of-stock");
											$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').children("span").remove();
										}
										COSTCO.CMath.update_selected_option_label(optionsSelected[len - 1]);
									}
									if ($('#swatches-productOption0' + parseInt(optionsSelected.length - 2) + '').length > 0) {
										COSTCO.Product.strikeUpperLevelVariant(optionsSelected);
									} else if ($('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').length > 0) {
										COSTCO.Product.grayOutUpperLevelDropDown(optionsSelected);
									}
								}
							}
						}
					}
				}
			},
			invokeBatchCallForUpperLevel: function invokeBatchCallForUpperLevel(itemPartNumber) {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				if (COSTCO.CMath.pdpPageloadComplete) {
					var invokeBatchAPICall = true;
					for (var i in COSTCO.CMath.variantJSON) {
	
						var val = COSTCO.CMath.variantJSON[i];
						for (var j in val) {
							var sub_key = j;
							if (sub_key == itemPartNumber) {
								invokeBatchAPICall = false;
							}
						}
					}
	
					for (var i = 0; i < optionsSelected.length; i++) {
						if (optionsSelected[i] != COSTCO.CMath.selectedswatches[i] && i != optionsSelected.length - 1) {
							COSTCO.CMath.invokebatchCall = true;
							break;
						}
					}
					var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
					if (COSTCO.CMath.invokebatchCall && !scheduledDeliverable && (COSTCO.Product.item_type === 'multi_variant' || COSTCO.Product.item_type === 'single_variant')) {
						$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
						$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').hide();
						$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
						$('#swatches-productOption0' + parseInt(len - 2) + ' .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("select-span1-OOS");
						});
						$('#swatches-productOption00 .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("select-span1-OOS");
						});
						$('.varis-v2[automation-id=varisSwatch_0' + parseInt(len - 1) + ']').find('option.opt:not(:disabled)').each(function () {
							$(this).removeClass("out-of-stock");
							$(this).children("span").remove();
							CMath.update_selected_option_label(optionsSelected[len - 1]);
						});
						$('#swatches-productOption0' + parseInt(len - 1) + ' .selection-box-v2').find('span.selection-item').each(function () {
							$(this).removeClass("span1-outofstock");
							$(this).children("p").remove(); // for removing P
							// tag;
							CMath.update_selected_option_label(optionsSelected[len - 1]);
						});
	
						COSTCO.Product.findOOSitem(invokeBatchAPICall);
					}
				}
			},
			ajaxStrikeSwatches: function ajaxStrikeSwatches() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
	
				// $('.selection-item').removeClass("select-span1-OOS");
	
				variable = $('input[value=' + optionsSelected[len - 1] + ']').next().attr("automation-id");
				if ($("input[automation-id='variationOptions_" + optionsSelected[len - 1] + "']:checked").length) {
					//if($('span[automation-id='+variable+']').attr('aria-checked') === 'true'){
					$('span[automation-id=' + variable + ']').addClass("select-span1-OOS");
					//folowing  code for appending OOS label in lower level
					COSTCO.Product.appendLabelSwatches(len - 1);
				} else {
	
					$('span[automation-id=' + variable + ']').removeClass("select-span1-OOS");
				}
				if (!$('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
					$('span[automation-id=' + variable + ']').addClass("span1-outofstock");
				} else {
					if (!$('span[automation-id=' + variable + ']').children('p').length) {
						$('span[automation-id=' + variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
						$('span[automation-id=' + variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					}
				}
			},
			ajaxGrayOutDropDown: function ajaxGrayOutDropDown() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
	
				if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').hasClass('out-of-stock')) {
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').append('<span class="out-of-stock-text"></span>');
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 1] + ']').addClass("out-of-stock");
					var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 1) + ']');
					var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
					if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
						var textToReplace = $selectedOptionValue.text();
						var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
						$selectedOptionValue.text(newText);
						$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
					}
					$selectedOptionValue.show();
				}
			},
			callAjaxBundleInventory: function callAjaxBundleInventory(productId, itemId, count, size) {
	
				var catentryid = itemId;
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var whParam = COSTCO.LWSearch.getRegionalLocations();
				var warehouse = COSTCO.LWSearch.fetchWarehouseCookieVal('nearestWarehouse');
				var signedIn = false;
				backordered = false;
				initalizeAjaxCall = true;
				var backorderMessage = '';
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				COSTCO.util.ajax({
					url: '/AjaxGetInventoryDetail',
					method: 'GET',
					async: false,
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(itemId),
						catalogId: wcs.catalogId,
						productId: productId,
						WH: whParam,
						warehouse: warehouse,
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
						if (data.errorMessageKey) {
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
						} else {
							isRegionalPdtAvlble = data.invAvailable;
							dispOnZeroInv = data.dispOnZeroInvtry;
							backordered = data.isBackOrdered;
							backorderMessage = data.backOrderMessage;
							if (isPDPVariantGreyOutEnabled == 'false') {
								if (!isRegionalPdtAvlble && dispOnZeroInv && !backordered) {
									var oosImgTag = COSTCO.util.tmpl('tmpl_oos_overlay_img');
									$('#productImageOverlay').prepend(oosImgTag);
									$('.primary-clause').hide();
								} else {
									if (!$('#vendorName').val()) {
										$('.primary-clause').show();
									}
								}
							} else {
	
								if (!$('#vendorName').val()) {
									$('.primary-clause').show();
								}
							}
							var isEDDItem = $('#liveEDD').length > 0 && $('#liveEDD').val() === 'true';
							//For LocationControlledInventory Items 
							if (backordered && backorderMessage !== '') {
								$('#backorder-message').text(backorderMessage);
								$('#backorder-message').append('<span id="backordered"></span>');
								$('#backorder-message').show();
								$('.edd-container').hide();
								$('#edd-message-block').hide();
								$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.inv_backorderd);
							} else {
								$('#backorder-message').hide();
								$('.edd-container').show();
								$('.online-price[data-catentry=' + catentryid + ']').data('inv', 'IN_STOCK');
								if (isRegionalPdtAvlble && !isEDDItem) {
									$('.primary-clause').show();
								}
							}
							CMath.mathTableDisplayRules();
							CMath.showBundleSpecificData(data, count, size);
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
			/**Iterate bundle items in order to invoke ajaxgetcontract price **/
			showBundleSpecificData: function showBundleSpecificData(data, count, size) {
				var productOnlinePrice = parseFloat(0.00).toFixed(2);
				var catentryid = data.itemId;
				var pricePerUnit = "";
				var dispOnZeroInv = true;
				var isFrozenItem = $('#isFrozenItem').val();
				var isBundleItem = $('#bundleItem').val();
				var signedIn = false;
				signedIn = COSTCO.util.getMemberCookie().signedIn;
				isRegionalPdt = COSTCO.util.islocationControlledInventoryFlow();
				isRegionalPdtAvlble = false;
				blockContractAjax = false;
				$('#product-page').addClass('ajax-busy');
				//Call AJAX to get the contract prices of the given item
				COSTCO.util.ajax({
					url: '/AjaxGetContractPrice',
					method: 'GET',
					dataType: 'json',
					data: {
						itemId: encodeURIComponent(data.itemId),
						catalogId: wcs.catalogId,
						productId: data.productId[0],
						isFrozenItem: isFrozenItem,
						isRegionalPdt: isRegionalPdt,
						isBundleItem: isBundleItem
	
					},
					done: function done(data, textStatus, jqXHR, options) {
						$('#product-page').removeClass('ajax-busy');
	
						CMath.showBreakdown(false);
						if (data.errorMessageKey) {
							//setUp2DayErrorPage with zip code overlay
							if (data.errorMessageKey == 'ERR_2DAY_PRICE_INVALID') {
								CMath.handleContractPriceAjaxFailure(data);
							} else {
								CMath.setUp2DayErrorPage();
								if (!signedIn) {
									$('.view-zip-signin').removeClass('hide');
								}
								$('.grocery-zip-form').removeClass('hide');
								$('.your-price .value').text('- -.- -');
								$('.unitcurrency').text('$-.- -');
								$('.math-table').show();
								$('#price-per-unit-container').show();
								//Paint the error message on the zip code overlay
								if (data.errorMessageKey != 'ERR_ZIP_NOTVALID') {
									$('.alert-notification').empty();
									$('.critical-notification').empty();
									var error = COSTCO.util.get_decoded_html(data.errorMessage);
	
									if (data.errorMessageKey != 'ERR_2DAY_NOT_AVAILABLE' && data.errorMessageKey != 'ERR_2DAY_ITEM_UNAVAILABLE' && data.errorMessageKey != 'ERR_LOCATIONCONTROLLED_ITEM_UNAVAILABLE') {
										error = error.replace(/[0-9]*\./, $.cookie('invCheckPostalCode') + '.');
									}
									CMath.addBorderToShipItMolecule('default');
									$('.alert-notification').append(error);
									$('.alert-notification').removeClass('hide');
									$('.critical-notification').addClass('hide');
								}
							}
							$('.online-price[data-catentry=' + catentryid + ']').data('inv', COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail);
							$('.edd-container').hide();
							$('#edd-message-block').hide();
							$('#backorder-message').hide();
						} else {
							//Added logic to retrive minimumItemPrice for bundle
							bundlePriceMap.set(data.itemId, data.finalOnlinePrice);
							if (count + 1 == size) {
								var minItemPrice = data.finalOnlinePrice;
								bundlePriceMap.forEach(function (values, keys) {
									var currentPrice = values;
									if (currentPrice < minItemPrice) minItemPrice = currentPrice.toString();
								});
								$('#starting-bundle-price').text('$' + phelper.formatMoney(phelper.processPrice(minItemPrice)));
							}
							productOnlinePrice = data.finalOnlinePrice;
							pricePerUnit = data.pricePerUnit;
							$('#bundle-info-container[data-product=' + count + '] .price span').text('$' + phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
							discount = data.discount;
							catentryid = data.itemId;
							//if there exists value for price
							if (typeof productOnlinePrice !== 'undefined' && !isNaN(productOnlinePrice)) {
								//if there exists value for discount, show discount node
								//Paint the contract price on PDP and encode the final item price to PDP page
								$('.online-price[data-catentry=' + catentryid + '] .op-value').text(phelper.formatMoney(phelper.processPrice(productOnlinePrice)));
								$('.online-price[data-catentry=' + catentryid + ']').data('opvalue', COSTCO.util.encode(productOnlinePrice + ''));
								$('#price-per-unit-container').addClass('hide');
								//Handle other render events - 
								//Rules to hide/show UI elements , based on bussines requirement -
								//This will only be executed after Successfull price update.
								//CMath.pricingInfo($('.online-price[data-catentry='+catentryid+']').data('catentry'));		        			
							}
						}
					}, fail: function fail(data) {
						CMath.handleContractPriceAjaxFailure(data);
					}
				});
			},
	
			/**
	   * Handles Ajax failure scenario, painting the refresh button and 
	   * critical error message.
	   */
			handleContractPriceAjaxFailure: function handleContractPriceAjaxFailure(data) {
				CMath.setUp2DayErrorPage();
				//Hide prices and show Refresh Item Details button with error message
				$('#price-per-unit-container').addClass('hide');
				$('#product-page').removeClass('ajax-busy');
				$priceSection = $('#productPriceSection');
				$priceSection.hide();
				$('.product-interaction').hide();
				$('#refreshSection').removeClass('hide');
				$("#RefreshBtn").attr("disabled", false);
				if (retryCount == retryLimit) {
					$('div#criticalMsg1').removeClass('hide');
					$('button#RefreshBtn').addClass('hide');
				}
			},
			/**
	   * Performs string manipulations to extract warehouse number from warehouse cookie
	   * based on catalog type.
	   */
			fetchWarehouseCookieVal: function fetchWarehouseCookieVal(catalogType) {
				var result = $('#defWHCookieVal').val();
				var warehouseCookie = $.cookie('WAREHOUSEDELIVERY_WHS');
				if (warehouseCookie != null && warehouseCookie != '') {
					var cookieArray = warehouseCookie.split(',');
					for (index in cookieArray) {
						var cookieVal = cookieArray[index];
						if (cookieVal.toLowerCase().includes(catalogType.toLowerCase())) {
							result = cookieVal.split('=').length == 2 ? cookieVal.split('=')[1] : $('#defWHCookieVal').val();
						}
					}
				}
				return result;
			},
			//Grocery US change - Depot Catalog Online - Should not show espots, discount, fee in case of errors
			setUp2DayErrorPage: function setUp2DayErrorPage() {
				$functionalElements = $('.grocery-espot-class,.marketing-container,.delivery-fee');
				$functionalElements.remove();
			},
			//Rule to invoke Ajax call for contract specific data
			isContractSpecificAjaxRequired: function isContractSpecificAjaxRequired() {
				return COSTCO.util.isDepotCatalogEnabled() && (COSTCO.util.islocationControlledInventoryFlow() || COSTCO.util.issiteControlledInventoryFlow()) && !blockContractAjax;
			},
			//Hide functional elements before ajax
			hideElementsBeforeAjax: function hideElementsBeforeAjax() {
				$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty,#price-per-unit-container');
				$functionalElements.hide();
				$('.grocery-zip-form').addClass('hide');
			},
			//Show Availability for regional items
			showLocationControlledInventoryItemsAvailability: function showLocationControlledInventoryItemsAvailability() {
				var targetedCartBehaviour = $('#targetedCartBehaviour').val() === "Membership" ? true : false;
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				if (scheduledDeliverable) {
					$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty');
				} else {
					$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty');
				}
				if (!targetedCartBehaviour && !scheduledDeliverable) {
					if (retryCount <= retryLimit && isRegionalPdtAvlble) {
						//Basically , changes to show the PDP as OOS INSTOCK , based on AJAX response ie , based on contract is done here .
						//Here changes are made to handle the pdt image and add to cart section , when the product is made INSTOCK for the customer selected
						//zipcode (ffm center based on zip code)
						var atcMsg = messages.ADDTOCART;
						$('img.oos-overlay').addClass("hide");
						$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
						$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
						$functionalElements.show();
					} else if (retryCount <= retryLimit && !isRegionalPdtAvlble) {
						//Basically , changes to show the PDP as OOS(Out of Stock) , based on AJAX response ie , based on contract is done here .
						//Here changes are made to handle the pdt image and add to cart section , when the product is made OOS for the customer selected
						//zipcode (ffm center based on zip code)
						if (backordered) {
							var atcMsg = messages.ADDTOCART;
							$('img.oos-overlay').addClass("hide");
							$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
							$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
							$functionalElements.show();
						} else {
							var oosMsg = messages.ADDTOCART_OUTOFSTOCK;
							$functionalElements.show();
							$('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
							if (isPDPVariantGreyOutEnabled == 'false') {
								$('img.oos-overlay').removeClass("hide");
							}
							$("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");
							$('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
						}
					}
				} else {
					$functionalElements.show();
				}
				this.showSelectedOptions();
			},
	
	
			strikealllevelvariants: function strikealllevelvariants() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var len = optionsSelected.length;
				var itemCount = 0,
				    oosCount = 0;
				if (COSTCO.Product.item_type === 'multi_variant' && optionsSelected.length == 3) {
					for (var i = 0; i < product.length; i++) {
						for (var j = 0; j < products[i].length; j++) {
							var itemId = products[i][j].partNumber;
							if (products[i][j].options.includes(optionsSelected[0])) {
								itemCount++;
								for (var k in COSTCO.CMath.variantJSON) {
									var val = COSTCO.CMath.variantJSON[k];
									for (var l in val) {
										var sub_key = l;
										var sub_val = val[l];
										if (sub_key == itemId && sub_val.OL == '0' && sub_val.WH == '0') {
											oosCount++;
										}
									}
								}
							}
						}
						if (oosCount == itemCount) {
							$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 2) + '').find('.selection-box-v2:visible').each(function () {
								if (!$(this).find('span.selection-item').hasClass('span1-outofstock')) {
									$(this).find('span.selection-item').addClass("span1-outofstock");
									if (!$(this).find('span.selection-item').children('p').length) {
										$(this).find('span.selection-item').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
										$(this).find('span.selection-item').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
									}
								}
							});
							variable = $('input[value=' + optionsSelected[0] + ']').next().attr("automation-id");
							if (!$('span[automation-id=' + variable + ']').hasClass('span1-outofstock')) {
								$('span[automation-id=' + variable + ']').addClass("span1-outofstock");
								if (!$('span[automation-id=' + variable + ']').children('p').length) {
									$('span[automation-id=' + variable + ']').append('<p class="p-outofstock"><span class="sr-only"></span></p>');
									$('span[automation-id=' + variable + ']').find('.p-outofstock span.sr-only').text(' ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								}
							}
							COSTCO.Product.appendLabelSwatches(len - 3);
							$('.varis-v2[automation-id=varisSwatch_0' + parseInt(optionsSelected.length - 2) + ']').find('option.opt:not(:disabled)').each(function () {
								if (!$(this).hasClass('out-of-stock')) {
									$(this).append('<span class="out-of-stock-text"></span>');
									$(this).find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
									$(this).addClass("out-of-stock");
								}
							});
							if (!$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').hasClass('out-of-stock')) {
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').append('<span class="out-of-stock-text"></span>');
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').find('.out-of-stock-text').text('  ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								$('.varis-v2 option[automation-id=varisOption_' + optionsSelected[len - 3] + ']').addClass("out-of-stock");
								var $selectedOptionLabel = $('label[for=productOption0' + parseInt(len - 3) + ']');
								var $selectedOptionValue = $selectedOptionLabel.find('.selectedOptionValue');
								if (!$selectedOptionValue.text().includes(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT)) {
									var textToReplace = $selectedOptionValue.text();
									var newText = textToReplace.replace(messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT, "");
									$selectedOptionValue.text(newText);
									$selectedOptionValue.append(' - ' + messages.PDETAIL_IMAGE_OUT_OF_STOCK_ALT);
								}
								$selectedOptionValue.show();
							}
						}
					}
				}
			},
	
			// Rules to hide/show the math-table / price-breakdown based on business requirements. 
			mathTableDisplayRules: function mathTableDisplayRules() {
				var status = COSTCO.TOBACCO.userMemberInfo(),
				    hasLicense = status.hasLicense != 'undefined' ? status.hasLicense : false;
				var userInfo = COSTCO.util.getMemberCookie(),
				    signedIn = userInfo.signedIn,
				    costcoMember = userInfo.costcoMember != 'undefined' ? userInfo.costcoMember : false,
				    isCostcoMembers = costcoMember;
				isUserSignedIn = signedIn;
				memberOnly = $('#memberItem').val() == "true" ? true : false, mapItem = $('#mapItem').val() == "true" ? true : false, tobaccoProduct = $('#tobaccoProduct').val() == "true" ? true : false, inStock = $('#outOfStock').val() == "true" ? true : false, $functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#add-to-cart,#qty,#price-per-unit-container');
				$functionalElementsTob = $('#qty-decrement,#qty-input,#qty-increment,#variants,#add-to-cart,#qty');
	
				var $signInToBuy = costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('.sign-in-to-buy') : $('#sign-in-to-buy');
	
				var validated = userInfo.validated;
				var verified = userInfo.verified;
				var memberActive = userInfo.active;
				blockContractAjax = false;
	
				$('#link-membership').hide();
				$('#link-membership-v2').hide();
				$('#purchase-membership').hide();
				$('#renew-membership').hide();
				$('.mem-button').hide();
				var zipcode = $.cookie('WC_BD_ZIP');
				var appType = $('#applicationType').val();
				if (zipcode != '' && zipcode != null || appType == 'BC') {
					$('.social-share-link').show();
				} else {
					$('.social-share-link').hide();
				}
				if (isRegionalPdt) {
					COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
				} else if (mapItem && !memberOnly) {
					// map item
					if (signedIn && costcoMember) {
						$functionalElements.show();
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						this.showSelectedOptions();
					} else if (!signedIn && !costcoMember) {
						$functionalElements.hide();
						blockContractAjax = true;
					} else if (signedIn && !costcoMember) {
						$functionalElements.hide();
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						$('#add-to-cart-map').show();
						this.showSelectedOptions();
						blockContractAjax = true;
					} else if (!signedIn && costcoMember) {
						$('#sign-in-for-details').hide();
						$signInToBuy.hide();
						$('#sign-in-to-buy-v2').hide();
						blockContractAjax = true;
					}
				} else if (tobaccoProduct) {
					// tobacco product 
					if (signedIn) {
						$('#sign-in-for-details').hide();
						$('#yellow-alert').show();
						if (inStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
								document.getElementById('add-to-cart-btn').disabled = false;
							} else {
								if (hasLicense) {
									document.getElementById('add-to-cart-btn').disabled = false;
								} else {
									document.getElementById('add-to-cart-btn').disabled = true;
								}
							}
						}
					} else {
						var zipcode = $.cookie('WC_BD_ZIP');
						if (zipcode != '' || zipcode != null) {
							$functionalElementsTob.hide();
							$('#sign-in-for-details').show();
						}
					}
				} else if (memberOnly) {
					// member only item
					$('#prod-page-delivery').removeClass('hide');
					if (!signedIn) {
						var rememberedShowMemberItem = $.cookie('rememberedShowMemberItem');
						if (typeof rememberedShowMemberItem !== 'undefined' && rememberedShowMemberItem !== null) {
							$('#sign-in-to-buy, .mem-button').hide();
							$('#price-per-unit-container').removeClass('hide');
							this.showSelectedOptions();
							$('#sign-in-to-buy-v2, .sign-in-to-buy').hide();
							$('.sign-in-to-buy').removeClass('interaction-element');
						} else {
							$functionalElements.hide();
							$('.mem-button').hide();
							$signInToBuy.show();
							if (COSTCO.CMath.iskitsbundle) {
								$('#bundle-button-container').hide();
							}
							$('#sign-in-to-buy-v2').show();
							if ($('#scheduledDeliverable').val() === 'true') {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && !COSTCO.CMath.iskitsbundle) {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if ($('#edd-form-block').length > 0 && !$('#edd-form-block').hasClass('hidden') && COSTCO.CMath.iskitsbundle && !inStock) {
								$('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							blockContractAjax = true;
						}
					} else {
						if (costcoMember) {
							if (validated || verified) {
								$signInToBuy.hide();
								$('.mem-button').hide();
								$('#sign-in-to-buy-v2').hide();
								$('#price-per-unit-container').removeClass("hide");
								if (memberActive) {
									this.showSelectedOptions();
									var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
									if ($('#isBDAppVar').val() != 'BD' && !scheduledDeliverable) {
										var atcMsg = messages.ADDTOCART;
										$('img.oos-overlay').addClass("hide");
										$("input[type='button'][name='add-to-cart']").attr("disabled", false).val(atcMsg).attr("disabled", false).removeClass("out-of-stock");
										$('li#add-to-cart,li#add-to-cart-map').val(atcMsg).removeClass("out-of-stock");
										$functionalElements.show();
										if (initalizeAjaxCall && !isRegionalPdtAvlble && !backordered) {
											var oosMsg = messages.ADDTOCART_OUTOFSTOCK;
											$('#qty-decrement,#qty-input,#qty-increment,#qty').hide();
											if (isPDPVariantGreyOutEnabled == 'false') {
												$('img.oos-overlay').removeClass("hide");
											}
											$("input[type='button'][name='add-to-cart']").attr("disabled", true).val(oosMsg).attr("disabled", true).addClass("out-of-stock");
											$('li#add-to-cart,li#add-to-cart-map').val(oosMsg).addClass("out-of-stock");
										}
									} else if ($('#isBDAppVar').val() != 'BD' && scheduledDeliverable) {
										$functionalElements = $('.math-table,#taxable-item,#qty-decrement,#qty-input,#qty-increment,#qty,#price-per-unit-container');
										$functionalElements.show();
									}
								} else {
									$functionalElements.hide();
									if (COSTCO.CMath.iskitsbundle) {
										$('#bundle-button-container').hide();
									}
									$('#renew-membership').show();
									blockContractAjax = true;
								}
							} else {
								$functionalElements.hide();
								$('.mem-button').hide();
								$signInToBuy.hide();
								$('#sign-in-to-buy-v2').hide();
								$('#link-membership').show();
								$('#link-membership-v2').show();
								$('#purchase-membership').show();
								if (COSTCO.CMath.iskitsbundle) {
									$('#bundle-button-container').hide();
								}
								blockContractAjax = true;
							}
						} else {
							$functionalElements.hide();
							$signInToBuy.hide();
							$('#sign-in-to-buy-v2').hide();
							$('#link-membership').show();
							$('#link-membership-v2').show();
							$('#purchase-membership').show();
							if ($('#scheduledDeliverable').val() === 'true') {
								$('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
							}
							if (COSTCO.CMath.iskitsbundle) {
								$('#bundle-button-container').hide();
							}
							blockContractAjax = true;
						}
					}
				} else if ($('#isBDAppVar').val() != 'BD' && !isRegionalPdt && initalizeAjaxCall) {
					COSTCO.CMath.showLocationControlledInventoryItemsAvailability();
				} else {
					if (($('#isBDAppVar').val() == 'BD' || !initalizeAjaxCall) && !isRegionalPdt) {
						$functionalElements.show();
					}
					this.showSelectedOptions();
				}
				if ($('#isBDAppVar').val() == 'BD' && $('#edd-form-block').length > 0 && !isRegionalPdt) {
					$('#add-to-cart-btn').attr("disabled", true);
				}
				if ($('.oos-notify-me-v2').length == 0) {
					$('#ctas').removeClass('hide');
				}
				//Call this method to change border color of ShipIt molecule in BC flow
				CMath.addBorderToShipItMolecule();
			},
			/**This function is called only in BC flow to change the 
	   * border color of ShipIt Molecule to green when item available and border is deemphasized when item out of stock   
	   */
			addBorderToShipItMolecule: function addBorderToShipItMolecule(border) {
				if ('BC' === $('#applicationType').val()) {
					if (typeof border === 'undefined' && $('#add-to-cart').is(':visible')) {
						var atc = document.getElementById('add-to-cart-btn');
						if (null != atc) border = document.getElementById('add-to-cart-btn').disabled ? 'outOfStock' : 'available';
					}
					switch (border) {
						case 'available':
							$('.product-interaction').addClass('delivery-mol-border-green');
							break;
						case 'outOfStock':
							$('.product-interaction').removeClass('delivery-mol-border-green');
							$('.product-interaction').addClass('delivery-border');
							break;
						default:
							$('.product-interaction').removeClass('delivery-mol-border-green');
							$('.product-interaction').removeClass('delivery-border');
					}
				}
			},
			/**
	  * This function is called when a swatch color tile is clicked and
	  * the Rich FX event is triggered for switching colors.
	  * During the event, Rich FX calls RMActiveColor, which contains this function.
	  * We need to select the corresponding value in our Select element
	  * and mimick a normal varis selection.
	  */
			triggerSwatchTilesSelection: function triggerSwatchTilesSelection(activeColor, activeElement) {
	
				var preselectAttrsStr = COSTCO.util.getParameterByName('preselect');
				var swatchMode = $('.swatchDropdown').data('swatch-mode');
				if (!initSwatch && typeof preselectAttrsStr !== 'undefined' && preselectAttrsStr != null && preselectAttrsStr != 'null' && preselectAttrsStr.length > 0 && typeof swatchMode !== 'undefined' && swatchMode == 2) {
					initSwatch = true;
					var preselectattr = preselectAttrsStr.split(':').length > 1 ? preselectAttrsStr.split(':')[1] : activeColor;
					$('#productOption00 option.opt').each(function () {
						if ($(this).text().toLowerCase() == preselectattr || $(this).data('swatch') == preselectattr) {
							$(this)[0].selected = true;
							activeColor = preselectattr;
							console.log('Selecting preselect of ' + preselectattr);
							CMath.updateSwatchToPreselect(preselectattr.split(' ').join(''));
						}
					});
				}
	
				activeColor = DOMPurify.sanitize(activeColor);
				var $swatchElement = $('[data-swatch=' + activeColor + ']');
				$swatchElement.prop('selected', true);
				if (COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor) {
					COSTCO.CMath.swatchActiveColor = activeColor;
					COSTCO.CMath.swatchTileSelected = true;
				} else if (!COSTCO.CMath.swatchInitialTileSelected && activeColor == COSTCO.CMath.swatchActiveColor) {
					COSTCO.CMath.swatchTileSelected = false;
				}
				if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
					CMath.redirectPDP();
				} else {
					$swatchElement.trigger('change.vari');
				}
	
				var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
					if ($(option).text().includes(messages.BACKORDER_TEXT)) {
						var sliceStr = ' - ' + messages.BACKORDER_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
						var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(' -')) {
						return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else {
						return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					}
				});
				var colorNameTitle = $.map(colorsNames, function (value) {
					if (value.includes(' -' + activeColor + '-')) {
						return value.slice(0, value.indexOf(' -' + activeColor + '-'));
					}
				});
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
					var colorNameSpan = document.createElement("SPAN");
					$(colorNameSpan).text(messages.COLOR + ': ' + colorNameTitle);
					$(colorNameSpan).addClass('bold');
	
					$('label[for="theSwatches"]').html(colorNameSpan);
					$('label[for="pdpSwatches"]').html(colorNameSpan);
				} else {
					$('label', '#variants .variantContainer').first().text(messages.COLOR + ': ' + colorNameTitle);
				}
	
				$('img', '#theSwatches').each(function () {
					var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
					if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
						var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
						if (itemDescriptionArray.length == 2) {
							if (typeof $(this).parent().find('#selectedOffScreenSwatch') !== 'undefined') {
								$(this).parent().find('#selectedOffScreenSwatch').each(function () {
									$(this).remove();
								});
							}
							if (itemDescriptionArray[1].toLowerCase() === activeColor) {
								$(this).parent().prepend('<span id="selectedOffScreenSwatch" class="offscreen">Selected</span>');
							}
						}
					}
				});
			},
	
			updateSwatchToPreselect: function updateSwatchToPreselect(color) {
				$('.RICHFXColorChangeLink span').each(function () {
					var swatchIdx = $(this).html().indexOf(' ' + color);
					if (swatchIdx >= 0 && $(this).html().substr(swatchIdx + 1) == color) {
						$(this).next().click();
					}
				});
			},
	
			runRMAActiveColor: function runRMAActiveColor(event, color) {
				if (event.keyCode == 13) {
					event.preventDefault();
					console.log("Pressed enter key with color : " + color);
					// The space at the beginning is added so blue won't match against lightblue.
					CMath.updateSwatchToPreselect(color);
				}
			},
	
			/**
	   * This function is called to  the stock availability using the response from the GE webservice. 
	   * Adding the 'X' on the swatch and making it disabled. Also reseting it when we re call the service. 
	   * We're using '-' as delimiter for the swatch code and swatch description and inventory status and if price added than that too..
	   *  
	   */
			updateGEStockAvailability: function updateGEStockAvailability() {
				var colorsNames = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
					if ($(option).text().includes(messages.BACKORDER_TEXT)) {
						var sliceStr = ' - ' + messages.BACKORDER_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
						var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
						return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else if ($(option).text().includes(' -')) {
						return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					} else {
						return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
					}
				});
				//span.RICHFXColorChangeSwatchName has the name in format '1 colorname' to we split it on space and on index 1 we get colorname.
				//and for french also , the colorname from RICHFX is also same. 
	
				$('[data-attr-name="Color"]', '.swatchDropdown').each(function () {
					var swatchElement = $(this)[0];
					if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
						var color = $(swatchElement).data('swatch').trim().toLowerCase();
						var colorNameTitle = $.map(colorsNames, function (value) {
							if (value.includes(' -' + color + '-')) {
								return value.slice(0, value.indexOf(' -' + color + '-'));
							}
						});
	
						var colorsOutStock = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
							if ($(option).data('swatch') === color) {
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
										if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
											if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
												var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(optionText);
											}
											if (!$(option).text().includes(messages.BACKORDER_TEXT)) {
												var message = $(option).text() + ' - ' + messages.BACKORDER_TEXT;
												$(option).text(message);
											}
										}
										if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
											if ($(option).text().includes(messages.BACKORDER_TEXT)) {
												var sliceStr = ' - ' + messages.BACKORDER_TEXT;
												var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(optionText);
											}
											if (!$(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var message = $(option).text() + ' - ' + messages.OUT_OF_STOCK_TEXT;
												$(option).text(message);
											}
											$(option).attr("disabled", "disabled");
											return $(option).data('swatch').trim().toLowerCase();
										}
									}
								}
							}
						});
						var colorsInStock = $.map($('[data-attr-name="Color"]', '.swatchDropdown'), function (option) {
							if ($(option).data('swatch') === color) {
								for (var i = 0; i < products[0].length; i++) {
									if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
										if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled") {
											$(option).removeAttr("disabled");
											if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
												var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
												var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(message);
											} else if ($(option).text().includes(messages.BACKORDER_TEXT)) {
												var sliceStr = ' - ' + messages.BACKORDER_TEXT;
												var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
												$(option).text(message);
											}
											return $(option).data('swatch').trim().toLowerCase();
										}
									}
								}
							}
						});
	
						$('img', '#theSwatches').each(function () {
							var swatchElement = $(this).siblings('span.RICHFXColorChangeSwatchName')[0];
							if (typeof swatchElement !== 'undefined' && swatchElement !== null) {
								var itemDescriptionArray = $(swatchElement)[0].innerHTML.split(" ");
								if (itemDescriptionArray.length == 2 && itemDescriptionArray[1].toLowerCase() === color) {
									if (colorsOutStock[0] === color && !$(this).parent().hasClass('disabledSwatch')) {
										$(this).parent().addClass('disabledSwatch');
										if (color == 'white') {
											$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
										} else {
											$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
										}
										$(this).parent().get(0).setAttribute("tabindex", "-1");
										$(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" tabindex="0" data-toggle="popover" data-html="true" data-content="' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
										$(this).parent().prepend('<span class="offscreen">' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '</span>');
	
										$(this).parent().get(0).removeAttribute("data-sort");
										$(this).parent().get(0).removeAttribute("data-content");
										$(this).parent().get(0).removeAttribute("data-placement");
										$(this).parent().get(0).removeAttribute("data-trigger");
										$(this).parent().get(0).removeAttribute("data-toggle");
	
										$(this).parent().get(0).removeAttribute("aria-expanded");
										$(this).parent().get(0).removeAttribute("aria-haspopup");
										$(this).parent().get(0).removeAttribute("data-original-title");
										$(this).parent().get(0).removeAttribute("role");
										$(this).parent().get(0).removeAttribute("title");
	
										$(this).parent().get(0).removeAttribute("data-html");
										$(this).parent().get(0).classList.remove("swatch-help");
									}
									if (colorsInStock[0] === color && $(this).parent().hasClass('disabledSwatch')) {
	
										$(this).parent().removeClass('disabledSwatch');
	
										$(this).siblings('img.disableOverlaySwatch').remove();
										$(this).siblings('span.offscreen').remove();
	
										$(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
										$(this).parent().get(0).removeAttribute("tabindex");
										$(this).parent().get(0).setAttribute("data-content", colorNameTitle);
										$(this).parent().get(0).setAttribute("data-placement", "bottom");
										$(this).parent().get(0).setAttribute("data-trigger", "focus hover");
										$(this).parent().get(0).setAttribute("data-toggle", "popover");
										$(this).parent().get(0).setAttribute("data-html", "true");
										$(this).parent().get(0).classList.add("swatch-help");
										$(this).parent().unwrap();
									}
									COSTCO.util.swatch_accesible_popover('.swatch-help');
								}
							}
						});
					}
				});
	
				//NEED FOR BF?
				if ($('#theSwatches').children().length == 0) {
					var itemOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
						if ($(option).data('swatch') === 'pedestal option') {
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
									if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd) {
										if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if (!$(option).text().includes(messages.BACKORDER_TEXT)) {
											var message = $(option).text() + ' - ' + messages.BACKORDER_TEXT;
											$(option).text(message);
										}
									}
									if (products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || products[0][i].zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
										if ($(option).text().includes(messages.BACKORDER_TEXT)) {
											var sliceStr = ' - ' + messages.BACKORDER_TEXT;
											var optionText = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(optionText);
										}
										if (!$(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var message = $(option).text() + ' - ' + messages.OUT_OF_STOCK_TEXT;
											$(option).text(message);
										}
										$(option).attr("disabled", "disabled");
										return $(option).data('swatch').trim().toLowerCase();
									}
								}
							}
						}
					});
	
					var itemsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
						if ($(option).data('swatch') === 'pedestal option') {
							for (var i = 0; i < products[0].length; i++) {
								if (products[0][i].options.length === 1 && $(option).val() === products[0][i].options[0] || products[0][i].options.length === 2 && ($(option).val() === products[0][i].options[0] || $(option).val() === products[0][i].options[1])) {
									if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock && products[0][i].zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_invalidSku && $(option).attr("disabled") === "disabled") {
										$(option).removeAttr("disabled");
										if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
											var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										} else if ($(option).text().includes(messages.BACKORDER_TEXT)) {
											var sliceStr = ' - ' + messages.BACKORDER_TEXT;
											var message = $(option).text().slice(0, $(option).text().indexOf(sliceStr));
											$(option).text(message);
										}
										return $(option).data('swatch').trim().toLowerCase();
									}
								}
							}
						}
					});
				}
	
				var $variant_options = $('.varis[data-product=0]').find('option:not(.defaultOpt)');
				var optionsSelected = phelper.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				$variant_options.each(function (index, opt) {
					if (optionsSelected.includes(opt.value)) {
						products[0].forEach(function (product_obj) {
							CMath.update_variant_option_GE(opt, product_obj, $variant_options.length, optionsSelected);
						});
					}
				});
			},
	
			/**
	   * Function that disables/enables variant option and updates option text after GE Availability Call
	   */
			update_variant_option_GE: function update_variant_option_GE(opt, product_obj, nextVariantLength) {
	
				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
					$(opt).siblings().each(function (index, option) {
						if (typeof option.innerHTML != 'undefined' && !option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(option).removeAttr('disabled');
						}
						if (option.innerHTML.includes(messages.BACKORDER_TEXT) || option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							if (option.innerHTML.includes(messages.BACKORDER_TEXT)) {
								var sliceStr = ' - ' + messages.BACKORDER_TEXT;
								option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
							}
							if (option.innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
								var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
								option.innerHTML = option.innerHTML.slice(0, option.innerHTML.indexOf(sliceStr));
							}
							$(option).disabled = false;
						}
						$variant_option_input = $('input[value=' + option.value + ']');
						if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
							$variant_option_input.siblings('.selection-item')[0].innerHTML = option.innerHTML;
						}
						$variant_option_span = $variant_option_input.closest('span');
						if ($variant_option_span.length > 0) {
							if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
								$variant_option_span.addClass('disabledSwatch');
							} else {
								$variant_option_span.removeClass('disabledSwatch');
							}
						}
					});
					$(opt).closest('label').removeClass('disabled');
				}
				if (typeof opt.value !== "undefined" && product_obj.options.includes(opt.value)) {
	
					if (product_obj.inventory === COSTCO.util.productConstants.inv_backorderd || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_backorderd && product_obj.zipcodeAvailabilityResponseCode === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	
						if ($(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.BACKORDER_TEXT;
						}
					} else if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
	
						if ($(opt)[0].innerHTML.includes(messages.BACKORDER_TEXT)) {
							var sliceStr = ' - ' + messages.BACKORDER_TEXT;
							$(opt)[0].innerHTML = $(opt)[0].innerHTML.slice(0, $(opt)[0].innerHTML.indexOf(sliceStr));
						}
						if (!$(opt)[0].innerHTML.includes(messages.OUT_OF_STOCK_TEXT)) {
							$(opt)[0].innerHTML += ' - ' + messages.OUT_OF_STOCK_TEXT;
						}
						if (product_obj.zipcodeAvailabilityMessageCode !== COSTCO.util.productConstants.inv_outOfStock) {
							if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
								$(opt).siblings().attr('disabled', 'disabled');
								$(opt).closest('span').addClass('disabled');
							}
							$(opt).attr('disabled', 'disabled');
						}
					}
	
					if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && numberOfOptionsToDisplayAsTiles && nextVariantLength < numberOfOptionsToDisplayAsTiles) {
						if (typeof opt.value !== "undefined") {
							$variant_option_input = $('input[value=' + opt.value + ']');
							if (typeof $variant_option_input.siblings('.selection-item')[0] !== "undefined") {
								$variant_option_input.siblings('.selection-item')[0].innerHTML = $(opt)[0].innerHTML;
							}
							$variant_option_span = $variant_option_input.closest('span');
							if ($variant_option_span.length > 0) {
								if (product_obj.inventory === COSTCO.util.productConstants.inv_outOfStock || product_obj.zipcodeAvailabilityMessageCode === COSTCO.util.productConstants.inv_invalidSku) {
									$variant_option_span.addClass('disabledSwatch');
								} else {
									$variant_option_span.removeClass('disabledSwatch');
								}
							}
						}
					}
				}
			},
			/**
	   * This function is called when a color is selected in our swatch dropdown.
	   * We need to trigger a click event on Rich FX's swatch color tiles in order
	   * for the zoomviewer to correctly update to the chosen color. The swatch color
	   * tiles should be hidden when our swatch color dropdown is showing.
	   */
			triggerSwatchDropDownSelection: function triggerSwatchDropDownSelection(swatchColor) {
	
				if (typeof swatchColor == 'undefined' || swatchColor == '') {
					return;
				}
	
				// The space at the beginning is added so blue won't match against lightblue.
				$('.RICHFXColorChangeLink span.RICHFXColorChangeSwatchName').each(function () {
					var swatchIdx = $(this).html().indexOf(' ' + swatchColor);
					if (swatchIdx >= 0 && $(this).html().substr(swatchIdx + 1) == swatchColor) {
						var $theViews = $('#theViews');
						if ($theViews) {
							$theViews.find('img').each(function () {
								$(this).off("click");
							});
						}
						$(this).next().click();
						if ($theViews) {
							$theViews.find('img').each(function () {
								$(this).on('click', function (event) {
									$(this).on("click");
								});
							});
						}
					}
				});
			},
			// displays the lowest price of all variants when no variants are selected
			showLowestPriceVariant: function showLowestPriceVariant() {
				if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)) {
					var catentry = products[0][0].catentry;
					var minPrice = this.calculateYourPrice(catentry, true);
					var maxPrice = this.calculateYourPrice(catentry, true);
					for (var i = 0, len = products[0].length; i < len; i++) {
						if (minPrice > this.calculateYourPrice(products[0][i].catentry, true)) {
							minPrice = this.calculateYourPrice(products[0][i].catentry, true);
							catentry = products[0][i].catentry;
						} else if (maxPrice < this.calculateYourPrice(products[0][i].catentry, true)) {
							maxPrice = this.calculateYourPrice(products[0][i].catentry, true);
						}
					}
					if (minPrice === maxPrice) {
						$('.starting-price').hide();
					} else {
						$('.starting-price').show();
					}
					this.pricingInfo(catentry);
					this.showBreakdown(true);
				}
			},
			// determines price to show for same price variants
			showPriceVariants: function showPriceVariants() {
				if (phelper.isSingleVariant(products) || phelper.isMultiVariant(products)) {
					// Get the price of the first product from the products array to compare
					var catentry = products[0][0].catentry,
					    price = this.calculateYourPrice(catentry, true);
					// Check to see if every other variant has the same price
					for (var i = 0, len = products[0].length; i < len; i++) {
						var item_price = this.calculateYourPrice(products[0][i].catentry, true);
						if (price != item_price) {
							break;
						}
						if (i == len - 1) {
							this.pricingInfo(catentry);
							this.showBreakdown(true);
						}
					}
				}
			},
			optionsInStockMAP: function optionsInStockMAP() {
				var inStockMap = {};
	
				for (var j = 0; j < options.length; j++) {
					// options Sku level count
					for (var k = 0; k < options[j].length; k++) {
						// options Sku attribute level count
						var skuAttr = options[j][k];
						if (skuAttr && skuAttr.s && skuAttr.s > 0) {
							//Key - optiondesc, value = Swatch type and value
							var mapValue = { 'swatchable_mode': skuAttr.s, 'vimage': skuAttr.vimage };
							inStockMap[skuAttr.i] = mapValue;
						}
					}
				}
				return inStockMap;
			},
			showBackorderMessage: function showBackorderMessage() {
				if (typeof backorderMessage !== "undefined") {
					$('#backorder-message').removeClass('hide');
					$('#backorder-message').html(backorderMessage);
				}
			},
			showSelectedOptions: function showSelectedOptions() {
				// GE scheduled deliverable
				var scheduledDeliverable = $('#scheduledDeliverable').val() == "true" ? true : false;
				$schDeliveryElements = $('#select-options');
	
				if (scheduledDeliverable) {
					$schDeliveryElements.show();
					$('#prod-page-delivery').removeClass('hide');
					$('#add-to-cart').hide();
					$('#add-to-cart-map').hide();
				}
			},
			handleEDDForms: function handleEDDForms() {
	
				eddInstallationServicesJSON = {};
				if (!$('#vendorName').val() || phelper.item_type == 'bundle') {
					$('#liveEDD').val("false");
					$('#edd-message-block').hide();
					$('.edd-container').hide();
					$('.primary-clause').show();
	
					if (COSTCO.util.checkElementById('#outOfStock', 'true')) {
						COSTCO.Product.enableAddtoCart();
					}
				} else {
					$('#liveEDD').val("true");
					$('.primary-clause').hide();
					$('#edd-message-block').show();
				}
			},
			formatMaxShipDate: function formatMaxShipDate(startDate) {
				var d = new Date(startDate),
				    month = '' + (d.getMonth() + 1),
				    day = '' + d.getDate(),
				    year = d.getFullYear();
	
				if (month.length < 2) month = '0' + month;
				if (day.length < 2) day = '0' + day;
	
				var langId = COSTCO.util.getLangId();
				if (langId === '-25') {
					return [day, month, year].join('/');
				} else {
					return [month, day, year].join('/');
				}
			},
	
			isValidShipMode: function isValidShipMode(defaultShipcode) {
				if (defaultShipcode && (defaultShipcode.toLowerCase() == messages.SHIPCODE_NO_SHIPPING || defaultShipcode.toLowerCase() == messages.SHIPCODE_MAIL)) {
					return false;
				} else {
					return true;
				}
			},
			invokeBuildABundle: function invokeBuildABundle(catentryid) {
				if (COSTCO.CMath.iskitsbundle) {
					var itemPartNumber = COSTCO.Product.getPartnumber();
					var ItemType = 'single';
					if (ItemType != phelper.item_type) {
						ItemType = 'variant';
					}
					var varaintParameters = { "partNumber": itemPartNumber, "catentryId": catentryid, "ItemType": ItemType };
					window.reactObj.bundle.partNumber = itemPartNumber;
					window.reactObj.bundle.catentryId = catentryid;
					window.reactObj.bundle.ItemType = ItemType;
					try {
						if ((typeof varaintParameters === 'undefined' ? 'undefined' : _typeof(varaintParameters)) != undefined) {
							window.wioEventBus.publish('bundleDataRequest', varaintParameters);
						}
					} catch (e) {
						console.log(e);
					}
				}
			},
			invokeBundleSetForPDP: function invokeBundleSetForPDP(virtualBundleID) {
				try {
					if ((typeof virtualBundleID === 'undefined' ? 'undefined' : _typeof(virtualBundleID)) != undefined) {
						var itemType = 'single';
						if (itemType != phelper.item_type) {
							itemType = 'variant';
						}
						var inputJson = { partNumber: COSTCO.Product.getPartnumber(), ItemType: itemType, virtualBundleID: virtualBundleID };
						window.wioEventBus.publish('displayBundlePackage', inputJson);
					}
				} catch (e) {
					console.log(e);
				}
			}, selectNextSwatch: function selectNextSwatch(id, count) {
				var activeColor = id.split('_')[1];
				var imageId = count + "_" + activeColor;
				if (activeColor != COSTCO.CMath.swatchActiveColor) {
					$('.selectedSwatch').removeClass('selectedSwatch');
					$("#" + id).addClass("selectedSwatch");
					$('img').removeClass('kBSwatchSelected');
					$("#" + imageId).removeClass("kBSwatchUnSelected");
					$("#" + imageId).addClass("kBSwatchSelected");
					COSTCO.CMath.setKbLabel();
					var $swatchElement = $('[data-swatch=' + activeColor + ']');
					$swatchElement.prop('selected', true);
					if (COSTCO.CMath.swatchInitialTileSelected && activeColor != COSTCO.CMath.swatchActiveColor) {
						COSTCO.CMath.swatchActiveColor = activeColor;
						COSTCO.CMath.swatchTileSelected = true;
					}
					if (COSTCO.CMath.iskitsbundle && COSTCO.CMath.kbPageloadComplete) {
						CMath.redirectPDP();
					}
				}
			},
			setKbLabel: function setKbLabel() {
				var labelColor = $(".selectedSwatch").attr("data-content");
				$('label[for="theKBSwatches"]').html('<span class="bold">Color: </span>' + labelColor);
			},
			buildTooltip: function buildTooltip() {
				$('body').append('<div id="KBTooltipId" class="popover fade bottom in" style=" display: block;position:absolute;visiblity:hidden;">' + '<div class="arrow" style="left: 50%;"></div><div class="popover-content"></div></div>');
			},
			showKBTooltip: function showKBTooltip(data) {
				var index = data.id.split('_')[0];
				var labelColor = $('#' + data.id).attr("data-content");
				var target = $('#' + data.id);
				$('#KBTooltipId').removeClass('hide');
				$('#KBTooltipId .popover-content').html(target.attr('data-content'));
				// update text
				target.attr('title', '');
				var tt = $('#RICHFXTooltip').offset();
				var absoluteOffset = target.offset();
				// following code for setting top postion
				var topPosition = "38";
				var actLeftPosition = parseFloat(absoluteOffset.left);
				var actTopPosition = parseFloat(absoluteOffset.top) + parseFloat(topPosition);
				$('#KBTooltipId').css('top', parseFloat(actTopPosition) + 'px');
				// following code for setting left postion
				var element = document.getElementById("KBTooltipId");
				var rect = element.getBoundingClientRect();
				var widthfalf = rect.width / 2;
				actLeftPosition = actLeftPosition - widthfalf + 20;
				$('#KBTooltipId').css('left', parseFloat(actLeftPosition) + 'px');
				$('#KBTooltipId').css('visibility', 'visible');
			}, hideKBTooltip: function hideKBTooltip(data) {
				var index = data.id.split('_')[0];
				$('#KBTooltipId').css('visibility', 'hidden');
			},
	
			redirectPDP: function redirectPDP() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				var equalOption = optionsSelected.length === COSTCO.CMath.onloadSelectOption.length && optionsSelected.every(function (value, index) {
					return value === COSTCO.CMath.onloadSelectOption[index];
				});
				if (!equalOption) {
					var isPreviousSwatchAvailable;
					var reloadProductUrl;
					var i;
					var i;
					var swatch;
					var dropDown;
	
					(function () {
						isPreviousSwatchAvailable = false;
	
						var arr1 = optionsSelected.concat().sort();
						for (i = 0; i < product.length; i++) {
							if (products[i] != undefined) {
								products[i].forEach(function (list) {
									var arr2 = list.options.concat().sort();
									var equalValues = arr2.length === arr1.length && arr2.every(function (value, index) {
										return value === arr1[index];
									});
									if (equalValues) {
										isPreviousSwatchAvailable = true;
										reloadProductUrl = list.productUrl;
										return;
									}
								});
							}
						}
						if (!isPreviousSwatchAvailable) {
							CMath.redirectwithFirstItem(optionsSelected);
						}
						if (isPreviousSwatchAvailable) {
							// disable swatch
							$(".RICHFXColorChangeLink").addClass('disabledSwatch'); //disable image
							if (undefined != optionsSelected) {
								for (i = 0; i < optionsSelected.length; i++) {
									swatch = $('#swatches-productOption0' + i + '').length > 0;
									dropDown = $('.varis-v2[automation-id=varisSwatch_0' + i + ']').length > 0;
	
									if (swatch) {
										$("#swatchesID-productOption0" + i + "").attr('disabled', 'disabled'); //disable tile swatches
									} else if (dropDown) {
										$('.varis-v2[automation-id=varisSwatch_0' + i + ']').attr('disabled', 'disabled'); //disable dropdown
									}
								}
							}
	
							document.location.href = reloadProductUrl + "?isSwatchReload";
						}
					})();
				}
			}, reloadOnRadio: function reloadOnRadio(radioId, inputLevel) {
	
				var level = inputLevel.replace('productOption0', '');
				var tileId = radioId.split('_')[1];
				$('.radio-padding[automation-id=selectionItem_' + tileId + ']').addClass("select-radio-remove-boarder");
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				if ($('#swatches-productOption0' + level + ' .selection-box-v2 input').length > 0) {
					var firstSelectedVariant = $('#swatches-productOption0' + level + ' input[value=' + tileId + ']');
					$('#productOption0' + level).val($(firstSelectedVariant).val());
					$variant_option_input = $('input[value=' + tileId + ']');
					$variant_option_input.prop('checked', true);
					CMath.redirectPDP();
				}
			}, redirectwithFirstItem: function redirectwithFirstItem(optionsSelected) {
				var reloadPage = false;
				for (var i = 0; i < product.length; i++) {
					if (products[i] != undefined) {
						products[i].forEach(function (list) {
							list.options.forEach(function (option) {
								if (optionsSelected[0] == option) {
									reloadPage = true;
									reloadProductUrl = list.productUrl;
									return;
								}
							});
						});
					}
				}
				if (reloadPage) {
					document.location.href = reloadProductUrl + "?isSwatchReload";
				}
			}, selectCurrentSelectedItem: function selectCurrentSelectedItem() {
				$('.variantContainer select.varis option').each(function (index, inputVar) {
					$(inputVar).removeAttr('checked');
					$(inputVar).attr('aria-checked', 'false');
					$(inputVar).attr('selected', false);
				});
				var selectedAttribute = $('#selectedSwatchAttr').val();
				if (null != selectedAttribute && undefined != selectedAttribute && selectedAttribute != "") {
					selectedAttribute = selectedAttribute.replace('[', '').replace(']', '');
					var arrayselect = [];
					arrayselect = selectedAttribute.split(',');
					arrayselect.forEach(function (option) {
						//Swatch selection
	
						if ($("#activeswatch_" + option.split('#')[1] + "").length > 0) {
							$("#activeswatch_" + option.split('#')[1] + "").addClass('selectedSwatch');
							$("#activeswatch_" + option.split('#')[1] + "").attr('aria-pressed', 'true');
							$("#activeswatch_" + option.split('#')[1] + " img").removeClass('kBSwatchUnSelected');
							$("#activeswatch_" + option.split('#')[1] + " img").addClass('kBSwatchSelected');
						}
						//Tiles selection
						$('.variantContainer select.varis option').each(function (index, inputVar) {
							if ($(inputVar).val() == option.split('#')[0].trim()) {
								$(inputVar).prop('checked', true);
								$(inputVar).attr('aria-checked', 'true');
								$(inputVar).attr('selected', true);
								$(inputVar).addClass('selection-item');
							}
						});
						//Dropdown selection
						var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
						// const arr1 = optionsSelected.concat().sort();
						var noOflevels = optionsSelected.length;
						var dropDown = $('.varis[automation-id=varisSwatch_0' + parseInt(noOflevels - 1) + ']').length > 0;
						var options = [];
						if (noOflevels > 1 && dropDown) {
							for (var i = 0; i < product.length; i++) {
								if (products[i] != undefined) {
									products[i].forEach(function (list) {
										if (list.options.includes(optionsSelected[0])) {
											list.options.forEach(function (opt) {
												if (opt != optionsSelected[0]) {
													options.push(opt);
												}
											});
										}
									});
								}
							}
							if (options.length > 0) {
								$('.varis[automation-id=varisSwatch_0' + parseInt(noOflevels - 1) + ']').find('option.opt:not(:disabled)').each(function () {
									if (!options.includes($(this).attr("value"))) {
										var opt = $(this).attr("value");
										$variant_option_input = $('.varis [automation-id=varisOption_' + opt + ']');
										if ($variant_option_input.length > 0) {
											$variant_option_input.attr('disabled', 'disabled').hide();
											$variant_option_input.prop('checked', false);
										}
									}
								});
							}
						}
					});
				}
			}, hideKBSkeletone: function hideKBSkeletone() {
				var optionsSelected = COSTCO.Product.get_selected_array($('.varis[data-product=0]').find('option:selected'));
				$('#PDPSwatchSkeletone-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
				$('#swatchesID-productOption0' + parseInt(optionsSelected.length - 1) + '').show();
				$('.dropdown-skeleton-productOption0' + parseInt(optionsSelected.length - 1) + '').hide();
				$('[name=productOption0' + parseInt(optionsSelected.length - 1) + ']').show();
			}
	
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.CMath = CMath;
	
		return CMath;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title zoom-viewer.js: Sub-module of Browse feature
	 * @description This module encapsulates all of the
	 * functionality related to the zoom viewer component of quickview display.
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var ZoomViewer = {
	    getViewerSize: function getViewerSize() {
	      var width = $(window).width();
	      var height = $(window).height();
	      if (width > 1000 && height > 870 || width <= 667 && width > 382) return zoomViewer.xl;
	      if (width > 764 && height > 650) return zoomViewer.lg;
	      return zoomViewer.xs;
	    },
	
	    richMediaLoaded: function richMediaLoaded() {
	      ZoomViewer.setupViewer();
	      ZoomViewer.setupSwatches();
	      ZoomViewer.constants.$initialImage.hide(); //hide the overlayed image after zoom viewer finishes loading
	      ZoomViewer.constants.$viewerDiv.css('visibility', 'visible');
	      ZoomViewer.constants.$viewerDiv.find('#productImageContainer').focus();
	      ZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
	      ZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
	      var $externalVideo = ZoomViewer.constants.$theViews.find('img[id*=External]');
	      if ($externalVideo.length > 0) {
	        //only load liveclicker files once
	        ZoomViewer.loadVideoData();
	      }
	
	      if (ZoomViewer.constants.imageLightboxV2) {
	        var slides = ZoomViewer.constants.$theViews.find('a').length;
	        $('#currentSlide').html(COSTCO.ZoomViewer.constants.currentSlide + 1 + messages.PDP_REDESIGN_V2_OF + slides);
	      }
	    },
	
	    richMediaSwatchChange: function richMediaSwatchChange() {
	
	      if (ZoomViewer.constants.$theViews.hasClass('slick-initialized')) {
	        ZoomViewer.destroyThumbnailCarousel();
	        ZoomViewer.constants.currentSlide = 0;
	        ZoomViewer.constants.firstActiveSlide = 0;
	        ZoomViewer.makeViewerResponsive();
	        ZoomViewer.setupThumbnailCarousel();
	      }
	    },
	
	    richMediaViewChange: function richMediaViewChange() {
	      var $selected = $('.RICHFXColorChangeViewSelected');
	      ZoomViewer.destroyThumbnailCarousel();
	      ZoomViewer.constants.currentSlide = $selected.parent().index();
	      ZoomViewer.makeViewerResponsive();
	      ZoomViewer.setupThumbnailCarousel();
	      $('.selectedSlide').first().focus();
	      if (ZoomViewer.constants.imageLightboxV2) {
	        var slides = $('#theViews').find('a').length;
	        $('#viewsPrevArrow').removeClass('hideViewsArrow');
	        $('#viewsNextArrow').removeClass('hideViewsArrow');
	        if (ZoomViewer.constants.currentSlide == slides - 1) {
	          $('#viewsNextArrow').addClass('hideViewsArrow');
	        }
	        if (ZoomViewer.constants.currentSlide == 0) {
	          $('#viewsPrevArrow').addClass('hideViewsArrow');
	        }
	        $('#currentSlide').html(COSTCO.ZoomViewer.constants.currentSlide + 1 + messages.PDP_REDESIGN_V2_OF + slides);
	      }
	    },
	
	    initZoomViewer: function initZoomViewer() {
	      console.log('Calling InitZoomViewer...');
	      ZoomViewer.constants = {
	        $viewerDiv: $('#zoomViewer'),
	        $viewerLib: $('#productImageLibrary'),
	        $viewerImg: $('#productImage'),
	        $thumbnails: $('#thumbnails'),
	        $theViews: $('#theViews'),
	        $initialImage: $('#initialProductImage'),
	        $prevArrow: $('#viewsPrevArrow'),
	        $nextArrow: $('#viewsNextArrow'),
	        viewerSize: ZoomViewer.getViewerSize(),
	        currentSlide: 0,
	        firstActiveSlide: 0,
	        imageLightboxV2: false
	      };
	
	      ZoomViewer.createViewer(ZoomViewer.constants.viewerSize);
	    },
	
	    createViewer: function createViewer(viewerSize) {
	      //[Vladimir] the following line is from original script, this is now already included in SearchResultsBody page
	      //$viewerLib.attr('src', zoomViewer.libraryUrl + viewerSize);
	      ZoomViewer.constants.$viewerImg.attr('src', zoomViewer.viewerUrl + viewerSize.substr(2));
	    },
	
	    //adjusts thumbnail width and position of video overlay images
	    adjustThumbnails: function adjustThumbnails() {
	      var thumbWidth = Math.floor(ZoomViewer.constants.$theViews.width() / 6);
	      ZoomViewer.constants.$theViews.find('img').css('width', thumbWidth);
	
	      var $vidOverlay = $('img[id*=videoOverlay]');
	      $vidOverlay.each(function () {
	        $(this).parent().css('width', '');
	        $(this).parent().css('height', '');
	        $(this).css('left', $(this).siblings().position().left);
	      });
	    },
	
	    //adds responsive properties to the zoom viewer
	    makeViewerResponsive: function makeViewerResponsive() {
	      var $container = $('.RICHFXViewerContainer');
	      $container.css('width', '');
	      $container.css('height', '');
	      $('#zoomViewer').find('img').addClass('img-responsive');
	    },
	
	    //creates thumbnail carousel
	    setupThumbnailCarousel: function setupThumbnailCarousel() {
	      if (ZoomViewer.constants.currentSlide == 'undefined') {
	        ZoomViewer.constants.currentSlide = 0;
	      }
	      if (ZoomViewer.constants.firstActiveSlide == 'undefined') {
	        ZoomViewer.constants.firstActiveSlide = 0;
	      }
	      var slides = ZoomViewer.constants.$theViews.find('a').length;
	
	      var responsiveBreakpoints = [];
	
	      var slickSettings = {
	        dots: false,
	        arrows: true,
	        slidesToShow: 5,
	        infinite: false,
	        slidesToScroll: 5,
	        autoplay: false,
	        draggable: true,
	        accessibility: true,
	        prevArrow: $('#viewsPrevArrow'),
	        nextArrow: $('#viewsNextArrow')
	      };
	
	      if (ZoomViewer.constants.imageLightboxV2) {
	
	        var breakPointMobile = {
	          breakpoint: 320,
	          settings: {
	            slidesToShow: 5
	          }
	        };
	
	        responsiveBreakpoints.push(breakPointMobile);
	
	        var breakPoint = {
	          breakpoint: 768,
	          settings: {
	            slidesToShow: 7
	          }
	        };
	
	        responsiveBreakpoints.push(breakPoint);
	
	        slickSettings['responsive'] = responsiveBreakpoints;
	        slickSettings['slidesToScroll'] = 1;
	        slickSettings['mobileFirst'] = true;
	
	        var productImageWidth = $('#productImageContainer').find('img:visible').width();
	        ZoomViewer.constants.$thumbnails.width(productImageWidth);
	      }
	
	      COSTCO.util.carousel(ZoomViewer.constants.$theViews, slickSettings);
	      ZoomViewer.constants.$theViews.find('a').on('keyup', function (e) {
	        //If user use keyboard enter key to select image simulate the click
	        if (e.which == 13) {
	          $(this).find('img').click();
	          //Move the focus to the selected slide, need to do this as the click simulation reset the focus
	          $('.selectedSlide').first().focus();
	        }
	      });
	      ZoomViewer.constants.$theViews.slick('slickGoTo', 5 * Math.ceil(ZoomViewer.constants.firstActiveSlide / 5), true); //go to the set of 5 slides that were active
	      ZoomViewer.constants.$theViews.find('.selectedSlide').removeClass('selectedSlide');
	      ZoomViewer.constants.$theViews.find('.slick-slide:nth-child(' + (ZoomViewer.constants.currentSlide + 1) + ')').addClass('selectedSlide');
	      ZoomViewer.adjustThumbnails();
	      //if there are more than 5 slides, show the arrows to scroll through thumbs
	      if (slides > 5) {
	        ZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
	        ZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
	      } else {
	        ZoomViewer.constants.$prevArrow.hide();
	        ZoomViewer.constants.$nextArrow.hide();
	      }
	      ZoomViewer.constants.$theViews.unbind('afterChange').on('afterChange', function () {
	        ZoomViewer.constants.firstActiveSlide = ZoomViewer.constants.$theViews.find('.slick-active').first().attr('data-slick-index');
	      });
	    },
	
	    //destroys thumbnail carousel
	    destroyThumbnailCarousel: function destroyThumbnailCarousel() {
	      ZoomViewer.constants.$theViews.slick('destroy');
	      ZoomViewer.constants.$theViews.find('a[tabindex]').remove();
	      ZoomViewer.constants.$prevArrow.css('visibility', 'hidden');
	      ZoomViewer.constants.$nextArrow.css('visibility', 'hidden');
	    },
	
	    //uses liveclicker's scripts to setup videos
	    loadVideoData: function loadVideoData() {
	      COSTCO.Global.logger('External Video Detected. Loading Liveclicker.');
	      $('#liveClickerCss').attr('href', zoomViewer.videoCssUrl);
	      $.cachedScript(zoomViewer.videoJqueryUrl).done(function () {
	        $.cachedScript(zoomViewer.videoJsUrl);
	      });
	      document.addEventListener('RichMedia.ExternalVideo.Show', COSTCO.ZoomViewer.hideZoomInstruction);
	      document.addEventListener('RichMedia.ExternalVideo.Hide', COSTCO.ZoomViewer.showZoomInstruction);
	    },
	
	    hideZoomInstruction: function hideZoomInstruction() {
	      $('#zoomInstruction').addClass('hidden-preserve-height');
	    },
	
	    showZoomInstruction: function showZoomInstruction() {
	      $('#zoomInstruction').removeClass('hidden-preserve-height');
	    },
	
	    //selects the first available swatch color from our side so
	    //that the customer will not see a color that's unavailable.
	    selectInitialSwatch: function selectInitialSwatch() {
	      var swatch = void 0;
	      try {
	        swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
	        //trigger a select of the first swatch color from the color select dropdown
	        COSTCO.CMath.triggerSwatchDropDownSelection(swatch);
	      } catch (err) {
	        console.error(err);
	      }
	      $('#theSwatches').find('img[alt="' + swatch + '"]').first().click();
	    },
	
	    //out of stock items do not reflect properly in the swatch tiles from rich media
	    //so we have to sync their tiles with our product options.
	    syncSwatchTiles: function syncSwatchTiles(swatchMode) {
	      var colorsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).attr("disabled") != "disabled") {
	          return $(option).data('swatch').trim().toLowerCase();
	        }
	      });
	      var colorsOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).attr("disabled") == "disabled") {
	          return $(option).data('swatch').trim().toLowerCase();
	        }
	      });
	      var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).text().includes(messages.BACKORDER_TEXT)) {
	          var sliceStr = ' - ' + messages.BACKORDER_TEXT;
	          return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
	          var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
	          return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else if ($(option).text().includes(' -')) {
	          return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else {
	          return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        }
	      });
	
	      $('img', '#theSwatches').each(function () {
	        var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
	        if (itemDescriptionArray.length == 2) {
	          var color = itemDescriptionArray[1].toLowerCase();
	          var colorNameTitle = $.map(colorsNames, function (value) {
	            if (value.includes(' -' + color)) {
	              return value.slice(0, value.indexOf(' -' + color + '-'));
	            }
	          });
	          if (colorsInStock.indexOf(color) < 0 && colorsOutStock.indexOf(color) < 0) {
	            $(this).parent().remove();
	          } else if (colorsInStock.indexOf(color) < 0) {
	            $(this).parent().addClass('disabledSwatch');
	            if (color == 'white') {
	              $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
	            } else {
	              $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
	            }
	            $(this).parent().get(0).setAttribute("tabindex", "-1");
	            $(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" data-toggle="popover" data-html="true" data-content="' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
	            $(this).parent().prepend('<span class="offscreen">' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '</span>');
	          } else {
	            $(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
	
	            $(this).parent().get(0).setAttribute("data-content", colorNameTitle);
	            $(this).parent().get(0).setAttribute("data-placement", "bottom");
	            $(this).parent().get(0).setAttribute("data-trigger", "focus hover");
	            $(this).parent().get(0).setAttribute("data-toggle", "popover");
	            $(this).parent().get(0).setAttribute("data-html", "true");
	            $(this).parent().get(0).classList.add("swatch-help");
	            $(this).parent().get(0).setAttribute("onkeydown", "COSTCO.CMath.runRMAActiveColor(event, '" + color + "')");
	          }
	        }
	      });
	
	      var sortedSwatches = $('#theSwatches').children().sort(function (a, b) {
	        return a.getAttribute('data-sort') - b.getAttribute('data-sort');
	      });
	
	      $('#theSwatches').empty();
	      $('#theSwatches').append(sortedSwatches);
	      if (swatchMode == 2) {
	        $('#theSwatches').removeClass('hide');
	      }
	    },
	
	    //sets up swatches based on swatchMode
	    //swatchMode = 1 is the regular dropdown
	    //swatchMode = 2 is RichFx's swatch color tiles and we hide our dropdown
	    setupSwatches: function setupSwatches() {
	      var swatchMode = $('.swatchDropdown').data('swatch-mode');
	
	      if (swatchMode == 1 || swatchMode == 2) {
	        ZoomViewer.syncSwatchTiles(swatchMode);
	        ZoomViewer.selectInitialSwatch();
	
	        //fallback to our select if RichFx's swatch tiles didn't load
	        if (swatchMode == 2 && $('#theSwatches').children().length == 0) {
	          $('.swatchDropdown').removeClass('hide');
	        }
	        COSTCO.util.swatch_accesible_popover('.swatch-help');
	      } else {
	        $('#product-body-item-number').removeClass('hide');
	        $('#product-body-model-number').removeClass('hide');
	      }
	    },
	
	    //setus up the viewer to have responsive properties and
	    //shows thumbnails if they are available
	    setupViewer: function setupViewer() {
	      ZoomViewer.makeViewerResponsive();
	      if (ZoomViewer.constants.$theViews.find('img').length > 0) {
	        ZoomViewer.constants.$thumbnails.show();
	        ZoomViewer.setupThumbnailCarousel();
	      }
	    },
	
	    cleanupEvents: function cleanupEvents() {
	      document.removeEventListener('richmedia.state.loaded', COSTCO.ZoomViewer.richMediaLoaded);
	      document.removeEventListener('richmedia.swatch.changed', COSTCO.ZoomViewer.richMediaSwatchChange);
	      document.removeEventListener('richmedia.view.changed', COSTCO.ZoomViewer.richMediaViewChange);
	      document.removeEventListener('RichMedia.ExternalVideo.Show', COSTCO.ZoomViewer.hideZoomInstruction);
	      document.removeEventListener('RichMedia.ExternalVideo.Hide', COSTCO.ZoomViewer.showZoomInstruction);
	      jQuery(document).unbind();
	    },
	
	    /**
	     * Resets Liveclicker video player.
	     */
	    resetLiveclicker: function resetLiveclicker() {
	      if (typeof liveclicker != 'undefined') {
	        liveclicker = {
	          lcCheckReadyObject: function lcCheckReadyObject() {}
	        };
	      }
	    },
	    /**
	     * This event-bound function "locks" window position, since the external Liveclicker library has several
	     * window.scrollTo() executions that cause the background to scroll down after each click on a video.
	     */
	    lockWindowScrolling: function lockWindowScrolling(event) {
	      if (typeof event.data.position != 'undefined') {
	        $(window).scrollTop(event.data.position);
	      }
	    },
	    /**
	     * Liveclicker library may break, leaving the thumbnails un-reloaded.
	     * Until this is fixed on the Liveclicker side, use this error event listener function.
	     */
	    reloadThumbnailsOnScriptError: function reloadThumbnailsOnScriptError(event) {
	      if (event.originalEvent.message == 'Script error.') {
	        try {
	          console.error('A script error occurred. Reloading thumbnails.');
	          ZoomViewer.richMediaViewChange();
	        } catch (err) {
	          console.error('An error occurred while trying to reload thumbnails.');
	        }
	      }
	    }
	
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.ZoomViewer = ZoomViewer;
	
	  return ZoomViewer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 62:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * @title addtocart.js: Sub-module
	 * @description Associated with ProductForm.jsp
	 * This JS file binds add to cart event listeners.
	 * Checks if a selection is back ordered to invoke a
	 * backordered modal.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5), __webpack_require__(54)], __WEBPACK_AMD_DEFINE_RESULT__ = function (phelper, mathtable) {
	    var AddToCart = {
	        init: function init() {
	            this.validate();
	            if ($('#ProductForm').length && $("span#backordered").length) {
	                phelper.bindSubmitToBackOrderModal(); // Here because span#backordered was included on the page
	            } else {
	                // Nothing backordered, add-to-cart button submit normally.
	                $("#ProductForm input[name='add-to-cart']").unbind('click').click(function (event) {
	                    if (event != undefined && event.target != undefined) {
	                        var callerElement = event.target;
	                        COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	                    } else {
	                        COSTCO.dialog.returnFocusOnCallerElement(document.activeElement);
	                    }
	                    $('#ProductForm').submit();
	                });
	            }
	        },
	
	        validate: function validate() {
	
	            $.validator.addMethod("quantityincrement", function (value, element) {
	                var $quantityIncrement = $(element).data("quantity-increment");
	                var errorMesg = $(element).data("error-message");
	
	                var quantityIncrement = 1; //default quantityIncrement is always 1 (a whole number)
	                if ((typeof $quantityIncrement === 'undefined' ? 'undefined' : _typeof($quantityIncrement)) == undefined || !$quantityIncrement) {
	                    return true;
	                }
	                var qty = parseInt($quantityIncrement);
	                if (qty) {
	                    quantityIncrement = qty;
	                }
	                if (value % quantityIncrement != 0) {
	                    return false;
	                }
	                return true;
	            }, function (params, element) {
	
	                return $(element).data("error-message") + " " + $(element).data("quantity-increment");
	            });
	
	            var _rules = {
	                submitHandler: function (form) {
	                    var item_type = phelper.item_type,
	                        $product_error = $('body').find('.product-error'),
	                        $add_success = $(form).find('.add-success'),
	                        quantity_obj = phelper.is_valid_quantity(item_type, $('input[name=quantity]')),
	                        valid = true;
	                    // Clear any previous error/success state and disable add to cart
	                    $product_error.html('');
	                    tobaccoProduct = $('#tobaccoProduct').val() == "true" ? true : false;
	                    if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && tobaccoProduct) {
	                        $('#add-to-cart').addClass('interaction-element');
	                        $('#error-notification-placeholder').empty();
	                        $('#error-notification-placeholder').addClass('hide');
	                    }
	                    $add_success.html('');
	                    // Disable quantity and add to cart to avoid spam
	                    $('#add-to-cart input').attr('disabled', 'disabled');
	                    $('input[name=quantity]').attr('disabled', 'disabled');
	
	                    // Check if we have a valid quantity
	                    if (!quantity_obj.valid) {
	                        $product_error.html(quantity_obj.message);
	                        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                            $('#minQtyText ').addClass('error');
	                        }
	                        valid = false;
	                    }
	                    // Check if we have a valid sku resolved
	                    if (valid && !phelper.is_sku_resolved(item_type, quantity_obj)) {
	                        $product_error.html("<span class='sr-only'>" + messages.ERROR + "</span>" + messages.ERR_ADD_TO_CART_SELECT_ONE);
	                        valid = false;
	                    }
	                    // If valid, Add to cart
	                    if (valid && typeof $('#vendorName').val() !== 'undefined' && ($('#vendorName').val().toLowerCase().includes('narvar') || COSTCO.Product.eddFormDisplayed != true || $('#ProductForm').length && $("span#backordered").length)) {
	                        this.ajaxAddToCart('#ProductForm', this.product_form_done, this.product_form_fail, this.product_form_always);
	                        $('#add-to-cart-btn').not('[offscreen]').focus();
	                    } else {
	                        // enable quantity and add to cart
	                        if (COSTCO.Product.eddFormDisplayed === '' || $('#edd-date-msg.hide').length == 0) {
	                            $('#add-to-cart input').removeAttr('disabled');
	                        }
	                        $('input[name=quantity]').removeAttr('disabled');
	                        $('#minQtyText').focus();
	                    }
	                }.bind(this)
	            };
	            var appType = $('#applicationType').val();
	            if (appType == 'BD') {
	                _rules.rules = {
	                    quantity: { quantityincrement: true }
	                };
	
	                _rules.messages = {
	                    quantity: {
	                        quantityincrement: function quantityincrement(params, element) {
	                            var unitOfMeasure = COSTCO.Product.getUnitOfMeasure($(element));
	                            var increment = COSTCO.Product.getQuantityStep($(element), unitOfMeasure);
	                            return "<p class='sr-only'>" + messages.ERROR + "</p>" + $(element).data("error-message") + " " + increment;
	                        }
	                    }
	                };
	
	                _rules.errorPlacement = function (error, element) {
	                    $product_error = element.closest('#ProductForm').find('.product-error');
	                    $product_error.html(error.css({ "margin": 0 }));
	                    COSTCO.Product.expendErrorOnQtyUnit(element, 'span');
	                };
	            }
	
	            if ($('#ProductForm')) {
	                var validate = $('#ProductForm').validate(_rules);
	                if (validate != undefined) {
	                    validate.form();
	                }
	            }
	        },
	
	        add_related: function add_related(form, done, fail, always) {
	            $(form).find('.related-success').empty();
	            $(form).find('.product-error').empty();
	            $(form).find('button.add-to-cart').attr('disabled', 'disabled');
	            this.ajaxAddToCart(form, done, fail, always);
	        },
	
	        ajaxAddToCart: function ajaxAddToCart(form, done, fail, always) {
	            var isRestrictedPostalCode = COSTCO.Header.checkIsRestricted();
	            var singleVariant = "single_variant";
	            var multiVariant = "multi-variant";
	            var targetedAttribute = $('#targetedCartBehaviour').val();
	            var targetedCart = "";
	            if (targetedAttribute !== undefined && targetedAttribute === 'Membership') {
	                //Any new behaviour, like Tickets, can be added to this condition to ensure that item is added to targeted cart
	                targetedCart = targetedAttribute;
	            }
	            //Fetch the contract specific flag for the Depot catalog flow
	            var programType = $('#programType').val();
	            var contractIdentifier = "";
	            if (typeof programType === "undefined") {
	                programType = "";
	            }
	            if (programType == "2DayDelivery") {
	                contractIdentifier = "Regional";
	            }
	
	            var isRelatedForm = form.indexOf('#RelatedProductForm') >= 0 ? true : false;
	            var $form = $(form),
	                locale = COSTCO.util.getLocale(),
	                productErrorDiv = $form.find('.product-error').empty(),
	                relatedProductErrorDiv = $form.find('.related-product-error').empty(),
	                quantity_text = messages.RWD_QUANTITY + ' ',
	                quantity,
	                final_price = (locale == 'en-US' || locale == 'en-CA' ? ' $' : '') + (isRelatedForm ? $form.find('.price').text().replace('$', '') : costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#pull-right-price .value').text() : $('.your-price .value').text()) + (locale == 'fr-CA' ? ' $' : ''),
	                formData = $form.serializeArray(),
	                cleanData = { 'ajaxFlag': true, 'checkOmsInventory': true, 'isPdpPage': true, 'isRestrictedPostalCode': isRestrictedPostalCode, 'targetedCartBehaviour': targetedCart, 'contractIdentifier': contractIdentifier },
	                selected_products = [];
	            $.each(formData, function (index, value) {
	                var dataName = formData[index].name;
	                var dataValue = formData[index].value;
	                if (dataName == 'relatedQty') {
	                    dataName = 'quantity';
	                }
	                if (!/_\d$/.test(dataName) && dataValue !== '' && dataValue !== '0') {
	                    cleanData[dataName] = dataValue;
	                }
	            });
	            var productIndex = 1;
	            cleanData['catalogEntryId_' + productIndex] = cleanData['catEntryId'];
	            if (cleanData['quantity'] == undefined) {
	                cleanData['quantity'] = $('#minQtyText').val();
	                if (cleanData['quantity'] == undefined) {
	                    cleanData['quantity'] = 1;
	                }
	            }
	            var isShipRestrictionStore = $('#shipRestrictionStore').val();
	            cleanData['isShipRestrictionStore'] = isShipRestrictionStore;
	            cleanData['quantity_' + productIndex] = cleanData['quantity'];
	            $form.find('.variantContainer').each(function (i, p) {
	                var dropdowns = $(p).find('option:selected').map(function () {
	                    return $(this).val();
	                }).get();
	                var swatches = $(p).find('.selected').map(function () {
	                    return $(this).attr('value');
	                }).get();
	                var selectedVariants = dropdowns.concat(swatches);
	                var selected_product = phelper.findItem(products[i], selectedVariants);
	                if (selected_product) {
	                    quantity = phelper.item_type == 'bundle' ? parseInt($(p).find('[id^=qty-input] input').val()) : parseInt($('input[name=quantity]').val());
	                    selected_product.quantity = quantity_text + quantity;
	                    var itemText = $('span.item-number-bundles').text().trim();
	                    selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
	                    var bundle_item_number = phelper.item_type == 'bundle' ? itemText + '  ' + (selected_product.partNumber || "") : "";
	                    selected_product.item_number = bundle_item_number == "" ? $('span.item-number').text() || '#' + selected_product.partNumber || "" : bundle_item_number;
	                    selected_product.final_price = phelper.item_type != 'bundle' ? final_price : $('.online-price[data-catentry=' + selected_product.catentry + ']').data('opvalue') ? phelper.formatMoney(mathtable.calculateYourPrice(selected_product.catentry, true), true) : '';
	                }
	                if (selected_product && quantity > 0) {
	                    selected_products = selected_products.concat(selected_product);
	                    cleanData['catalogEntryId_' + productIndex] = selected_product.catentry;
	                    cleanData['quantity_' + productIndex] = quantity;
	                    productIndex++;
	                }
	            });
	            if (phelper.item_type == 'single') {
	                var selected_product = phelper.findItem(products[0], []);
	                selected_product.quantity = quantity_text + $('input[name=quantity]').val();
	                selected_product.item_number = $('span.item-number').text();
	                selected_product.final_price = final_price;
	                selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
	                selected_products = selected_products.concat(selected_product);
	            }
	
	            if (typeof eddInstallationServicesJSON !== 'undefined') {
	                cleanData['eddInstallationServicesJSON'] = JSON.stringify(eddInstallationServicesJSON);
	            }
	
	            var eddPrimaryClause = $('#eddPrimaryClause').val();
	            if (typeof eddPrimaryClause !== 'undefined') {
	                cleanData['eddPrimaryClause'] = eddPrimaryClause;
	            }
	
	            $.ajax({
	                url: "/AjaxManageShoppingCartCmd",
	                type: 'POST',
	                data: cleanData,
	                dataType: 'json'
	            }).done(function (data, textStatus, xhr) {
	
	                data.selected_products = selected_products;
	                data.form_id = form;
	                $('#isPickUpItem').val(data.pickUp);
	                $('#isSTWtem').val(data.isSTWPickUp);
	                $('#isMDOItem').val(data.mdoPickUp);
	                if (done) done(data, textStatus, xhr);
	                if (COSTCO.util.isNdEnabled()) {
	                    var surcharge = data.surchargeAmount;
	                    var thresholdAmount = data.thresholdAmount;
	                    var shipmethodId = data.shipmethodId;
	                    var toolTipDeliverySurcharge = data.toolTipDeliverySurcharge;
	                    $('#freeDeliveryOrderAmount').val(parseFloat(thresholdAmount));
	                    $('#deliverySurcharge').val(parseFloat(surcharge));
	                    $('#toolTipDeliverySurcharge').val(parseFloat(toolTipDeliverySurcharge));
	                    COSTCO.Header.displayTooltip(shipmethodId);
	                }
	                if (data.multipleRestricted) {
	                    $form.find('.product-notification').html('<span>' + data.multipleRestricted + '<span>').show();
	                }
	                $('input[name="associatedParentIds"]').val(data.associatedParentIds);
	                COSTCO.Header.refreshGroceryBanner();
	            }).fail(function (xhr, textStatus, errorThrown) {
	                if (fail) fail(xhr, textStatus, errorThrown);
	            }).always(function (data, textStatus, errorThrown) {
	                if (always) always(data, textStatus, errorThrown);
	            });
	        },
	
	        has_error: function has_error(data) {
	            var productErrorDiv = void 0;
	            var bundleProduct = $('#bundle-items-container').length !== 0 ? true : false;
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                if (bundleProduct) {
	                    productErrorDiv = $('#bundle-items-container').find('.product-error');
	                } else {
	                    productErrorDiv = $(data.form_id + ' .product-error').length ? $(data.form_id + ' .product-error') : $('#pdp-sticky-container').find('.product-error');
	                }
	            }
	            var relatedProductErrorDiv = $(data.form_id + ' .related-product-error');
	            var errorCount = 0;
	            if (data.errorCode) {
	                errorCount++;
	                if (data.errorCode == 2510) {
	                    // session timeout
	                    document.location.href = 'Logoff?URL=ReLogonFormView';
	                    return;
	                } else {
	                    if (data.errorCode && data.errorMessage) {
	                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</label>" + "<p class=\"span\">" + data.errorCode + data.errorMessage + "</p>");
	                        COSTCO.util.logToClickTale(data, location.href, 151);
	                        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                            $('#minQtyText ').addClass('error');
	                        }
	                    } else {
	                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</label>" + "<p class=\"span\" System Error adding to cart, please retry at a later time </p>");
	                        COSTCO.util.logToClickTale(data, location.href, 152);
	                    }
	                }
	            } else {
	                if (data.orderErrMsgObj) {
	                    var errors = data.orderErrMsgObj;
	                    var errorLoc = data.orderErrMsgLocObj;
	                    for (var errorKey in errors) {
	                        if (errors.hasOwnProperty(errorKey)) {
	                            errorCount++;
	                            var isErrorPopup = false;
	                            if (errorLoc.hasOwnProperty(errorKey)) {
	                                if (errorLoc[errorKey] === 'popup') isErrorPopup = true;
	                            }
	                            var errorMsg = errors[errorKey].replace('~', ',').replaceAll("''", "'");
	                            if (isErrorPopup) {
	                                var msgContent = errorMsg;
	                                if (COSTCO.util.isCAStore() && COSTCO.Header.checkIsRestricted()) {
	                                    msgContent = messages.GROCERY_ITEM_UNAVAILABLE_TEXT;
	                                }
	                                var modalOptions = {
	                                    title: messages.GROCERY_ITEM_UNAVAILABLE_TITLE,
	                                    body: '<p>' + msgContent + '</p>',
	                                    primary: messages.GROCERY_ITEM_UNAVAILABLE_PRIMARY,
	                                    primary_event: function primary_event() {
	                                        COSTCO.dialog.close();
	                                    }
	                                };
	                                COSTCO.dialog.showAndHideModal(modalOptions);
	                            } else if (errorKey === messages.SHIP_RESTRICTION_ERROR_KEY || errorKey === messages.SHIP_RESTRICTION_ERROR_KEY_CA || errorKey === messages.ERR_OMS_INVENTORY_API_FAILURE_ERROR) {
	                                productErrorDiv.append('<p class="alert-notification">' + errorMsg + '</p>');
	                                $('.product-error').removeClass('error');
	                                $('#prod-page-restriction').removeClass('hide');
	                            } else {
	                                if (errorKey === messages.RELATED_ITEM_ADD_ERROR_KEY) {
	                                    relatedProductErrorDiv.append('<p class="error">' + errorMsg + "</p>");
	                                } else {
	                                    if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	                                        errorMsg = errorMsg.replace(/&lt;/g, '<');
	                                        errorMsg = errorMsg.replace(/&gt;/g, '>');
	                                        productErrorDiv.append('<span><p class="sr-only">Error</p>' + errorMsg + '</span>');
	                                        productErrorDiv.removeClass('hide');
	                                        productErrorDiv.focus();
	                                        if (Object.keys(oosFreeGiftAnalyticsMessages).includes(errorKey)) {
	                                            window.digitalDataEvents = window.digitalDataEvents || [];
	                                            digitalDataEvents.push({ uimsg: 'ProductDetail | Buy One Get One Free | Error | ' + oosFreeGiftAnalyticsMessages[errorKey] });
	                                        }
	                                    } else {
	                                        productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</span>" + '<p class="error">' + errorMsg + '</p>');
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return errorCount;
	        },
	
	        product_form_done: function product_form_done(data, textStatus, xhr) {
	            if (COSTCO.AddToCart.has_error(data) == 0) {
	                var paramData = data;
	                if (data.redirecturl != null) {
	                    urlWithoutQueryString = data.redirecturl.split('?')[0];
	                    var appType = $('#applicationType').val();
	                    if (urlWithoutQueryString.indexOf('CatalogSearch') != -1 || urlWithoutQueryString.indexOf('CategoryDisplay') != -1 || urlWithoutQueryString.indexOf('.html') != -1 && urlWithoutQueryString.indexOf('.product.') == -1 || appType !== undefined && appType === 'BC' && urlWithoutQueryString.indexOf('QuickMembershipApplicationView') !== -1 || urlWithoutQueryString.indexOf('MembershipApplicationView') !== -1) {
	                        var url = data.redirecturl;
	                        delete data.redirecturl;
	                        delete data.selected_products;
	                        var params = $.param(data);
	                        var decodedUrl = $("<div/>").html(url).text();
	                        var finalUrl;
	                        if (decodedUrl.indexOf('?') != -1) {
	                            if (decodedUrl.substr(decodedUrl.length - 1) == '&') {
	                                finalUrl = decodedUrl + params;
	                            } else {
	                                finalUrl = decodedUrl + '&' + params;
	                            }
	                        } else {
	                            finalUrl = decodedUrl + '?' + params;
	                        }
	                        document.location.href = finalUrl;
	                        return;
	                    }
	                }
	                // Invoke add to cart modal
	                phelper.added_modal(data.selected_products, data.orderItemId, data.itemMessage, data.originalQuantity);
	                var quantity = '1';
	                var langId = parseInt(COSTCO.util.getLangId());
	                if (langId == -1 || langId == -24) {
	                    quantity = data.selected_products[0].quantity.replace("Quantity ", "");
	                } else {
	                    quantity = data.selected_products[0].quantity.replace("Quantité ", "");
	                }
	
	                var price = data.selected_products[0].final_price.replace(" $", "");
	                var partNumber = parseInt(data.selected_products[0].partNumber);
	                var orderItemId = data.orderItemId;
	                var qtyBought = data.itemMessage;
	                var itemInventory = data.selected_products[0].inventory === "IN_STOCK" ? "In stock" : "Out of stock";
	                var orderId = data.orderId;
	                var data = {
	                    partNumber: partNumber,
	                    price: price,
	                    quantity: quantity,
	                    orderItemId: orderItemId,
	                    qtyBought: qtyBought
	                };
	
	                $('body').trigger("costco.cart.item.added", [data]);
	
	                var windsorProductData = {
	                    partNumber: partNumber,
	                    price: price,
	                    quantity: qtyBought,
	                    inventory: itemInventory
	                };
	                try {
	                    if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
	                        if (typeof contextVariables != 'undefined' && typeof adobeProductData != 'undefined' && typeof adobeProductData[0] != 'undefined') {
	                            contextVariables.orderId = orderId;
	                            adobeProductData[0].quantity = parseInt(quantity);
	                            if (!($('#mymdGenericItemNumber').length > 0 && $('#mymdGenericItemNumber').val() == adobeProductData[0].SKU)) {
	                                COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListAdds', adobeProductData, adobeAnalyticsCommonData, contextVariables);
	                            }
	                        }
	                    }
	                } catch (err) {
	                    console.log('Problem with sending product data to Adobe');
	                }
	
	                $('body').trigger("windsor.product.cart.item.added", [windsorProductData]);
	                $('#related-products-container').find('.sign-in').on("click", function () {
	                    sessionStorage.setItem('AddedToCartModalData', JSON.stringify(paramData));
	                    window.digitalDataEvents = window.digitalDataEvents || [];
	                    digitalDataEvents.push({
	                        event: "interface interaction",
	                        interfaceInteractionName: "sign in for price"
	                    });
	                });
	            }
	            if ($('#isPickUpItem').val() != 'true') {
	                $('#add-to-cart input').removeAttr('disabled');
	                $('input[name=quantity]').removeAttr('disabled');
	            }
	        },
	
	        product_form_fail: function product_form_fail() {
	            $('#add-to-cart input').removeAttr('disabled');
	            $('input[name=quantity]').removeAttr('disabled');
	        },
	
	        product_form_always: function product_form_always() {
	            $('#add-to-cart input').removeAttr('disabled');
	            $('input[name=quantity]').removeAttr('disabled');
	            COSTCO.Header.miniShopCartRefresh();
	        },
	
	        related_done: function related_done(data, textStatus, xhr) {
	            if (COSTCO.AddToCart.has_error(data) == 0) {
	                var addedToCartMessage = data.itemMessage == 1 ? messages.PDETAIL_ITEMS_ADDED_TO_CART : messages.PDETAIL_ITEMS_ADDED_TO_CART2;
	
	                $(data.form_id).find('.form_and_button').addClass('hide');
	                $(data.form_id).find('.ctas').addClass('hide');
	                $(data.form_id).find('.related-success').append('<p><i class="co-checkmark"></i> ' + addedToCartMessage + '</p>');
	
	                //if called on replacement products modal on checkout pages, disable Cancel button to force user to go to View Cart
	                if (typeof checkoutPage !== 'undefined') {
	                    $('.related-products.replacements .add-buttons .btn-tertiary').prop('disabled', true);
	                }
	            } else {
	                $(data.form_id).find('button.add-to-cart').removeAttr('disabled');
	            }
	        },
	
	        related_fail: function related_fail(data, textStatus, errorThrown) {
	            $(data.form_id).find('.product-error').append(errorThrown);
	            $(data.form_id).find('button.add-to-cart').removeAttr('disabled');
	        },
	
	        related_always: function related_always(data, textStatus, errorThrown) {
	            COSTCO.Header.miniShopCartRefresh();
	        },
	
	        getUrlParameter: function getUrlParameter(sParam) {
	            var sPageURL = decodeURIComponent(window.location.search.substring(1));
	            var sURLVariables = sPageURL.split('&');
	
	            for (var i = 0; i < sURLVariables.length; i++) {
	                var sParameterName = sURLVariables[i].split('=');
	
	                if (sParameterName[0] === sParam) {
	                    return sParameterName[1] === undefined ? true : sParameterName[1];
	                }
	            }
	        },
	
	        removeItemFromCart: function removeItemFromCart(orderId, orderItemsId, redirectUrl) {
	            var urlParam = { 'actionType': 'delete',
	                'backURL': redirectUrl,
	                'orderId': orderId,
	                'orderItemId': orderItemsId
	            };
	            var removeItemfromCartUrl = 'ManageShoppingCartCmd?' + jQuery.param(urlParam);
	            console.log(removeItemfromCartUrl);
	            window.location.href = removeItemfromCartUrl;
	        },
	
	        removeMembersipItemFromCart: function removeMembersipItemFromCart() {
	            var orderId = COSTCO.AddToCart.getUrlParameter('orderId');
	            var orderItemId = void 0;
	            if (orderId == undefined) {
	                orderId = $('#membershipOrderId').val();
	                orderItemId = $('#membershipOrderItemId').val();
	            } else {
	                orderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
	            }
	
	            COSTCO.AddToCart.removeItemFromCart(orderId, orderItemId, "/");
	        },
	        acceptTermsAndConditions: function acceptTermsAndConditions() {
	
	            var command = '/UpdateTermsAndConditions';
	            var urlForRedirection = COSTCO.AddToCart.getUrlParameter('urlForRedirection');
	            var quickMembership = COSTCO.AddToCart.getUrlParameter('quickMembership');
	            var fromCheckout = COSTCO.AddToCart.getUrlParameter('fromCheckout');
	            var membershipOrderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
	
	            var urlParam = { 'fromCheckout': fromCheckout,
	                'quickMembership': quickMembership,
	                'urlForRedirection': urlForRedirection,
	                'membershipOrderItemId': membershipOrderItemId };
	
	            var updateTermsAndConditions = command + '?' + jQuery.param(urlParam);
	            window.location.href = updateTermsAndConditions;
	        }
	
	    };
	    if (typeof window.COSTCO == 'undefined') {
	        window.COSTCO = new Object();
	    }
	    window.COSTCO.AddToCart = AddToCart;
	
	    return AddToCart;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title scheduledDeliverable.js: Sub-module
	 * @description Associated with DeliverableAvailabilityForm.jsp and ScheduleDeliverableModal
	 *
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (phelper) {
	  var ScheduledDeliverable = {
	    init: function init() {
	      if ($('#DeliveryAvailabilityForm').length > 0 || $('.parts-and-services').length > 0) {
	        //this.registerOnClickGoButton();
	        $("#reset-delivery-form").unbind('click').click(function () {
	          COSTCO.ScheduledDeliverable.resetDeliverableForm();
	        });
	        $("#reset-delivery-form-error").unbind('click').click(function () {
	          COSTCO.ScheduledDeliverable.resetDeliverableForm();
	        });
	        COSTCO.ScheduledDeliverable.maskZipInput();
	        COSTCO.ScheduledDeliverable.maskPhone();
	        COSTCO.ScheduledDeliverable.validationRules.phone();
	        COSTCO.ScheduledDeliverable.popovers();
	        $('body').bind("costco.address.added", function (event, address) {
	          COSTCO.ScheduledDeliverable.maskPhone();
	          COSTCO.ScheduledDeliverable.validationRules.phone();
	        });
	
	        $(window).on('beforeunload', function () {
	          sessionStorage.removeItem('DeliveryReservationCalendarData');
	        });
	      }
	    },
	    popovers: function popovers() {
	      $('.co-help').popover();
	    },
	    validate: {
	      deliveryAvailabilityForm: function deliveryAvailabilityForm(form) {
	        COSTCO.ScheduledDeliverable.validationRules.zipcode();
	        return $(form).validate({
	          rules: {
	            deliveryZipCode: {
	              required: true,
	              countryspecificpostalcodePassCountrySelectorModal: true
	            }
	          },
	          messages: {
	            deliveryZipCode: messages.SCHD_ENTER_VALID_ZIP_CODE
	          },
	          invalidHandler: function invalidHandler(event, validator) {
	            validator.errorList[0].element.focus();
	          },
	          highlight: COSTCO.util.highlightWithErrorLabel,
	          unhighlight: COSTCO.util.unhighlightWithErrorLabel
	        }).form();
	      },
	      partsAndServicesPhone: function partsAndServicesPhone(element) {
	        var form = element.form;
	        var validator = $(form).validate();
	        $('input[id^="contactPhone"]').each(function (i, input) {
	          $(input).rules("add", {
	            required: true,
	            contactPhone: true,
	            messages: {
	              contactPhone: messages.ERR_INVALID_PHONE1
	            }
	          });
	        });
	        return validator.element("#" + element.id);
	      },
	      partsAndServicesDeliverableDates: function partsAndServicesDeliverableDates(element) {
	        var form = element.form;
	        var validator = $(form).validate();
	        $('input[id^="deliveryDate"]').each(function (i, input) {
	          $(input).rules("add", {
	            required: true
	          });
	        });
	        return validator.element("#" + element.id);
	      }
	    },
	    validationRules: {
	      phone: function phone() {
	        $.validator.addMethod("contactPhone", function (value, element) {
	          if (value.startsWith("0") || value.startsWith("1")) {
	            return false;
	          }
	          return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
	        }, messages.ERR_INVALID_PHONE1);
	      },
	      zipcode: function zipcode() {
	        $.validator.addMethod("countryspecificpostalcodePassCountrySelectorModal", function (value, element) {
	          return !COSTCO.ScheduledDeliverable.isUS() ? this.optional(element) || /^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} \d{1}[A-Za-z]{1}\d{1}$/.test($.trim(value)) : this.optional(element) || /^(\d{5}(-\d{4})?$)$/.test($.trim(value));
	        }, messages.ERR_ENTER_ZIPCODE);
	      }
	    },
	    isUS: function isUS() {
	      if (COSTCO.util.getLangId() != -1) {
	        return false;
	      }
	      return true;
	    },
	    /**
	     * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val() to get unformatted value
	     */
	    maskZipInput: function maskZipInput() {
	      if (COSTCO.ScheduledDeliverable.isUS()) {
	        $('#delivery-zip').unmask().mask('00000');
	      } else {
	        $('#delivery-zip').unmask().mask('S0S 0S0');
	      }
	    },
	    maskPhone: function maskPhone() {
	      $('input[id^="contactPhone"]').each(function (i, input) {
	        $(input).unmask().mask('000-000-0000');
	      });
	    },
	    registerOnClickGoButton: function registerOnClickGoButton() {
	      $("#submit-delivery-area").unbind('click').click(function () {
	        disableZipInput();
	        var vendorSku = $('#deliveryVendorSku').val();
	        var zipcode = $('#delivery-zip').val();
	        var zipcodeCookie = $.cookie('invCheckPostalCode');
	        var productSku = $('#productPartnumberVal').val();
	        var url = "AjaxDeliveryReservationCalendarCmd?storeId=10301&deliveryVendorSku=" + vendorSku + "&zipCode=" + zipcode + "&productSku=" + productSku;
	        if (zipcode === zipcodeCookie) {
	          COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
	            sku: vendorSku,
	            url: url,
	            productSku: productSku,
	            zipCode: zipcode
	          });
	        } else {
	
	          var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	          serviceToUpdateCookies(zipcode).then(function () {
	            var state = $.cookie('invCheckStateCode');
	            window.wioEventBus.publish('changeDeliveryLocation', zipcode);
	          }).fail(function (data) {
	            // bing failed
	            $('#zip-group').addClass('hide');
	            var errorContainer = $('#zip-group').find('label.error');
	            errorContainer.empty();
	            errorContainer.append(messages.ERR_ENTER_ZIPCODE);
	            errorContainer.show();
	          });
	        }
	      });
	    },
	    setDeliverableInputsFromSelectedProduct: function setDeliverableInputsFromSelectedProduct() {
	      var selectedProduct = COSTCO.Product.getSelectedBundleAndVariantItems();
	      $('#deliveryVendorSku').val(selectedProduct[0].manufacturerPartNumber);
	    },
	    disableZipInput: function disableZipInput() {
	      $('#zip-group').addClass("order-ajax ajax-busy");
	    },
	    enableZipInput: function enableZipInput() {
	      $('#zip-group').removeClass("order-ajax ajax-busy");
	    },
	    disableQtyInput: function disableQtyInput() {
	      $('#select-options').addClass("order-ajax ajax-busy");
	      $('#qty-input').addClass("order-ajax ajax-busy");
	      $('#qty').addClass("order-ajax ajax-busy");
	    },
	    enableQtyInput: function enableQtyInput() {
	      $('#select-options').removeClass("order-ajax ajax-busy");
	      $('#qty-input').removeClass("order-ajax ajax-busy");
	      $('#qty').removeClass("order-ajax ajax-busy");
	    },
	    /**
	     * Calls bing and updates zip/state/city cookies
	     * @retrns jquery Deferred object
	     */
	    callBingOrGeocodeAndUpdateCookies: function callBingOrGeocodeAndUpdateCookies(event) {
	
	      var deferred = $.Deferred();
	      var zipcode = $('#delivery-zip').val();
	      var updateCookieValues = function updateCookieValues(data) {
	        if ($('#isGeocodeService').val() != "true") {
	          var _totalResponses = data.resourceSets[0].estimatedTotal;
	        } else {
	          var _totalResponses2 = data.length;
	        }
	        var province = null;
	        var country = null;
	        var city = null;
	        if (totalResponses != 0) {
	          if ($('#isGeocodeService').val() != "true") {
	            city = data.resourceSets[0].resources[0].address.locality;
	            try {
	              //Check out if country is Puerto Rico specific
	              country = data.resourceSets[0].resources[0].address.countryRegionIso2;
	              if (country != undefined && country === 'PR') {
	                province = data.resourceSets[0].resources[0].address.countryRegionIso2;
	                country = 'US';
	              } else {
	                province = data.resourceSets[0].resources[0].address.adminDistrict;
	              }
	            } catch (e) {
	              province = "";
	            }
	          } else {
	            try {
	              city = data[0].city;
	              province = data[0].stateProvinceAbbreviation;
	              if (province == null) {
	                province = data[0].stateProvince;
	              }
	              country = data[0].country;
	            } catch (e) {
	              console.error('Error: ' + e.message);
	            }
	          }
	          $.cookie("invCheckPostalCode", zipcode);
	          $.cookie("invCheckStateCode", province);
	          $.cookie("invCheckCity", city);
	
	          window.location.reload();
	          deferred.resolve(data);
	        } else {
	          errorMessage = messages.SHIP_RESTRICTION_INVALID_MESSAGE;
	          errorMessage = errorMessage.replace(/\{0\}/g, zipcode);
	          var productErrorDiv = $('.product-error');
	          $(".product-error").empty();
	          productErrorDiv.append('<p class="alert-notification">' + errorMessage + '</p>');
	          deferred.reject();
	        }
	      };
	      if ($('#isGeocodeService').val() != "true") {
	        COSTCO.util.callBing(zipcode, updateCookieValues);
	      } else {
	        COSTCO.util.callGeocodeAPI(zipcode, updateCookieValues);
	      }
	
	      return deferred.promise();
	    },
	    validateEDDScheduledDelivery: function validateEDDScheduledDelivery(event) {
	      event.preventDefault();
	      if (COSTCO.ScheduledDeliverable.validate.deliveryAvailabilityForm(event.currentTarget.form || event.currentTarget)) {
	        var zipcode = $('#delivery-zip').val();
	        window.wioEventBus.publish('changeDeliveryLocation', zipcode);
	      } else {
	        $('#deliveryFailMessage').removeClass('hide');
	        $('#zip-group').addClass('hide');
	        $('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
	        $('#geDeliveryFailMessageSpan').text(messages.ERR_GROCERY_INVALID_ZIP);
	      }
	    },
	
	    availabilityFormOnSubmit: function availabilityFormOnSubmit(event) {
	      event.preventDefault();
	      if (COSTCO.ScheduledDeliverable.validate.deliveryAvailabilityForm(event.currentTarget.form || event.currentTarget)) {
	        var zipcode = $('#delivery-zip').val();
	        var zipcodeCookie = $.cookie('invCheckPostalCode');
	        var vendorSku = '';
	        if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
	          vendorSku = $('#deliveryVendorSku').val();
	        } else {
	          vendorSku = $('#deliveryVendorSkuArr').val();
	        }
	        var productSku = $('#productPartnumberVal').val();
	        var url = "AjaxDeliveryReservationCalendarCmd?storeId=10301&deliveryVendorSku=" + vendorSku + "&zipCode=" + zipcode + "&productSku=" + productSku;
	        $('#deliveryAvailabilityZip').val(zipcode);
	
	        var response = '';
	
	        if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
	          response = ScheduledDeliverable.doesDeliveryAvailablityExists(vendorSku, zipcode);
	        }
	
	        var serviceToUpdateCookies = $('#isGeocodeService').val() != "true" ? COSTCO.util.callBingAndUpdateCookies : COSTCO.util.callGeocodeAPIAndUpdateCookies;
	
	        if (zipcode === zipcodeCookie) {
	          if (response != '') {
	            ScheduledDeliverable.deliveryCalendarSuccess(response);
	          } else {
	            COSTCO.ScheduledDeliverable.submitDeliverableAvailabilityAjax({
	              sku: vendorSku,
	              url: url,
	              productSku: productSku,
	              zipCode: zipcode
	            });
	          }
	        } else {
	          if (response != '') {
	            ScheduledDeliverable.deliveryCalendarSuccess(response);
	          } else {
	            serviceToUpdateCookies(zipcode).then(function () {
	              var state = $.cookie('invCheckStateCode');
	              window.wioEventBus.publish('changeDeliveryLocation', zipcode);
	            }).fail(function (data) {
	              // bing failed
	              $('#zip-group').addClass('hide');
	              var errorContainer = $('#zip-group').find('label.error');
	              errorContainer.empty();
	              errorContainer.append(messages.ERR_ENTER_ZIPCODE);
	              errorContainer.show();
	            });
	          }
	        }
	      }
	    },
	    submitDeliverableAvailabilityAjax: function submitDeliverableAvailabilityAjax(settings) {
	      COSTCO.ScheduledDeliverable.disableZipInput();
	      COSTCO.util.ajaxSend();
	      $.ajax({
	        url: "/" + settings.url,
	        type: 'POST',
	        dataType: 'json',
	        success: function success(data, textStatus, xhr) {
	          if (costcoStoreFeatures.GE_RESPONSE_CACHEING_ENABLED) {
	            ScheduledDeliverable.cacheDeliveryAvailability(data);
	          }
	          ScheduledDeliverable.deliveryCalendarSuccess(data);
	        },
	        complete: function complete() {
	          COSTCO.ScheduledDeliverable.enableZipInput();
	          COSTCO.util.ajaxComplete();
	        }
	      });
	    },
	    resetDeliverableForm: function resetDeliverableForm(url) {
	      $('#prod-page-delivery').removeClass('hide').addClass('form-group');
	      //$('#DeliveryAvailabilityForm')[0].reset();
	      $('#deliveryDateMessage').addClass('hide');
	      $('#deliveryFailMessage').addClass('hide');
	      $('#deliveryLocationText').addClass('hide');
	      $('#zip-group').removeClass('hide');
	      $('#deliveryInfoText').addClass('hide');
	      $('#geDeliveryFailMessageSpan').text('');
	      $('[name=select-options]').prop("disabled", true);
	      $("[name='select-options']").unbind('click');
	      $('#delivery-zip').focus();
	      $('#sign-in-to-buy-button-v2').removeClass('primary-button-v2').addClass('secondary-button-v2');
	      $('#link-membership-for-price').removeClass('primary-button-v2').addClass('secondary-button-v2');
	
	      for (var i = 0; i < products[0].length; i++) {
	        if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
	          products[0][i].zipcodeAvailabilityMessage = '0';
	          products[0][i].zipcodeAvailabilityResponseCode = COSTCO.util.productConstants.check_StatusSuccess;
	        }
	      }
	    },
	    attachEventSelectOptions: function attachEventSelectOptions(settings) {
	      //Enable select options button
	      $("[name='select-options']").removeAttr('disabled');
	      $("[name='select-options']").unbind('click').click(function () {
	        //check does variants selected
	        if ("unselected" != $('select[type="select-variants"] option:selected').val()) {
	          // COSTCO.util.ajaxSend();
	          //call GetParts Webservice
	          $.ajax({
	            url: '/AjaxGetPartsAndServicesDeliveryCmd?deliveryVendorSku=' + settings.sku + '&zipCode=' + settings.zipCode + '&categoryCode=' + settings.categoryCode,
	            type: 'POST',
	            //data: cleanData,
	            dataType: 'json',
	            success: function success(data, textStatus, xhr) {
	              if (data.errorCode) {
	                if (data.errorCode == 2510) {
	                  // session timeout
	                  document.location.href = 'Logoff?URL=ReLogonFormView';
	                  return;
	                }
	              }
	              //console.log('Success !!'+JSON.stringify(data.DeliveryJSONResponse));
	              COSTCO.ScheduledDeliverable.showSelectOptionsModal(JSON.parse(data.DeliveryJSONResponse));
	            },
	            complete: function complete() {
	              COSTCO.util.ajaxComplete();
	            }
	          });
	        } else {
	          $product_error = $('#ProductForm').find('.product-error');
	          $product_error.html(messages.ERR_ADD_TO_CART_SELECT_ONE);
	        }
	      });
	    },
	    showSelectOptionsModal: function showSelectOptionsModal(data) {
	      //set global variable to capture service selection form user in Select options modal.
	      partsandservices = data;
	      //Show modal
	      phelper.show_options_modal(data);
	      //attach onclick event event to add-to-cart button on select options modal
	      $("[name='select-options-addtocart']").unbind('click').click(function () {
	        COSTCO.ScheduledDeliverable.selectOptionsAddToCartBtnClick();
	      });
	    },
	    selectOptionsAddToCartBtnClick: function selectOptionsAddToCartBtnClick() {
	
	      $('#ProductForm #configuredInfo').val(JSON.stringify(partsandservices));
	      $('#ProductForm #configuredInfoType').val("7");
	
	      $('#costcoModal').on('hidden.bs.modal', function (e) {
	        $('#ProductForm').submit();
	      });
	
	      $('#costcoModal').modal('hide');
	    },
	    servicesSelection: function servicesSelection(element) {
	      COSTCO.ScheduledDeliverable.selectServicesById(element.name, $(element).is(':checked') ? true : false);
	    },
	    selectServicesById: function selectServicesById(id, selected) {
	      $.each(partsandservices.services, function (index, value) {
	        if (value.id == id) {
	          value.selected = selected;
	          return;
	        }
	      });
	    },
	    hideServicesById: function hideServicesById(id, selected) {
	      $.each(partsandservices.services, function (index, value) {
	        if (value.id == id) {
	          value.hidden = selected;
	          return;
	        }
	      });
	    },
	    /**
	     * Creates list of parts and services html to be added to a modal.
	     * @param data = Parts and Services JSON
	     * @return htmls array  - Array that contains HTML for parts and services list
	     * and HTML for remarks
	     *
	     */
	    create_parts_and_services_list: function create_parts_and_services_list(data) {
	      //Services
	      var servicesList = new Array();
	      var partsList = new Array();
	      var dishwasherPartsList = new Array();
	      var servicesPartsRemarksList = new Array();
	      var remark_html = '';
	      var remarkMade = false;
	
	      $.each(data.services, function (index, value) {
	        if (value.serviceType.toUpperCase() == 'SERVICE') {
	          servicesList.push(value);
	        } else if (value.serviceType.toUpperCase() == 'PART' && value.groupId == 1) {
	          dishwasherPartsList.push(value);
	        } else if (value.serviceType.toUpperCase() == 'PART') {
	          partsList.push(value);
	        }
	        if (value.remark != "undefined" && value.remark != "" && value.remark != null && value.availabilityType != 'hidden') {
	          servicesPartsRemarksList.push(value);
	          remarkMade = true; //indicate that we need to add the remarks container
	          remark_html += COSTCO.util.tmpl('tmpl_delivery_service_remark', { remark: value.remark });
	        }
	      });
	
	      // Add services not included to remark list
	      if (data.installationAvailable != undefined && data.installationAvailable != 'true') {
	        if (data.installationAvailabilityText != undefined && data.installationAvailabilityText.trim().length > 0) {
	          remarkMade = true;
	          remark_html += COSTCO.util.tmpl('tmpl_delivery_service_remark', {
	            remark: messages.SCHED_DELIV_NO_INSTALLATION_ALERT
	          });
	        }
	      }
	
	      var partsservices_html = '';
	      var dishwasherParts_html = '';
	
	      $.each(servicesList, function (index, value) {
	        var yesChecked = 'checked';
	        var noChecked = '';
	        if (!value.selected) {
	          yesChecked = '';
	          noChecked = 'checked';
	        }
	        partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_service', {
	          description: value.question,
	          code: value.id,
	          yes_checked: yesChecked,
	          no_checked: noChecked
	        });
	      }); //end loop
	      var remark_container_html = '';
	      if (remarkMade) {
	        remark_container_html += COSTCO.util.tmpl('tmpl_delivery_service_remark_container', {
	          remarks: remark_html
	        });
	      }
	
	      //Display the rest of the part list
	      $.each(partsList, function (index, value) {
	        if (value.availabilityType == undefined || value.availabilityType == 'visible' || value.availabilityType == 'null' || value.availabilityType == "") {
	          if (value.description.toUpperCase().includes(":")) {
	            var new_description_array = value.description.split(":");
	            var new_description = new_description_array[0];
	            var new_description_remark = new_description_array[1];
	            partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_description_remark', {
	              description: new_description,
	              remark: new_description_remark
	            });
	          } else if (!value.selected) {
	            partsservices_html += COSTCO.util.tmpl('tmpl_deselected_delivery_parts_description', {
	              description: value.description
	            });
	          } else {
	            partsservices_html += COSTCO.util.tmpl('tmpl_selected_delivery_parts_description', {
	              description: value.description
	            });
	          }
	        }
	      });
	
	      if (dishwasherPartsList.length > 0) {
	        // sort the Array so that parent records go on top (without dependency id's)
	        // this will also put them into a better numerical order if more DW hose lengths are used
	        dishwasherPartsList.sort(function (a, b) {
	          var depIdA = a.dependent_service_ids.length;
	          var depIdB = b.dependent_service_ids.length;
	          if (depIdA < depIdB) {
	            return -1;
	          }
	          if (depIdA > depIdB) {
	            return 1;
	          }
	          // compare must be equal
	          return 0;
	        });
	
	        // build the parent parts out into radio buttons
	        $.each(dishwasherPartsList, function (index, value) {
	          if (value.dependent_service_ids.length <= 0) {
	            // process parent records
	
	            var dishwasherRadioButton = document.createElement("INPUT"); // make a cool input button object
	            dishwasherRadioButton.setAttribute("type", "radio");
	            dishwasherRadioButton.setAttribute("name", value.serviceType); // part
	            dishwasherRadioButton.setAttribute("class", "control__indicator"); // bootstrap for radio button
	            dishwasherRadioButton.setAttribute("id", value.id); // M911
	            if (value.selected) {
	              // true
	              dishwasherRadioButton.setAttribute("checked", "checked"); // sets the default checked radio button
	              //note: the attribute that sets the default stays on that element even after the selection changes
	            }
	            dishwasherRadioButton.setAttribute("onchange", "COSTCO.ScheduledDeliverable.dishwasherPartsSelect(this)");
	            //note: onchange does not trigger when the radio button changes to a de-selected state (its much like a onclick)
	
	            var dishwasherRadioButtonToHTML = dishwasherRadioButton.outerHTML; // convert it for passing to template
	
	            if (value.selected == true && value.dependent_service_ids.length <= 0) {
	              dishwasherParts_html = COSTCO.util.tmpl('tmpl_selectable_delivery_dishwasher_parts', {
	                costco_ge_dishwasher_part_radio_button: dishwasherRadioButtonToHTML,
	                description: value.description
	              }) + dishwasherParts_html;
	            } else {
	              dishwasherParts_html += COSTCO.util.tmpl('tmpl_selectable_delivery_dishwasher_parts', {
	                costco_ge_dishwasher_part_radio_button: dishwasherRadioButtonToHTML,
	                description: value.description
	              });
	            }
	          }
	        });
	        //put the radio buttons into a container
	        dishwasherParts_html = '<div class="costco_ge_dishwasher_parts_container">' + '<p class="body-copy-bold">' + messages.SCHED_DELIV_DISHWASHER_KIT + '</p>' + dishwasherParts_html + '</div>';
	        partsservices_html += dishwasherParts_html;
	      }
	
	      var htmls = {
	        'partsservices_html': partsservices_html,
	        'remark_html': remark_container_html
	      };
	      return htmls;
	    },
	    /**
	     * Gathers required data from JSON's embedded in the HTML and
	     * launches the EditParts and Services Modal
	     * @param orderItemID = ID for the given item in the cart. Needed to references
	     * embedded JSON in HTML.
	     *
	     */
	    editPartsAndServices: function editPartsAndServices(orderItemId) {
	      var selected_product = $("#modalData_" + orderItemId).text();
	      selected_product = $.parseJSON(selected_product);
	      var scheduledDeliveryConfig = $("#scheduledDeliveryConfig_" + orderItemId).text();
	      scheduledDeliveryConfig = $.parseJSON(scheduledDeliveryConfig);
	      //create global variable
	      partsandservices = scheduledDeliveryConfig;
	      var options_htmls = COSTCO.ScheduledDeliverable.create_parts_and_services_list(scheduledDeliveryConfig);
	      partsservices_html = options_htmls['partsservices_html'];
	      remark_container_html = options_htmls['remark_html'];
	      var items_html = COSTCO.util.tmpl('tmpl_edit_delivery_Item_services', {
	        img_url: selected_product.img_url,
	        item_name: selected_product.item_name,
	        item_url: selected_product.item_url,
	        item_number: selected_product.item_number,
	        partsservices: partsservices_html,
	        remarksContainer: remark_container_html
	      });
	      $('.modal-footer').addClass('hide');
	      COSTCO.dialog.createExtDialogBox({
	        title: messages.SCHED_DELIV_EDIT_OPTIONS_HEADING,
	        body: COSTCO.util.tmpl('tmpl_edit_options_modal', {
	          items: items_html
	        }),
	        onclose: function onclose() {
	          $('.modal-footer').removeClass('hide');
	        }
	      });
	      //attach onclick event event to save changes button on edit options modal
	      $("[name='select-options-edit-config']").unbind('click').click(function () {
	        COSTCO.ScheduledDeliverable.editSchedDeliveryConfigBtnClick(orderItemId, scheduledDeliveryConfig);
	      });
	    },
	    /**
	     * Updates the server and local copies of ScheduledDeliveryConfig with updates
	     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
	     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
	     */
	    editSchedDeliveryConfigBtnClick: function editSchedDeliveryConfigBtnClick(orderItemId, scheduledDeliveryConfig) {
	      window.COSTCO.ScheduledDeliverable.updateLocalCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig);
	      window.COSTCO.ScheduledDeliverable.updateServerCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig);
	    },
	    /**
	     * Updates the local copy of ScheduledDeliveryConfig with updates
	     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
	     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
	     */
	    updateLocalCopySchedDeliveryConfig: function updateLocalCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig) {
	      //update the JSON in the page
	      var configJson = JSON.stringify(scheduledDeliveryConfig);
	      var $configJsonContainer = $("#scheduledDeliveryConfig_" + orderItemId);
	      $configJsonContainer.text(configJson);
	      //loop through and update response in the services text
	      $.each(scheduledDeliveryConfig.services, function (index, value) {
	        if (value.serviceType == 'Service') {
	          var serviceId = value.id;
	          var $responseContainer = $("#scheduledDeliveryServiceResponse_" + orderItemId + "_" + serviceId);
	          if (value.selected) {
	            $responseContainer.text(messages.SCHED_DELIVY_SERVICE_YES);
	          } else {
	            $responseContainer.text(messages.SCHED_DELIVY_SERVICE_NO);
	          }
	        }
	      });
	    },
	    /**
	     * Updates the server copy of ScheduledDeliveryConfig with updates. Will close any modal id=costcoModal
	     * @param orderItemId - identifies the cart entry the ScheduledDeliveryConfig is associated with
	     * @param scheduledDeliveryConfig - JSON that contains all Scheduled Delivery information
	     */
	    updateServerCopySchedDeliveryConfig: function updateServerCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfig) {
	      var url = '/AjaxUpdateScheduledDeliveryCmd?storeId=10301&orderItemId=' + orderItemId;
	      console.log(scheduledDeliveryConfig);
	      var configJson = JSON.stringify(scheduledDeliveryConfig);
	      console.log(configJson);
	      var req = encodeURIComponent(configJson);
	      //submitAjax(url, req, "Upated Parts and Services", $('#updateMessage'), $('#results'));
	      $.ajax({
	        url: url,
	        type: 'POST',
	        data: 'payload=' + req,
	        dataType: 'json',
	        success: function success(data, textStatus, xhr) {
	          if (data.errorCode) {
	            if (data.errorCode == 2510) {
	              // session timeout
	              document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	              return;
	            }
	          } else {
	            if (data.code == 500) {
	              console.log(data.message);
	            } else {
	              console.log(data.message);
	              //close modal
	              $('#costcoModal').modal('hide');
	            }
	          }
	        }
	      });
	    },
	    handlePartsAndServicesEdit: function handlePartsAndServicesEdit(element, orderItemId) {
	      if (COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId != orderItemId) {
	        var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
	        var hasErrors = false;
	        var serviceType = $(element).attr('service-type');
	        if (serviceType == 'service') {
	          $.each(scheduledDeliveryConfigJSON.services, function (i, service) {
	            if ($(element).attr('name') == service.id) {
	              service.selected = $(element).is(':checked');
	              return false; // break for each loop
	            }
	          });
	        } else if (serviceType == 'Part') {
	          var partSelected = $(element).attr("id");
	          $.each(scheduledDeliveryConfigJSON.services, function (i, service) {
	            //reset all parts to unselected
	            if (service.groupId == '1') {
	              service.selected = false;
	            }
	            // set part selected and it's children to selected: true
	            if (service.id == partSelected) {
	              service.selected = true;
	            }
	          });
	        } else {
	          var name = $(element).attr('name');
	          if ('deliveryDate_' + orderItemId == name) {
	            var date = $('#deliveryDate_' + orderItemId).datepicker().val();
	            if (date) {
	
	              var formattedDate = new Date(date);
	
	              // OMS needs normally formatted Date
	              var month = '' + (formattedDate.getMonth() + 1);
	              var day = '' + formattedDate.getDate();
	
	              if (month.length < 2) month = '0' + month;
	              if (day.length < 2) day = '0' + day;
	
	              var year = formattedDate.getFullYear();
	              var scheduledDeliveryJSONDate = year + '-' + month + '-' + day;
	              if (scheduledDeliveryJSONDate != scheduledDeliveryConfigJSON['deliveryDate']) {
	                var noOfItems = $('.order-item').length;
	                for (var i = 1; i <= noOfItems; i++) {
	                  var scheduledOrderItemId = $('#orderItem_' + i).val();
	                  var itemScheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + scheduledOrderItemId];
	                  if (typeof itemScheduledDeliveryConfigJSON !== 'undefined' && orderItemId != scheduledOrderItemId && $('#deliveryDate_' + scheduledOrderItemId).val() != date && !date.includes("/")) {
	                    itemScheduledDeliveryConfigJSON['deliveryDate'] = year + '-' + month + '-' + day;
	                    itemScheduledDeliveryConfigJSON['costcoErrorCode'] = null;
	                    COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId = scheduledOrderItemId;
	                    COSTCO.ScheduledDeliverable.date_picker_update($('#deliveryDate_' + scheduledOrderItemId), scheduledOrderItemId);
	                  }
	                }
	
	                scheduledDeliveryConfigJSON['deliveryDate'] = scheduledDeliveryJSONDate;
	                scheduledDeliveryConfigJSON['costcoErrorCode'] = null;
	                if (COSTCO.ScheduledDeliverable.validate.partsAndServicesDeliverableDates(element)) {
	                  $('#parts-and-service-error-message_' + orderItemId).addClass('hide');
	                  $('label[for="date_' + orderItemId + '"]').addClass('active');
	                } else {
	                  hasErrors = true;
	                }
	              } else {
	                hasErrors = true;
	              }
	            } else {
	              hasErrors = true;
	            }
	          } else if ('contactPhone_' + orderItemId == name) {
	            if (COSTCO.ScheduledDeliverable.validate.partsAndServicesPhone(element)) {
	              if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
	                scheduledDeliveryConfigJSON['contactPhone'] = $(element).val();
	              }
	            } else {
	              hasErrors = true;
	            }
	          }
	        }
	        if (!hasErrors) {
	          COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId = '';
	          COSTCO.ScheduledDeliverable.updateServerCopySchedDeliveryConfig(orderItemId, scheduledDeliveryConfigJSON);
	        }
	      }
	    },
	    togglePartsAndServices: function togglePartsAndServices(elementId1, elementId2) {
	      $('#' + elementId1).toggleClass('hide');
	      $('#' + elementId2).toggleClass('hide');
	    },
	    /**
	     * Function to convert dates from yyyy-mm-dd to mm/dd/yyyy
	     * Conversion makes datepicker ADA compliance
	     * @return array
	     */
	    convertScheduledDeliverableDates: function convertScheduledDeliverableDates(dates) {
	      for (var _i = 0; _i < dates.length; _i++) {
	        var year = dates[_i].split('-')[0];
	        var month = dates[_i].split('-')[1];
	        var day = dates[_i].split('-')[2];
	        dates[_i] = month + '/' + day + '/' + year;
	      }
	      return dates;
	    },
	    /**
	     * Holds the available schedule deliverable dates for order items.
	     * @type {Object}
	     */
	    schedule_deliveravle_dates: {},
	
	    update_deliveryDate_orderItemId: '',
	
	    date_picker_deliverable: function date_picker_deliverable(element, orderItemId) {
	      var options = [];
	      options.input = element;
	      var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
	      var available_dates = [];
	      if (scheduledDeliveryConfigJSON && scheduledDeliveryConfigJSON.deliveryAvailability) {
	        var calendar_dates = scheduledDeliveryConfigJSON.deliveryAvailability.calendar_dates;
	        if (calendar_dates) {
	          for (i = 0; i < calendar_dates.length; i++) {
	            if (calendar_dates[i].available) {
	              available_dates.push(calendar_dates[i].date);
	            }
	          }
	        }
	      }
	      COSTCO.ScheduledDeliverable.schedule_deliveravle_dates[orderItemId] = available_dates.map(function (date_str) {
	        return {
	          date_obj: new Date(new Date(date_str).getTime() + new Date(date_str).getTimezoneOffset() * 60000),
	          date_str: date_str
	        };
	      });
	      $(options.input).datepicker({
	        format: 'D, M dd, yyyy',
	        autoclose: true,
	        showOnFocus: false,
	        orientation: "auto right",
	        todayHighlight: true,
	        datesEnabled: COSTCO.ScheduledDeliverable.convertScheduledDeliverableDates(available_dates),
	        language: wcs.langId === '-25' ? 'fr' : 'en'
	      }).on('changeDate', function (e) {
	        if (typeof e.date !== 'undefined') {
	          // The change event needs the date string to pass to the server.
	          console.log("changeDate : " + e.date);
	          var date_str = "",
	              selected_date = e.date;
	          this.allowed_objs.forEach(function (allowed_obj) {
	            var date_obj = allowed_obj.date_obj;
	            if (selected_date.getDate() == date_obj.getDate() && selected_date.getMonth() == date_obj.getMonth() && selected_date.getFullYear() == date_obj.getFullYear()) {
	              date_str = allowed_obj.date_str;
	              return;
	            }
	          });
	        }
	      }.bind({
	        allowed_objs: COSTCO.ScheduledDeliverable.schedule_deliveravle_dates[orderItemId]
	      }));
	      $(options.input).datepicker('show');
	      $(options.input).addClass('datepicker-initialized');
	    },
	    date_picker_update: function date_picker_update(element, orderItemId) {
	      var options = [];
	      options.input = element;
	      var scheduledDeliveryConfigJSON = window['scheduledDeliveryConfig_' + orderItemId];
	
	      var available_dates = [];
	      if (scheduledDeliveryConfigJSON && scheduledDeliveryConfigJSON.deliveryAvailability) {
	        var calendar_dates = scheduledDeliveryConfigJSON.deliveryAvailability.calendar_dates;
	        if (calendar_dates) {
	          for (i = 0; i < calendar_dates.length; i++) {
	            if (calendar_dates[i].available) {
	              available_dates.push(calendar_dates[i].date);
	            }
	          }
	        }
	      }
	      $(options.input).datepicker({
	        format: 'D, M dd, yyyy',
	        autoclose: true,
	        showOnFocus: false,
	        orientation: "auto right",
	        todayHighlight: true,
	        datesEnabled: COSTCO.ScheduledDeliverable.convertScheduledDeliverableDates(available_dates),
	        language: wcs.langId === '-25' ? 'fr' : 'en'
	      }).on('changeDate', function (e) {
	        if (typeof e.date !== 'undefined' && COSTCO.ScheduledDeliverable.update_deliveryDate_orderItemId === e.target.id.replace('deliveryDate_', '')) {
	          // The change event needs the date string to pass to the server.
	          console.log("changeDate on update: " + e.date);
	          if ($("#deliveryDateDisplayMode_" + orderItemId).length > 0) {
	            var dateVal = e.date.getDate();
	            var month = e.date.getMonth();
	            var year = e.date.getFullYear();
	            var day = e.date.getDay();
	            var date_str_formatted = COSTCO.OrderItems.formatDate(day, dateVal, month, year);
	            $("#deliveryDateDisplayMode_" + orderItemId).html(messages.SCHEDULED_DELIVERY_DELIVERY_DATE + ": " + date_str_formatted);
	          }
	          var date_str = "",
	              selected_date = e.date;
	        }
	      });
	      $(options.input).datepicker('setDate', new Date(new Date(scheduledDeliveryConfigJSON.deliveryDate).getTime() + new Date(scheduledDeliveryConfigJSON.deliveryDate).getTimezoneOffset() * 60 * 1000));
	      $("label[for='date_" + orderItemId + "'].form-label").addClass('active');
	    },
	    handleZipCodeChange: function handleZipCodeChange(zipcode) {
	      var options = {
	        url: "/AjaxScheduledDeliveryUpdateCmd",
	        method: "POST",
	        dataType: 'json',
	        data: {
	          'authToken': COSTCO.Checkout.getAuthToken(),
	          'zipCode': zipcode
	        },
	        replaceKey: {
	          original: 'order-items',
	          replace: 'order-items'
	        },
	        done: function done() {}
	      };
	      COSTCO.Checkout.ajax_update_state(options);
	    },
	    dishwasherPartsSelect: function dishwasherPartsSelect(element) {
	      var partSelected = $(element).attr("id");
	
	      //iterate through all dishwasher parts and set to not selected
	      if (partsandservices.services.length > 0) {
	        $.each(partsandservices.services, function (index, value) {
	          if (value.serviceType.toUpperCase() == "PART" && value.groupId == 1) {
	            //reset all parts to unselected
	            COSTCO.ScheduledDeliverable.selectServicesById(value.id, false);
	
	            // set part selected and it's children to selected: true
	            if (value.id == partSelected) {
	              COSTCO.ScheduledDeliverable.selectServicesById(value.id, true);
	            }
	
	            if (value.dependent_service_ids.length > 0) {
	              var thisId = value.id;
	              $.each(value.dependent_service_ids, function (index, value) {
	                if (value == partSelected) {
	                  COSTCO.ScheduledDeliverable.selectServicesById(thisId, true);
	                }
	              });
	            }
	          }
	        });
	      }
	    }, // end of dishwasherPartsSelect
	
	    /**
	     * If the call to AjaxDeliveryReservationCalendarCmd is executed this method is used for cacheing.
	     * It receives the data from response and store it in  DeliveryReservationCalendarData object which is
	     * stored as JSON in session storage. 
	     * 
	     * @param data
	     * */
	    cacheDeliveryAvailability: function cacheDeliveryAvailability(data) {
	      var deliveryReservationCalendarData = JSON.parse(sessionStorage.getItem('DeliveryReservationCalendarData'));
	      if (deliveryReservationCalendarData == null) {
	        deliveryReservationCalendarData = [];
	      }
	      var deliveryReservationCalendar = new Object();
	      deliveryReservationCalendar.deliveryVendorSku = data.deliveryVendorSku[0];
	      deliveryReservationCalendar.zipCode = data.zipCode;
	      deliveryReservationCalendar.data = data;
	      deliveryReservationCalendarData.push(deliveryReservationCalendar);
	
	      sessionStorage.setItem('DeliveryReservationCalendarData', JSON.stringify(deliveryReservationCalendarData));
	    },
	
	    /**
	     * Compare input value of sku and zipcode with saved values in session storage. 
	     * If data exists returns the data if not returns empty string. 
	     * @param vendorSku number and zipCode entered.
	     * @return response data from cached session storage object DeliveryReservationCalendarData. 
	     * */
	    doesDeliveryAvailablityExists: function doesDeliveryAvailablityExists(vendorSku, zipCode) {
	      var response = '';
	      var deliveryReservationCalendarData = [];
	      deliveryReservationCalendarData = JSON.parse(sessionStorage.getItem('DeliveryReservationCalendarData'));
	
	      $(deliveryReservationCalendarData).each(function (i, obj) {
	        if (obj.deliveryVendorSku == vendorSku && obj.zipCode == zipCode) {
	          response = obj.data;
	          return false;
	        }
	      });
	
	      return response;
	    },
	
	    /**
	     * Data manipulation when ajax call is executed or when data is passed from session storage. 
	     * @param data - represents JSON response with messages, status and product number, sku number and zipcode.
	     * */
	    deliveryCalendarSuccess: function deliveryCalendarSuccess(data) {
	
	      $('#deliveryDateMessageTxt').text('');
	      if (data.errorCode) {
	        if (data.errorCode === 2510) {
	          // session timeout
	          document.location.href = 'Logoff?URL=ReLogonFormView&storeId=' + wcs.storeId;
	          return;
	        }
	      } else {
	        if (data['ResponseCode'] === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	          $('#deliveryFailMessage').removeClass('hide');
	          $('#zip-group').addClass('hide');
	          $('#geDeliveryFailMessageSpan').text(data['message']);
	          $('#prod-page-delivery').addClass('hide');
	        } else {
	
	          COSTCO.ScheduledDeliverable.resetDeliverableForm();
	
	          for (var i = 0; i < products[0].length; i++) {
	            if (products[0][i].inventory !== COSTCO.util.productConstants.inv_outOfStock) {
	              var itemMsgKey = 'message_' + products[0][i].manufacturerPartNumber.trim();
	              var itemResponseCodeKey = 'ResponseCode_' + products[0][i].manufacturerPartNumber.trim();
	              var itemMsgCodeKey = 'messageCode_' + products[0][i].manufacturerPartNumber.trim();
	
	              products[0][i].zipcodeAvailabilityMessage = data[itemMsgKey];
	              products[0][i].zipcodeAvailabilityMessageCode = data[itemMsgCodeKey];
	              products[0][i].zipcodeAvailabilityResponseCode = data[itemResponseCodeKey];
	            }
	          }
	          COSTCO.CMath.updateGEStockAvailability();
	          COSTCO.CMath.bindVariantProducts();
	
	          //attach event to select options button
	          COSTCO.ScheduledDeliverable.attachEventSelectOptions({
	            sku: $('#deliveryVendorSku').val(),
	            zipCode: data.zipCode,
	            categoryCode: $('#categoryCode').val()
	          });
	
	          var vendorSku = $('#deliveryVendorSku').val();
	          var msgKey = 'message_' + vendorSku;
	          var msgCodeKey = 'messageCode_' + vendorSku;
	          var delJSONResponseKey = 'DeliveryJSONResponse_' + vendorSku;
	          var responseCodeKey = 'ResponseCode_' + vendorSku;
	
	          if (data[responseCodeKey] === COSTCO.util.productConstants.zipcodeAvailCheck_StatusFail) {
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              $('#deliveryFailMessage').removeClass('hide');
	              $('#zip-group').addClass('hide');
	              $('#geDeliveryFailMessageSpan').text(data[msgKey]);
	              if (data[msgCodeKey] === COSTCO.util.productConstants.inv_backorderd) {
	                $('#deliveryFailMessage').addClass("warning").removeClass("critical-notification");
	                $('[name=select-options]').prop("disabled", false);
	              } else {
	                $('#deliveryFailMessage').removeClass("warning").addClass("critical-notification");
	                $('[name=select-options]').prop("disabled", true);
	              }
	            } else {
	              $('#deliveryFailMessage').removeClass('hide');
	              $('#zip-group').addClass('hide');
	              $('#geDeliveryFailMessageSpan').text(data[msgKey]);
	              $('#prod-page-delivery').addClass('hide');
	              if (data[msgCodeKey] === COSTCO.util.productConstants.inv_backorderd) {
	                $('[name=select-options]').prop("disabled", false);
	              } else {
	                $('[name=select-options]').prop("disabled", true);
	              }
	            }
	          } else {
	
	            console.log(data[delJSONResponseKey]);
	            $('#deliveryFailMessage').addClass('hide');
	            $('#prod-page-delivery').addClass('hide');
	            $('#zip-group').addClass('hide');
	            $('#deliveryDateMessage').removeClass('hide').addClass('success');
	
	            if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
	              var deliveryDate = data[msgKey];
	              var date = deliveryDate ? new Date(deliveryDate).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : "";
	              $('#deliveryDateMessageTxt').text(date);
	            } else {
	              $('#deliveryDateMessageTxt').text(data[msgKey]);
	            }
	
	            $('#deliveryLocationText').removeClass('hide');
	            $('#deliveryInfoText').removeClass('hide');
	            $('#deliveryZipCode').text(data.zipCode);
	            $('#sign-in-to-buy-button-v2').removeClass('secondary-button-v2').addClass('primary-button-v2');
	            $('#link-membership-for-price').removeClass('secondary-button-v2').addClass('primary-button-v2');
	          }
	
	          if ($('label', '#variants .variantContainer').length > 0) {
	            var swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
	            if (typeof swatch === 'undefined' || swatch === null) {
	              $('[name=select-options]').prop("disabled", true);
	            }
	          }
	        }
	      }
	    }
	  };
	  // end of ScheduledDeliverable
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	  window.COSTCO.ScheduledDeliverable = ScheduledDeliverable;
	  return ScheduledDeliverable;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 76:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * @title addtocart.js: Sub-module
	 * @description Associated with ProductForm.jsp
	 * This JS file binds add to cart event listeners.
	 * Checks if a selection is back ordered to invoke a
	 * backordered modal.
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var AddMembershipNumber = {
			membershipNumberUpdateCmd: "/AjaxMembershipNumberUpdateCmd",
			redirectTimeout: 6000,
			start: function start() {
				$("#membershipNumberVerifyError").hide();
	
				$('.modal-footer').removeClass('hide');
				COSTCO.dialog.createExtDialogBox({
					title: AddMembershipNumberStatic.ADDMEMBERSHIPNUMBER_Title,
					body: COSTCO.util.tmpl('tmpl_addmembernumber_modal', {}),
					primary: AddMembershipNumberStatic.CONTINUE,
					primary_event: function primary_event() {
						COSTCO.AddMembershipNumber.updateMembershipNumber();
					},
					secondary: AddMembershipNumberStatic.CANCEL
				});
	
				$("#membershipNumberToAdd").keypress(function () {
					$("#membershipNumberToAddError").hide();
				});
			},
			submitRequest: function submitRequest(urlWithParams, successFunction) {
				$.ajax({
					type: 'POST',
					url: urlWithParams,
					dataType: 'json',
					success: function success(data) {
						successFunction(data);
					},
					timeout: 6000,
					error: function error(x, t, m) {
						if (t === "timeout") {
							console.log("Error timeout.");
						} else {
							console.log("Error");
						}
					}
				});
			},
			costcoMembershipNumber: function costcoMembershipNumber(value) {
				return (/^\d{12,16}$/.test(value)
				);
			},
			updateMembershipNumber: function updateMembershipNumber() {
				if (COSTCO.AddMembershipNumber.costcoMembershipNumber($("#membershipNumberToAdd").val())) {
	
					var url = COSTCO.AddMembershipNumber.membershipNumberUpdateCmd + "?membershipNumber=" + $("#membershipNumberToAdd").val();
					COSTCO.AddMembershipNumber.submitRequest(url, COSTCO.AddMembershipNumber.reload);
				} else {
					$("#membershipNumberToAddError").show();
				}
			},
			reload: function reload(data) {
				if (data.success) {
					location.reload();
				} else {
					$("#membershipNumberToAddError").show();
				}
			}
	
		};
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
		window.COSTCO.AddMembershipNumber = AddMembershipNumber;
	
		return AddMembershipNumber;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 88:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title whitelist.js: Sub-module for Global pages
	 * @description This module is used to check whitelist links 
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_RESULT__ = function (dialog) {
	
		var whitelist = {
	
			// initialization	
			init: function init() {
				this.attachExternalClass();
			},
	
			attachExternalClass: function attachExternalClass() {
				var locHost = location.hostname;
				$('a').filter(function () {
					return this.hostname && this.hostname != locHost && !this.href.match(/^(mailto|javascript)\:/) && this.href != '' && !whitelist.isOnWhiteList(this.hostname);
				}).addClass("external").unbind().on('click', this.bind_external);
			},
	
			//if hostname found in whitelist return true
			isOnWhiteList: function isOnWhiteList(hostname) {
				var retVal = false;
				if (urlWhitelist && urlWhitelist.findIndex(function (x) {
					return hostname.includes(x);
				}) > -1 && domainWhiteListWithExternalPopup && domainWhiteListWithExternalPopup.findIndex(function (x) {
					return hostname.includes(x);
				}) < 0) {
					retVal = true;
				}
	
				return retVal;
			},
	
			bind_external: function bind_external(event) {
				whitelist.createDialogBox(this.href);
				event.preventDefault();
			},
	
			createDialogBox: function createDialogBox(url) {
				dialog.createExtDialogBox({
					url: url,
					title: messages.JS_DIALOG_EXTERNAL_LINK,
					body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
					secondary: messages.JS_DIALOG_CANCEL,
					primary: messages.JS_DIALOG_EXTERNAL_LINK,
					oneTimePopup: whitelist.oneTimePopup(url)
				});
			},
	
			oneTimePopup: function oneTimePopup(url) {
				if (urlWarnOncePerSessionList && urlWarnOncePerSessionList.findIndex(function (x) {
					return url.includes(x);
				}) > -1) {
					return true;
				} else {
					return false;
				}
			}
	
		}; //end whitelist object
	
		// Expose whiteList to the global scope.
		if (typeof window.COSTCO === "undefined") {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.whiteList = whitelist;
	
		return whitelist;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 92:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		var AdobeEvents = {
	
			// fields definition
			eventName: '',
			productItems: [],
			contextVars: '',
			adobeAnalyticsData: {},
			event: {
				name: {
					VIEWPDP: 'commerce.productViews',
					ADDTOCART: 'commerce.productListAdds',
					VIEWCART: 'commerce.productListViews',
					ORDER: 'commerce.purchases',
					EMAILSIGNUP: 'Email SignUp'
				}
			},
			language: {
				FRENCH: '-25'
			},
	
			/**
	   * Initialization of the module.
	   */
			init: function init(eventName, productItems, adobeAnalyticsData, contextVars) {
				AdobeEvents.eventName = eventName;
				AdobeEvents.productItems = productItems;
				AdobeEvents.adobeAnalyticsData = adobeAnalyticsData;
				AdobeEvents.contextVars = contextVars;
				$(document).ready(function () {
					var adobeURL = AdobeEvents.adobeAnalyticsData.serviceURL;
					if (typeof adobeURL !== 'undefined' && adobeURL.trim().length !== 0) {
						var adobeObject = AdobeEvents.getAdobeAnalyticsEventObject();
						COSTCO.util.sha256(AdobeEvents.getAdobeUUID(), function (hash) {
							if (hash) {
								adobeObject.body.xdmEntity._id = hash;
							}
							AdobeEvents.sendAdobeEvent(adobeURL, JSON.stringify(adobeObject));
						});
					}
				});
			},
	
			/**
	   * Init call only if user is logged in
	   */
			initEventIfLoggedIn: function initEventIfLoggedIn(eventName, productItems, adobeAnalyticsData, contextVars) {
				if (COSTCO.util.isUserLoggedIn()) {
					AdobeEvents.init(eventName, productItems, adobeAnalyticsData, contextVars);
				}
			},
	
			sendAdobeEvent: function sendAdobeEvent(url, payload) {
				var noConsentRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
				if (typeof url === 'undefined' || url.trim().length === 0) {
					//skip if url is not set
					return;
				}
				var saleOfInfoCode = "C0004";
				var personalizedAdvConsent = costcoConsentManager.checkConsent(saleOfInfoCode);
				//send adobe events only when the personalized advertising is active on cookie settings or if no consent required when the consent is implicit
				if (personalizedAdvConsent || noConsentRequired) {
					COSTCO.util.ajax({
						url: window.location.protocol + '//' + window.location.host + '/' + 'CostcoAdobeAuthCmd?storeId=' + AdobeEvents.contextVars.storeId + '&catalogId=' + AdobeEvents.contextVars.catalogId,
						method: 'GET',
						done: function done(data, textStatus, jqXHR, options) {
							data = JSON.parse(data);
							if (data.accessToken != null || data.status != '') {
								return AdobeEvents.sendEvent(url, payload, data.accessToken);
							} else {
								console.log('Error bearer token is missing or empty');
							}
						}, fail: function fail(data) {
							console.log('Unexpected Error Occured while retrieving bearer token');
						}
					});
				}
			},
	
			sendEvent: function sendEvent(url, payload, bearerToken) {
				if (typeof url === 'undefined' || url.trim().length === 0) {
					//skip if url is not set
					return;
				}
				var adobeFlowId = $("input[name='adobeFlowId']").val();
				var adobeSandBoxName = $("input[name='adobeParamSandBox']").val();
				COSTCO.util.ajax({
					url: url,
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + bearerToken,
						'x-adobe-flow-id': adobeFlowId,
						'x-sandbox-name': adobeSandBoxName
					},
					data: payload,
					done: function done(data, textStatus, jqXHR, options) {
						if (data.status != null || data.status != '') {
							if (AdobeEvents.contextVars.eventName === 'Connections Email SignUp') {
								window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'costco-connection-confirmation.html');
							}
							if (typeof AdobeEvents.event.name.EMAILSIGNUP != 'undefined' && AdobeEvents.event.name.EMAILSIGNUP != '') {
								if (AdobeEvents.event.name.EMAILSIGNUP == AdobeEvents.contextVars.eventName) {
									if (COSTCO.util.isUSStore()) {
										window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html');
									}
									if (COSTCO.util.isCAStore()) {
										window.location.replace(window.location.protocol + '//' + window.location.host + '/' + 'email-sign-up-confirmation.html?email=' + $("input[name='email']").val());
									}
								}
							}
						} else {
							console.log('Error sending Adobe event');
						}
					}, fail: function fail(data) {
						console.log('Unexpected Error Occured while sending Adobe event');
					}
				});
			},
	
			sendEmailSubscriptionEvent: function sendEmailSubscriptionEvent(emailPopUpUrl, contextVars, data) {
				AdobeEvents.contextVars = contextVars;
				emailPopUpUrl = emailPopUpUrl.replace('http://', 'https://');
				var emailPopUpPayload = AdobeEvents.returnEmailSubscriptionAdobeAnalyticsObject(data);
				if (COSTCO.util.isCABDStore() || COSTCO.util.isUSBDStore()) {
					delete emailPopUpPayload.consents.marketing.email.subscriptions;
				} else {
					if (COSTCO.util.isUSStore()) {
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily = {};
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_US_Daily.val = AdobeEvents.getDaily(data);
					} else {
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily = {};
						emailPopUpPayload.consents.marketing.email.subscriptions.Costco_CA_Daily.val = AdobeEvents.getDaily(data);
					}
				}
				AdobeEvents.sendAdobeEvent(emailPopUpUrl, JSON.stringify(emailPopUpPayload), true);
			},
	
			getAdobeAnalyticsEventObject: function getAdobeAnalyticsEventObject() {
				var adobeAnalyticsEventObject = {
					header: AdobeEvents.getEventHeader(),
					body: AdobeEvents.getEventBody()
				};
				return adobeAnalyticsEventObject;
			},
	
			returnEmailSubscriptionAdobeAnalyticsObject: function returnEmailSubscriptionAdobeAnalyticsObject(data) {
				return {
					memberNumber: data.memberNumber,
					webMembershipType: data.webMembershipType,
					source: COSTCO.util.getSource(),
					listSource: data.listSource,
					sourceRegion: COSTCO.util.getLocale().slice(-2),
					emailAddress: data.emailAddress,
					activeInd: "A",
					languagePref: AdobeEvents.getLanguagePreference(data.listSource),
					homeLocationNum: "",
					homeLocationRegionCode: "",
					warehouse: data.warehouse,
					zip: AdobeEvents.getZipCode(data),
					consents: {
						marketing: {
							email: {
								reason: "subscribe",
								Time: new Date().toISOString(),
								subscriptions: {
									Costco_Digital_Connections: {
										val: AdobeEvents.getConnections(data)
									}
								},
								val: "y"
							}
						}
					}
				};
			},
	
			getEventHeader: function getEventHeader() {
				return {
					schemaRef: {
						id: AdobeEvents.adobeAnalyticsData.schemaRefId,
						contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
					},
					imsOrgId: AdobeEvents.adobeAnalyticsData.imsOrgId,
					datasetId: AdobeEvents.adobeAnalyticsData.datasetId,
					flowId: AdobeEvents.adobeAnalyticsData.flowId,
					source: {
						name: AdobeEvents.adobeAnalyticsData.sourceName
					}
				};
			},
	
			getEventBody: function getEventBody() {
				return {
					xdmMeta: AdobeEvents.getXdmMeta(),
					xdmEntity: AdobeEvents.getXdmEntity()
				};
			},
	
			getLanguagePreference: function getLanguagePreference(source) {
				if ((source === 'EmailPopUp' || source === 'Email SignUp') && !(COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore()) && document.getElementsByName('slid_1').length === 2) {
					var isFirstOptionChecked = document.getElementsByName('slid_1')[0].checked;
					if (!isFirstOptionChecked) {
						return COSTCO.util.getLocale() == 'en-CA' ? 'FR' : 'EN';
					}
				}
				return COSTCO.util.getLocale().slice(0, 2).toUpperCase();
			},
	
			getXdmMeta: function getXdmMeta() {
				return {
					schemaRef: {
						id: AdobeEvents.adobeAnalyticsData.schemaRefId,
						contentType: AdobeEvents.adobeAnalyticsData.schemaRefContenType
					}
				};
			},
	
			getXdmEntity: function getXdmEntity() {
				return {
					_costco: {
						costcoIdentity: {
							hashedCostcoID: $.cookie("costcoHashId"),
							sourceRegion: AdobeEvents.adobeAnalyticsData.sourceRegion
						}
					},
					commerce: AdobeEvents.getCommerce(),
					eventType: AdobeEvents.eventName,
					extSourceSystemAudit: {
						lastActivityDate: new Date().toISOString(),
						lastUpdatedBy: AdobeEvents.adobeAnalyticsData.lastUpdatedBy
					},
					identityMap: AdobeEvents.getCostcoHashedId(),
					productListItems: AdobeEvents.getProductItemsDetails(),
					timestamp: new Date().toISOString(),
					web: {
						webInteraction: {
							region: AdobeEvents.contextVars.language == AdobeEvents.language.FRENCH ? 'FR' : 'EN'
						},
						webPageDetails: {
							URL: document.getElementsByTagName("title")[0].baseURI.split('?')[0],
							name: document.getElementsByTagName("title")[0].innerText.replace(/\r?\n|\r/g, "")
						}
					}
				};
			},
	
			getCostcoHashedId: function getCostcoHashedId() {
				return {
					costcoHashedID: [{
						authenticatedState: 'authenticated',
						id: $.cookie("costcoHashId"),
						primary: true
					}]
				};
			},
	
			/**
	   * Adobe require UUID to mark particular event with the suffix of the event.
	   */
			getAdobeUUID: function getAdobeUUID() {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
				});
				var id = uuid + '-' + COSTCO.util.getCookieByName('costcoHashId');
				return id;
			},
	
			getCommerce: function getCommerce() {
				if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
					return {
						cart: {
							cartSource: AdobeEvents.getCartSource()
						},
						productViews: {
							value: AdobeEvents.productItems[0].priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.ADDTOCART) {
					return {
						cart: {
							cartID: AdobeEvents.contextVars.orderId,
							cartSource: AdobeEvents.getCartSource()
						},
						productListAdds: {
							value: AdobeEvents.productItems[0].priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
					if (typeof AdobeEvents.contextVars.orderId != 'undefined' && AdobeEvents.contextVars.orderId != '') {
						localStorage.setItem("adobeOrderId", AdobeEvents.contextVars.orderId);
					}
					return {
						cart: {
							cartID: AdobeEvents.getCartOrderId(),
							cartSource: AdobeEvents.getCartSource()
						},
						productListViews: {
							value: AdobeEvents.contextVars.priceTotal
						}
					};
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.ORDER) {
					localStorage.removeItem("adobeOrderId", AdobeEvents.contextVars.orderId);
					return {
						order: {
							currencyCode: AdobeEvents.contextVars.currencyCode,
							discountAmount: AdobeEvents.contextVars.discountAmount,
							priceTotal: AdobeEvents.contextVars.priceTotal,
							purchaseOrderNumber: AdobeEvents.contextVars.purchaseOrderNumber
						},
						cart: {
							cartID: AdobeEvents.contextVars.orderId,
							cartSource: AdobeEvents.getCartSource()
						},
						purchases: {
							value: AdobeEvents.contextVars.priceTotal
						}
					};
				}
			},
	
			getCartOrderId: function getCartOrderId() {
				if (localStorage.getItem("adobeOrderId") === null) {
					return;
				} else {
					return localStorage.getItem("adobeOrderId");
				}
			},
	
			getProductItemsDetails: function getProductItemsDetails() {
				if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWCART) {
					return AdobeEvents.getCartItemsDetails();
				} else if (AdobeEvents.eventName == AdobeEvents.event.name.VIEWPDP) {
					if ($("#product-page").attr('data-bi-private')) {
						AdobeEvents.productItems[0].productImageUrl = window.location.hostname;
						AdobeEvents.productItems[0].product = window.location.hostname;
					}
					AdobeEvents.productItems[0].quantity = $('#add-to-cart-btn').length > 0 && $('#add-to-cart-btn').hasClass('out-of-stock') != true ? 1 : -1;
				}
				return AdobeEvents.productItems;
			},
	
			getCartItemsDetails: function getCartItemsDetails() {
				if (typeof AdobeEvents.productItems != 'undefined' && AdobeEvents.productItems.length > 0) {
					for (var i = 0; i < AdobeEvents.productItems.length; i++) {
						var orderItemNumberInArray = i + 1;
						if ($("#order-item_" + orderItemNumberInArray).attr('data-bi-private')) {
							AdobeEvents.productItems[i].productImageUrl = window.location.hostname;
							AdobeEvents.productItems[i].product = window.location.hostname;
						} else {
							AdobeEvents.productItems[i].productImageUrl = $('#order-item_' + orderItemNumberInArray + ' .item-thumbnail img').attr('src');
							AdobeEvents.productItems[i].product = $('#order-item_' + orderItemNumberInArray + ' .product-title a').attr('href');
						}
						if (AdobeEvents.contextVars && AdobeEvents.contextVars.outOfStock && AdobeEvents.contextVars.outOfStock.length > 0) {
							AdobeEvents.productItems[i].quantity = AdobeEvents.getOutOfStockQuantity(AdobeEvents.productItems[i].SKU, AdobeEvents.productItems[i].quantity);
						}
					}
				}
				return AdobeEvents.productItems;
			},
	
			getOutOfStockQuantity: function getOutOfStockQuantity(partnumber, quantity) {
				for (var i = 0; i < AdobeEvents.contextVars.outOfStock.length; i++) {
					if (AdobeEvents.contextVars.outOfStock[i] == partnumber) {
						return quantity != -1 ? -1 * quantity : quantity;
					}
				}
				return quantity;
			},
	
			getCartSource: function getCartSource() {
				if (COSTCO.util.isBusinessDelivery()) {
					return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BD';
				} else {
					return AdobeEvents.adobeAnalyticsData.sourceRegion + 'BC';
				}
			},
	
			getZipCode: function getZipCode(data) {
				if (COSTCO.util.isUSStore() || COSTCO.util.isUSBDStore()) {
					return data.zip;
				} else if (COSTCO.util.isCAStore() || COSTCO.util.isCABDStore()) {
					return data.postalCode;
				}
			},
	
			getConnections: function getConnections(data) {
				if (data.listSource === 'Connections_EmailSignUp') {
					return 'y';
				} else {
					return 'n';
				}
			},
	
			getDaily: function getDaily(data) {
				if (data.listSource === 'Connections_EmailSignUp') {
					return 'n';
				} else {
					return 'y';
				}
			}
		};
		if (typeof window.COSTCO === 'undefined') {
			window.COSTCO = {};
		}
		window.COSTCO.AdobeEvents = AdobeEvents;
		return AdobeEvents;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 98:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var Social = {
	
			shareWindow: function shareWindow(vendor) {
				var canonical = encodeURIComponent($('link[rel=canonical]').attr('href')),
				    desc = encodeURIComponent($('head title').text()),
				    media = encodeURIComponent($('meta[property=og\\:image]').attr('content'));
				if (vendor == 'facebook') {
					if (!COSTCO.whiteList.isOnWhiteList('"facebook.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://www.facebook.com/sharer/sharer.php?u=' + canonical + '&t=' + desc, '', 'left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://www.facebook.com/sharer/sharer.php?u=' + canonical + '&t=' + desc, '', 'left=0,top=0,width=626,height=436,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'twitter') {
					if (!COSTCO.whiteList.isOnWhiteList('"twitter.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://twitter.com/intent/tweet?url=' + canonical, '', 'left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://twitter.com/intent/tweet?text=' + desc + '&url=' + canonical, '', 'left=0,top=0,width=795,height=700,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'pinterest') {
					if (!COSTCO.whiteList.isOnWhiteList('"pinterest.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://www.pinterest.com/pin/create/button/?url=' + canonical + '&media=' + media + '&description=' + desc, '', 'left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://www.pinterest.com/pin/create/button/?url=' + canonical + '&media=' + media + '&description=' + desc, '', 'left=0,top=0,width=700,height=600,toolbar=1,location=0,resizable=1,scrollbars=1');
					};
				} else if (vendor == 'google') {
					if (!COSTCO.whiteList.isOnWhiteList('"google.com"')) {
						COSTCO.dialog.createExtDialogBox({
							title: messages.JS_DIALOG_EXTERNAL_LINK,
							body: isBDApplication === "BD" ? messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG_BD : messages.JS_LEAVING_DOMAIN_ALERT_SINGLE_TAG,
							secondary: messages.JS_DIALOG_CANCEL,
							primary: messages.JS_DIALOG_EXTERNAL_LINK,
							primary_event: function primary_event() {
								window.open('https://plus.google.com/share?url=' + canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
								COSTCO.dialog.close();
							}
						});
					} else {
						window.open('https://plus.google.com/share?url=' + canonical, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
					};
				}
			}
	
		}; //End Vendor object
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.Social = Social;
	
		return Social;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 99:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title vendor.js: sub-module for vendor integration
	 * @description This module is used to integrate with third-party vendors
	 * @dependency
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
		var Vendor = {
	
			initProductPage: function initProductPage() {
				document.addEventListener("CostcoSubModulesLoaded", COSTCO.Vendor.initProductDetailIntegrations, false);
			},
	
			initProductDetailIntegrations: function initProductDetailIntegrations() {
				COSTCO.Vendor.initWebCollage();
				if (!COSTCO.util.isBusinessDelivery($('#isBDAppVar').val()) && !$('#order-details-wrapper').length > 0) {
					COSTCO.Vendor.initBazaarVoice();
				}
			},
			narvarScriptLoaded: false,
			bvInitialized: false,
			/**
	   * First gets the bazaar voice script (from BazaarVoiceSetup.jspf) and
	   * then initializes the global configuration (using product id) and displays
	   * summary (stars at top) and reviews (in ProductInfo.jsp accordion). There is
	   * a promise when calling $BV.ui that when resolved, binds custom functionality
	   * on BV buttons.
	   * @return {[void]}
	   */
			initBazaarVoice: function initBazaarVoice() {
				if (typeof bazaar_voice_src != "undefined" && !COSTCO.Vendor.bvInitialized) {
					COSTCO.Vendor.bvInitialized = true;
	
					var bvUserToken = $.cookie('bvUserToken');
	
					bvUserToken = typeof bvUserToken == 'undefined' || bvUserToken === null || bvUserToken == '' || bvUserToken == '""' ? "" : bvUserToken;
	
					//SFSTRY0036927 - user shouldn't be able to add review as guest
					if (bvUserToken !== "" && !COSTCO.util.getMemberCookie().signedIn) {
						$.removeCookie('bvUserToken');
						bvUserToken = "";
					}
					// BV to check for user authentication
					// Create the bv:userToken meta element
					var bvAuth = document.createElement('meta');
					bvAuth.name = 'bv:userToken';
					bvAuth.content = bvUserToken;
	
					// Append it to the head of the page
					document.head.appendChild(bvAuth);
	
					$.cachedScript(bazaar_voice_src);
				}
			},
	
			initWebCollage: function initWebCollage() {
				console.log('initWebCollage called');
				if (typeof wcJS != 'undefined') {
					console.log('invoking WebCollage JS ' + wcJS);
					$.cachedScript(wcJS).done(function () {
						console.log('WebCollage JS loaded');
						Webcollage.loadContent(wcLocalization, wcCpi, { autoPlayAndStop: true });
						console.log('WebCollage JS function called');
					});
				}
			}
	
		}; //End Vendor object
	
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		window.COSTCO.Vendor = Vendor;
	
		return Vendor;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 100:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title image-lightbox.js: Sub-module of Product feature
	 * @description This module encapsulates all of the
	 * functionality related to the image-lightbox view component of product display.
	 * @dependency dialog.js, mathtable.js, zoom-viewer.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(54), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_RESULT__ = function (CMath, ZoomViewer) {
	  var ImageLightboxView = {
	
	    /**
	     * Opens Image Lightbox modal.
	     */
	    openImageLightBoxModal: function openImageLightBoxModal(event) {
	
	      if ($('#zoomViewer').length) {
	
	        var currentWindowPosition = $(window).scrollTop();
	        if (!$('#theViews').is(':empty')) {
	          $('#theViews').slick('destroy');
	          $('#theViews').find('a[tabindex]').remove();
	        }
	        var zoomViewerHTML = $('#zoomViewer')[0].outerHTML;
	        $('#zoomViewer').remove();
	        if (event !== undefined) {
	          ImageLightboxView.saveFocusedElement(event);
	        }
	        COSTCO.dialog.createExtDialogBox({
	          body: COSTCO.util.tmpl('tmpl_modal_lightbox', {}),
	          hideFooter: true,
	          dialogclasses: 'medium image-lightbox-modal image-lightbox-modal-v2',
	          onshow: function onshow() {
	
	            $(window).on('scroll', { position: currentWindowPosition }, COSTCO.ZoomViewer.lockWindowScrolling);
	            $(window).on('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
	            $('body').addClass('image-lightbox-modal-open');
	            ImageLightboxView.bindNextArrowEvent();
	            ImageLightboxView.bindPrevArrowEvent();
	            $("#costcoModal").addClass('lightbox-modal-v2');
	          },
	          onclose: function onclose() {
	
	            $(window).off('scroll', COSTCO.ZoomViewer.lockWindowScrolling);
	            $(window).off('error', COSTCO.ZoomViewer.reloadThumbnailsOnScriptError);
	
	            $('.top-content').prepend(zoomViewerHTML);
	
	            ZoomViewer.cleanupEvents();
	            ZoomViewer.resetLiveclicker();
	
	            RICHFX.load.fullReset();
	            $('#theViews').removeClass();
	            $('#theViews').empty();
	            initZoomViewer();
	            RICHFX.init();
	            setInitialSwatchValues();
	            $('body').removeClass('image-lightbox-modal-open');
	            $("#costcoModal").removeClass('lightbox-modal-v2');
	          }
	        });
	
	        document.addEventListener('richmedia.state.loaded', COSTCO.ZoomViewer.richMediaLoaded);
	        document.addEventListener('richmedia.view.changed', COSTCO.ZoomViewer.richMediaViewChange);
	        document.addEventListener('richmedia.swatch.changed', COSTCO.ZoomViewer.richMediaSwatchChange);
	
	        ZoomViewer.initZoomViewer();
	        ZoomViewer.constants.imageLightboxV2 = true;
	        RICHFX.load.fullReset();
	        RICHFX.init();
	
	        $('#viewsPrevArrow').addClass('hideViewsArrow');
	      }
	    },
	
	    /**
	     * Executes when click on arrow for the next slide
	     */
	    bindNextArrowEvent: function bindNextArrowEvent() {
	
	      $('#viewsNextArrow').on('click', function () {
	
	        var slides = $('#theViews').find('a').length;
	
	        $('#viewsPrevArrow').removeClass('hideViewsArrow');
	
	        if (ZoomViewer.constants.currentSlide < slides - 1) {
	
	          if (ZoomViewer.constants.currentSlide == slides - 2) {
	            $('#viewsNextArrow').addClass('hideViewsArrow');
	          }
	
	          ZoomViewer.constants.currentSlide = ZoomViewer.constants.currentSlide + 1;
	          var currentSlide = $('#theViews').find('a')[ZoomViewer.constants.currentSlide];
	
	          $(currentSlide).find('img').click();
	          $('.selectedSlide').first().focus();
	        }
	      });
	    },
	
	    /**
	     * Executes when click on arrow for the previous slide
	     */
	    bindPrevArrowEvent: function bindPrevArrowEvent() {
	
	      $('#viewsPrevArrow').on('click', function () {
	
	        var slides = $('#theViews').find('a').length;
	
	        $('#viewsNextArrow').removeClass('hideViewsArrow');
	
	        if (ZoomViewer.constants.currentSlide > 0) {
	
	          if (ZoomViewer.constants.currentSlide == 1) {
	            $('#viewsPrevArrow').addClass('hideViewsArrow');
	          }
	
	          ZoomViewer.constants.currentSlide = ZoomViewer.constants.currentSlide - 1;
	          var currentSlide = $('#theViews').find('a')[ZoomViewer.constants.currentSlide];
	
	          $(currentSlide).find('img').click();
	          $('.selectedSlide').first().focus();
	        }
	      });
	    },
	
	    /**
	     * Saved id of focused element  on lightbox open
	     */
	    saveFocusedElement: function saveFocusedElement(event) {
	      if (typeof event !== 'undefined') {
	        if (event.target.id) {
	          $('<input>').attr({
	            type: 'hidden',
	            id: 'lastFocusedElement',
	            value: event.target.id
	          }).appendTo('body');
	        } else {
	          //keyboard event was triggered
	          img = $(event.target).find('img').attr('id');
	          elementId = $(event.target).find('img').attr('id');
	          if (elementId) {
	            $('<input>').attr({
	              type: 'hidden',
	              id: 'lastFocusedElement',
	              value: elementId
	            }).appendTo('body');
	          }
	        }
	      }
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.ImageLightboxView = ImageLightboxView;
	
	  return ImageLightboxView;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 101:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title ModalImage-lightbox.js: Sub-module of Product feature
	 * @description This module encapsulates all of the
	 * functionality related to the ModalImage-lightbox view component of product display.
	 * @dependency  modalZoom-viewer.js
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var ModalImageLightboxView = {
	
	    /**
	     * Opens Image Lightbox modal.
	     */
	    openImageLightBoxModal: function openImageLightBoxModal(event) {
	      var overlayThumbClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	
	      if ($('#zoomViewer').length) {
	
	        ModalImageLightboxView.destroyLCVideo();
	
	        var currentWindowPosition = $(window).scrollTop();
	        var newViewerSize = ModalImageLightboxView.getViewerSize();
	        var imageContainerWidth = newViewerSize > $(window).width() ? 'auto' : newViewerSize + 'px';
	        var activeElement = document.activeElement;
	
	        var currentView = ModalImageLightboxView.getSelectedViewId(overlayThumbClicked);
	
	        var itemID = null;
	        var imageURL = zoomViewer.viewerUrl;
	        var rfxMediaParams = $('#productImage').attr('rfxmedia');
	        //Check if the product has swatches for color change 
	        var swatch = RICHFX.settings.sCurrentSwatch;
	        if (swatch != 'undefined' && swatch != "" && swatch != null && swatch != undefined) {
	          swatch = '&swatchId=' + swatch;
	        } else {
	          swatch = "";
	        }
	        rfxMediaParams.split("&").forEach(function (part) {
	          var item = part.split("=");
	          if (item[0] === 'itemid') {
	            itemID = item[1];
	          }
	        });
	
	        _LCdiv_ID = 'contentWrapper';
	        var modalHTML = '<div id="openModal" class="modalDialog">' + '<div id="modalContainer">' + '<button id="viewsPrevArrow" class="showForDesktop" style="display:none !important">' + '<span class="sr-only">' + messages.PREVIOUS_IMAGE + '</span>' + '</button>' + '<div id="imageHolder" style="width: ' + imageContainerWidth + '; top 0px; margin: 0px auto;">' + '<img id="modalImage" src="' + zoomViewer.viewerUrl + newViewerSize + swatch + '&viewId=' + currentView + '" rfxccgroup="itemId=' + itemID + '" rfxMedia="profileId=12026540&' + itemID + swatch + '&viewId=' + currentView + '">' + '</div>' + '<div id="contentWrapper" style="padding: 0 10%"></div>' + '<button id="viewsNextArrow" class="showForDesktop" style="display:none !important">' + '<span class="sr-only">' + messages.NEXT_IMAGE + '</span>' + '</button>' + '<div id="zoomInstruction">' + '<div class="modal-zoom-pan showForDesktop">' + '<img src="/wcsstore/RWDStaticAssets/img/ZoomComponent-ZoomIn.svg" alt="Zoomer" usemap="#zoomerImage">' + '<map id="zoomAndPanImage" name="zoomerImage">' + '<area id="zoomAndPanImage_magnifier_in" shape="rect" alt="' + messages.MAGNIFYING_GLASS_ZOOM_IN + '" title="" coords="11,11,20,20" href="#" target="" />' + '<area id="zoomAndPanImage_arrow_up" shape="rect" alt="' + messages.UP_CHEVRON_PAN_UP + '" title="" coords="11,0,20,10" href="#" target=""/>' + '<area id="zoomAndPanImage_arrow_right" shape="rect" alt="' + messages.RIGHT_CHEVRON_PAN_RIGHT + '" title="" coords="21,11,30,20" href="#" target="" />' + '<area id="zoomAndPanImage_arrow_down" shape="rect" alt="' + messages.DOWN_CHEVRON_PAN_DOWN + '" title="" coords="11,21,20,30" href="#" target="" />' + '<area id="zoomAndPanImage_arrow_left" shape="rect" alt="' + messages.LEFT_CHEVRON_PAN_LEFT + '" title="" coords="0,11,10,20" href="#" target="" />' + '</map>' + '</div>' + '<div class="zoom-message-wrapper zoomInstructionOverlay" style="background-color: #fff;">' + '<div class="col-xl-12 showForDesktop" style="padding-top: 5px; background-color: #fff; opacity: 0.8">' + messages.RWD_CLICK_ZOOM + '</div>' + '<div class="col-lg-12 showForMobile" style="padding-top: 5px;">' + messages.RWD_TAP_ZOOM + '</div>' + '</div>' + '</div>' + '</div>' + '<div id="currentSlide" class="row"></div>' + '<hr>' + '<div id="modalThumbnails" class="row" style="margin: 0px auto;">' + '<div class="col-xs-12">' + '<div id="modalViews"></div>' + '</div>' + '</div>' + '<div id="modalSwatches" style="display:none;"></div>' + '</div>';
	        $('div#videoViewer-popup').css("width", newViewerSize);
	        window.eventBus.publish('videoUpdate', { ItemNumbers: _LCdim5, type: "basic", aspectRatio: "1:1", bfFolderType: "pdp" });
	        $('#videoViewer-popup').hide();
	
	        COSTCO.dialog.createExtDialogBox({
	          body: modalHTML,
	          hideFooter: true,
	          dialogclasses: 'medium image-lightbox-modal image-lightbox-modal-v2',
	          onshow: function onshow() {
	            console.log('PDP Image Modal: onshow');
	
	            var $image = $('#modalImage');
	            $image.on('load', function () {
	              console.log('PDP Image Modal: Enter load');
	              console.log('PDP Image Modal: initialized = ' + COSTCO.ModalZoomViewer.initialized);
	
	              if (COSTCO.ModalZoomViewer.initialized == false) {
	                console.log('PDP Image Modal: initializing richfx');
	                COSTCO.ModalZoomViewer.initialized = true;
	                console.log('PDP Image Modal: richfx initialized');
	
	                RICHFX.load.reset();
	                RICHFX.settings.init('PZ' + newViewerSize + 'Multi');
	                console.log('PDP Image Modal: richfx initialization started, now wait for richmedia.state.loaded event');
	              }
	
	              console.log('PDP Image Modal: Exit load');
	            });
	
	            /*
	             *  This is required for safari browser, safari will not trigger regular 'load' event if image is served from cache (ususally second open of modal)
	             */
	            if ($image[0].complete) {
	              console.log('PDP Image Modal: Manually triggered event for image loaded');
	              $image.load();
	            }
	
	            $(window).on('scroll', { position: currentWindowPosition }, COSTCO.ModalZoomViewer.lockWindowScrolling);
	            $(window).on('error', COSTCO.ModalZoomViewer.reloadThumbnailsOnScriptError);
	            $('body').addClass('image-lightbox-modal-open');
	            $("#costcoModal").addClass('lightbox-modal-v2');
	          },
	          onclose: function onclose() {
	            $(window).off('scroll', COSTCO.ModalZoomViewer.lockWindowScrolling);
	            $(window).off('error', COSTCO.ModalZoomViewer.reloadThumbnailsOnScriptError);
	
	            $('.RICHFXViewerContainer').show();
	
	            if (activeElement != undefined) {
	              activeElement.focus();
	            }
	
	            ModalImageLightboxView.resetLiveclicker();
	
	            $('body').removeClass('image-lightbox-modal-open');
	            $("#costcoModal").removeClass('lightbox-modal-v2');
	
	            COSTCO.ModalZoomViewer.initialized = false;
	            console.log('PDP Image Modal: Closing modal, initialized = ' + COSTCO.ModalZoomViewer.initialized);
	            window.eventBus.publish('videoUpdate', { ItemNumbers: _LCdim5, type: "basic", aspectRatio: "1:1", bfFolderType: "pdp" });
	            $(document).trigger('costco.pdp.modal.closed');
	          }
	        });
	
	        //This line needs to be removed when the WebCollage changes the scripts
	        $('.wc-content-package-mosaic-board').attr('style', 'z-index:20010 !important');
	      }
	    },
	
	    /**
	     * Removes element with ID lcVideo, if found on the page / modal. This is necessary if having 2 instances of video (inline and modal)
	     */
	    destroyLCVideo: function destroyLCVideo() {
	      if ($('#lcVideo').length == 1) {
	        console.log('PDP Image Modal: Destroying #lcVideo');
	        $('#lcVideo').remove();
	      }
	    },
	
	    /**
	     * Resets Liveclicker video player.
	     */
	    resetLiveclicker: function resetLiveclicker() {
	      ModalImageLightboxView.destroyLCVideo();
	
	      _LCdiv_ID = 'productImageContainer'; // This value is required for inline lightbox viewer.
	
	      if (typeof liveclicker != 'undefined') {
	        liveclicker = {
	          lcCheckReadyObject: function lcCheckReadyObject() {}
	        };
	      }
	    },
	
	    /**
	     * Gets the currently selected view id
	     */
	    getSelectedViewId: function getSelectedViewId(clickedOnOverlayImages) {
	      if (clickedOnOverlayImages) {
	        return ModalImageLightboxView.getIdOfFirstOverlayImage();
	      } else {
	        var tmpArray = $('.RICHFXColorChangeViewSelected').length > 0 ? $('.RICHFXColorChangeViewSelected').attr('id').split('_') : $('.RICHFXColorChangeViewSelected');
	        if (tmpArray && tmpArray.length > 0) {
	          return tmpArray[tmpArray.length - 1];
	        } else {
	          return "1";
	        }
	      }
	    },
	
	    getIdOfFirstOverlayImage: function getIdOfFirstOverlayImage() {
	      var idValue = $('.overlay').parent().find('img').attr('id');
	      var tmpArray = idValue.length > 0 ? idValue.split('_') : idValue;
	      if (tmpArray && tmpArray.length > 0) {
	        firstOverlayImageId = tmpArray[tmpArray.length - 1];
	      } else {
	        firstOverlayImageId = "1";
	      }
	      return firstOverlayImageId;
	    },
	
	    getViewerSize: function getViewerSize() {
	      var width = $(window).width();
	      var height = $(window).height();
	      if (width > 1000 && height > 870) return 680;
	      if (width > 764 && height > 729) return 470;
	      if (width > 750 && height > 600) return 352;
	      return 344;
	    },
	
	    /**
	     * Saved id of focused element  on lightbox open
	     */
	    saveFocusedElement: function saveFocusedElement(event) {
	      if (typeof event !== 'undefined') {
	        if (event.target.id) {
	          $('<input>').attr({
	            type: 'hidden',
	            id: 'lastFocusedElement',
	            value: event.target.id
	          }).appendTo('body');
	        } else {
	          //keyboard event was triggered
	          img = $(event.target).find('img').attr('id');
	          elementId = $(event.target).find('img').attr('id');
	          if (elementId) {
	            $('<input>').attr({
	              type: 'hidden',
	              id: 'lastFocusedElement',
	              value: elementId
	            }).appendTo('body');
	          }
	        }
	      }
	    }
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.ModalImageLightboxView = ModalImageLightboxView;
	
	  return ModalImageLightboxView;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },

/***/ 102:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * @title zoom-viewer.js: Sub-module of Browse feature
	 * @description This module encapsulates all of the
	 * functionality related to the zoom viewer component of quickview display.
	 * @dependency 
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  var ModalZoomViewer = {
	
	    initialized: false,
	
	    getViewerSize: function getViewerSize() {
	      var width = $(window).width();
	      var height = $(window).height();
	      if (width > 1000 && height > 870) return zoomViewer.xl;
	      if (width > 764 && height > 729) return zoomViewer.lg;
	      if (width > 750 && height > 600) return zoomViewer.md;
	      return zoomViewer.xs;
	    },
	
	    /**
	     * Invoked on event trigger 'richmedia.state.loaded'
	     */
	    richMediaLoaded: function richMediaLoaded() {
	      console.log("PDP Image Modal: Enter richMediaLoaded");
	
	      ModalZoomViewer.init();
	      ModalZoomViewer.setupViewer();
	      //ModalZoomViewer.setupSwatches();
	      ModalZoomViewer.constants.$viewerDiv.css('visibility', 'visible');
	      ModalZoomViewer.constants.$viewerDiv.find('#imageHolder').focus();
	
	      if (ModalZoomViewer.hasVideoContent()) {
	        ModalZoomViewer.loadVideoData();
	      }
	
	      ModalZoomViewer.showHideControls();
	
	      ModalZoomViewer.setUpADA();
	      console.log("PDP Image Modal: Exit richMediaLoaded");
	    },
	
	    hasVideoContent: function hasVideoContent() {
	      var $externalVideo = ModalZoomViewer.constants.$theViews.find('img[id*=External]');
	      var videoContent = false;
	      if ($externalVideo.length > 0) {
	        videoContent = true;
	      }
	
	      console.log("PDP Image Modal: Has video content = " + videoContent);
	      return videoContent;
	    },
	
	    richMediaSwatchChange: function richMediaSwatchChange() {
	      if (ModalZoomViewer.constants.$theViews.hasClass('slick-initialized')) {
	        ModalZoomViewer.destroyThumbnailCarousel();
	        ModalZoomViewer.makeViewerResponsive();
	        ModalZoomViewer.setupThumbnailCarousel();
	      }
	    },
	
	    /**
	     * Invoked on event trigger 'richmedia.view.changed'
	     */
	    richMediaViewChange: function richMediaViewChange() {
	      ModalZoomViewer.destroyThumbnailCarousel();
	      ModalZoomViewer.makeViewerResponsive();
	      ModalZoomViewer.setupThumbnailCarousel();
	
	      ModalZoomViewer.showHideControls();
	      ModalZoomViewer.setUpADA();
	
	      var $selected = $('#modalViews .RICHFXColorChangeViewSelected');
	      var selectedIndex = $('#modalThumbnails').find('img').index($selected) + 1;
	
	      $selected.focus();
	      var currentImageIndex = $selected.closest('a').index();
	      setTimeout(function () {
	        ModalZoomViewer.setupADAValuesForHeroImage(currentImageIndex);
	      }, 500);
	    },
	
	    init: function init() {
	      console.log('PDP Image Modal: Calling ModalZoomViewer.init...');
	      ModalZoomViewer.constants = {
	        $viewerDiv: $('#modalModalZoomViewer'),
	        $viewerLib: $('#productImageLibrary'),
	        $viewerImg: $('#modalImage'),
	        $thumbnails: $('#modalThumbnails'),
	        $theViews: $('#modalViews'),
	        $initialImage: $('#initialProductImage'),
	        $prevArrow: $('#viewsPrevArrow'),
	        $nextArrow: $('#viewsNextArrow'),
	        totalSlidesCount: $('#modalViews').find('a').length,
	        viewerSize: ModalZoomViewer.getViewerSize() + 'Multi'
	      };
	      var $selected = $('#modalViews .RICHFXColorChangeViewSelected');
	      var selectedIndex = $('#modalThumbnails').find('img').index($selected) + 1;
	
	      ModalZoomViewer.bindNextArrowEvent();
	      ModalZoomViewer.bindPrevArrowEvent();
	
	      //next four lines makes panning utility working for Firefox
	      if (!COSTCO.util.isIE11OrOlder()) {
	        $('.modal-zoom-pan').removeClass('hidden-until-focus');
	        $('.modal-zoom-pan').addClass('hidden-until-focus');
	      }
	
	      var currentImageIndex = $selected.closest('a').index();
	      setTimeout(function () {
	        ModalZoomViewer.setupADAValuesForHeroImage(currentImageIndex);
	        ModalZoomViewer.trapFocusInsideModal();
	        ModalZoomViewer.bindZoomAndPanEvents();
	      }, 200);
	      ModalZoomViewer.loaded();
	    },
	
	    setupADAValuesForHeroImage: function setupADAValuesForHeroImage(imageIndex) {
	      if (imageIndex == 0) {
	        imageIndex = 1;
	      } else {
	        if (!ModalZoomViewer.hasVideoContent()) {
	          imageIndex = imageIndex + 1;
	        }
	      }
	      $('div[id ^="RICHFXViewerContainer___richfx_id_"][tabindex=0]').find('img').removeAttr("aria-label");
	      $('div[id ^="RICHFXViewerContainer___richfx_id_"][tabindex=0]').find('img').removeAttr("title");
	      // want to change alt attribute only on modal instance of hero image
	      $('img[id ^="RICHFXViewerContainer___richfx_id_"][id $="_initialImage"]:not([id ^="RICHFXViewerContainer___richfx_id_0"]').find('img').attr("alt", "");
	      $('img[id ^="RICHFXViewerContainer___richfx_id_"][id $="_initialImage"]:not([id ^="RICHFXViewerContainer___richfx_id_0"]').attr("alt", messages.PDETAIL_VIEW_LARGER_IMAGE + " " + imageIndex);
	    },
	
	    /**  
	     * Gets the position index of the selected slide element, starts from 0
	     */
	    getCurrentSlideIndex: function getCurrentSlideIndex() {
	      var slideIndex = 0;
	      var $selected = $('#modalViews .RICHFXColorChangeViewSelected');
	      if ($selected.length > 0) {
	        slideIndex = $selected.closest('a').index();
	      }
	
	      console.log('PDP Image Modal: Real current slide index = ' + slideIndex);
	      return slideIndex;
	    },
	
	    /**
	     * Gets current slide number for display purposes, starts from 1
	     */
	    getCurrentSlideNumber: function getCurrentSlideNumber() {
	      var slideNumber = ModalZoomViewer.getCurrentSlideIndex() + 1;
	      console.log('PDP Image Modal: Current slide display number = ' + slideNumber);
	      return slideNumber;
	    },
	
	    /**
	     * Executes when click on arrow for the next slide
	     */
	    bindNextArrowEvent: function bindNextArrowEvent() {
	      $('#viewsNextArrow').on('click', function () {
	
	        var slides = ModalZoomViewer.constants.totalSlidesCount;
	        var currentSlideIndex = ModalZoomViewer.getCurrentSlideIndex();
	        if (currentSlideIndex < slides - 1) {
	          var nextSlideIndex = currentSlideIndex + 1;
	          var nextSlide = $('#modalViews').find('a')[nextSlideIndex];
	          console.log('PDP Image Modal: Display next slide = ' + nextSlideIndex);
	
	          $(nextSlide).find('img').click();
	          $('.selectedSlide').first().focus();
	        }
	      });
	    },
	
	    /**
	     * Executes when click on arrow for the previous slide
	     */
	    bindPrevArrowEvent: function bindPrevArrowEvent() {
	      $('#viewsPrevArrow').on('click', function () {
	        var currentSlideIndex = ModalZoomViewer.getCurrentSlideIndex();
	        if (currentSlideIndex > 0) {
	          var prevSlideIndex = currentSlideIndex - 1;
	          var prevSlide = $('#modalViews').find('a')[prevSlideIndex];
	          console.log('PDP Image Modal: Display previous slide = ' + prevSlideIndex);
	
	          $(prevSlide).find('img').click();
	          $('.selectedSlide').first().focus();
	        }
	      });
	    },
	
	    bindZoomAndPanEvents: function bindZoomAndPanEvents() {
	      $('#zoomAndPanImage_arrow_up').on('click', function (event) {
	        console.log("PDP Image Modal: Pan arrow UP ");
	        RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panup');
	      });
	
	      $('#zoomAndPanImage_arrow_right').on('click', function (event) {
	        console.log("PDP Image Modal: Pan arrow RIGHT ");
	        RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panright');
	      });
	
	      $('#zoomAndPanImage_arrow_down').on('click', function (event) {
	        console.log("PDP Image Modal: Pan arrow DOWN ");
	        RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.pandown');
	      });
	
	      $('#zoomAndPanImage_arrow_left').on('click', function (event) {
	        console.log("PDP Image Modal: Pan arrow LEFT ");
	        RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('richmedia.external.panleft');
	      });
	
	      $('#zoomAndPanImage_magnifier_in').on('click', function (event) {
	        console.log("PDP Image Modal: Zoom Magnifier ");
	        RICHFX.jQuery('#RICHFXViewerContainer___richfx_id_1').trigger('clicked.zoombehavior');
	      });
	    },
	
	    //adjusts thumbnail width and position of video overlay images
	    adjustThumbnails: function adjustThumbnails() {
	      var viewerSize = ModalZoomViewer.getViewerSize();
	      var thumbWidth = viewerSize === zoomViewer.xl ? 90 : viewerSize === zoomViewer.lg ? 60 : 45;
	      ModalZoomViewer.constants.$theViews.find('img').css('width', thumbWidth);
	
	      var $vidOverlay = $('img[id*=videoOverlay]');
	      $vidOverlay.each(function () {
	        $(this).parent().css('width', '');
	        $(this).parent().css('height', '');
	        $(this).css('left', $(this).siblings().position().left);
	      });
	    },
	
	    //adds responsive properties to the zoom viewer
	    makeViewerResponsive: function makeViewerResponsive() {
	      var $container = $('.RICHFXViewerContainer');
	      $container.css('width', '');
	      $container.css('height', '');
	      $container.css('cursor', 'url(../../CostcoGLOBALSAS/images/product-zoom.cur),auto');
	      $('#modalModalZoomViewer').find('img').addClass('img-responsive');
	    },
	    setUpADA: function setUpADA() {
	      //This id is changing need to find another selector for the main image
	      $("#imageHolder").find("[id$='_initialImage']").attr('tabindex', '0');
	      $('#modalViews').find('a').each(function (index) {
	        $(this).find('span').attr('aria-hidden', 'true');
	        $(this).attr('tabindex', '-1').find('img').attr('tabindex', '0').attr('aria-label', messages.PREVIEW + ' ' + ++index);
	        $(this).find('img').attr('aria-hidden', 'false');
	        $(this).attr('aria-hidden', 'false');
	      });
	      $('#viewsPrevArrow').attr('aria-disabled', 'false');
	      $("#viewsNextArrow").on('focus click', function () {
	        $('#viewsNextArrow').attr('aria-disabled', 'false');
	      });
	      $('#imageHolder').find('img').removeAttr('tabindex');
	      $('#imageHolder').children('div').attr('tabindex', '0');
	      ModalZoomViewer.setupTabindexForVideoThumbnail();
	    },
	
	    //creates thumbnail carousel
	    setupThumbnailCarousel: function setupThumbnailCarousel() {
	      var responsiveBreakpoints = [];
	
	      var slickSettings = {
	        arrows: true,
	        slidesToShow: 3,
	        dots: true,
	        infinite: false,
	        slidesToScroll: 4,
	        autoplay: false,
	        draggable: ModalZoomViewer.draggableThumbnails(),
	        accessibility: true,
	        variableWidth: true,
	        prevArrow: $('#viewsPrevArrow'),
	        nextArrow: $('#viewsNextArrow')
	      };
	      //Show dots on mobile
	      if (ModalZoomViewer.getViewerSize() === zoomViewer.xs) {
	        slickSettings.arrows = false;
	      }
	
	      COSTCO.util.carousel(ModalZoomViewer.constants.$theViews, slickSettings);
	      ModalZoomViewer.constants.$theViews.find('a').on('keyup', function (e) {
	        //If user use keyboard enter key to select image simulate the click
	        if (e.which == 13) {
	          $(this).find('img').click();
	        }
	      });
	
	      ModalZoomViewer.adjustThumbnails();
	      ModalZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
	      ModalZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
	    },
	
	    draggableThumbnails: function draggableThumbnails() {
	      if ($(window).width() < 1025) return true;
	      return false;
	    },
	
	    //destroys thumbnail carousel
	    destroyThumbnailCarousel: function destroyThumbnailCarousel() {
	      ModalZoomViewer.constants.$theViews.slick('destroy');
	      ModalZoomViewer.constants.$theViews.find('a[tabindex]').remove();
	      ModalZoomViewer.constants.$prevArrow.css('visibility', 'hidden');
	      ModalZoomViewer.constants.$nextArrow.css('visibility', 'hidden');
	    },
	
	    //uses liveclicker's scripts to setup videos
	    loadVideoData: function loadVideoData() {
	      COSTCO.Global.logger('External Video Detected. Loading Brandfolder videos.');
	      $('div#openModal').find('div#modalContainer').prepend($('#videoViewer-popup'));
	    },
	
	    hideZoomInstruction: function hideZoomInstruction() {
	      $('#zoomInstruction').addClass('hidden-preserve-height');
	      $('#imageHolder').hide();
	      $('#videoViewer-popup').show();
	      ModalZoomViewer.showHideControls();
	    },
	
	    showZoomInstruction: function showZoomInstruction() {
	      $('#zoomInstruction').removeClass('hidden-preserve-height');
	      $('#videoViewer-popup').hide();
	      $('#imageHolder').show();
	    },
	
	    //selects the first available swatch color from our side so
	    //that the customer will not see a color that's unavailable.
	    selectInitialSwatch: function selectInitialSwatch() {
	      var swatch = void 0;
	      try {
	        swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
	        //trigger a select of the first swatch color from the color select dropdown
	        COSTCO.CMath.triggerSwatchDropDownSelection(swatch);
	      } catch (err) {
	        console.error(err);
	      }
	      $('#theSwatches').find('img[alt="' + swatch + '"]').first().click();
	    },
	
	    //out of stock items do not reflect properly in the swatch tiles from rich media
	    //so we have to sync their tiles with our product options.
	    syncSwatchTiles: function syncSwatchTiles(swatchMode) {
	      var colorsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).attr("disabled") != "disabled") {
	          return $(option).data('swatch').trim().toLowerCase();
	        }
	      });
	      var colorsOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).attr("disabled") == "disabled") {
	          return $(option).data('swatch').trim().toLowerCase();
	        }
	      });
	      var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function (option) {
	        if ($(option).text().includes(messages.BACKORDER_TEXT)) {
	          var sliceStr = ' - ' + messages.BACKORDER_TEXT;
	          return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else if ($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
	          var sliceStr = ' - ' + messages.OUT_OF_STOCK_TEXT;
	          return $(option).text().slice(0, $(option).text().indexOf(sliceStr)) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else if ($(option).text().includes(' -')) {
	          return $(option).text().slice(0, $(option).text().indexOf(' -')) + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        } else {
	          return $(option).text() + " -" + $(option).data('swatch').trim().toLowerCase() + "-";
	        }
	      });
	
	      $('img', '#theSwatches').each(function () {
	        var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
	        if (itemDescriptionArray.length == 2) {
	          var color = itemDescriptionArray[1].toLowerCase();
	          var colorNameTitle = $.map(colorsNames, function (value) {
	            if (value.includes(' -' + color)) {
	              return value.slice(0, value.indexOf(' -' + color + '-'));
	            }
	          });
	          if (colorsInStock.indexOf(color) < 0 && colorsOutStock.indexOf(color) < 0) {
	            $(this).parent().remove();
	          } else if (colorsInStock.indexOf(color) < 0) {
	            $(this).parent().addClass('disabledSwatch');
	            if (color == 'white') {
	              $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
	            } else {
	              $(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
	            }
	            $(this).parent().get(0).setAttribute("tabindex", "-1");
	            $(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" data-toggle="popover" data-html="true" data-content="' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
	            $(this).parent().prepend('<span class="offscreen">' + colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '</span>');
	          } else {
	            $(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
	
	            $(this).parent().get(0).setAttribute("data-content", colorNameTitle);
	            $(this).parent().get(0).setAttribute("data-placement", "bottom");
	            $(this).parent().get(0).setAttribute("data-trigger", "focus hover");
	            $(this).parent().get(0).setAttribute("data-toggle", "popover");
	            $(this).parent().get(0).setAttribute("data-html", "true");
	            $(this).parent().get(0).classList.add("swatch-help");
	            $(this).parent().get(0).setAttribute("onkeydown", "COSTCO.CMath.runRMAActiveColor(event, '" + color + "')");
	          }
	        }
	      });
	
	      var sortedSwatches = $('#theSwatches').children().sort(function (a, b) {
	        return a.getAttribute('data-sort') - b.getAttribute('data-sort');
	      });
	
	      $('#theSwatches').empty();
	      $('#theSwatches').append(sortedSwatches);
	      if (swatchMode == 2) {
	        $('#theSwatches').removeClass('hide');
	      }
	    },
	
	    //sets up swatches based on swatchMode
	    //swatchMode = 1 is the regular dropdown
	    //swatchMode = 2 is RichFx's swatch color tiles and we hide our dropdown
	    setupSwatches: function setupSwatches() {
	      var swatchMode = $('.swatchDropdown').data('swatch-mode');
	
	      if (swatchMode == 1 || swatchMode == 2) {
	        ModalZoomViewer.syncSwatchTiles(swatchMode);
	        ModalZoomViewer.selectInitialSwatch();
	
	        //fallback to our select if RichFx's swatch tiles didn't load
	        if (swatchMode == 2 && $('#theSwatches').children().length == 0) {
	          $('.swatchDropdown').removeClass('hide');
	        }
	        COSTCO.util.swatch_accesible_popover('.swatch-help');
	      } else {
	        $('#product-body-item-number').removeClass('hide');
	        $('#product-body-model-number').removeClass('hide');
	      }
	    },
	
	    //setus up the viewer to have responsive properties and
	    //shows thumbnails if they are available
	    setupViewer: function setupViewer() {
	      ModalZoomViewer.makeViewerResponsive();
	      if (ModalZoomViewer.constants.totalSlidesCount > 0) {
	        ModalZoomViewer.constants.$thumbnails.show();
	        ModalZoomViewer.setupThumbnailCarousel();
	      }
	    },
	
	    /**
	     * This event-bound function "locks" window position, since the external Liveclicker library has several
	     * window.scrollTo() executions that cause the background to scroll down after each click on a video.
	     */
	    lockWindowScrolling: function lockWindowScrolling(event) {
	      if (typeof event.data.position != 'undefined') {
	        $(window).scrollTop(event.data.position);
	      }
	    },
	    /**
	     * Liveclicker library may break, leaving the thumbnails un-reloaded.
	     * Until this is fixed on the Liveclicker side, use this error event listener function.
	     */
	    reloadThumbnailsOnScriptError: function reloadThumbnailsOnScriptError(event) {
	      if (event.originalEvent.message == 'Script error.') {
	        try {
	          console.error('A script error occurred. Reloading thumbnails.');
	          ModalZoomViewer.richMediaViewChange();
	        } catch (err) {
	          console.error('An error occurred while trying to reload thumbnails.');
	        }
	      }
	    },
	    /**
	     * Shows modal previous item image arrow
	     */
	    showPreviousArrow: function showPreviousArrow() {
	      ModalZoomViewer.constants.$prevArrow.removeClass('slick-disabled');
	      $('#viewsPrevArrow').removeClass('hideViewsArrow');
	      $('#viewsPrevArrow').css('display', '');
	      $('#viewsPrevArrow').attr('tabindex', '0');
	    },
	    /**
	     * Hides modal previous item image arrow
	     */
	    hidePreviousArrow: function hidePreviousArrow() {
	      ModalZoomViewer.constants.$prevArrow.addClass('slick-disabled');
	      $('#viewsPrevArrow').addClass('hideViewsArrow');
	      $('#viewsPrevArrow').attr('tabindex', '-1');
	    },
	    /**
	     * Shows modal next item image arrow
	     */
	    showNextArrow: function showNextArrow() {
	      ModalZoomViewer.constants.$nextArrow.removeClass('slick-disabled');
	      $('#viewsNextArrow').removeClass('hideViewsArrow');
	
	      $('#viewsNextArrow').css('display', '');
	      $('#viewsNextArrow').attr('tabindex', '0');
	    },
	    /**
	     * Hides modal next item image arrow
	     */
	    hideNextArrow: function hideNextArrow() {
	      ModalZoomViewer.constants.$nextArrow.addClass('slick-disabled');
	      $('#viewsNextArrow').addClass('hideViewsArrow');
	      $('#viewsNextArrow').attr('tabindex', '-1');
	    },
	
	    showHidePreviousArrow: function showHidePreviousArrow(cSlideIndex, slides) {
	      console.log('PDP Image Modal: showHidePreviousArrow(' + cSlideIndex + ', ' + slides + ')');
	
	      if (slides == 0 || cSlideIndex == 0) {
	        console.log('PDP Image Modal: Hide previous arrow');
	        ModalZoomViewer.hidePreviousArrow();
	      } else {
	        console.log('PDP Image Modal: Show previous arrow');
	        ModalZoomViewer.showPreviousArrow();
	      }
	    },
	
	    showHideNextArrow: function showHideNextArrow(cSlideIndex, slides) {
	      console.log('PDP Image Modal: showHideNextArrow(' + cSlideIndex + ', ' + slides + ')');
	      if (cSlideIndex < slides - 1) {
	        console.log('PDP Image Modal: Show next arrow');
	        ModalZoomViewer.showNextArrow();
	      } else {
	        console.log('PDP Image Modal: Hide next arrow');
	        ModalZoomViewer.hideNextArrow();
	      }
	    },
	
	    showHideClickHereToZoomOverlay: function showHideClickHereToZoomOverlay(slides) {
	      if (slides > 0) {
	        var cSlideNumber = ModalZoomViewer.getCurrentSlideNumber();
	        $('#currentSlide').html(cSlideNumber + messages.PDP_REDESIGN_V2_OF + slides);
	      } else {
	        $('#currentSlide').hide();
	      }
	    },
	
	    showHideControls: function showHideControls() {
	      var slides = ModalZoomViewer.constants.totalSlidesCount;
	      var cSlideIndex = ModalZoomViewer.getCurrentSlideIndex();
	      ModalZoomViewer.showHidePreviousArrow(cSlideIndex, slides);
	      ModalZoomViewer.showHideNextArrow(cSlideIndex, slides);
	      ModalZoomViewer.showHideClickHereToZoomOverlay(slides);
	    },
	
	    setupTabindexForVideoThumbnail: function setupTabindexForVideoThumbnail() {
	      var $vidOverlay = $('img[id*=videoOverlay]');
	      $vidOverlay.each(function () {
	        $(this).attr('tabindex', -1);
	      });
	    },
	    /**
	     * Overrides trapFocusInside from utility modal function
	     * to get aria element as focusable element
	     */
	    trapFocusInsideModal: function trapFocusInsideModal() {
	      var modalBody = $(".modal-dialog").get(0);
	      if (modalBody != undefined) {
	        var focusableElements = COSTCO.util.returnAllFocusableElements(modalBody);
	        var focusableVisible = ModalZoomViewer.returnAllFocusableVisibleElements(focusableElements);
	        if (focusableVisible.length > 0) {
	          var firstElement = focusableVisible[0];
	          var lastElement = focusableVisible[focusableVisible.length - 1];
	          COSTCO.util.bindModalFocusEvents(firstElement, lastElement);
	        }
	      }
	    },
	    /**
	     * Returns all elements including area element
	     */
	    returnAllFocusableVisibleElements: function returnAllFocusableVisibleElements(focusableElements) {
	      var visibleFocusable = [];
	
	      function findVisibleElements(item, index) {
	        $(item).unbind('keydown');
	        //Does element or its parent has display none
	        if (item.style.display !== "none" && item.offsetParent !== null) {
	          if ($(item).is(':visible') || $(item).is('area')) {
	            visibleFocusable.push(item);
	          }
	        }
	      }
	
	      for (var i = 0; i < focusableElements.length; i++) {
	        findVisibleElements(focusableElements[i]);
	      }
	      return visibleFocusable;
	    },
	    /**
	     * Fires the ModalZoomViewerLoaded event.
	     */
	    loaded: function loaded() {
	      COSTCO.Global.notify('ModalZoomViewerLoaded');
	    }
	
	  };
	
	  if (typeof window.COSTCO == 'undefined') {
	    window.COSTCO = new Object();
	  }
	
	  window.COSTCO.ModalZoomViewer = ModalZoomViewer;
	
	  return ModalZoomViewer;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }

/******/ });


// WEBPACK FOOTER //
// product.module.min.js